/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export enum Action_Method {
  GrpcAlarmPostalarmstandard = 'GRPC_ALARM_POSTALARMSTANDARD',
  GrpcDeviceGetdeviceinfo = 'GRPC_DEVICE_GETDEVICEINFO',
  GrpcDevicePostalarmstandard = 'GRPC_DEVICE_POSTALARMSTANDARD',
  GrpcDevicePostdeviceinstallation = 'GRPC_DEVICE_POSTDEVICEINSTALLATION',
  GrpcDevicePostdeviceuninstalldevice = 'GRPC_DEVICE_POSTDEVICEUNINSTALLDEVICE',
  GrpcDevicePostequipmentports = 'GRPC_DEVICE_POSTEQUIPMENTPORTS',
  GrpcLayoutSubstationgetinfo = 'GRPC_LAYOUT_SUBSTATIONGETINFO',
  GrpcLayoutSubstationinstallation = 'GRPC_LAYOUT_SUBSTATIONINSTALLATION',
  GrpcLayoutSubstationremove = 'GRPC_LAYOUT_SUBSTATIONREMOVE',
  GrpcLayoutSubstationupdate = 'GRPC_LAYOUT_SUBSTATIONUPDATE'
}

export type Action_MethodOperationFilterInput = {
  eq?: InputMaybe<Action_Method>;
  in?: InputMaybe<Array<Action_Method>>;
  neq?: InputMaybe<Action_Method>;
  nin?: InputMaybe<Array<Action_Method>>;
};

export enum Action_Proto {
  Broker = 'BROKER',
  Grpc = 'GRPC'
}

export type Action_ProtoOperationFilterInput = {
  eq?: InputMaybe<Action_Proto>;
  in?: InputMaybe<Array<Action_Proto>>;
  neq?: InputMaybe<Action_Proto>;
  nin?: InputMaybe<Array<Action_Proto>>;
};

export enum Action_Type {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type Action_TypeOperationFilterInput = {
  eq?: InputMaybe<Action_Type>;
  in?: InputMaybe<Array<Action_Type>>;
  neq?: InputMaybe<Action_Type>;
  nin?: InputMaybe<Array<Action_Type>>;
};

export enum Alarm_Group_Name {
  BrokenNeutral = 'BROKEN_NEUTRAL',
  BusbarLineNullVoltage = 'BUSBAR_LINE_NULL_VOLTAGE',
  BusbarOverVoltage = 'BUSBAR_OVER_VOLTAGE',
  BusbarUnderVoltage = 'BUSBAR_UNDER_VOLTAGE',
  DevicePowerFail = 'DEVICE_POWER_FAIL',
  Empty = 'EMPTY',
  FeederLineFuseBlown = 'FEEDER_LINE_FUSE_BLOWN',
  FeederLineNullCurrent = 'FEEDER_LINE_NULL_CURRENT',
  FeederLineOvercurrent = 'FEEDER_LINE_OVERCURRENT',
  FeederLinePreFault = 'FEEDER_LINE_PRE_FAULT',
  HvLineDown = 'HV_LINE_DOWN',
  HvPhaseLoss = 'HV_PHASE_LOSS',
  Uint = 'UINT',
  Voltage = 'VOLTAGE',
  Wfc = 'WFC'
}

export type Alarm_Group_NameOperationFilterInput = {
  eq?: InputMaybe<Alarm_Group_Name>;
  in?: InputMaybe<Array<Alarm_Group_Name>>;
  neq?: InputMaybe<Alarm_Group_Name>;
  nin?: InputMaybe<Array<Alarm_Group_Name>>;
};

export enum Alarm_Type {
  BrokenNeutral = 'BROKEN_NEUTRAL',
  BusbarLineNullVoltage = 'BUSBAR_LINE_NULL_VOLTAGE',
  BusbarNeutralOpenCircuit = 'BUSBAR_NEUTRAL_OPEN_CIRCUIT',
  BusbarOverloadAgg = 'BUSBAR_OVERLOAD_AGG',
  BusbarOverVoltage = 'BUSBAR_OVER_VOLTAGE',
  BusbarOverVoltageAgg = 'BUSBAR_OVER_VOLTAGE_AGG',
  BusbarUnderVoltage = 'BUSBAR_UNDER_VOLTAGE',
  BusbarUnderVoltageAgg = 'BUSBAR_UNDER_VOLTAGE_AGG',
  DevicePowerFail = 'DEVICE_POWER_FAIL',
  Empty = 'EMPTY',
  FeederLineFuseBlown = 'FEEDER_LINE_FUSE_BLOWN',
  FeederLineNullCurrent = 'FEEDER_LINE_NULL_CURRENT',
  FeederLineOvercurrent = 'FEEDER_LINE_OVERCURRENT',
  FeederLineOverloadAgg = 'FEEDER_LINE_OVERLOAD_AGG',
  FeederLinePreFault = 'FEEDER_LINE_PRE_FAULT',
  FeederLineReversePowerAgg = 'FEEDER_LINE_REVERSE_POWER_AGG',
  FeederNeutralOvercurrentAgg = 'FEEDER_NEUTRAL_OVERCURRENT_AGG',
  HvPhaseLoss = 'HV_PHASE_LOSS',
  InstallReactivePowerCheck = 'INSTALL_REACTIVE_POWER_CHECK',
  InstallReversePowerCheck = 'INSTALL_REVERSE_POWER_CHECK',
  InstallVoltageCheck = 'INSTALL_VOLTAGE_CHECK',
  NewHvLineDown = 'NEW_HV_LINE_DOWN',
  Uint = 'UINT',
  Wfc = 'WFC'
}

export type Alarm_TypeOperationFilterInput = {
  eq?: InputMaybe<Alarm_Type>;
  in?: InputMaybe<Array<Alarm_Type>>;
  neq?: InputMaybe<Alarm_Type>;
  nin?: InputMaybe<Array<Alarm_Type>>;
};

export enum Anchor_Type {
  Double = 'DOUBLE',
  Single = 'SINGLE'
}

export enum Apn_Auth_Type {
  Chap = 'CHAP',
  None = 'NONE',
  Pap = 'PAP',
  PapOrChap = 'PAP_OR_CHAP'
}

export type Apn_Auth_TypeOperationFilterInput = {
  eq?: InputMaybe<Apn_Auth_Type>;
  in?: InputMaybe<Array<Apn_Auth_Type>>;
  neq?: InputMaybe<Apn_Auth_Type>;
  nin?: InputMaybe<Array<Apn_Auth_Type>>;
};

export enum Asset_State {
  Archived = 'ARCHIVED',
  Installed = 'INSTALLED',
  NotInstalled = 'NOT_INSTALLED'
}

export type Asset_StateOperationFilterInput = {
  eq?: InputMaybe<Asset_State>;
  in?: InputMaybe<Array<Asset_State>>;
  neq?: InputMaybe<Asset_State>;
  nin?: InputMaybe<Array<Asset_State>>;
};

export enum Asset_Type {
  DistributionBox = 'DISTRIBUTION_BOX',
  Error = 'ERROR',
  EvChargeStation = 'EV_CHARGE_STATION',
  HvDistributionBox = 'HV_DISTRIBUTION_BOX',
  HvPole = 'HV_POLE',
  HvSubstation = 'HV_SUBSTATION',
  LvGroundSubstation = 'LV_GROUND_SUBSTATION',
  LvPoleMounted = 'LV_POLE_MOUNTED',
  Meter = 'METER'
}

export type Asset_TypeOperationFilterInput = {
  eq?: InputMaybe<Asset_Type>;
  in?: InputMaybe<Array<Asset_Type>>;
  neq?: InputMaybe<Asset_Type>;
  nin?: InputMaybe<Array<Asset_Type>>;
};

export type AccessGroup = {
  __typename?: 'AccessGroup';
  assets: Array<LayoutEquipment>;
  companies: Array<Company>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enterprises: Array<Enterprise>;
  id: Scalars['Long']['output'];
  isDefault: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isProtected: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  operationalAreas: Array<OperationalArea>;
  regions: Array<Region>;
  users: Array<User>;
  workingOperationalAreas: Array<OperationalArea>;
};

export type AccessGroupFilterInput = {
  and?: InputMaybe<Array<AccessGroupFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  companies?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  enterprises?: InputMaybe<ListFilterInputTypeOfEnterpriseFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isProtected?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  operationalAreas?: InputMaybe<ListFilterInputTypeOfOperationalAreaFilterInput>;
  or?: InputMaybe<Array<AccessGroupFilterInput>>;
  regions?: InputMaybe<ListFilterInputTypeOfRegionFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
  workingOperationalAreas?: InputMaybe<ListFilterInputTypeOfOperationalAreaFilterInput>;
};

export type AccessGroupSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  isProtected?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AccessGroupToAsset = {
  __typename?: 'AccessGroupToAsset';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  asset: LayoutEquipment;
  assetId: Scalars['Long']['output'];
};

export type AccessGroupToCompany = {
  __typename?: 'AccessGroupToCompany';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  company: Company;
  companyId: Scalars['Long']['output'];
};

export type AccessGroupToOperationalArea = {
  __typename?: 'AccessGroupToOperationalArea';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  operationalArea: OperationalArea;
  operationalAreaId: Scalars['Long']['output'];
};

export type AccessGroupToRegion = {
  __typename?: 'AccessGroupToRegion';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  region: Region;
  regionId: Scalars['Long']['output'];
};

export type AccessGroupToUser = {
  __typename?: 'AccessGroupToUser';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  user: User;
  userId: Scalars['Long']['output'];
};

export type AccessGroupToWorkingOperationalArea = {
  __typename?: 'AccessGroupToWorkingOperationalArea';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  operationalArea: OperationalArea;
  operationalAreaId: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type AccessGroupsConnection = {
  __typename?: 'AccessGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AccessGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<AccessGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccessGroupsEdge = {
  __typename?: 'AccessGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccessGroup>;
};

export type Action = {
  __typename?: 'Action';
  id: Scalars['Long']['output'];
  menuRoles?: Maybe<Array<MenuRoles>>;
  type: ActionType;
};

/** A connection to a list of items. */
export type ActionConnection = {
  __typename?: 'ActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ActionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Action>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActionEdge = {
  __typename?: 'ActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Action;
};

export type ActionFilterInput = {
  and?: InputMaybe<Array<ActionFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  menuRoles?: InputMaybe<ListFilterInputTypeOfMenuRolesFilterInput>;
  or?: InputMaybe<Array<ActionFilterInput>>;
  type?: InputMaybe<ActionTypeOperationFilterInput>;
};

export enum ActionLoggingType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Unknown = 'UNKNOWN',
  Update = 'UPDATE'
}

export type ActionLoggingTypeOperationFilterInput = {
  eq?: InputMaybe<ActionLoggingType>;
  in?: InputMaybe<Array<ActionLoggingType>>;
  neq?: InputMaybe<ActionLoggingType>;
  nin?: InputMaybe<Array<ActionLoggingType>>;
};

export type ActionSortInput = {
  id?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum ActionType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Update = 'UPDATE'
}

export type ActionTypeOperationFilterInput = {
  eq?: InputMaybe<ActionType>;
  in?: InputMaybe<Array<ActionType>>;
  neq?: InputMaybe<ActionType>;
  nin?: InputMaybe<Array<ActionType>>;
};

export type AlarmStandard = {
  __typename?: 'AlarmStandard';
  alarmStandardDefinitions: Array<AlarmStandardDefinition>;
  alarmStandardVariableDefinitions: Array<AlarmStandardVariableDefinition>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type AlarmStandardDefinition = {
  __typename?: 'AlarmStandardDefinition';
  alarmStandard: AlarmStandard;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  alarmType: AlarmType;
  alarmTypeId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  enable: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AlarmStandardDefinitionFilterInput = {
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  alarmType?: InputMaybe<AlarmTypeFilterInput>;
  alarmTypeId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<AlarmStandardDefinitionFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  enable?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AlarmStandardDefinitionFilterInput>>;
};

export type AlarmStandardDefinitionSortInput = {
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  alarmType?: InputMaybe<AlarmTypeSortInput>;
  alarmTypeId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  enable?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlarmStandardDefinitionsConnection = {
  __typename?: 'AlarmStandardDefinitionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmStandardDefinitionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmStandardDefinition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmStandardDefinitionsEdge = {
  __typename?: 'AlarmStandardDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmStandardDefinition;
};

export type AlarmStandardFilterInput = {
  alarmStandardDefinitions?: InputMaybe<ListFilterInputTypeOfAlarmStandardDefinitionFilterInput>;
  alarmStandardVariableDefinitions?: InputMaybe<ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput>;
  and?: InputMaybe<Array<AlarmStandardFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  device?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  editable?: InputMaybe<BooleanOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  feeders?: InputMaybe<ListFilterInputTypeOfFeederFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmStandardFilterInput>>;
};

export type AlarmStandardSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  editable?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AlarmStandardVariableAggregation = {
  __typename?: 'AlarmStandardVariableAggregation';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AlarmStandardVariableAggregationByAlarm = {
  __typename?: 'AlarmStandardVariableAggregationByAlarm';
  name: Scalars['String']['output'];
  value: Array<AlarmStandardVariableAggregation>;
};

export type AlarmStandardVariableAggregationByAlarmFilterInput = {
  and?: InputMaybe<Array<AlarmStandardVariableAggregationByAlarmFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmStandardVariableAggregationByAlarmFilterInput>>;
  value?: InputMaybe<ListFilterInputTypeOfAlarmStandardVariableAggregationFilterInput>;
};

export type AlarmStandardVariableAggregationByAlarmInput = {
  name: Scalars['String']['input'];
  value: Array<AlarmStandardVariableAggregationInput>;
};

export type AlarmStandardVariableAggregationFilterInput = {
  and?: InputMaybe<Array<AlarmStandardVariableAggregationFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmStandardVariableAggregationFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type AlarmStandardVariableAggregationInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AlarmStandardVariableDefinition = {
  __typename?: 'AlarmStandardVariableDefinition';
  alarmStandard: AlarmStandard;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  alarmVariable: AlarmVariable;
  alarmVariableId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  isValidAlarmStandardVariableAggregationDefinition?: Maybe<Array<KeyValuePairOfStringAndString>>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  listAlarmsStandardAggregation?: Maybe<Array<AlarmStandardVariableAggregationByAlarm>>;
  value: Scalars['String']['output'];
};


export type AlarmStandardVariableDefinitionIsValidAlarmStandardVariableAggregationDefinitionArgs = {
  lines: Array<AlarmStandardVariableAggregationByAlarmInput>;
};

export type AlarmStandardVariableDefinitionFilterInput = {
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  alarmVariable?: InputMaybe<AlarmVariableFilterInput>;
  alarmVariableId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<AlarmStandardVariableDefinitionFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  listAlarmsStandardAggregation?: InputMaybe<ListFilterInputTypeOfAlarmStandardVariableAggregationByAlarmFilterInput>;
  or?: InputMaybe<Array<AlarmStandardVariableDefinitionFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type AlarmStandardVariableDefinitionSortInput = {
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  alarmVariable?: InputMaybe<AlarmVariableSortInput>;
  alarmVariableId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlarmStandardVariableDefinitionsConnection = {
  __typename?: 'AlarmStandardVariableDefinitionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmStandardVariableDefinitionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmStandardVariableDefinition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmStandardVariableDefinitionsEdge = {
  __typename?: 'AlarmStandardVariableDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmStandardVariableDefinition;
};

/** A connection to a list of items. */
export type AlarmStandardsConnection = {
  __typename?: 'AlarmStandardsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmStandardsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmStandard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmStandardsEdge = {
  __typename?: 'AlarmStandardsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmStandard;
};

export type AlarmType = {
  __typename?: 'AlarmType';
  alarmStandardDefinitions: Array<AlarmStandardDefinition>;
  alarmVariables: Array<AlarmVariable>;
  defaultStatus: Scalars['Boolean']['output'];
  entityType: Entity_Type;
  id: Scalars['Long']['output'];
  source: Source;
  type: Alarm_Type;
};

export type AlarmTypeFilterInput = {
  alarmStandardDefinitions?: InputMaybe<ListFilterInputTypeOfAlarmStandardDefinitionFilterInput>;
  alarmVariables?: InputMaybe<ListFilterInputTypeOfAlarmVariableFilterInput>;
  and?: InputMaybe<Array<AlarmTypeFilterInput>>;
  defaultStatus?: InputMaybe<BooleanOperationFilterInput>;
  entityType?: InputMaybe<Entity_TypeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AlarmTypeFilterInput>>;
  source?: InputMaybe<SourceOperationFilterInput>;
  type?: InputMaybe<Alarm_TypeOperationFilterInput>;
};

export type AlarmTypeSortInput = {
  defaultStatus?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlarmTypesConnection = {
  __typename?: 'AlarmTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmTypesEdge = {
  __typename?: 'AlarmTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmType;
};

export type AlarmVariable = {
  __typename?: 'AlarmVariable';
  alarmStandardVariableDefinitions: Array<AlarmStandardVariableDefinition>;
  alarmType: AlarmType;
  alarmTypeId?: Maybe<Scalars['Long']['output']>;
  defaultValue: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  groupName: Alarm_Group_Name;
  id: Scalars['Long']['output'];
  jsonConstrains?: Maybe<Scalars['String']['output']>;
  listAlarmsVariablesAggregation?: Maybe<Array<AlarmVariableAggregation>>;
  name: Scalars['String']['output'];
  region: Region;
  type: Scalars['String']['output'];
};

export type AlarmVariableAggregation = {
  __typename?: 'AlarmVariableAggregation';
  defaultValue: Scalars['String']['output'];
  jsonConstraints?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AlarmVariableAggregationFilterInput = {
  and?: InputMaybe<Array<AlarmVariableAggregationFilterInput>>;
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  jsonConstraints?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmVariableAggregationFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type AlarmVariableFilterInput = {
  alarmStandardVariableDefinitions?: InputMaybe<ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput>;
  alarmType?: InputMaybe<AlarmTypeFilterInput>;
  alarmTypeId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<AlarmVariableFilterInput>>;
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  deviceName?: InputMaybe<StringOperationFilterInput>;
  groupName?: InputMaybe<Alarm_Group_NameOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  jsonConstrains?: InputMaybe<StringOperationFilterInput>;
  listAlarmsVariablesAggregation?: InputMaybe<ListFilterInputTypeOfAlarmVariableAggregationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmVariableFilterInput>>;
  region?: InputMaybe<RegionOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type AlarmVariableSortInput = {
  alarmType?: InputMaybe<AlarmTypeSortInput>;
  alarmTypeId?: InputMaybe<SortEnumType>;
  defaultValue?: InputMaybe<SortEnumType>;
  deviceName?: InputMaybe<SortEnumType>;
  groupName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jsonConstrains?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlarmVariablesConnection = {
  __typename?: 'AlarmVariablesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmVariablesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmVariable>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmVariablesEdge = {
  __typename?: 'AlarmVariablesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmVariable;
};

export type Application = {
  __typename?: 'Application';
  authorizationTokens: Array<AuthorizationToken>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ApplicationFilterInput = {
  and?: InputMaybe<Array<ApplicationFilterInput>>;
  authorizationTokens?: InputMaybe<ListFilterInputTypeOfAuthorizationTokenFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationFilterInput>>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type Asset = {
  __typename?: 'Asset';
  alarmStandard?: Maybe<EquipmentsAlarmStandard>;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  alarmStandardName?: Maybe<Scalars['String']['output']>;
  assetType: Asset_Type;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  customProperties: Array<CustomProperties>;
  description?: Maybe<Scalars['String']['output']>;
  devices: Array<EquipmentsDevice>;
  equipBulkConfiguration?: Maybe<EquipmentsBulkConfiguration>;
  equipBulkConfigurationId?: Maybe<Scalars['Long']['output']>;
  equipBulkConfigurationName?: Maybe<Scalars['String']['output']>;
  equipments: Array<Equipment>;
  feeders: Array<Feeder>;
  hasAbscenceOfVoltage: Scalars['Boolean']['output'];
  hasData: Scalars['Boolean']['output'];
  hasEarthData: Scalars['Boolean']['output'];
  hasEvents: Scalars['Boolean']['output'];
  hasHvLineDown: Scalars['Boolean']['output'];
  hasPhaseLoss: Scalars['Boolean']['output'];
  hasRawData: Scalars['Boolean']['output'];
  hvLineDownProperties?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastCommissioningDate?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  lines: Array<Line>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  operationalArea?: Maybe<EquipmentsOperationalArea>;
  operationalAreaId?: Maybe<Scalars['Long']['output']>;
  operationalAreaV2Id?: Maybe<Scalars['Long']['output']>;
  parentAssetId?: Maybe<Scalars['Long']['output']>;
  parentAssetName?: Maybe<Scalars['String']['output']>;
  parentAssetV2Id?: Maybe<Scalars['Long']['output']>;
  parentFeederId?: Maybe<Scalars['Long']['output']>;
  parentFeederName?: Maybe<Scalars['String']['output']>;
  parentFeederV2Id?: Maybe<Scalars['Long']['output']>;
  region?: Maybe<EquipmentsRegion>;
  regionId?: Maybe<Scalars['Long']['output']>;
  regionV2Id?: Maybe<Scalars['Long']['output']>;
  registryNumber: Scalars['String']['output'];
  sdsType?: Maybe<Substation_Type>;
  state: Asset_State;
  transformerType: Transformer_Type;
  xGeometricPosition: Scalars['Int']['output'];
  yGeometricPosition: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type AssetBulkConfigurationsConnection = {
  __typename?: 'AssetBulkConfigurationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AssetBulkConfigurationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EquipmentsBulkConfiguration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetBulkConfigurationsEdge = {
  __typename?: 'AssetBulkConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EquipmentsBulkConfiguration;
};

export type AssetFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  alarmStandardName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AssetFilterInput>>;
  assetType?: InputMaybe<Asset_TypeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customProperties?: InputMaybe<ListFilterInputTypeOfCustomPropertiesFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  equipBulkConfiguration?: InputMaybe<EquipBulkConfigurationFilterInput>;
  equipBulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  equipBulkConfigurationName?: InputMaybe<StringOperationFilterInput>;
  equipments?: InputMaybe<ListFilterInputTypeOfEquipmentFilterInput>;
  externalAssetId?: InputMaybe<LongOperationFilterInput>;
  feeders?: InputMaybe<ListFilterInputTypeOfFeederFilterInput>;
  gpsPoint?: InputMaybe<GpsPointFilterInput>;
  hasAbscenceOfVoltage?: InputMaybe<BooleanOperationFilterInput>;
  hasData?: InputMaybe<BooleanOperationFilterInput>;
  hasEarthData?: InputMaybe<BooleanOperationFilterInput>;
  hasEvents?: InputMaybe<BooleanOperationFilterInput>;
  hasHvLineDown?: InputMaybe<BooleanOperationFilterInput>;
  hasPhaseLoss?: InputMaybe<BooleanOperationFilterInput>;
  hasRawData?: InputMaybe<BooleanOperationFilterInput>;
  hvLineDownProperties?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastCommissioningDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  lines?: InputMaybe<ListFilterInputTypeOfLineFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  operationalArea?: InputMaybe<OperationalAreaFilterInput>;
  operationalAreaId?: InputMaybe<LongOperationFilterInput>;
  operationalAreaV2Id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AssetFilterInput>>;
  parentAssetId?: InputMaybe<LongOperationFilterInput>;
  parentAssetName?: InputMaybe<StringOperationFilterInput>;
  parentAssetV2Id?: InputMaybe<LongOperationFilterInput>;
  parentFeederId?: InputMaybe<LongOperationFilterInput>;
  parentFeederName?: InputMaybe<StringOperationFilterInput>;
  parentFeederV2Id?: InputMaybe<LongOperationFilterInput>;
  region?: InputMaybe<RegionFilterInput>;
  regionId?: InputMaybe<LongOperationFilterInput>;
  regionV2Id?: InputMaybe<LongOperationFilterInput>;
  registrationNumber?: InputMaybe<StringOperationFilterInput>;
  registryNumber?: InputMaybe<StringOperationFilterInput>;
  sdsType?: InputMaybe<NullableOfSubstation_TypeOperationFilterInput>;
  state?: InputMaybe<Asset_StateOperationFilterInput>;
  transformerType?: InputMaybe<Transformer_TypeOperationFilterInput>;
  xGeometricPosition?: InputMaybe<IntOperationFilterInput>;
  yGeometricPosition?: InputMaybe<IntOperationFilterInput>;
};

export type AssetSortInput = {
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  alarmStandardName?: InputMaybe<SortEnumType>;
  assetType?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  equipBulkConfiguration?: InputMaybe<EquipBulkConfigurationSortInput>;
  equipBulkConfigurationId?: InputMaybe<SortEnumType>;
  equipBulkConfigurationName?: InputMaybe<SortEnumType>;
  externalAssetId?: InputMaybe<SortEnumType>;
  gpsPoint?: InputMaybe<GpsPointSortInput>;
  hasAbscenceOfVoltage?: InputMaybe<SortEnumType>;
  hasData?: InputMaybe<SortEnumType>;
  hasEarthData?: InputMaybe<SortEnumType>;
  hasEvents?: InputMaybe<SortEnumType>;
  hasHvLineDown?: InputMaybe<SortEnumType>;
  hasPhaseLoss?: InputMaybe<SortEnumType>;
  hasRawData?: InputMaybe<SortEnumType>;
  hvLineDownProperties?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastCommissioningDate?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  operationalArea?: InputMaybe<OperationalAreaSortInput>;
  operationalAreaId?: InputMaybe<SortEnumType>;
  operationalAreaV2Id?: InputMaybe<SortEnumType>;
  parentAssetId?: InputMaybe<SortEnumType>;
  parentAssetName?: InputMaybe<SortEnumType>;
  parentAssetV2Id?: InputMaybe<SortEnumType>;
  parentFeederId?: InputMaybe<SortEnumType>;
  parentFeederName?: InputMaybe<SortEnumType>;
  parentFeederV2Id?: InputMaybe<SortEnumType>;
  region?: InputMaybe<RegionSortInput>;
  regionId?: InputMaybe<SortEnumType>;
  regionV2Id?: InputMaybe<SortEnumType>;
  registrationNumber?: InputMaybe<SortEnumType>;
  registryNumber?: InputMaybe<SortEnumType>;
  sdsType?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  transformerType?: InputMaybe<SortEnumType>;
  xGeometricPosition?: InputMaybe<SortEnumType>;
  yGeometricPosition?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AssetsConnection = {
  __typename?: 'AssetsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AssetsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Asset>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetsEdge = {
  __typename?: 'AssetsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

export type Authorization = {
  __typename?: 'Authorization';
  id: Scalars['Long']['output'];
  method: Scalars['String']['output'];
  roles?: Maybe<Array<Role>>;
  scope: Scalars['String']['output'];
};

export type AuthorizationAccessGroup = {
  __typename?: 'AuthorizationAccessGroup';
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  users: Array<User>;
};

/** A connection to a list of items. */
export type AuthorizationConnection = {
  __typename?: 'AuthorizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AuthorizationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Authorization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type AuthorizationDevice = {
  __typename?: 'AuthorizationDevice';
  authorizationTokens: Array<AuthorizationToken>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  serialNumber: Scalars['String']['output'];
};

/** An edge in a connection. */
export type AuthorizationEdge = {
  __typename?: 'AuthorizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Authorization;
};

export type AuthorizationFilterInput = {
  and?: InputMaybe<Array<AuthorizationFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  method?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AuthorizationFilterInput>>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleFilterInput>;
  scope?: InputMaybe<StringOperationFilterInput>;
};

export type AuthorizationSortInput = {
  id?: InputMaybe<SortEnumType>;
  method?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
};

export type AuthorizationToken = {
  __typename?: 'AuthorizationToken';
  application?: Maybe<Application>;
  applicationId?: Maybe<Scalars['Long']['output']>;
  devices: Array<AuthorizationDevice>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  expirationType: ExpirationType;
  guid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  key?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  tokenType: TokenType;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Long']['output']>;
};

export type AuthorizationTokenFilterInput = {
  and?: InputMaybe<Array<AuthorizationTokenFilterInput>>;
  application?: InputMaybe<ApplicationFilterInput>;
  applicationId?: InputMaybe<LongOperationFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  expirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  expirationType?: InputMaybe<ExpirationTypeOperationFilterInput>;
  guid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AuthorizationTokenFilterInput>>;
  token?: InputMaybe<StringOperationFilterInput>;
  tokenType?: InputMaybe<TokenTypeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<LongOperationFilterInput>;
};

export type BatchDevice = {
  __typename?: 'BatchDevice';
  batchIncludes: Array<BatchInclude>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  devices: Array<Device>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type BatchDeviceFilterInput = {
  and?: InputMaybe<Array<BatchDeviceFilterInput>>;
  batchIncludes?: InputMaybe<ListFilterInputTypeOfBatchIncludeFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BatchDeviceFilterInput>>;
};

export type BatchDeviceSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BatchDevicesConnection = {
  __typename?: 'BatchDevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BatchDevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BatchDevice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BatchDevicesEdge = {
  __typename?: 'BatchDevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BatchDevice;
};

export type BatchInclude = {
  __typename?: 'BatchInclude';
  batchDevice: BatchDevice;
  batchDeviceId: Scalars['Long']['output'];
  batchSim: BatchSim;
  batchSimId: Scalars['Long']['output'];
  conTest: ConTest;
  conTestId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type BatchIncludeFilterInput = {
  and?: InputMaybe<Array<BatchIncludeFilterInput>>;
  batchDevice?: InputMaybe<BatchDeviceFilterInput>;
  batchDeviceId?: InputMaybe<LongOperationFilterInput>;
  batchSim?: InputMaybe<BatchSimFilterInput>;
  batchSimId?: InputMaybe<LongOperationFilterInput>;
  conTest?: InputMaybe<ConTestFilterInput>;
  conTestId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BatchIncludeFilterInput>>;
};

export type BatchIncludeSortInput = {
  batchDevice?: InputMaybe<BatchDeviceSortInput>;
  batchDeviceId?: InputMaybe<SortEnumType>;
  batchSim?: InputMaybe<BatchSimSortInput>;
  batchSimId?: InputMaybe<SortEnumType>;
  conTest?: InputMaybe<ConTestSortInput>;
  conTestId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BatchIncludesConnection = {
  __typename?: 'BatchIncludesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BatchIncludesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BatchInclude>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BatchIncludesEdge = {
  __typename?: 'BatchIncludesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BatchInclude;
};

export type BatchSim = {
  __typename?: 'BatchSim';
  batchIncludes: Array<BatchInclude>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  simCards: Array<SimCard>;
};

export type BatchSimFilterInput = {
  and?: InputMaybe<Array<BatchSimFilterInput>>;
  batchIncludes?: InputMaybe<ListFilterInputTypeOfBatchIncludeFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BatchSimFilterInput>>;
  simCards?: InputMaybe<ListFilterInputTypeOfSimCardFilterInput>;
};

export type BatchSimSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BatchSimsConnection = {
  __typename?: 'BatchSimsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BatchSimsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BatchSim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BatchSimsEdge = {
  __typename?: 'BatchSimsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BatchSim;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
};

export enum Connection_Type {
  LashedDown = 'LASHED_DOWN',
  Suspended = 'SUSPENDED'
}

export enum Constraint_Type {
  Custom = 'CUSTOM',
  System = 'SYSTEM'
}

export type Constraint_TypeOperationFilterInput = {
  eq?: InputMaybe<Constraint_Type>;
  in?: InputMaybe<Array<Constraint_Type>>;
  neq?: InputMaybe<Constraint_Type>;
  nin?: InputMaybe<Array<Constraint_Type>>;
};

export enum Con_Test_Result_Type {
  Error = 'ERROR',
  Null = 'NULL',
  Ok = 'OK',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING'
}

export type Con_Test_Result_TypeOperationFilterInput = {
  eq?: InputMaybe<Con_Test_Result_Type>;
  in?: InputMaybe<Array<Con_Test_Result_Type>>;
  neq?: InputMaybe<Con_Test_Result_Type>;
  nin?: InputMaybe<Array<Con_Test_Result_Type>>;
};

export type CableType = {
  __typename?: 'CableType';
  color: Scalars['String']['output'];
  coreSection: Scalars['Float']['output'];
  cores: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  fuseWay?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type CableTypeFilterInput = {
  and?: InputMaybe<Array<CableTypeFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  coreSection?: InputMaybe<FloatOperationFilterInput>;
  cores?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  fuseWay?: InputMaybe<FloatOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CableTypeFilterInput>>;
};

export type CableTypeSortInput = {
  color?: InputMaybe<SortEnumType>;
  coreSection?: InputMaybe<SortEnumType>;
  cores?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  fuseWay?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CableTypesConnection = {
  __typename?: 'CableTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CableTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CableType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CableTypesEdge = {
  __typename?: 'CableTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CableType;
};

export type Company = {
  __typename?: 'Company';
  accessGroups: Array<AccessGroup>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enterprise: Enterprise;
  enterpriseId: Scalars['Long']['output'];
  gpsPoints: Array<GpsPoint>;
  id: Scalars['Long']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  regions: Array<Region>;
  users: Array<User>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<CompanyFilterInput>>;
  country?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  enterprise?: InputMaybe<EnterpriseFilterInput>;
  enterpriseId?: InputMaybe<LongOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  gpsPoints?: InputMaybe<ListFilterInputTypeOfGpsPointFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  image?: InputMaybe<StringOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
  regions?: InputMaybe<ListFilterInputTypeOfRegionFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
  website?: InputMaybe<StringOperationFilterInput>;
};

export type CompanySortInput = {
  country?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  enterprise?: InputMaybe<EnterpriseSortInput>;
  enterpriseId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  image?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  website?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CompanysConnection = {
  __typename?: 'CompanysConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CompanysEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Company>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompanysEdge = {
  __typename?: 'CompanysEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Company>;
};

export type ConTest = {
  __typename?: 'ConTest';
  batchIncludes: Array<BatchInclude>;
  checkTimeOut?: Maybe<Scalars['Int']['output']>;
  conTestDeviceResults: Array<ConTestDeviceResult>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceBulkConfiguration: DeviceBulkConfiguration;
  deviceBulkConfigurationId: Scalars['Long']['output'];
  hasConnectivity: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type ConTestDeviceResult = {
  __typename?: 'ConTestDeviceResult';
  conTest: ConTest;
  conTestId: Scalars['Long']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  externalResult: Con_Test_Result_Type;
  externalResultTime?: Maybe<Scalars['DateTime']['output']>;
  hasRawData: Scalars['Boolean']['output'];
  hasStateField: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  result: Con_Test_Result_Type;
  resultLog?: Maybe<Scalars['String']['output']>;
};

export type ConTestDeviceResultFilterInput = {
  and?: InputMaybe<Array<ConTestDeviceResultFilterInput>>;
  conTest?: InputMaybe<ConTestFilterInput>;
  conTestId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  externalResult?: InputMaybe<Con_Test_Result_TypeOperationFilterInput>;
  externalResultTime?: InputMaybe<DateTimeOperationFilterInput>;
  hasRawData?: InputMaybe<BooleanOperationFilterInput>;
  hasStateField?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ConTestDeviceResultFilterInput>>;
  result?: InputMaybe<Con_Test_Result_TypeOperationFilterInput>;
  resultLog?: InputMaybe<StringOperationFilterInput>;
};

export type ConTestDeviceResultSortInput = {
  conTest?: InputMaybe<ConTestSortInput>;
  conTestId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  externalResult?: InputMaybe<SortEnumType>;
  externalResultTime?: InputMaybe<SortEnumType>;
  hasRawData?: InputMaybe<SortEnumType>;
  hasStateField?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  result?: InputMaybe<SortEnumType>;
  resultLog?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ConTestDeviceResultsConnection = {
  __typename?: 'ConTestDeviceResultsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConTestDeviceResultsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConTestDeviceResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConTestDeviceResultsEdge = {
  __typename?: 'ConTestDeviceResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConTestDeviceResult;
};

export type ConTestExtended = {
  __typename?: 'ConTestExtended';
  batchIncludes: Array<BatchInclude>;
  checkTimeOut?: Maybe<Scalars['Int']['output']>;
  conTestDeviceResults: Array<ConTestDeviceResult>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceBulkConfiguration: DeviceBulkConfiguration;
  deviceBulkConfigurationId: Scalars['Long']['output'];
  hasConnectivity: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  remainingDevices: Scalars['Long']['output'];
  remainingSimCards: Scalars['Long']['output'];
  testedDevices: Scalars['Long']['output'];
};

export type ConTestExtendedFilterInput = {
  and?: InputMaybe<Array<ConTestExtendedFilterInput>>;
  batchIncludes?: InputMaybe<ListFilterInputTypeOfBatchIncludeFilterInput>;
  checkTimeOut?: InputMaybe<IntOperationFilterInput>;
  conTestDeviceResults?: InputMaybe<ListFilterInputTypeOfConTestDeviceResultFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  deviceBulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  hasConnectivity?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConTestExtendedFilterInput>>;
  remainingDevices?: InputMaybe<LongOperationFilterInput>;
  remainingSimCards?: InputMaybe<LongOperationFilterInput>;
  testedDevices?: InputMaybe<LongOperationFilterInput>;
};

export type ConTestExtendedSortInput = {
  checkTimeOut?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  deviceBulkConfigurationId?: InputMaybe<SortEnumType>;
  hasConnectivity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  remainingDevices?: InputMaybe<SortEnumType>;
  remainingSimCards?: InputMaybe<SortEnumType>;
  testedDevices?: InputMaybe<SortEnumType>;
};

export type ConTestFilterInput = {
  and?: InputMaybe<Array<ConTestFilterInput>>;
  batchIncludes?: InputMaybe<ListFilterInputTypeOfBatchIncludeFilterInput>;
  checkTimeOut?: InputMaybe<IntOperationFilterInput>;
  conTestDeviceResults?: InputMaybe<ListFilterInputTypeOfConTestDeviceResultFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  deviceBulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  hasConnectivity?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConTestFilterInput>>;
};

export type ConTestSortInput = {
  checkTimeOut?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  deviceBulkConfigurationId?: InputMaybe<SortEnumType>;
  hasConnectivity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ConTestsConnection = {
  __typename?: 'ConTestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConTestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConTestsEdge = {
  __typename?: 'ConTestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConTest;
};

/** A connection to a list of items. */
export type ConTestsExtendedConnection = {
  __typename?: 'ConTestsExtendedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConTestsExtendedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConTestExtended>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConTestsExtendedEdge = {
  __typename?: 'ConTestsExtendedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConTestExtended;
};

export type Contact = {
  __typename?: 'Contact';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<Subscription>>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Long']['output']>;
};

export type ContactFilterInput = {
  and?: InputMaybe<Array<ContactFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  subscriptions?: InputMaybe<ListFilterInputTypeOfSubscriptionFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<LongOperationFilterInput>;
};

export type ContactSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ContactsConnection = {
  __typename?: 'ContactsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContactsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactsEdge = {
  __typename?: 'ContactsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

export type Credentials = {
  __typename?: 'Credentials';
  algorithm?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Array<KeyValuePairOfStringAndString>>;
  counter?: Maybe<Scalars['Int']['output']>;
  createdDate?: Maybe<Scalars['Long']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  digits?: Maybe<Scalars['Int']['output']>;
  hashIterations?: Maybe<Scalars['Int']['output']>;
  hashSaltedValue?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  salt?: Maybe<Scalars['String']['output']>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CredentialsFilterInput = {
  algorithm?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CredentialsFilterInput>>;
  config?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput>;
  counter?: InputMaybe<IntOperationFilterInput>;
  createdDate?: InputMaybe<LongOperationFilterInput>;
  device?: InputMaybe<StringOperationFilterInput>;
  digits?: InputMaybe<IntOperationFilterInput>;
  hashIterations?: InputMaybe<IntOperationFilterInput>;
  hashSaltedValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CredentialsFilterInput>>;
  period?: InputMaybe<IntOperationFilterInput>;
  salt?: InputMaybe<StringOperationFilterInput>;
  temporary?: InputMaybe<BooleanOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type CurrentHarmonics = {
  __typename?: 'CurrentHarmonics';
  aggregatedInterval: Scalars['Int']['output'];
  angles: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endType: Scalars['Int']['output'];
  endTypeValue: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  scheduleOperationModes: Array<ScheduleOperationMode>;
};

/** A connection to a list of items. */
export type CurrentHarmonicsConnection = {
  __typename?: 'CurrentHarmonicsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CurrentHarmonicsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CurrentHarmonics>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CurrentHarmonicsEdge = {
  __typename?: 'CurrentHarmonicsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CurrentHarmonics;
};

export type CurrentHarmonicsFilterInput = {
  aggregatedInterval?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<CurrentHarmonicsFilterInput>>;
  angles?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endType?: InputMaybe<IntOperationFilterInput>;
  endTypeValue?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CurrentHarmonicsFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  scheduleOperationModes?: InputMaybe<ListFilterInputTypeOfScheduleOperationModeFilterInput>;
};

export type CurrentHarmonicsSortInput = {
  aggregatedInterval?: InputMaybe<SortEnumType>;
  angles?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endType?: InputMaybe<SortEnumType>;
  endTypeValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
};

export type CustomProperties = {
  __typename?: 'CustomProperties';
  asset: Asset;
  assetId: Scalars['Long']['output'];
  constraintType: Constraint_Type;
  dataType: Data_Type;
  defaultValue: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  jsonConstraints?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type CustomPropertiesConnection = {
  __typename?: 'CustomPropertiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomPropertiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomProperties>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomPropertiesEdge = {
  __typename?: 'CustomPropertiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomProperties;
};

export type CustomPropertiesFilterInput = {
  and?: InputMaybe<Array<CustomPropertiesFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  constraintType?: InputMaybe<Constraint_TypeOperationFilterInput>;
  dataType?: InputMaybe<Data_TypeOperationFilterInput>;
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  jsonConstraints?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomPropertiesFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type CustomPropertiesSortInput = {
  asset?: InputMaybe<AssetSortInput>;
  assetId?: InputMaybe<SortEnumType>;
  constraintType?: InputMaybe<SortEnumType>;
  dataType?: InputMaybe<SortEnumType>;
  defaultValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jsonConstraints?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export enum Data_Type {
  DateTime = 'DATE_TIME',
  Float = 'FLOAT',
  Int = 'INT',
  String = 'STRING'
}

export type Data_TypeOperationFilterInput = {
  eq?: InputMaybe<Data_Type>;
  in?: InputMaybe<Array<Data_Type>>;
  neq?: InputMaybe<Data_Type>;
  nin?: InputMaybe<Array<Data_Type>>;
};

export enum Device_Type {
  Dte = 'DTE',
  Dtvi4G = 'DTVI4G',
  Dtvi4Gpmt = 'DTVI4GPMT',
  Dtvi4Gpmt2 = 'DTVI4GPMT2',
  Dtvig = 'DTVIG',
  Dtvigpmt = 'DTVIGPMT',
  Dtvigpmt2 = 'DTVIGPMT2',
  Dtvim = 'DTVIM',
  Hvii = 'HVII',
  Ingrid90 = 'INGRID90',
  Ingrid91 = 'INGRID91',
  Ingrid92 = 'INGRID92'
}

export type Device_TypeOperationFilterInput = {
  eq?: InputMaybe<Device_Type>;
  in?: InputMaybe<Array<Device_Type>>;
  neq?: InputMaybe<Device_Type>;
  nin?: InputMaybe<Array<Device_Type>>;
};

export enum Duration_Type {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  None = 'NONE',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Duration_TypeOperationFilterInput = {
  eq?: InputMaybe<Duration_Type>;
  in?: InputMaybe<Array<Duration_Type>>;
  neq?: InputMaybe<Duration_Type>;
  nin?: InputMaybe<Array<Duration_Type>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Device = {
  __typename?: 'Device';
  acquisitionRate?: Maybe<Scalars['Int']['output']>;
  alarmLastConfigTs?: Maybe<Scalars['DateTime']['output']>;
  alarmStandard: DevicesAlarmStandard;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  alarmsConfig: Scalars['String']['output'];
  assetId?: Maybe<Scalars['Long']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  batchDevice?: Maybe<BatchDevice>;
  batchDeviceId?: Maybe<Scalars['Long']['output']>;
  bulkConfiguration?: Maybe<DeviceBulkConfiguration>;
  bulkConfigurationConfig: Scalars['String']['output'];
  bulkConfigurationId?: Maybe<Scalars['Long']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  comissionDate?: Maybe<Scalars['DateTime']['output']>;
  communicationRate?: Maybe<Scalars['Int']['output']>;
  conTestDeviceResults?: Maybe<Array<ConTestDeviceResult>>;
  configRefreshInterval: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  decomissionDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceSlot?: Maybe<Scalars['Long']['output']>;
  deviceSpecificConfig: Scalars['String']['output'];
  deviceTags: Array<DeviceTag>;
  deviceToken: Scalars['String']['output'];
  deviceType: Device_Type;
  externalReference?: Maybe<Scalars['String']['output']>;
  firmwareDeployDate?: Maybe<Scalars['DateTime']['output']>;
  firmwareTasks?: Maybe<Array<FirmwareTask>>;
  firmwareTasksLogs: Array<FirmwareTaskLog>;
  firmwareVersion: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  interfaces: Array<Interface>;
  isCommissioned: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastAddress?: Maybe<Scalars['String']['output']>;
  lastCommunication?: Maybe<Scalars['DateTime']['output']>;
  lastConfigTs?: Maybe<Scalars['DateTime']['output']>;
  lastContacts: Array<LastContactByType>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  micros: Array<Micro_Controller_Type>;
  name?: Maybe<Scalars['String']['output']>;
  ports: Array<Port>;
  serialNumber: Scalars['String']['output'];
  simCard?: Maybe<SimCard>;
  simCardId?: Maybe<Scalars['Long']['output']>;
};

export type DeviceBulkConfiguration = {
  __typename?: 'DeviceBulkConfiguration';
  aquisitionRate: Scalars['Int']['output'];
  aquisitionRateEarth: Scalars['Int']['output'];
  bluetoothTimeout: Scalars['Int']['output'];
  communicationRate: Scalars['Int']['output'];
  communicationRateEarth: Scalars['Int']['output'];
  conTests: Array<ConTest>;
  customDnsEnabled: Scalars['Boolean']['output'];
  device: Array<Device>;
  deviceTypeConfigurations: Array<DeviceTypeConfiguration>;
  dnsServerName1?: Maybe<Scalars['String']['output']>;
  dnsServerName2?: Maybe<Scalars['String']['output']>;
  emailSettings?: Maybe<EmailSettings>;
  httpCreateAlarm: Scalars['Boolean']['output'];
  httpRawData: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isDefault: Scalars['Boolean']['output'];
  maxSlots?: Maybe<Scalars['Long']['output']>;
  mqttCertificateUrl: Scalars['String']['output'];
  mqttCreateAlarm: Scalars['Boolean']['output'];
  mqttGroupId: Scalars['String']['output'];
  mqttPassword: Scalars['String']['output'];
  mqttRawData: Scalars['Boolean']['output'];
  mqttServerUrl: Scalars['String']['output'];
  mqttUsername: Scalars['String']['output'];
  name: Scalars['String']['output'];
  protectionEarthFrequencyF1: Scalars['Int']['output'];
  protectionEarthFrequencyF2: Scalars['Int']['output'];
  protectionEarthFrequencyF3: Scalars['Int']['output'];
  proxyEnabled: Scalars['Boolean']['output'];
  proxyPort?: Maybe<Scalars['Int']['output']>;
  proxyUrl?: Maybe<Scalars['String']['output']>;
  scheduleOperationModes: Array<ScheduleOperationMode>;
  serverUrl: Scalars['String']['output'];
  serviceEarthFrequencyF1: Scalars['Int']['output'];
  serviceEarthFrequencyF2: Scalars['Int']['output'];
  serviceEarthFrequencyF3: Scalars['Int']['output'];
  slotType: Slot_Type;
  timeServerPort: Scalars['Int']['output'];
  timeServerProtocol: Scalars['String']['output'];
  timeServerType: Time_Server_Type;
  timeServerUrl: Scalars['String']['output'];
};

export type DeviceBulkConfigurationFilterInput = {
  and?: InputMaybe<Array<DeviceBulkConfigurationFilterInput>>;
  aquisitionRate?: InputMaybe<IntOperationFilterInput>;
  aquisitionRateEarth?: InputMaybe<IntOperationFilterInput>;
  bluetoothTimeout?: InputMaybe<IntOperationFilterInput>;
  communicationRate?: InputMaybe<IntOperationFilterInput>;
  communicationRateEarth?: InputMaybe<IntOperationFilterInput>;
  conTests?: InputMaybe<ListFilterInputTypeOfConTestFilterInput>;
  customDnsEnabled?: InputMaybe<BooleanOperationFilterInput>;
  device?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  deviceTypeConfigurations?: InputMaybe<ListFilterInputTypeOfDeviceTypeConfigurationFilterInput>;
  dnsServerName1?: InputMaybe<StringOperationFilterInput>;
  dnsServerName2?: InputMaybe<StringOperationFilterInput>;
  emailSettings?: InputMaybe<EmailSettingsFilterInput>;
  httpCreateAlarm?: InputMaybe<BooleanOperationFilterInput>;
  httpRawData?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  maxSlots?: InputMaybe<LongOperationFilterInput>;
  mqttCertificateUrl?: InputMaybe<StringOperationFilterInput>;
  mqttCreateAlarm?: InputMaybe<BooleanOperationFilterInput>;
  mqttGroupId?: InputMaybe<StringOperationFilterInput>;
  mqttPassword?: InputMaybe<StringOperationFilterInput>;
  mqttRawData?: InputMaybe<BooleanOperationFilterInput>;
  mqttServerUrl?: InputMaybe<StringOperationFilterInput>;
  mqttUsername?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceBulkConfigurationFilterInput>>;
  protectionEarthFrequencyF1?: InputMaybe<IntOperationFilterInput>;
  protectionEarthFrequencyF2?: InputMaybe<IntOperationFilterInput>;
  protectionEarthFrequencyF3?: InputMaybe<IntOperationFilterInput>;
  proxyEnabled?: InputMaybe<BooleanOperationFilterInput>;
  proxyPort?: InputMaybe<IntOperationFilterInput>;
  proxyUrl?: InputMaybe<StringOperationFilterInput>;
  scheduleOperationModes?: InputMaybe<ListFilterInputTypeOfScheduleOperationModeFilterInput>;
  serverUrl?: InputMaybe<StringOperationFilterInput>;
  serviceEarthFrequencyF1?: InputMaybe<IntOperationFilterInput>;
  serviceEarthFrequencyF2?: InputMaybe<IntOperationFilterInput>;
  serviceEarthFrequencyF3?: InputMaybe<IntOperationFilterInput>;
  slotType?: InputMaybe<Slot_TypeOperationFilterInput>;
  timeServerPort?: InputMaybe<IntOperationFilterInput>;
  timeServerProtocol?: InputMaybe<StringOperationFilterInput>;
  timeServerType?: InputMaybe<Time_Server_TypeOperationFilterInput>;
  timeServerUrl?: InputMaybe<StringOperationFilterInput>;
};

export type DeviceBulkConfigurationSortInput = {
  aquisitionRate?: InputMaybe<SortEnumType>;
  aquisitionRateEarth?: InputMaybe<SortEnumType>;
  bluetoothTimeout?: InputMaybe<SortEnumType>;
  communicationRate?: InputMaybe<SortEnumType>;
  communicationRateEarth?: InputMaybe<SortEnumType>;
  customDnsEnabled?: InputMaybe<SortEnumType>;
  dnsServerName1?: InputMaybe<SortEnumType>;
  dnsServerName2?: InputMaybe<SortEnumType>;
  emailSettings?: InputMaybe<EmailSettingsSortInput>;
  httpCreateAlarm?: InputMaybe<SortEnumType>;
  httpRawData?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  maxSlots?: InputMaybe<SortEnumType>;
  mqttCertificateUrl?: InputMaybe<SortEnumType>;
  mqttCreateAlarm?: InputMaybe<SortEnumType>;
  mqttGroupId?: InputMaybe<SortEnumType>;
  mqttPassword?: InputMaybe<SortEnumType>;
  mqttRawData?: InputMaybe<SortEnumType>;
  mqttServerUrl?: InputMaybe<SortEnumType>;
  mqttUsername?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  protectionEarthFrequencyF1?: InputMaybe<SortEnumType>;
  protectionEarthFrequencyF2?: InputMaybe<SortEnumType>;
  protectionEarthFrequencyF3?: InputMaybe<SortEnumType>;
  proxyEnabled?: InputMaybe<SortEnumType>;
  proxyPort?: InputMaybe<SortEnumType>;
  proxyUrl?: InputMaybe<SortEnumType>;
  serverUrl?: InputMaybe<SortEnumType>;
  serviceEarthFrequencyF1?: InputMaybe<SortEnumType>;
  serviceEarthFrequencyF2?: InputMaybe<SortEnumType>;
  serviceEarthFrequencyF3?: InputMaybe<SortEnumType>;
  slotType?: InputMaybe<SortEnumType>;
  timeServerPort?: InputMaybe<SortEnumType>;
  timeServerProtocol?: InputMaybe<SortEnumType>;
  timeServerType?: InputMaybe<SortEnumType>;
  timeServerUrl?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceBulkConfigurationsConnection = {
  __typename?: 'DeviceBulkConfigurationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceBulkConfigurationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceBulkConfiguration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceBulkConfigurationsEdge = {
  __typename?: 'DeviceBulkConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceBulkConfiguration;
};

export type DeviceFilterInput = {
  acquisitionRate?: InputMaybe<IntOperationFilterInput>;
  alarmLastConfigTs?: InputMaybe<DateTimeOperationFilterInput>;
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  alarmsConfig?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<DeviceFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  assetName?: InputMaybe<StringOperationFilterInput>;
  authorizationTokens?: InputMaybe<ListFilterInputTypeOfAuthorizationTokenFilterInput>;
  batchDevice?: InputMaybe<BatchDeviceFilterInput>;
  batchDeviceId?: InputMaybe<LongOperationFilterInput>;
  bulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  bulkConfigurationConfig?: InputMaybe<StringOperationFilterInput>;
  bulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  comissionDate?: InputMaybe<DateTimeOperationFilterInput>;
  communicationRate?: InputMaybe<IntOperationFilterInput>;
  conTestDeviceResults?: InputMaybe<ListFilterInputTypeOfConTestDeviceResultFilterInput>;
  configRefreshInterval?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  decomissionDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceInputs?: InputMaybe<ListFilterInputTypeOfDeviceInputNumberFilterInput>;
  deviceSlot?: InputMaybe<LongOperationFilterInput>;
  deviceSpecificConfig?: InputMaybe<StringOperationFilterInput>;
  deviceTags?: InputMaybe<ListFilterInputTypeOfDeviceTagFilterInput>;
  deviceToken?: InputMaybe<StringOperationFilterInput>;
  deviceType?: InputMaybe<Device_TypeOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  externalReference?: InputMaybe<StringOperationFilterInput>;
  firmwareDeployDate?: InputMaybe<DateTimeOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  firmwareTasksLogs?: InputMaybe<ListFilterInputTypeOfFirmwareTaskLogFilterInput>;
  firmwareVersion?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  interfaces?: InputMaybe<ListFilterInputTypeOfInterfaceFilterInput>;
  isCommissioned?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastAddress?: InputMaybe<StringOperationFilterInput>;
  lastCommunication?: InputMaybe<DateTimeOperationFilterInput>;
  lastConfigTs?: InputMaybe<DateTimeOperationFilterInput>;
  lastContacts?: InputMaybe<ListFilterInputTypeOfLastContactByTypeFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceFilterInput>>;
  ports?: InputMaybe<ListFilterInputTypeOfPortFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  simCard?: InputMaybe<SimCardFilterInput>;
  simCardId?: InputMaybe<LongOperationFilterInput>;
};

export type DeviceInputNumberFilterInput = {
  and?: InputMaybe<Array<DeviceInputNumberFilterInput>>;
  deviceExternalId?: InputMaybe<LongOperationFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  devicePortId?: InputMaybe<LongOperationFilterInput>;
  deviceSerialNumber?: InputMaybe<StringOperationFilterInput>;
  equipmentId?: InputMaybe<LongOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  feederId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputNumber?: InputMaybe<IntOperationFilterInput>;
  inputType?: InputMaybe<Input_TypeOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  masterBusLineId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DeviceInputNumberFilterInput>>;
  portNumber?: InputMaybe<IntOperationFilterInput>;
  powerBusLineId?: InputMaybe<LongOperationFilterInput>;
  typeId?: InputMaybe<IntOperationFilterInput>;
};

export type DeviceInputNumberSortInput = {
  deviceExternalId?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  devicePortId?: InputMaybe<SortEnumType>;
  deviceSerialNumber?: InputMaybe<SortEnumType>;
  equipmentId?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  feederId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputNumber?: InputMaybe<SortEnumType>;
  inputType?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  masterBusLineId?: InputMaybe<SortEnumType>;
  portNumber?: InputMaybe<SortEnumType>;
  powerBusLineId?: InputMaybe<SortEnumType>;
  typeId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceInputNumbersConnection = {
  __typename?: 'DeviceInputNumbersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceInputNumbersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EquipmentsDeviceInputNumber>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceInputNumbersEdge = {
  __typename?: 'DeviceInputNumbersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EquipmentsDeviceInputNumber;
};

export type DeviceLog = {
  __typename?: 'DeviceLog';
  body?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['Long']['output'];
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  method?: Maybe<Scalars['String']['output']>;
  requestDate: Scalars['DateTime']['output'];
  requestType: Lastcontact_Type;
  serialNumber: Scalars['String']['output'];
  serverIp?: Maybe<Scalars['String']['output']>;
  serverPort?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type DeviceLogConnection = {
  __typename?: 'DeviceLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceLogEdge = {
  __typename?: 'DeviceLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceLog;
};

export type DeviceLogFilterInput = {
  and?: InputMaybe<Array<DeviceLogFilterInput>>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  body?: InputMaybe<StringOperationFilterInput>;
  comissionDate?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deComissionDate?: InputMaybe<DateTimeOperationFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  host?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  method?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceLogFilterInput>>;
  requestDate?: InputMaybe<DateTimeOperationFilterInput>;
  requestType?: InputMaybe<Lastcontact_TypeOperationFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  serverIp?: InputMaybe<StringOperationFilterInput>;
  serverPort?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type DeviceLogSortInput = {
  assetId?: InputMaybe<SortEnumType>;
  body?: InputMaybe<SortEnumType>;
  comissionDate?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deComissionDate?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  host?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  method?: InputMaybe<SortEnumType>;
  requestDate?: InputMaybe<SortEnumType>;
  requestType?: InputMaybe<SortEnumType>;
  serialNumber?: InputMaybe<SortEnumType>;
  serverIp?: InputMaybe<SortEnumType>;
  serverPort?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceLogsConnection = {
  __typename?: 'DeviceLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EquipmentsDeviceLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceLogsEdge = {
  __typename?: 'DeviceLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EquipmentsDeviceLog;
};

export type DeviceMessage = {
  __typename?: 'DeviceMessage';
  actionMethod: Action_Method;
  actionProto: Action_Proto;
  actionType: Action_Type;
  errorMessage: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  inputData: Scalars['String']['output'];
  result?: Maybe<Scalars['Boolean']['output']>;
  resultData: Scalars['String']['output'];
};

export type DeviceMessageFilterInput = {
  actionMethod?: InputMaybe<Action_MethodOperationFilterInput>;
  actionProto?: InputMaybe<Action_ProtoOperationFilterInput>;
  actionType?: InputMaybe<Action_TypeOperationFilterInput>;
  and?: InputMaybe<Array<DeviceMessageFilterInput>>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputData?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceMessageFilterInput>>;
  result?: InputMaybe<BooleanOperationFilterInput>;
  resultData?: InputMaybe<StringOperationFilterInput>;
};

export type DeviceMessageSortInput = {
  actionMethod?: InputMaybe<SortEnumType>;
  actionProto?: InputMaybe<SortEnumType>;
  actionType?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputData?: InputMaybe<SortEnumType>;
  result?: InputMaybe<SortEnumType>;
  resultData?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceMessagesConnection = {
  __typename?: 'DeviceMessagesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceMessagesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceMessagesEdge = {
  __typename?: 'DeviceMessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceMessage;
};

export type DeviceSortInput = {
  acquisitionRate?: InputMaybe<SortEnumType>;
  alarmLastConfigTs?: InputMaybe<SortEnumType>;
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  alarmsConfig?: InputMaybe<SortEnumType>;
  asset?: InputMaybe<AssetSortInput>;
  assetId?: InputMaybe<SortEnumType>;
  assetName?: InputMaybe<SortEnumType>;
  batchDevice?: InputMaybe<BatchDeviceSortInput>;
  batchDeviceId?: InputMaybe<SortEnumType>;
  bulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  bulkConfigurationConfig?: InputMaybe<SortEnumType>;
  bulkConfigurationId?: InputMaybe<SortEnumType>;
  clientId?: InputMaybe<SortEnumType>;
  comissionDate?: InputMaybe<SortEnumType>;
  communicationRate?: InputMaybe<SortEnumType>;
  configRefreshInterval?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  decomissionDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceSlot?: InputMaybe<SortEnumType>;
  deviceSpecificConfig?: InputMaybe<SortEnumType>;
  deviceToken?: InputMaybe<SortEnumType>;
  deviceType?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  externalReference?: InputMaybe<SortEnumType>;
  firmwareDeployDate?: InputMaybe<SortEnumType>;
  firmwareVersion?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  isCommissioned?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastAddress?: InputMaybe<SortEnumType>;
  lastCommunication?: InputMaybe<SortEnumType>;
  lastConfigTs?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  serialNumber?: InputMaybe<SortEnumType>;
  simCard?: InputMaybe<SimCardSortInput>;
  simCardId?: InputMaybe<SortEnumType>;
};

export type DeviceTag = {
  __typename?: 'DeviceTag';
  devices: Array<Device>;
  firmwareTasks: Array<FirmwareTask>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DeviceTagFilterInput = {
  and?: InputMaybe<Array<DeviceTagFilterInput>>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceTagFilterInput>>;
};

export type DeviceTypeConfiguration = {
  __typename?: 'DeviceTypeConfiguration';
  bulkConfigurationId: Scalars['Long']['output'];
  deviceBulkConfiguration: DeviceBulkConfiguration;
  deviceType: Device_Type;
  id: Scalars['Long']['output'];
};

export type DeviceTypeConfigurationFilterInput = {
  and?: InputMaybe<Array<DeviceTypeConfigurationFilterInput>>;
  bulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  deviceType?: InputMaybe<Device_TypeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DeviceTypeConfigurationFilterInput>>;
};

export type DeviceTypeConfigurationSortInput = {
  bulkConfigurationId?: InputMaybe<SortEnumType>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  deviceType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceTypeConfigurationsConnection = {
  __typename?: 'DeviceTypeConfigurationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceTypeConfigurationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceTypeConfiguration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceTypeConfigurationsEdge = {
  __typename?: 'DeviceTypeConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceTypeConfiguration;
};

export type DevicesAccessGroup = {
  __typename?: 'DevicesAccessGroup';
  externalId: Scalars['Long']['output'];
  firmwareTasks?: Maybe<Array<FirmwareTask>>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DevicesAlarmStandard = {
  __typename?: 'DevicesAlarmStandard';
  device: Array<Device>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DevicesCompany = {
  __typename?: 'DevicesCompany';
  externalId: Scalars['Long']['output'];
  firmwareTasks: Array<FirmwareTask>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type DevicesConnection = {
  __typename?: 'DevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Device>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DevicesEdge = {
  __typename?: 'DevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Device>;
};

export type DevicesFirmwareDocument = {
  __typename?: 'DevicesFirmwareDocument';
  deviceType: Device_Type;
  externalId: Scalars['Long']['output'];
  firmware: Firmware;
  id: Scalars['Long']['output'];
  microType: Micro_Controller_Type;
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type DevicesFirmwareDocumentsConnection = {
  __typename?: 'DevicesFirmwareDocumentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DevicesFirmwareDocumentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DevicesFirmwareDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DevicesFirmwareDocumentsEdge = {
  __typename?: 'DevicesFirmwareDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DevicesFirmwareDocument;
};

export type DevicesOperationalArea = {
  __typename?: 'DevicesOperationalArea';
  externalId: Scalars['Long']['output'];
  firmwareTasks: Array<FirmwareTask>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DevicesRegion = {
  __typename?: 'DevicesRegion';
  externalId: Scalars['Long']['output'];
  firmwareTasks: Array<FirmwareTask>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export enum Encryption_Type {
  Ssl = 'SSL',
  Tls = 'TLS'
}

export enum Entity_Type {
  Asset = 'ASSET',
  AssetBusbar = 'ASSET_BUSBAR',
  Device = 'DEVICE',
  Empty = 'EMPTY',
  Feeder = 'FEEDER'
}

export type Entity_TypeOperationFilterInput = {
  eq?: InputMaybe<Entity_Type>;
  in?: InputMaybe<Array<Entity_Type>>;
  neq?: InputMaybe<Entity_Type>;
  nin?: InputMaybe<Array<Entity_Type>>;
};

export enum Equipment_Type {
  BaseHvPole = 'BASE_HV_POLE',
  DeliveryPoint = 'DELIVERY_POINT',
  DistributionBox = 'DISTRIBUTION_BOX',
  HvIsolator = 'HV_ISOLATOR',
  Substation = 'SUBSTATION',
  TranformerHm = 'TRANFORMER_HM',
  TransformerMl = 'TRANSFORMER_ML'
}

export type Equipment_TypeOperationFilterInput = {
  eq?: InputMaybe<Equipment_Type>;
  in?: InputMaybe<Array<Equipment_Type>>;
  neq?: InputMaybe<Equipment_Type>;
  nin?: InputMaybe<Array<Equipment_Type>>;
};

export type Email = {
  __typename?: 'Email';
  bcc?: Maybe<Scalars['String']['output']>;
  bccName?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  bodyEncoding?: Maybe<Scalars['String']['output']>;
  bodyPlainText?: Maybe<Scalars['String']['output']>;
  bodyTransferEncoding: TransferEncoding;
  cc?: Maybe<Scalars['String']['output']>;
  ccName?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deliverDate: Scalars['DateTime']['output'];
  emailAttachments?: Maybe<Array<EmailAttachment>>;
  emailStatus?: Maybe<Array<EmailStatus>>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Scalars['String']['output']>;
  headersEncoding?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isBodyHtml: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  messageSent: Scalars['Boolean']['output'];
  receptionDate: Scalars['DateTime']['output'];
  replyToList?: Maybe<Scalars['String']['output']>;
  replyToListName?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectEncoding?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
};

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  documentManagerId: Scalars['Long']['output'];
  email?: Maybe<Email>;
  emailId: Scalars['Long']['output'];
  fileData?: Maybe<Array<Scalars['Byte']['output']>>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailAttachmentFilterInput = {
  and?: InputMaybe<Array<EmailAttachmentFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  documentManagerId?: InputMaybe<LongOperationFilterInput>;
  email?: InputMaybe<EmailFilterInput>;
  emailId?: InputMaybe<LongOperationFilterInput>;
  fileData?: InputMaybe<ListByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailAttachmentFilterInput>>;
};

export type EmailAttachmentSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  documentManagerId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<EmailSortInput>;
  emailId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EmailAttachmentsConnection = {
  __typename?: 'EmailAttachmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailAttachmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EmailAttachment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailAttachmentsEdge = {
  __typename?: 'EmailAttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EmailAttachment;
};

export type EmailFilterInput = {
  and?: InputMaybe<Array<EmailFilterInput>>;
  bcc?: InputMaybe<StringOperationFilterInput>;
  bccName?: InputMaybe<StringOperationFilterInput>;
  body?: InputMaybe<StringOperationFilterInput>;
  bodyEncoding?: InputMaybe<StringOperationFilterInput>;
  bodyPlainText?: InputMaybe<StringOperationFilterInput>;
  bodyTransferEncoding?: InputMaybe<TransferEncodingOperationFilterInput>;
  cc?: InputMaybe<StringOperationFilterInput>;
  ccName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deliverDate?: InputMaybe<DateTimeOperationFilterInput>;
  emailAttachments?: InputMaybe<ListFilterInputTypeOfEmailAttachmentFilterInput>;
  emailStatus?: InputMaybe<ListFilterInputTypeOfEmailStatusFilterInput>;
  errorMsg?: InputMaybe<StringOperationFilterInput>;
  from?: InputMaybe<StringOperationFilterInput>;
  fromName?: InputMaybe<StringOperationFilterInput>;
  headers?: InputMaybe<StringOperationFilterInput>;
  headersEncoding?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isBodyHtml?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  messageSent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<EmailFilterInput>>;
  receptionDate?: InputMaybe<DateTimeOperationFilterInput>;
  replyToList?: InputMaybe<StringOperationFilterInput>;
  replyToListName?: InputMaybe<StringOperationFilterInput>;
  sender?: InputMaybe<StringOperationFilterInput>;
  senderName?: InputMaybe<StringOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  subjectEncoding?: InputMaybe<StringOperationFilterInput>;
  to?: InputMaybe<StringOperationFilterInput>;
  toName?: InputMaybe<StringOperationFilterInput>;
};

export type EmailSettings = {
  __typename?: 'EmailSettings';
  checkIntervalEmail?: Maybe<Scalars['Int']['output']>;
  deviceBulkConfiguration?: Maybe<DeviceBulkConfiguration>;
  deviceBulkConfigurationId?: Maybe<Scalars['Long']['output']>;
  emailBodyExpression?: Maybe<Scalars['String']['output']>;
  emailEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailPassword?: Maybe<Array<Scalars['Byte']['output']>>;
  emailServerType?: Maybe<Server_Type>;
  emailServerUrl?: Maybe<Scalars['String']['output']>;
  emailSubjectExpression?: Maybe<Scalars['String']['output']>;
  emailUsername?: Maybe<Scalars['String']['output']>;
  encryptionType?: Maybe<Encryption_Type>;
  id: Scalars['Long']['output'];
  maxChecksEmail?: Maybe<Scalars['Int']['output']>;
  serverEmailPort?: Maybe<Scalars['Int']['output']>;
};

export type EmailSettingsFilterInput = {
  and?: InputMaybe<Array<EmailSettingsFilterInput>>;
  checkIntervalEmail?: InputMaybe<IntOperationFilterInput>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  deviceBulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  emailBodyExpression?: InputMaybe<StringOperationFilterInput>;
  emailEnabled?: InputMaybe<BooleanOperationFilterInput>;
  emailPassword?: InputMaybe<ListByteOperationFilterInput>;
  emailServerType?: InputMaybe<NullableOfServer_TypeOperationFilterInput>;
  emailServerUrl?: InputMaybe<StringOperationFilterInput>;
  emailSubjectExpression?: InputMaybe<StringOperationFilterInput>;
  emailUsername?: InputMaybe<StringOperationFilterInput>;
  encryptionType?: InputMaybe<NullableOfEncryption_TypeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  maxChecksEmail?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EmailSettingsFilterInput>>;
  serverEmailPort?: InputMaybe<IntOperationFilterInput>;
};

export type EmailSettingsSortInput = {
  checkIntervalEmail?: InputMaybe<SortEnumType>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  deviceBulkConfigurationId?: InputMaybe<SortEnumType>;
  emailBodyExpression?: InputMaybe<SortEnumType>;
  emailEnabled?: InputMaybe<SortEnumType>;
  emailServerType?: InputMaybe<SortEnumType>;
  emailServerUrl?: InputMaybe<SortEnumType>;
  emailSubjectExpression?: InputMaybe<SortEnumType>;
  emailUsername?: InputMaybe<SortEnumType>;
  encryptionType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxChecksEmail?: InputMaybe<SortEnumType>;
  serverEmailPort?: InputMaybe<SortEnumType>;
};

export type EmailSortInput = {
  bcc?: InputMaybe<SortEnumType>;
  bccName?: InputMaybe<SortEnumType>;
  body?: InputMaybe<SortEnumType>;
  bodyEncoding?: InputMaybe<SortEnumType>;
  bodyPlainText?: InputMaybe<SortEnumType>;
  bodyTransferEncoding?: InputMaybe<SortEnumType>;
  cc?: InputMaybe<SortEnumType>;
  ccName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deliverDate?: InputMaybe<SortEnumType>;
  errorMsg?: InputMaybe<SortEnumType>;
  from?: InputMaybe<SortEnumType>;
  fromName?: InputMaybe<SortEnumType>;
  headers?: InputMaybe<SortEnumType>;
  headersEncoding?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isBodyHtml?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  messageSent?: InputMaybe<SortEnumType>;
  receptionDate?: InputMaybe<SortEnumType>;
  replyToList?: InputMaybe<SortEnumType>;
  replyToListName?: InputMaybe<SortEnumType>;
  sender?: InputMaybe<SortEnumType>;
  senderName?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SortEnumType>;
  subjectEncoding?: InputMaybe<SortEnumType>;
  to?: InputMaybe<SortEnumType>;
  toName?: InputMaybe<SortEnumType>;
};

export type EmailStatus = {
  __typename?: 'EmailStatus';
  appNoteId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deliverDate: Scalars['DateTime']['output'];
  email?: Maybe<Email>;
  emailId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  messageSent: Scalars['Boolean']['output'];
  receptionDate: Scalars['DateTime']['output'];
  smsId?: Maybe<Scalars['Long']['output']>;
  status: Status;
  statusMessage?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['Long']['output']>;
};

/** A connection to a list of items. */
export type EmailStatusConnection = {
  __typename?: 'EmailStatusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailStatusEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EmailStatus>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailStatusEdge = {
  __typename?: 'EmailStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EmailStatus;
};

export type EmailStatusFilterInput = {
  and?: InputMaybe<Array<EmailStatusFilterInput>>;
  appNoteId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deliverDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<EmailFilterInput>;
  emailId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  messageSent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<EmailStatusFilterInput>>;
  receptionDate?: InputMaybe<DateTimeOperationFilterInput>;
  smsId?: InputMaybe<LongOperationFilterInput>;
  status?: InputMaybe<StatusOperationFilterInput>;
  statusMessage?: InputMaybe<StringOperationFilterInput>;
  webhookId?: InputMaybe<LongOperationFilterInput>;
};

export type EmailStatusSortInput = {
  appNoteId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deliverDate?: InputMaybe<SortEnumType>;
  email?: InputMaybe<EmailSortInput>;
  emailId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  messageSent?: InputMaybe<SortEnumType>;
  receptionDate?: InputMaybe<SortEnumType>;
  smsId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusMessage?: InputMaybe<SortEnumType>;
  webhookId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EmailsConnection = {
  __typename?: 'EmailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Email>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailsEdge = {
  __typename?: 'EmailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Email;
};

export type EnergyBalance = {
  __typename?: 'EnergyBalance';
  aggregatedInterval: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endType: Scalars['Int']['output'];
  endTypeValue: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  scheduleOperationModes: Array<ScheduleOperationMode>;
};

/** A connection to a list of items. */
export type EnergyBalanceConnection = {
  __typename?: 'EnergyBalanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EnergyBalanceEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EnergyBalance>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnergyBalanceEdge = {
  __typename?: 'EnergyBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EnergyBalance;
};

export type EnergyBalanceFilterInput = {
  aggregatedInterval?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<EnergyBalanceFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endType?: InputMaybe<IntOperationFilterInput>;
  endTypeValue?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnergyBalanceFilterInput>>;
  scheduleOperationModes?: InputMaybe<ListFilterInputTypeOfScheduleOperationModeFilterInput>;
};

export type EnergyBalanceSortInput = {
  aggregatedInterval?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endType?: InputMaybe<SortEnumType>;
  endTypeValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Enterprise = {
  __typename?: 'Enterprise';
  accessGroups: Array<AccessGroup>;
  companies: Array<Company>;
  description: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type EnterpriseFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<EnterpriseFilterInput>>;
  companies?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnterpriseFilterInput>>;
};

export type EnterpriseSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EnterprisesConnection = {
  __typename?: 'EnterprisesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EnterprisesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Enterprise>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterprisesEdge = {
  __typename?: 'EnterprisesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Enterprise>;
};

export type EquipBulkConfigurationFilterInput = {
  and?: InputMaybe<Array<EquipBulkConfigurationFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EquipBulkConfigurationFilterInput>>;
};

export type EquipBulkConfigurationSortInput = {
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Equipment = {
  __typename?: 'Equipment';
  anchorType?: Maybe<Anchor_Type>;
  asset?: Maybe<Asset>;
  assetId?: Maybe<Scalars['Long']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  connectionType?: Maybe<Connection_Type>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  equipmentType: Equipment_Type;
  feederName?: Maybe<Scalars['String']['output']>;
  feeders?: Maybe<Array<Feeder>>;
  id: Scalars['Long']['output'];
  inputType?: Maybe<Input_Type>;
  installationType?: Maybe<Installation_Type>;
  interbarTransformer?: Maybe<Equipment>;
  interbarTransformerId?: Maybe<Scalars['Long']['output']>;
  interbarTransformers?: Maybe<Array<Equipment>>;
  isMainDeviceConnected?: Maybe<Scalars['Boolean']['output']>;
  isMainTransformer: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  manufactureDate?: Maybe<Scalars['DateTime']['output']>;
  masterBusLines?: Maybe<Array<Line>>;
  materialType?: Maybe<Material_Type>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentAsset?: Maybe<Asset>;
  parentAssetId?: Maybe<Scalars['Long']['output']>;
  parentFeeder?: Maybe<Feeder>;
  parentFeederId?: Maybe<Scalars['Long']['output']>;
  phaseRotation: Phase_Rotation;
  phaseType: Phase_Type;
  power: Scalars['Int']['output'];
  serviceEntryDate?: Maybe<Scalars['DateTime']['output']>;
  transformerType: Transformer_Type;
};

export type EquipmentFilterInput = {
  anchorType?: InputMaybe<NullableOfAnchor_TypeOperationFilterInput>;
  and?: InputMaybe<Array<EquipmentFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  brand?: InputMaybe<StringOperationFilterInput>;
  connectionType?: InputMaybe<NullableOfConnection_TypeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  enable?: InputMaybe<BooleanOperationFilterInput>;
  equipmentType?: InputMaybe<Equipment_TypeOperationFilterInput>;
  feederName?: InputMaybe<StringOperationFilterInput>;
  feeders?: InputMaybe<ListFilterInputTypeOfFeederFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputType?: InputMaybe<NullableOfInput_TypeOperationFilterInput>;
  installationType?: InputMaybe<NullableOfInstallation_TypeOperationFilterInput>;
  interbarTransformer?: InputMaybe<EquipmentFilterInput>;
  interbarTransformerId?: InputMaybe<LongOperationFilterInput>;
  interbarTransformers?: InputMaybe<ListFilterInputTypeOfEquipmentFilterInput>;
  isMainDeviceConnected?: InputMaybe<BooleanOperationFilterInput>;
  isMainTransformer?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  manufactureDate?: InputMaybe<DateTimeOperationFilterInput>;
  masterBusLines?: InputMaybe<ListFilterInputTypeOfLineFilterInput>;
  materialType?: InputMaybe<NullableOfMaterial_TypeOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EquipmentFilterInput>>;
  parentAsset?: InputMaybe<AssetFilterInput>;
  parentAssetId?: InputMaybe<LongOperationFilterInput>;
  parentFeeder?: InputMaybe<FeederFilterInput>;
  parentFeederId?: InputMaybe<LongOperationFilterInput>;
  phaseRotation?: InputMaybe<Phase_RotationOperationFilterInput>;
  phaseType?: InputMaybe<Phase_TypeOperationFilterInput>;
  power?: InputMaybe<IntOperationFilterInput>;
  serviceEntryDate?: InputMaybe<DateTimeOperationFilterInput>;
  transformerType?: InputMaybe<Transformer_TypeOperationFilterInput>;
};

export type EquipmentSortInput = {
  anchorType?: InputMaybe<SortEnumType>;
  asset?: InputMaybe<AssetSortInput>;
  assetId?: InputMaybe<SortEnumType>;
  brand?: InputMaybe<SortEnumType>;
  connectionType?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  enable?: InputMaybe<SortEnumType>;
  equipmentType?: InputMaybe<SortEnumType>;
  feederName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputType?: InputMaybe<SortEnumType>;
  installationType?: InputMaybe<SortEnumType>;
  interbarTransformer?: InputMaybe<EquipmentSortInput>;
  interbarTransformerId?: InputMaybe<SortEnumType>;
  isMainDeviceConnected?: InputMaybe<SortEnumType>;
  isMainTransformer?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  manufactureDate?: InputMaybe<SortEnumType>;
  materialType?: InputMaybe<SortEnumType>;
  model?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentAsset?: InputMaybe<AssetSortInput>;
  parentAssetId?: InputMaybe<SortEnumType>;
  parentFeeder?: InputMaybe<FeederSortInput>;
  parentFeederId?: InputMaybe<SortEnumType>;
  phaseRotation?: InputMaybe<SortEnumType>;
  phaseType?: InputMaybe<SortEnumType>;
  power?: InputMaybe<SortEnumType>;
  serviceEntryDate?: InputMaybe<SortEnumType>;
  transformerType?: InputMaybe<SortEnumType>;
};

export type EquipmentsAlarmStandard = {
  __typename?: 'EquipmentsAlarmStandard';
  assets: Array<Asset>;
  editable: Scalars['Boolean']['output'];
  externalId: Scalars['Long']['output'];
  feeders: Array<Feeder>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type EquipmentsBulkConfiguration = {
  __typename?: 'EquipmentsBulkConfiguration';
  assets: Array<Asset>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type EquipmentsConnection = {
  __typename?: 'EquipmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EquipmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Equipment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type EquipmentsDevice = {
  __typename?: 'EquipmentsDevice';
  asset: Asset;
  assetId: Scalars['Long']['output'];
  createdDate: Scalars['DateTime']['output'];
  deviceInputs: Array<EquipmentsDeviceInputNumber>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  serialNumber: Scalars['String']['output'];
};

export type EquipmentsDeviceInputNumber = {
  __typename?: 'EquipmentsDeviceInputNumber';
  deviceExternalId: Scalars['Long']['output'];
  deviceId: Scalars['Long']['output'];
  devicePortId?: Maybe<Scalars['Long']['output']>;
  deviceSerialNumber: Scalars['String']['output'];
  equipmentId?: Maybe<Scalars['Long']['output']>;
  externalId: Scalars['Long']['output'];
  feederId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  inputNumber: Scalars['Int']['output'];
  inputType: Input_Type;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  masterBusLineId?: Maybe<Scalars['Long']['output']>;
  portNumber: Scalars['Int']['output'];
  powerBusLineId?: Maybe<Scalars['Long']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type EquipmentsDeviceLog = {
  __typename?: 'EquipmentsDeviceLog';
  assetId: Scalars['Long']['output'];
  comissionDate: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deComissionDate: Scalars['DateTime']['output'];
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  serialNumber: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type EquipmentsDevicesConnection = {
  __typename?: 'EquipmentsDevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EquipmentsDevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EquipmentsDevice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EquipmentsDevicesEdge = {
  __typename?: 'EquipmentsDevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EquipmentsDevice;
};

/** An edge in a connection. */
export type EquipmentsEdge = {
  __typename?: 'EquipmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Equipment;
};

export type EquipmentsOperationalArea = {
  __typename?: 'EquipmentsOperationalArea';
  assets: Array<Asset>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type EquipmentsRegion = {
  __typename?: 'EquipmentsRegion';
  assets: Array<Asset>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  assetId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deviceEventId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['Long']['output']>;
  deviceSerial?: Maybe<Scalars['String']['output']>;
  deviceStatus?: Maybe<EventDataStatus>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  entityType: EventEntityType;
  equipmentId?: Maybe<Scalars['Long']['output']>;
  eventData: Array<EventData>;
  feederId?: Maybe<Scalars['Long']['output']>;
  feederName?: Maybe<Scalars['String']['output']>;
  fuseRating?: Maybe<Scalars['Float']['output']>;
  fuseWay?: Maybe<Scalars['Float']['output']>;
  hasWFC: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  line?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  portNumber?: Maybe<Scalars['Int']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  severity: EventSeverity;
  source: Source;
  sourceEntityType: Entity_Type;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: EventStatus;
  type: EventType;
};

export type EventData = {
  __typename?: 'EventData';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  delta_T?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceStatus?: Maybe<EventDataStatus>;
  event: Event;
  eventId: Scalars['Long']['output'];
  iavg?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Long']['output'];
  imax?: Maybe<Scalars['Int']['output']>;
  imin?: Maybe<Scalars['Int']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  status: EventStatus;
  timeStamp?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type EventDataConnection = {
  __typename?: 'EventDataConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventDataEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EventData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventDataEdge = {
  __typename?: 'EventDataEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EventData;
};

export type EventDataFilterInput = {
  and?: InputMaybe<Array<EventDataFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  data?: InputMaybe<StringOperationFilterInput>;
  delta_T?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceStatus?: InputMaybe<NullableOfEventDataStatusOperationFilterInput>;
  event?: InputMaybe<EventFilterInput>;
  eventId?: InputMaybe<LongOperationFilterInput>;
  iavg?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  imax?: InputMaybe<IntOperationFilterInput>;
  imin?: InputMaybe<IntOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventDataFilterInput>>;
  ratio?: InputMaybe<FloatOperationFilterInput>;
  status?: InputMaybe<EventStatusOperationFilterInput>;
  timeStamp?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EventDataSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  data?: InputMaybe<SortEnumType>;
  delta_T?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceStatus?: InputMaybe<SortEnumType>;
  event?: InputMaybe<EventSortInput>;
  eventId?: InputMaybe<SortEnumType>;
  iavg?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imax?: InputMaybe<SortEnumType>;
  imin?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  ratio?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  timeStamp?: InputMaybe<SortEnumType>;
};

export enum EventDataStatus {
  Resolved = 'RESOLVED',
  Unresolved = 'UNRESOLVED'
}

export enum EventEntityType {
  Asset = 'ASSET',
  AssetHv = 'ASSET_HV',
  AssetHvFeeder = 'ASSET_HV_FEEDER',
  AssetLvBusbar = 'ASSET_LV_BUSBAR',
  AssetLvFeeder = 'ASSET_LV_FEEDER',
  AssetLvLine = 'ASSET_LV_LINE',
  Device = 'DEVICE',
  Empty = 'EMPTY',
  Grid = 'GRID'
}

export type EventEntityTypeOperationFilterInput = {
  eq?: InputMaybe<EventEntityType>;
  in?: InputMaybe<Array<EventEntityType>>;
  neq?: InputMaybe<EventEntityType>;
  nin?: InputMaybe<Array<EventEntityType>>;
};

export type EventFilterInput = {
  and?: InputMaybe<Array<EventFilterInput>>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deviceEventId?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  deviceSerial?: InputMaybe<StringOperationFilterInput>;
  deviceStatus?: InputMaybe<NullableOfEventDataStatusOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  entityType?: InputMaybe<EventEntityTypeOperationFilterInput>;
  equipmentId?: InputMaybe<LongOperationFilterInput>;
  eventData?: InputMaybe<ListFilterInputTypeOfEventDataFilterInput>;
  feederId?: InputMaybe<LongOperationFilterInput>;
  feederName?: InputMaybe<StringOperationFilterInput>;
  fuseRating?: InputMaybe<FloatOperationFilterInput>;
  fuseWay?: InputMaybe<FloatOperationFilterInput>;
  hasWFC?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  line?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventFilterInput>>;
  portNumber?: InputMaybe<IntOperationFilterInput>;
  registrationNumber?: InputMaybe<StringOperationFilterInput>;
  severity?: InputMaybe<EventSeverityOperationFilterInput>;
  source?: InputMaybe<SourceOperationFilterInput>;
  sourceEntityType?: InputMaybe<Entity_TypeOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<EventStatusOperationFilterInput>;
  type?: InputMaybe<EventTypeOperationFilterInput>;
};

export enum EventSeverity {
  Critical = 'CRITICAL',
  Empty = 'EMPTY',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type EventSeverityOperationFilterInput = {
  eq?: InputMaybe<EventSeverity>;
  in?: InputMaybe<Array<EventSeverity>>;
  neq?: InputMaybe<EventSeverity>;
  nin?: InputMaybe<Array<EventSeverity>>;
};

export type EventSortInput = {
  assetId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deviceEventId?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  deviceSerial?: InputMaybe<SortEnumType>;
  deviceStatus?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  equipmentId?: InputMaybe<SortEnumType>;
  feederId?: InputMaybe<SortEnumType>;
  feederName?: InputMaybe<SortEnumType>;
  fuseRating?: InputMaybe<SortEnumType>;
  fuseWay?: InputMaybe<SortEnumType>;
  hasWFC?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  line?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  portNumber?: InputMaybe<SortEnumType>;
  registrationNumber?: InputMaybe<SortEnumType>;
  severity?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  sourceEntityType?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum EventStatus {
  Acknowledge = 'ACKNOWLEDGE',
  Empty = 'EMPTY',
  Presist = 'PRESIST',
  Resolved = 'RESOLVED',
  Resolving = 'RESOLVING',
  Unresolved = 'UNRESOLVED'
}

export type EventStatusOperationFilterInput = {
  eq?: InputMaybe<EventStatus>;
  in?: InputMaybe<Array<EventStatus>>;
  neq?: InputMaybe<EventStatus>;
  nin?: InputMaybe<Array<EventStatus>>;
};

export enum EventType {
  BrokenNeutral = 'BROKEN_NEUTRAL',
  BusbarLineNullVoltage = 'BUSBAR_LINE_NULL_VOLTAGE',
  BusbarNeutralOpenCircuit = 'BUSBAR_NEUTRAL_OPEN_CIRCUIT',
  BusbarOverloadAgg = 'BUSBAR_OVERLOAD_AGG',
  BusbarOverVoltage = 'BUSBAR_OVER_VOLTAGE',
  BusbarOverVoltageAgg = 'BUSBAR_OVER_VOLTAGE_AGG',
  BusbarUnderVoltage = 'BUSBAR_UNDER_VOLTAGE',
  BusbarUnderVoltageAgg = 'BUSBAR_UNDER_VOLTAGE_AGG',
  DevicePowerFail = 'DEVICE_POWER_FAIL',
  DeviceReport = 'DEVICE_REPORT',
  DeviceWithoutCommunications = 'DEVICE_WITHOUT_COMMUNICATIONS',
  Dip = 'DIP',
  Empty = 'EMPTY',
  FeederLineCurrentLevel = 'FEEDER_LINE_CURRENT_LEVEL',
  FeederLineCurrentLevelOptimization = 'FEEDER_LINE_CURRENT_LEVEL_OPTIMIZATION',
  FeederLineFuseBlown = 'FEEDER_LINE_FUSE_BLOWN',
  FeederLineNullCurrent = 'FEEDER_LINE_NULL_CURRENT',
  FeederLineOvercurrent = 'FEEDER_LINE_OVERCURRENT',
  FeederLineOverloadAgg = 'FEEDER_LINE_OVERLOAD_AGG',
  FeederLinePreFault = 'FEEDER_LINE_PRE_FAULT',
  FeederLineReversePowerAgg = 'FEEDER_LINE_REVERSE_POWER_AGG',
  FeederNeutralCurrentLevel = 'FEEDER_NEUTRAL_CURRENT_LEVEL',
  FeederNeutralOvercurrentAgg = 'FEEDER_NEUTRAL_OVERCURRENT_AGG',
  HvLineDown = 'HV_LINE_DOWN',
  HvPhaseLoss = 'HV_PHASE_LOSS',
  InstallReactivePowerCheck = 'INSTALL_REACTIVE_POWER_CHECK',
  InstallReversePowerCheck = 'INSTALL_REVERSE_POWER_CHECK',
  InstallVoltageCheck = 'INSTALL_VOLTAGE_CHECK',
  NewHvLineDown = 'NEW_HV_LINE_DOWN',
  PlatformFeederLineNullCurrent = 'PLATFORM_FEEDER_LINE_NULL_CURRENT',
  Rvc = 'RVC',
  SdsEarthingVoltageLevel = 'SDS_EARTHING_VOLTAGE_LEVEL',
  SdsMvDeadSection = 'SDS_MV_DEAD_SECTION',
  SdsMvDeadSectionVect = 'SDS_MV_DEAD_SECTION_VECT',
  SdsProtectiveEarthLevel = 'SDS_PROTECTIVE_EARTH_LEVEL',
  SdsVoltageFreqViolation = 'SDS_VOLTAGE_FREQ_VIOLATION',
  SdsVoltagePhaseUnbalance = 'SDS_VOLTAGE_PHASE_UNBALANCE',
  SdsVoltageUnbalance = 'SDS_VOLTAGE_UNBALANCE',
  SdsVoltageViolation = 'SDS_VOLTAGE_VIOLATION',
  Swell = 'SWELL',
  Uint = 'UINT',
  Wfc = 'WFC'
}

export type EventTypeOperationFilterInput = {
  eq?: InputMaybe<EventType>;
  in?: InputMaybe<Array<EventType>>;
  neq?: InputMaybe<EventType>;
  nin?: InputMaybe<Array<EventType>>;
};

/** A connection to a list of items. */
export type EventsConnection = {
  __typename?: 'EventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Event>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventsEdge = {
  __typename?: 'EventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Event;
};

export enum ExpirationType {
  Month = 'MONTH',
  Never = 'NEVER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ExpirationTypeOperationFilterInput = {
  eq?: InputMaybe<ExpirationType>;
  in?: InputMaybe<Array<ExpirationType>>;
  neq?: InputMaybe<ExpirationType>;
  nin?: InputMaybe<Array<ExpirationType>>;
};

export enum Feeder_Type {
  Busbar = 'BUSBAR',
  EarthProtectionLine = 'EARTH_PROTECTION_LINE',
  EarthServiceLine = 'EARTH_SERVICE_LINE',
  HvFeeder = 'HV_FEEDER',
  NeutralLine = 'NEUTRAL_LINE',
  NotDefined = 'NOT_DEFINED',
  Powerbusline = 'POWERBUSLINE'
}

export type Feeder_TypeOperationFilterInput = {
  eq?: InputMaybe<Feeder_Type>;
  in?: InputMaybe<Array<Feeder_Type>>;
  neq?: InputMaybe<Feeder_Type>;
  nin?: InputMaybe<Array<Feeder_Type>>;
};

export enum Firmware_Task_Status {
  Canceled = 'CANCELED',
  Done = 'DONE',
  Error = 'ERROR',
  Updating = 'UPDATING'
}

export type Firmware_Task_StatusOperationFilterInput = {
  eq?: InputMaybe<Firmware_Task_Status>;
  in?: InputMaybe<Array<Firmware_Task_Status>>;
  neq?: InputMaybe<Firmware_Task_Status>;
  nin?: InputMaybe<Array<Firmware_Task_Status>>;
};

export type FederatedIdentity = {
  __typename?: 'FederatedIdentity';
  identityProvider?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type FederatedIdentityFilterInput = {
  and?: InputMaybe<Array<FederatedIdentityFilterInput>>;
  identityProvider?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FederatedIdentityFilterInput>>;
  userId?: InputMaybe<StringOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type Feeder = {
  __typename?: 'Feeder';
  alarmStandard: EquipmentsAlarmStandard;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  assetId: Scalars['Long']['output'];
  cableType: CableType;
  cableTypeId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  equipmentId: Scalars['Long']['output'];
  feederType: Feeder_Type;
  fuseRating: Scalars['Float']['output'];
  hasData?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  isActive: Scalars['Boolean']['output'];
  isCommissioned: Scalars['Boolean']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  lines: Array<Line>;
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  parentEquipments?: Maybe<Array<Equipment>>;
};

export type FeederFilterInput = {
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<FeederFilterInput>>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  cableType?: InputMaybe<CableTypeFilterInput>;
  cableTypeId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  equipmentId?: InputMaybe<LongOperationFilterInput>;
  feederType?: InputMaybe<Feeder_TypeOperationFilterInput>;
  fuseRating?: InputMaybe<FloatOperationFilterInput>;
  hasData?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isCommissioned?: InputMaybe<BooleanOperationFilterInput>;
  isReadOnly?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lines?: InputMaybe<ListFilterInputTypeOfLineFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FeederFilterInput>>;
  parentEquipments?: InputMaybe<ListFilterInputTypeOfEquipmentFilterInput>;
};

export type FeederSortInput = {
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  assetId?: InputMaybe<SortEnumType>;
  cableType?: InputMaybe<CableTypeSortInput>;
  cableTypeId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  equipmentId?: InputMaybe<SortEnumType>;
  feederType?: InputMaybe<SortEnumType>;
  fuseRating?: InputMaybe<SortEnumType>;
  hasData?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isCommissioned?: InputMaybe<SortEnumType>;
  isReadOnly?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FeedersConnection = {
  __typename?: 'FeedersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FeedersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Feeder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FeedersEdge = {
  __typename?: 'FeedersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Feeder;
};

export type Filter = {
  __typename?: 'Filter';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  joinOperator: Join_Operator;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  operator: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['Long']['output']>;
  value: Scalars['String']['output'];
};

export type FilterFilterInput = {
  and?: InputMaybe<Array<FilterFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  joinOperator?: InputMaybe<Join_OperatorOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  operator?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FilterFilterInput>>;
  propertyName?: InputMaybe<StringOperationFilterInput>;
  subscription?: InputMaybe<SubscriptionFilterInput>;
  subscriptionId?: InputMaybe<LongOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type Firmware = {
  __typename?: 'Firmware';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  firmwareDocument: DevicesFirmwareDocument;
  firmwareDocumentId: Scalars['Long']['output'];
  firmwareTasks?: Maybe<Array<FirmwareTask>>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type FirmwareDocumentFilterInput = {
  and?: InputMaybe<Array<FirmwareDocumentFilterInput>>;
  deviceType?: InputMaybe<Device_TypeOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmware?: InputMaybe<FirmwareFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  microType?: InputMaybe<Micro_Controller_TypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareDocumentFilterInput>>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type FirmwareDocumentSortInput = {
  deviceType?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  firmware?: InputMaybe<FirmwareSortInput>;
  id?: InputMaybe<SortEnumType>;
  microType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type FirmwareFilterInput = {
  and?: InputMaybe<Array<FirmwareFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  firmwareDocument?: InputMaybe<FirmwareDocumentFilterInput>;
  firmwareDocumentId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareFilterInput>>;
};

export type FirmwareSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  firmwareDocument?: InputMaybe<FirmwareDocumentSortInput>;
  firmwareDocumentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type FirmwareTask = {
  __typename?: 'FirmwareTask';
  accessGroups?: Maybe<Array<DevicesAccessGroup>>;
  cancelDate?: Maybe<Scalars['DateTime']['output']>;
  companies?: Maybe<Array<DevicesCompany>>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deviceTags?: Maybe<Array<DeviceTag>>;
  devices?: Maybe<Array<Device>>;
  downloadAttempts: Scalars['Int']['output'];
  firmware: Firmware;
  firmwareId: Scalars['Long']['output'];
  firmwareTaskLogs?: Maybe<Array<FirmwareTaskLog>>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  operationalAreas?: Maybe<Array<DevicesOperationalArea>>;
  processed: Scalars['Boolean']['output'];
  processedDate?: Maybe<Scalars['DateTime']['output']>;
  regions?: Maybe<Array<DevicesRegion>>;
  scheduleDate: Scalars['DateTime']['output'];
  taskName: Scalars['String']['output'];
};

export type FirmwareTaskFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<FirmwareTaskFilterInput>>;
  cancelDate?: InputMaybe<DateTimeOperationFilterInput>;
  companies?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deviceTags?: InputMaybe<ListFilterInputTypeOfDeviceTagFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  downloadAttempts?: InputMaybe<IntOperationFilterInput>;
  firmware?: InputMaybe<FirmwareFilterInput>;
  firmwareId?: InputMaybe<LongOperationFilterInput>;
  firmwareTaskLogs?: InputMaybe<ListFilterInputTypeOfFirmwareTaskLogFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  operationalAreas?: InputMaybe<ListFilterInputTypeOfOperationalAreaFilterInput>;
  or?: InputMaybe<Array<FirmwareTaskFilterInput>>;
  processed?: InputMaybe<BooleanOperationFilterInput>;
  processedDate?: InputMaybe<DateTimeOperationFilterInput>;
  regions?: InputMaybe<ListFilterInputTypeOfRegionFilterInput>;
  scheduleDate?: InputMaybe<DateTimeOperationFilterInput>;
  taskName?: InputMaybe<StringOperationFilterInput>;
};

export type FirmwareTaskLog = {
  __typename?: 'FirmwareTaskLog';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  currentBlock: Scalars['Int']['output'];
  currentVersion: Scalars['String']['output'];
  device: Device;
  deviceId: Scalars['Long']['output'];
  downloadAttempts: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firmwareTask: FirmwareTask;
  firmwareTaskId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  numberBlocks: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Firmware_Task_Status;
  taskLog: Scalars['String']['output'];
  updatedVersion: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type FirmwareTaskLogConnection = {
  __typename?: 'FirmwareTaskLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwareTaskLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmwareTaskLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FirmwareTaskLogEdge = {
  __typename?: 'FirmwareTaskLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FirmwareTaskLog;
};

export type FirmwareTaskLogFilterInput = {
  and?: InputMaybe<Array<FirmwareTaskLogFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  currentBlock?: InputMaybe<IntOperationFilterInput>;
  currentVersion?: InputMaybe<StringOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  downloadAttempts?: InputMaybe<IntOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  firmwareTask?: InputMaybe<FirmwareTaskFilterInput>;
  firmwareTaskId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  numberBlocks?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareTaskLogFilterInput>>;
  progress?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<Firmware_Task_StatusOperationFilterInput>;
  taskLog?: InputMaybe<StringOperationFilterInput>;
  updatedVersion?: InputMaybe<StringOperationFilterInput>;
};

export type FirmwareTaskLogSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  currentBlock?: InputMaybe<SortEnumType>;
  currentVersion?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  downloadAttempts?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  firmwareTask?: InputMaybe<FirmwareTaskSortInput>;
  firmwareTaskId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  numberBlocks?: InputMaybe<SortEnumType>;
  progress?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskLog?: InputMaybe<SortEnumType>;
  updatedVersion?: InputMaybe<SortEnumType>;
};

export type FirmwareTaskSortInput = {
  cancelDate?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  downloadAttempts?: InputMaybe<SortEnumType>;
  firmware?: InputMaybe<FirmwareSortInput>;
  firmwareId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  processed?: InputMaybe<SortEnumType>;
  processedDate?: InputMaybe<SortEnumType>;
  scheduleDate?: InputMaybe<SortEnumType>;
  taskName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FirmwareTasksConnection = {
  __typename?: 'FirmwareTasksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwareTasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmwareTask>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FirmwareTasksEdge = {
  __typename?: 'FirmwareTasksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FirmwareTask;
};

/** A connection to a list of items. */
export type FirmwaresConnection = {
  __typename?: 'FirmwaresConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwaresEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Firmware>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FirmwaresEdge = {
  __typename?: 'FirmwaresEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Firmware;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type GeneralSettings = {
  __typename?: 'GeneralSettings';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  groupName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  settings: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GpsPoint = {
  __typename?: 'GpsPoint';
  asset?: Maybe<LayoutEquipment>;
  assetId?: Maybe<Scalars['Long']['output']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Long']['output']>;
  designOrder: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  operationalArea?: Maybe<OperationalArea>;
  operationalAreaId?: Maybe<Scalars['Long']['output']>;
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['Long']['output']>;
};

export type GpsPointFilterInput = {
  and?: InputMaybe<Array<GpsPointFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<LongOperationFilterInput>;
  designOrder?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  operationalArea?: InputMaybe<OperationalAreaFilterInput>;
  operationalAreaId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<GpsPointFilterInput>>;
  region?: InputMaybe<RegionFilterInput>;
  regionId?: InputMaybe<LongOperationFilterInput>;
};

export type GpsPointSortInput = {
  asset?: InputMaybe<AssetSortInput>;
  assetId?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  designOrder?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  operationalArea?: InputMaybe<OperationalAreaSortInput>;
  operationalAreaId?: InputMaybe<SortEnumType>;
  region?: InputMaybe<RegionSortInput>;
  regionId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type GpsPointsConnection = {
  __typename?: 'GpsPointsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GpsPointsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<GpsPoint>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GpsPointsEdge = {
  __typename?: 'GpsPointsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GpsPoint>;
};

export enum Input_Type {
  Agg = 'AGG',
  All = 'ALL',
  Earth = 'EARTH',
  EarthProtection = 'EARTH_PROTECTION',
  EarthService = 'EARTH_SERVICE',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  Neutral = 'NEUTRAL',
  NotDefined = 'NOT_DEFINED'
}

export type Input_TypeOperationFilterInput = {
  eq?: InputMaybe<Input_Type>;
  in?: InputMaybe<Array<Input_Type>>;
  neq?: InputMaybe<Input_Type>;
  nin?: InputMaybe<Array<Input_Type>>;
};

export enum Installation_Type {
  Downstream = 'DOWNSTREAM',
  Upstream = 'UPSTREAM',
  Vertical = 'VERTICAL'
}

export enum Interface_Type {
  Bluetooth = 'BLUETOOTH',
  Ethernet = 'ETHERNET',
  Gprs = 'GPRS',
  LoRa = 'LO_RA'
}

export type Interface_TypeOperationFilterInput = {
  eq?: InputMaybe<Interface_Type>;
  in?: InputMaybe<Array<Interface_Type>>;
  neq?: InputMaybe<Interface_Type>;
  nin?: InputMaybe<Array<Interface_Type>>;
};

export type Input = {
  __typename?: 'Input';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  devicePortId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  inputType: Input_Type;
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  number: Scalars['Int']['output'];
  port: Port;
};

export type InputFilterInput = {
  and?: InputMaybe<Array<InputFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  devicePortId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputType?: InputMaybe<Input_TypeOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<InputFilterInput>>;
  port?: InputMaybe<PortFilterInput>;
};

export type InputSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  devicePortId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputType?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  port?: InputMaybe<PortSortInput>;
};

/** A connection to a list of items. */
export type InputsConnection = {
  __typename?: 'InputsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InputsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Input>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InputsEdge = {
  __typename?: 'InputsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Input;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type Interface = {
  __typename?: 'Interface';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocols: Array<Protocol>;
};

export type InterfaceBluetooth = {
  __typename?: 'InterfaceBluetooth';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  lastStateChange?: Maybe<Scalars['DateTime']['output']>;
  protocols: Array<Protocol>;
  state: Scalars['Int']['output'];
};

export type InterfaceBluetoothFilterInput = {
  and?: InputMaybe<Array<InterfaceBluetoothFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastStateChange?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceBluetoothFilterInput>>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
  state?: InputMaybe<IntOperationFilterInput>;
};

export type InterfaceBluetoothSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  lastStateChange?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
};

export type InterfaceEthernet = {
  __typename?: 'InterfaceEthernet';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceAddress: Scalars['String']['output'];
  deviceId: Scalars['Long']['output'];
  deviceMac: Scalars['String']['output'];
  deviceMasc: Scalars['String']['output'];
  ethDutyCycle?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocols: Array<Protocol>;
};

export type InterfaceEthernetFilterInput = {
  and?: InputMaybe<Array<InterfaceEthernetFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceAddress?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  deviceMac?: InputMaybe<StringOperationFilterInput>;
  deviceMasc?: InputMaybe<StringOperationFilterInput>;
  ethDutyCycle?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceEthernetFilterInput>>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
};

export type InterfaceEthernetSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceAddress?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  deviceMac?: InputMaybe<SortEnumType>;
  deviceMasc?: InputMaybe<SortEnumType>;
  ethDutyCycle?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
};

export type InterfaceFilterInput = {
  and?: InputMaybe<Array<InterfaceFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceFilterInput>>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
};

export type InterfaceGprs = {
  __typename?: 'InterfaceGprs';
  apnAuthType: Apn_Auth_Type;
  apnName: Scalars['String']['output'];
  apnPwd: Scalars['String']['output'];
  apnUser: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  iccid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastCommunication?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocols: Array<Protocol>;
  simId?: Maybe<Scalars['String']['output']>;
  simIp?: Maybe<Scalars['String']['output']>;
};

export type InterfaceGprsFilterInput = {
  and?: InputMaybe<Array<InterfaceGprsFilterInput>>;
  apnAuthType?: InputMaybe<Apn_Auth_TypeOperationFilterInput>;
  apnName?: InputMaybe<StringOperationFilterInput>;
  apnPwd?: InputMaybe<StringOperationFilterInput>;
  apnUser?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  iccid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastCommunication?: InputMaybe<DateTimeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceGprsFilterInput>>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
  simId?: InputMaybe<StringOperationFilterInput>;
  simIp?: InputMaybe<StringOperationFilterInput>;
};

export type InterfaceGprsSortInput = {
  apnAuthType?: InputMaybe<SortEnumType>;
  apnName?: InputMaybe<SortEnumType>;
  apnPwd?: InputMaybe<SortEnumType>;
  apnUser?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  iccid?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastCommunication?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  simId?: InputMaybe<SortEnumType>;
  simIp?: InputMaybe<SortEnumType>;
};

export type InterfaceLoRa = {
  __typename?: 'InterfaceLoRa';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  modemSettings: ModemSettings;
  modemSettingsId: Scalars['Long']['output'];
  packetConfiguration: PacketConfiguration;
  packetConfigurationId: Scalars['Long']['output'];
  protocols: Array<Protocol>;
  rfSettings: RfSettings;
  rfSettingsId: Scalars['Long']['output'];
};

export type InterfaceLoRaFilterInput = {
  and?: InputMaybe<Array<InterfaceLoRaFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  modemSettings?: InputMaybe<ModemSettingsFilterInput>;
  modemSettingsId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceLoRaFilterInput>>;
  packetConfiguration?: InputMaybe<PacketConfigurationFilterInput>;
  packetConfigurationId?: InputMaybe<LongOperationFilterInput>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
  rfSettings?: InputMaybe<RfSettingsFilterInput>;
  rfSettingsId?: InputMaybe<LongOperationFilterInput>;
};

export type InterfaceLoRaSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  modemSettings?: InputMaybe<ModemSettingsSortInput>;
  modemSettingsId?: InputMaybe<SortEnumType>;
  packetConfiguration?: InputMaybe<PacketConfigurationSortInput>;
  packetConfigurationId?: InputMaybe<SortEnumType>;
  rfSettings?: InputMaybe<RfSettingsSortInput>;
  rfSettingsId?: InputMaybe<SortEnumType>;
};

export type InterfaceSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type InterfacesBluetoothConnection = {
  __typename?: 'InterfacesBluetoothConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InterfacesBluetoothEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InterfaceBluetooth>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterfacesBluetoothEdge = {
  __typename?: 'InterfacesBluetoothEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InterfaceBluetooth;
};

/** A connection to a list of items. */
export type InterfacesEthernetConnection = {
  __typename?: 'InterfacesEthernetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InterfacesEthernetEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InterfaceEthernet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterfacesEthernetEdge = {
  __typename?: 'InterfacesEthernetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InterfaceEthernet;
};

/** A connection to a list of items. */
export type InterfacesGprsConnection = {
  __typename?: 'InterfacesGprsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InterfacesGprsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InterfaceGprs>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterfacesGprsEdge = {
  __typename?: 'InterfacesGprsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InterfaceGprs;
};

/** A connection to a list of items. */
export type InterfacesLoRaConnection = {
  __typename?: 'InterfacesLoRaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InterfacesLoRaEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InterfaceLoRa>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterfacesLoRaEdge = {
  __typename?: 'InterfacesLoRaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InterfaceLoRa;
};

export enum Join_Operator {
  And = 'AND',
  Or = 'OR'
}

export type Join_OperatorOperationFilterInput = {
  eq?: InputMaybe<Join_Operator>;
  in?: InputMaybe<Array<Join_Operator>>;
  neq?: InputMaybe<Join_Operator>;
  nin?: InputMaybe<Array<Join_Operator>>;
};

export type KeyValuePairOfStringAndIEnumerableOfString = {
  __typename?: 'KeyValuePairOfStringAndIEnumerableOfString';
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type KeyValuePairOfStringAndIEnumerableOfStringFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>>;
  value?: InputMaybe<ListStringOperationFilterInput>;
};

export type KeyValuePairOfStringAndObject = {
  __typename?: 'KeyValuePairOfStringAndObject';
  key: Scalars['String']['output'];
};

export type KeyValuePairOfStringAndObjectFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndObjectFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndObjectFilterInput>>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type KeyValuePairOfStringAndStringFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type KeycloakRole = {
  __typename?: 'KeycloakRole';
  attributes?: Maybe<Array<KeyValuePairOfStringAndObject>>;
  clientRole?: Maybe<Scalars['Boolean']['output']>;
  composite?: Maybe<Scalars['Boolean']['output']>;
  composites?: Maybe<RoleComposite>;
  containerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type KeycloakRoleConnection = {
  __typename?: 'KeycloakRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<KeycloakRoleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<KeycloakRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KeycloakRoleEdge = {
  __typename?: 'KeycloakRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KeycloakRole;
};

export type KeycloakRoleFilterInput = {
  and?: InputMaybe<Array<KeycloakRoleFilterInput>>;
  attributes?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  clientRole?: InputMaybe<BooleanOperationFilterInput>;
  composite?: InputMaybe<BooleanOperationFilterInput>;
  composites?: InputMaybe<RoleCompositeFilterInput>;
  containerId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeycloakRoleFilterInput>>;
};

export type KeycloakRoleSortInput = {
  clientRole?: InputMaybe<SortEnumType>;
  composite?: InputMaybe<SortEnumType>;
  containerId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type KeycloakUser = {
  __typename?: 'KeycloakUser';
  access?: Maybe<UserAccess>;
  attributes?: Maybe<Array<KeyValuePairOfStringAndIEnumerableOfString>>;
  clientConsents?: Maybe<Array<Maybe<UserConsent>>>;
  clientRoles?: Maybe<Array<KeyValuePairOfStringAndObject>>;
  createdTimestamp: Scalars['Long']['output'];
  credentials?: Maybe<Array<Maybe<Credentials>>>;
  disableableCredentialTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  federatedIdentities?: Maybe<Array<Maybe<FederatedIdentity>>>;
  federationLink?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  notBefore?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  realmRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requiredActions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  self?: Maybe<Scalars['String']['output']>;
  serviceAccountClientId?: Maybe<Scalars['String']['output']>;
  totp?: Maybe<Scalars['Boolean']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type KeycloakUserConnection = {
  __typename?: 'KeycloakUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<KeycloakUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<KeycloakUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KeycloakUserEdge = {
  __typename?: 'KeycloakUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KeycloakUser;
};

export type KeycloakUserFilterInput = {
  access?: InputMaybe<UserAccessFilterInput>;
  and?: InputMaybe<Array<KeycloakUserFilterInput>>;
  attributes?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndIEnumerableOfStringFilterInput>;
  clientConsents?: InputMaybe<ListFilterInputTypeOfUserConsentFilterInput>;
  clientRoles?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  createdTimestamp?: InputMaybe<LongOperationFilterInput>;
  credentials?: InputMaybe<ListFilterInputTypeOfCredentialsFilterInput>;
  disableableCredentialTypes?: InputMaybe<ListStringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailVerified?: InputMaybe<BooleanOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  federatedIdentities?: InputMaybe<ListFilterInputTypeOfFederatedIdentityFilterInput>;
  federationLink?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  groups?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  notBefore?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<KeycloakUserFilterInput>>;
  origin?: InputMaybe<StringOperationFilterInput>;
  realmRoles?: InputMaybe<ListStringOperationFilterInput>;
  requiredActions?: InputMaybe<ListStringOperationFilterInput>;
  self?: InputMaybe<StringOperationFilterInput>;
  serviceAccountClientId?: InputMaybe<StringOperationFilterInput>;
  totp?: InputMaybe<BooleanOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type KeycloakUserSortInput = {
  access?: InputMaybe<UserAccessSortInput>;
  createdTimestamp?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailVerified?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  federationLink?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  notBefore?: InputMaybe<SortEnumType>;
  origin?: InputMaybe<SortEnumType>;
  self?: InputMaybe<SortEnumType>;
  serviceAccountClientId?: InputMaybe<SortEnumType>;
  totp?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

export enum Lastcontact_Type {
  Alarm = 'ALARM',
  AlarmSet = 'ALARM_SET',
  AlarmStatus = 'ALARM_STATUS',
  LogParameter = 'LOG_PARAMETER',
  RawData = 'RAW_DATA',
  StateField = 'STATE_FIELD',
  StateFieldAck = 'STATE_FIELD_ACK',
  StateFirmware = 'STATE_FIRMWARE',
  StateFirmwareAck = 'STATE_FIRMWARE_ACK',
  StateInstallation = 'STATE_INSTALLATION',
  StateParameter = 'STATE_PARAMETER',
  TestResult = 'TEST_RESULT'
}

export type Lastcontact_TypeOperationFilterInput = {
  eq?: InputMaybe<Lastcontact_Type>;
  in?: InputMaybe<Array<Lastcontact_Type>>;
  neq?: InputMaybe<Lastcontact_Type>;
  nin?: InputMaybe<Array<Lastcontact_Type>>;
};

export enum Line_Type {
  MasterBusLine = 'MASTER_BUS_LINE',
  PowerBusLine = 'POWER_BUS_LINE'
}

export type Line_TypeOperationFilterInput = {
  eq?: InputMaybe<Line_Type>;
  in?: InputMaybe<Array<Line_Type>>;
  neq?: InputMaybe<Line_Type>;
  nin?: InputMaybe<Array<Line_Type>>;
};

export type LastContactByType = {
  __typename?: 'LastContactByType';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  lastContact: Scalars['DateTime']['output'];
  lastContactType: Lastcontact_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  remoteIp?: Maybe<Scalars['String']['output']>;
};

export type LastContactByTypeFilterInput = {
  and?: InputMaybe<Array<LastContactByTypeFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastContact?: InputMaybe<DateTimeOperationFilterInput>;
  lastContactType?: InputMaybe<Lastcontact_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<LastContactByTypeFilterInput>>;
  remoteIp?: InputMaybe<StringOperationFilterInput>;
};

export type LastContactByTypeSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastContact?: InputMaybe<SortEnumType>;
  lastContactType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  remoteIp?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LastContactByTypesConnection = {
  __typename?: 'LastContactByTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LastContactByTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LastContactByType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LastContactByTypesEdge = {
  __typename?: 'LastContactByTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LastContactByType;
};

export type LayoutAsset = {
  __typename?: 'LayoutAsset';
  accessGroups: Array<AccessGroup>;
  externalAssetId: Scalars['Long']['output'];
  gpsPoint?: Maybe<GpsPoint>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  operationalArea?: Maybe<OperationalArea>;
  operationalAreaId?: Maybe<Scalars['Long']['output']>;
  registrationNumber: Scalars['String']['output'];
  updateAsset: Scalars['Boolean']['output'];
};


export type LayoutAssetUpdateAssetArgs = {
  name: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type LayoutAssetsConnection = {
  __typename?: 'LayoutAssetsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LayoutAssetsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LayoutEquipment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LayoutAssetsEdge = {
  __typename?: 'LayoutAssetsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LayoutEquipment>;
};

export type LayoutEquipment = {
  __typename?: 'LayoutEquipment';
  accessGroups: Array<AccessGroup>;
  externalAssetId: Scalars['Long']['output'];
  gpsPoint?: Maybe<GpsPoint>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  operationalArea?: Maybe<OperationalArea>;
  operationalAreaId?: Maybe<Scalars['Long']['output']>;
  registrationNumber: Scalars['String']['output'];
  updateAsset: Scalars['Boolean']['output'];
};


export type LayoutEquipmentUpdateAssetArgs = {
  name: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
};

export type LayoutMessage = {
  __typename?: 'LayoutMessage';
  actionMethod: Action_Method;
  actionProto: Action_Proto;
  actionType: Action_Type;
  errorMessage: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  inputData: Scalars['String']['output'];
  result?: Maybe<Scalars['Boolean']['output']>;
  resultData: Scalars['String']['output'];
};

export type LayoutMessageFilterInput = {
  actionMethod?: InputMaybe<Action_MethodOperationFilterInput>;
  actionProto?: InputMaybe<Action_ProtoOperationFilterInput>;
  actionType?: InputMaybe<Action_TypeOperationFilterInput>;
  and?: InputMaybe<Array<LayoutMessageFilterInput>>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputData?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LayoutMessageFilterInput>>;
  result?: InputMaybe<BooleanOperationFilterInput>;
  resultData?: InputMaybe<StringOperationFilterInput>;
};

export type LayoutMessageSortInput = {
  actionMethod?: InputMaybe<SortEnumType>;
  actionProto?: InputMaybe<SortEnumType>;
  actionType?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputData?: InputMaybe<SortEnumType>;
  result?: InputMaybe<SortEnumType>;
  resultData?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LayoutMessagesConnection = {
  __typename?: 'LayoutMessagesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LayoutMessagesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LayoutMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LayoutMessagesEdge = {
  __typename?: 'LayoutMessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LayoutMessage;
};

export type Line = {
  __typename?: 'Line';
  assetId?: Maybe<Scalars['Long']['output']>;
  childLines?: Maybe<Array<Line>>;
  equipmentId?: Maybe<Scalars['Long']['output']>;
  feederId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  inputType: Input_Type;
  lineType: Line_Type;
  oldId?: Maybe<Scalars['Long']['output']>;
  parentLine?: Maybe<Line>;
  parentLineId?: Maybe<Scalars['Long']['output']>;
  referenceAngle?: Maybe<Scalars['Float']['output']>;
};

export type LineFilterInput = {
  and?: InputMaybe<Array<LineFilterInput>>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  childLines?: InputMaybe<ListFilterInputTypeOfLineFilterInput>;
  equipmentId?: InputMaybe<LongOperationFilterInput>;
  feederId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  inputType?: InputMaybe<Input_TypeOperationFilterInput>;
  lineType?: InputMaybe<Line_TypeOperationFilterInput>;
  oldId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<LineFilterInput>>;
  parentLine?: InputMaybe<LineFilterInput>;
  parentLineId?: InputMaybe<LongOperationFilterInput>;
  referenceAngle?: InputMaybe<FloatOperationFilterInput>;
};

export type LineSortInput = {
  assetId?: InputMaybe<SortEnumType>;
  equipmentId?: InputMaybe<SortEnumType>;
  feederId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  inputType?: InputMaybe<SortEnumType>;
  lineType?: InputMaybe<SortEnumType>;
  oldId?: InputMaybe<SortEnumType>;
  parentLine?: InputMaybe<LineSortInput>;
  parentLineId?: InputMaybe<SortEnumType>;
  referenceAngle?: InputMaybe<SortEnumType>;
};

export type ListByteOperationFilterInput = {
  all?: InputMaybe<ByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ByteOperationFilterInput>;
  some?: InputMaybe<ByteOperationFilterInput>;
};

export type ListFilterInputTypeOfAccessGroupFilterInput = {
  all?: InputMaybe<AccessGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AccessGroupFilterInput>;
  some?: InputMaybe<AccessGroupFilterInput>;
};

export type ListFilterInputTypeOfActionFilterInput = {
  all?: InputMaybe<ActionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ActionFilterInput>;
  some?: InputMaybe<ActionFilterInput>;
};

export type ListFilterInputTypeOfAlarmStandardDefinitionFilterInput = {
  all?: InputMaybe<AlarmStandardDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmStandardDefinitionFilterInput>;
  some?: InputMaybe<AlarmStandardDefinitionFilterInput>;
};

export type ListFilterInputTypeOfAlarmStandardVariableAggregationByAlarmFilterInput = {
  all?: InputMaybe<AlarmStandardVariableAggregationByAlarmFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmStandardVariableAggregationByAlarmFilterInput>;
  some?: InputMaybe<AlarmStandardVariableAggregationByAlarmFilterInput>;
};

export type ListFilterInputTypeOfAlarmStandardVariableAggregationFilterInput = {
  all?: InputMaybe<AlarmStandardVariableAggregationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmStandardVariableAggregationFilterInput>;
  some?: InputMaybe<AlarmStandardVariableAggregationFilterInput>;
};

export type ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput = {
  all?: InputMaybe<AlarmStandardVariableDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmStandardVariableDefinitionFilterInput>;
  some?: InputMaybe<AlarmStandardVariableDefinitionFilterInput>;
};

export type ListFilterInputTypeOfAlarmVariableAggregationFilterInput = {
  all?: InputMaybe<AlarmVariableAggregationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmVariableAggregationFilterInput>;
  some?: InputMaybe<AlarmVariableAggregationFilterInput>;
};

export type ListFilterInputTypeOfAlarmVariableFilterInput = {
  all?: InputMaybe<AlarmVariableFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmVariableFilterInput>;
  some?: InputMaybe<AlarmVariableFilterInput>;
};

export type ListFilterInputTypeOfAssetFilterInput = {
  all?: InputMaybe<AssetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AssetFilterInput>;
  some?: InputMaybe<AssetFilterInput>;
};

export type ListFilterInputTypeOfAuthorizationFilterInput = {
  all?: InputMaybe<AuthorizationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AuthorizationFilterInput>;
  some?: InputMaybe<AuthorizationFilterInput>;
};

export type ListFilterInputTypeOfAuthorizationTokenFilterInput = {
  all?: InputMaybe<AuthorizationTokenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AuthorizationTokenFilterInput>;
  some?: InputMaybe<AuthorizationTokenFilterInput>;
};

export type ListFilterInputTypeOfBatchIncludeFilterInput = {
  all?: InputMaybe<BatchIncludeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BatchIncludeFilterInput>;
  some?: InputMaybe<BatchIncludeFilterInput>;
};

export type ListFilterInputTypeOfCompanyFilterInput = {
  all?: InputMaybe<CompanyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CompanyFilterInput>;
  some?: InputMaybe<CompanyFilterInput>;
};

export type ListFilterInputTypeOfConTestDeviceResultFilterInput = {
  all?: InputMaybe<ConTestDeviceResultFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConTestDeviceResultFilterInput>;
  some?: InputMaybe<ConTestDeviceResultFilterInput>;
};

export type ListFilterInputTypeOfConTestFilterInput = {
  all?: InputMaybe<ConTestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConTestFilterInput>;
  some?: InputMaybe<ConTestFilterInput>;
};

export type ListFilterInputTypeOfContactFilterInput = {
  all?: InputMaybe<ContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactFilterInput>;
  some?: InputMaybe<ContactFilterInput>;
};

export type ListFilterInputTypeOfCredentialsFilterInput = {
  all?: InputMaybe<CredentialsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CredentialsFilterInput>;
  some?: InputMaybe<CredentialsFilterInput>;
};

export type ListFilterInputTypeOfCustomPropertiesFilterInput = {
  all?: InputMaybe<CustomPropertiesFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomPropertiesFilterInput>;
  some?: InputMaybe<CustomPropertiesFilterInput>;
};

export type ListFilterInputTypeOfDeviceBulkConfigurationFilterInput = {
  all?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  some?: InputMaybe<DeviceBulkConfigurationFilterInput>;
};

export type ListFilterInputTypeOfDeviceFilterInput = {
  all?: InputMaybe<DeviceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceFilterInput>;
  some?: InputMaybe<DeviceFilterInput>;
};

export type ListFilterInputTypeOfDeviceInputNumberFilterInput = {
  all?: InputMaybe<DeviceInputNumberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceInputNumberFilterInput>;
  some?: InputMaybe<DeviceInputNumberFilterInput>;
};

export type ListFilterInputTypeOfDeviceTagFilterInput = {
  all?: InputMaybe<DeviceTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceTagFilterInput>;
  some?: InputMaybe<DeviceTagFilterInput>;
};

export type ListFilterInputTypeOfDeviceTypeConfigurationFilterInput = {
  all?: InputMaybe<DeviceTypeConfigurationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceTypeConfigurationFilterInput>;
  some?: InputMaybe<DeviceTypeConfigurationFilterInput>;
};

export type ListFilterInputTypeOfEmailAttachmentFilterInput = {
  all?: InputMaybe<EmailAttachmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmailAttachmentFilterInput>;
  some?: InputMaybe<EmailAttachmentFilterInput>;
};

export type ListFilterInputTypeOfEmailStatusFilterInput = {
  all?: InputMaybe<EmailStatusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmailStatusFilterInput>;
  some?: InputMaybe<EmailStatusFilterInput>;
};

export type ListFilterInputTypeOfEnterpriseFilterInput = {
  all?: InputMaybe<EnterpriseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EnterpriseFilterInput>;
  some?: InputMaybe<EnterpriseFilterInput>;
};

export type ListFilterInputTypeOfEquipmentFilterInput = {
  all?: InputMaybe<EquipmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EquipmentFilterInput>;
  some?: InputMaybe<EquipmentFilterInput>;
};

export type ListFilterInputTypeOfEventDataFilterInput = {
  all?: InputMaybe<EventDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EventDataFilterInput>;
  some?: InputMaybe<EventDataFilterInput>;
};

export type ListFilterInputTypeOfFederatedIdentityFilterInput = {
  all?: InputMaybe<FederatedIdentityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FederatedIdentityFilterInput>;
  some?: InputMaybe<FederatedIdentityFilterInput>;
};

export type ListFilterInputTypeOfFeederFilterInput = {
  all?: InputMaybe<FeederFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FeederFilterInput>;
  some?: InputMaybe<FeederFilterInput>;
};

export type ListFilterInputTypeOfFilterFilterInput = {
  all?: InputMaybe<FilterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FilterFilterInput>;
  some?: InputMaybe<FilterFilterInput>;
};

export type ListFilterInputTypeOfFirmwareTaskFilterInput = {
  all?: InputMaybe<FirmwareTaskFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FirmwareTaskFilterInput>;
  some?: InputMaybe<FirmwareTaskFilterInput>;
};

export type ListFilterInputTypeOfFirmwareTaskLogFilterInput = {
  all?: InputMaybe<FirmwareTaskLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FirmwareTaskLogFilterInput>;
  some?: InputMaybe<FirmwareTaskLogFilterInput>;
};

export type ListFilterInputTypeOfGpsPointFilterInput = {
  all?: InputMaybe<GpsPointFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GpsPointFilterInput>;
  some?: InputMaybe<GpsPointFilterInput>;
};

export type ListFilterInputTypeOfInputFilterInput = {
  all?: InputMaybe<InputFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InputFilterInput>;
  some?: InputMaybe<InputFilterInput>;
};

export type ListFilterInputTypeOfInterfaceFilterInput = {
  all?: InputMaybe<InterfaceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InterfaceFilterInput>;
  some?: InputMaybe<InterfaceFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndIEnumerableOfStringFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
};

export type ListFilterInputTypeOfLastContactByTypeFilterInput = {
  all?: InputMaybe<LastContactByTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LastContactByTypeFilterInput>;
  some?: InputMaybe<LastContactByTypeFilterInput>;
};

export type ListFilterInputTypeOfLineFilterInput = {
  all?: InputMaybe<LineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LineFilterInput>;
  some?: InputMaybe<LineFilterInput>;
};

export type ListFilterInputTypeOfMenuFilterInput = {
  all?: InputMaybe<MenuFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MenuFilterInput>;
  some?: InputMaybe<MenuFilterInput>;
};

export type ListFilterInputTypeOfMenuRolesFilterInput = {
  all?: InputMaybe<MenuRolesFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MenuRolesFilterInput>;
  some?: InputMaybe<MenuRolesFilterInput>;
};

export type ListFilterInputTypeOfOperationalAreaFilterInput = {
  all?: InputMaybe<OperationalAreaFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationalAreaFilterInput>;
  some?: InputMaybe<OperationalAreaFilterInput>;
};

export type ListFilterInputTypeOfPortFilterInput = {
  all?: InputMaybe<PortFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PortFilterInput>;
  some?: InputMaybe<PortFilterInput>;
};

export type ListFilterInputTypeOfProtocolFilterInput = {
  all?: InputMaybe<ProtocolFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProtocolFilterInput>;
  some?: InputMaybe<ProtocolFilterInput>;
};

export type ListFilterInputTypeOfRegionFilterInput = {
  all?: InputMaybe<RegionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RegionFilterInput>;
  some?: InputMaybe<RegionFilterInput>;
};

export type ListFilterInputTypeOfRoleFilterInput = {
  all?: InputMaybe<RoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RoleFilterInput>;
  some?: InputMaybe<RoleFilterInput>;
};

export type ListFilterInputTypeOfRoleGraphQlFilterInput = {
  all?: InputMaybe<RoleGraphQlFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RoleGraphQlFilterInput>;
  some?: InputMaybe<RoleGraphQlFilterInput>;
};

export type ListFilterInputTypeOfScheduleOperationModeFilterInput = {
  all?: InputMaybe<ScheduleOperationModeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ScheduleOperationModeFilterInput>;
  some?: InputMaybe<ScheduleOperationModeFilterInput>;
};

export type ListFilterInputTypeOfSimCardFilterInput = {
  all?: InputMaybe<SimCardFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SimCardFilterInput>;
  some?: InputMaybe<SimCardFilterInput>;
};

export type ListFilterInputTypeOfSubscriptionFilterInput = {
  all?: InputMaybe<SubscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SubscriptionFilterInput>;
  some?: InputMaybe<SubscriptionFilterInput>;
};

export type ListFilterInputTypeOfTemplateFilterInput = {
  all?: InputMaybe<TemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TemplateFilterInput>;
  some?: InputMaybe<TemplateFilterInput>;
};

export type ListFilterInputTypeOfUserConsentFilterInput = {
  all?: InputMaybe<UserConsentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserConsentFilterInput>;
  some?: InputMaybe<UserConsentFilterInput>;
};

export type ListFilterInputTypeOfUserFilterInput = {
  all?: InputMaybe<UserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserFilterInput>;
  some?: InputMaybe<UserFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export enum Material_Type {
  Composite = 'COMPOSITE',
  Glass = 'GLASS'
}

export enum Micro_Controller_Type {
  Com = 'COM',
  Esp = 'ESP',
  Ingrid = 'INGRID',
  Mea = 'MEA',
  Msp = 'MSP',
  Pic = 'PIC'
}

export type Micro_Controller_TypeOperationFilterInput = {
  eq?: InputMaybe<Micro_Controller_Type>;
  in?: InputMaybe<Array<Micro_Controller_Type>>;
  neq?: InputMaybe<Micro_Controller_Type>;
  nin?: InputMaybe<Array<Micro_Controller_Type>>;
};

export type Menu = {
  __typename?: 'Menu';
  breadcrumbs: Scalars['Boolean']['output'];
  children?: Maybe<Array<Menu>>;
  element?: Maybe<Scalars['String']['output']>;
  enable: Scalars['Boolean']['output'];
  externalUrl?: Maybe<Scalars['Boolean']['output']>;
  i18nKey: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Menu>;
  parentId?: Maybe<Scalars['Long']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  section?: Maybe<Section>;
  sectionId?: Maybe<Scalars['Long']['output']>;
  type: MenuType;
  url?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type MenuConnection = {
  __typename?: 'MenuConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MenuEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Menu>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuEdge = {
  __typename?: 'MenuEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Menu;
};

export type MenuFilterInput = {
  and?: InputMaybe<Array<MenuFilterInput>>;
  breadcrumbs?: InputMaybe<BooleanOperationFilterInput>;
  children?: InputMaybe<ListFilterInputTypeOfMenuFilterInput>;
  element?: InputMaybe<StringOperationFilterInput>;
  enable?: InputMaybe<BooleanOperationFilterInput>;
  externalUrl?: InputMaybe<BooleanOperationFilterInput>;
  i18nKey?: InputMaybe<StringOperationFilterInput>;
  icon?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MenuFilterInput>>;
  parent?: InputMaybe<MenuFilterInput>;
  parentId?: InputMaybe<LongOperationFilterInput>;
  path?: InputMaybe<StringOperationFilterInput>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleFilterInput>;
  section?: InputMaybe<SectionFilterInput>;
  sectionId?: InputMaybe<LongOperationFilterInput>;
  type?: InputMaybe<MenuTypeOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type MenuRoles = {
  __typename?: 'MenuRoles';
  actions?: Maybe<Array<Action>>;
  id: Scalars['Long']['output'];
  menu?: Maybe<Menu>;
  menuId: Scalars['Long']['output'];
  role?: Maybe<Role>;
  roleId: Scalars['Long']['output'];
};

export type MenuRolesActions = {
  __typename?: 'MenuRolesActions';
  action?: Maybe<Action>;
  actionId: Scalars['Long']['output'];
  menuId: Scalars['Long']['output'];
  menuRoles?: Maybe<MenuRoles>;
  roleId: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type MenuRolesActionsConnection = {
  __typename?: 'MenuRolesActionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MenuRolesActionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MenuRolesActions>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuRolesActionsEdge = {
  __typename?: 'MenuRolesActionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MenuRolesActions;
};

export type MenuRolesActionsFilterInput = {
  action?: InputMaybe<ActionFilterInput>;
  actionId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<MenuRolesActionsFilterInput>>;
  menuId?: InputMaybe<LongOperationFilterInput>;
  menuRoles?: InputMaybe<MenuRolesFilterInput>;
  or?: InputMaybe<Array<MenuRolesActionsFilterInput>>;
  roleId?: InputMaybe<LongOperationFilterInput>;
};

export type MenuRolesActionsSortInput = {
  action?: InputMaybe<ActionSortInput>;
  actionId?: InputMaybe<SortEnumType>;
  menuId?: InputMaybe<SortEnumType>;
  menuRoles?: InputMaybe<MenuRolesSortInput>;
  roleId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MenuRolesConnection = {
  __typename?: 'MenuRolesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MenuRolesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MenuRoles>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuRolesEdge = {
  __typename?: 'MenuRolesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MenuRoles;
};

export type MenuRolesFilterInput = {
  actions?: InputMaybe<ListFilterInputTypeOfActionFilterInput>;
  and?: InputMaybe<Array<MenuRolesFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  menu?: InputMaybe<MenuFilterInput>;
  menuId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<MenuRolesFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<LongOperationFilterInput>;
};

export type MenuRolesSortInput = {
  id?: InputMaybe<SortEnumType>;
  menu?: InputMaybe<MenuSortInput>;
  menuId?: InputMaybe<SortEnumType>;
  role?: InputMaybe<RoleSortInput>;
  roleId?: InputMaybe<SortEnumType>;
};

export type MenuSortInput = {
  breadcrumbs?: InputMaybe<SortEnumType>;
  element?: InputMaybe<SortEnumType>;
  enable?: InputMaybe<SortEnumType>;
  externalUrl?: InputMaybe<SortEnumType>;
  i18nKey?: InputMaybe<SortEnumType>;
  icon?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<MenuSortInput>;
  parentId?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
  section?: InputMaybe<SectionSortInput>;
  sectionId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export enum MenuType {
  Collapse = 'COLLAPSE',
  Item = 'ITEM'
}

export type MenuTypeOperationFilterInput = {
  eq?: InputMaybe<MenuType>;
  in?: InputMaybe<Array<MenuType>>;
  neq?: InputMaybe<MenuType>;
  nin?: InputMaybe<Array<MenuType>>;
};

export type ModemSettings = {
  __typename?: 'ModemSettings';
  bandWidth: Scalars['Float']['output'];
  codingRate: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  interfaceLoRa: InterfaceLoRa;
  interfaceLoRaId: Scalars['Long']['output'];
  lowDataRate: Scalars['Int']['output'];
  spreadingFactor: Scalars['Int']['output'];
};

export type ModemSettingsFilterInput = {
  and?: InputMaybe<Array<ModemSettingsFilterInput>>;
  bandWidth?: InputMaybe<FloatOperationFilterInput>;
  codingRate?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaFilterInput>;
  interfaceLoRaId?: InputMaybe<LongOperationFilterInput>;
  lowDataRate?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ModemSettingsFilterInput>>;
  spreadingFactor?: InputMaybe<IntOperationFilterInput>;
};

export type ModemSettingsSortInput = {
  bandWidth?: InputMaybe<SortEnumType>;
  codingRate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaSortInput>;
  interfaceLoRaId?: InputMaybe<SortEnumType>;
  lowDataRate?: InputMaybe<SortEnumType>;
  spreadingFactor?: InputMaybe<SortEnumType>;
};

export enum Notification_Type {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

export type Notification_TypeOperationFilterInput = {
  eq?: InputMaybe<Notification_Type>;
  in?: InputMaybe<Array<Notification_Type>>;
  neq?: InputMaybe<Notification_Type>;
  nin?: InputMaybe<Array<Notification_Type>>;
};

export type NetworkPowerQuality = {
  __typename?: 'NetworkPowerQuality';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  inputReferenceFrequency: Scalars['Int']['output'];
  inputReferenceVoltage: Scalars['Int']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  negativeVoltageRVCHisterese: Scalars['Int']['output'];
  negativeVoltageRVCThreshold: Scalars['Int']['output'];
  positiveVoltageRVCHisterese: Scalars['Int']['output'];
  positiveVoltageRVCThreshold: Scalars['Int']['output'];
  scheduleOperationModes: Array<ScheduleOperationMode>;
  voltageDipHisterese: Scalars['Int']['output'];
  voltageDipThreshold: Scalars['Int']['output'];
  voltageInterruptHisterese: Scalars['Int']['output'];
  voltageInterruptThreshold: Scalars['Int']['output'];
  voltageSwellHisterese: Scalars['Int']['output'];
  voltageSwellThreshold: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type NetworkPowerQualityConnection = {
  __typename?: 'NetworkPowerQualityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<NetworkPowerQualityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<NetworkPowerQuality>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NetworkPowerQualityEdge = {
  __typename?: 'NetworkPowerQualityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NetworkPowerQuality;
};

export type NetworkPowerQualityFilterInput = {
  and?: InputMaybe<Array<NetworkPowerQualityFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputReferenceFrequency?: InputMaybe<IntOperationFilterInput>;
  inputReferenceVoltage?: InputMaybe<IntOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  negativeVoltageRVCHisterese?: InputMaybe<IntOperationFilterInput>;
  negativeVoltageRVCThreshold?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NetworkPowerQualityFilterInput>>;
  positiveVoltageRVCHisterese?: InputMaybe<IntOperationFilterInput>;
  positiveVoltageRVCThreshold?: InputMaybe<IntOperationFilterInput>;
  scheduleOperationModes?: InputMaybe<ListFilterInputTypeOfScheduleOperationModeFilterInput>;
  voltageDipHisterese?: InputMaybe<IntOperationFilterInput>;
  voltageDipThreshold?: InputMaybe<IntOperationFilterInput>;
  voltageInterruptHisterese?: InputMaybe<IntOperationFilterInput>;
  voltageInterruptThreshold?: InputMaybe<IntOperationFilterInput>;
  voltageSwellHisterese?: InputMaybe<IntOperationFilterInput>;
  voltageSwellThreshold?: InputMaybe<IntOperationFilterInput>;
};

export type NetworkPowerQualitySortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputReferenceFrequency?: InputMaybe<SortEnumType>;
  inputReferenceVoltage?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  negativeVoltageRVCHisterese?: InputMaybe<SortEnumType>;
  negativeVoltageRVCThreshold?: InputMaybe<SortEnumType>;
  positiveVoltageRVCHisterese?: InputMaybe<SortEnumType>;
  positiveVoltageRVCThreshold?: InputMaybe<SortEnumType>;
  voltageDipHisterese?: InputMaybe<SortEnumType>;
  voltageDipThreshold?: InputMaybe<SortEnumType>;
  voltageInterruptHisterese?: InputMaybe<SortEnumType>;
  voltageInterruptThreshold?: InputMaybe<SortEnumType>;
  voltageSwellHisterese?: InputMaybe<SortEnumType>;
  voltageSwellThreshold?: InputMaybe<SortEnumType>;
};

export type NullableOfAnchor_TypeOperationFilterInput = {
  eq?: InputMaybe<Anchor_Type>;
  in?: InputMaybe<Array<InputMaybe<Anchor_Type>>>;
  neq?: InputMaybe<Anchor_Type>;
  nin?: InputMaybe<Array<InputMaybe<Anchor_Type>>>;
};

export type NullableOfConnection_TypeOperationFilterInput = {
  eq?: InputMaybe<Connection_Type>;
  in?: InputMaybe<Array<InputMaybe<Connection_Type>>>;
  neq?: InputMaybe<Connection_Type>;
  nin?: InputMaybe<Array<InputMaybe<Connection_Type>>>;
};

export type NullableOfEncryption_TypeOperationFilterInput = {
  eq?: InputMaybe<Encryption_Type>;
  in?: InputMaybe<Array<InputMaybe<Encryption_Type>>>;
  neq?: InputMaybe<Encryption_Type>;
  nin?: InputMaybe<Array<InputMaybe<Encryption_Type>>>;
};

export type NullableOfEventDataStatusOperationFilterInput = {
  eq?: InputMaybe<EventDataStatus>;
  in?: InputMaybe<Array<InputMaybe<EventDataStatus>>>;
  neq?: InputMaybe<EventDataStatus>;
  nin?: InputMaybe<Array<InputMaybe<EventDataStatus>>>;
};

export type NullableOfInput_TypeOperationFilterInput = {
  eq?: InputMaybe<Input_Type>;
  in?: InputMaybe<Array<InputMaybe<Input_Type>>>;
  neq?: InputMaybe<Input_Type>;
  nin?: InputMaybe<Array<InputMaybe<Input_Type>>>;
};

export type NullableOfInstallation_TypeOperationFilterInput = {
  eq?: InputMaybe<Installation_Type>;
  in?: InputMaybe<Array<InputMaybe<Installation_Type>>>;
  neq?: InputMaybe<Installation_Type>;
  nin?: InputMaybe<Array<InputMaybe<Installation_Type>>>;
};

export type NullableOfMaterial_TypeOperationFilterInput = {
  eq?: InputMaybe<Material_Type>;
  in?: InputMaybe<Array<InputMaybe<Material_Type>>>;
  neq?: InputMaybe<Material_Type>;
  nin?: InputMaybe<Array<InputMaybe<Material_Type>>>;
};

export type NullableOfOf_MonthOperationFilterInput = {
  eq?: InputMaybe<Of_Month>;
  in?: InputMaybe<Array<InputMaybe<Of_Month>>>;
  neq?: InputMaybe<Of_Month>;
  nin?: InputMaybe<Array<InputMaybe<Of_Month>>>;
};

export type NullableOfOn_TheOperationFilterInput = {
  eq?: InputMaybe<On_The>;
  in?: InputMaybe<Array<InputMaybe<On_The>>>;
  neq?: InputMaybe<On_The>;
  nin?: InputMaybe<Array<InputMaybe<On_The>>>;
};

export type NullableOfOn_The_ItemOperationFilterInput = {
  eq?: InputMaybe<On_The_Item>;
  in?: InputMaybe<Array<InputMaybe<On_The_Item>>>;
  neq?: InputMaybe<On_The_Item>;
  nin?: InputMaybe<Array<InputMaybe<On_The_Item>>>;
};

export type NullableOfServer_TypeOperationFilterInput = {
  eq?: InputMaybe<Server_Type>;
  in?: InputMaybe<Array<InputMaybe<Server_Type>>>;
  neq?: InputMaybe<Server_Type>;
  nin?: InputMaybe<Array<InputMaybe<Server_Type>>>;
};

export type NullableOfSubstation_TypeOperationFilterInput = {
  eq?: InputMaybe<Substation_Type>;
  in?: InputMaybe<Array<InputMaybe<Substation_Type>>>;
  neq?: InputMaybe<Substation_Type>;
  nin?: InputMaybe<Array<InputMaybe<Substation_Type>>>;
};

export enum Of_Month {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  None = 'NONE',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export enum On_The {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  None = 'NONE',
  Second = 'SECOND',
  Third = 'THIRD'
}

export enum On_The_Item {
  Day = 'DAY',
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  None = 'NONE',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Week = 'WEEK',
  Weekend = 'WEEKEND'
}

export type OperationalArea = {
  __typename?: 'OperationalArea';
  accessGroups: Array<AccessGroup>;
  accessGroupsWorkingOP: Array<AccessGroup>;
  assets: Array<LayoutEquipment>;
  code: Scalars['String']['output'];
  gpsPoints: Array<GpsPoint>;
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  region: Region;
  regionId: Scalars['Long']['output'];
};

export type OperationalAreaFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  accessGroupsWorkingOP?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<OperationalAreaFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  gpsPoints?: InputMaybe<ListFilterInputTypeOfGpsPointFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationalAreaFilterInput>>;
  region?: InputMaybe<RegionFilterInput>;
  regionId?: InputMaybe<LongOperationFilterInput>;
};

export type OperationalAreaSortInput = {
  code?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  region?: InputMaybe<RegionSortInput>;
  regionId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OperationalAreasConnection = {
  __typename?: 'OperationalAreasConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OperationalAreasEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<OperationalArea>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OperationalAreasEdge = {
  __typename?: 'OperationalAreasEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OperationalArea>;
};

export enum Phase_Rotation {
  Anticlockwise = 'ANTICLOCKWISE',
  Clockwise = 'CLOCKWISE',
  Undefined = 'UNDEFINED'
}

export type Phase_RotationOperationFilterInput = {
  eq?: InputMaybe<Phase_Rotation>;
  in?: InputMaybe<Array<Phase_Rotation>>;
  neq?: InputMaybe<Phase_Rotation>;
  nin?: InputMaybe<Array<Phase_Rotation>>;
};

export enum Phase_Type {
  Biphasic = 'BIPHASIC',
  Monophasic = 'MONOPHASIC',
  Triphasic = 'TRIPHASIC'
}

export type Phase_TypeOperationFilterInput = {
  eq?: InputMaybe<Phase_Type>;
  in?: InputMaybe<Array<Phase_Type>>;
  neq?: InputMaybe<Phase_Type>;
  nin?: InputMaybe<Array<Phase_Type>>;
};

export enum Port_Type {
  EnergyMeter = 'ENERGY_METER',
  EnergyMeterNeutral = 'ENERGY_METER_NEUTRAL',
  Generic = 'GENERIC',
  ImpedanceMeter = 'IMPEDANCE_METER'
}

export type Port_TypeOperationFilterInput = {
  eq?: InputMaybe<Port_Type>;
  in?: InputMaybe<Array<Port_Type>>;
  neq?: InputMaybe<Port_Type>;
  nin?: InputMaybe<Array<Port_Type>>;
};

export enum Protocol_Type {
  Bluetooth = 'BLUETOOTH',
  Dnp3 = 'DNP3',
  EneidaLoRa = 'ENEIDA_LO_RA',
  Http = 'HTTP',
  Mqtt = 'MQTT'
}

export type Protocol_TypeOperationFilterInput = {
  eq?: InputMaybe<Protocol_Type>;
  in?: InputMaybe<Array<Protocol_Type>>;
  neq?: InputMaybe<Protocol_Type>;
  nin?: InputMaybe<Array<Protocol_Type>>;
};

export type PacketConfiguration = {
  __typename?: 'PacketConfiguration';
  crcEnabled: Scalars['Int']['output'];
  headerMode: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  interfaceLoRa: InterfaceLoRa;
  interfaceLoRaId: Scalars['Long']['output'];
  payloadLength: Scalars['Int']['output'];
  programmedPreamble: Scalars['Int']['output'];
  totalPreambleLength: Scalars['Int']['output'];
};

export type PacketConfigurationFilterInput = {
  and?: InputMaybe<Array<PacketConfigurationFilterInput>>;
  crcEnabled?: InputMaybe<IntOperationFilterInput>;
  headerMode?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaFilterInput>;
  interfaceLoRaId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PacketConfigurationFilterInput>>;
  payloadLength?: InputMaybe<IntOperationFilterInput>;
  programmedPreamble?: InputMaybe<IntOperationFilterInput>;
  totalPreambleLength?: InputMaybe<IntOperationFilterInput>;
};

export type PacketConfigurationSortInput = {
  crcEnabled?: InputMaybe<SortEnumType>;
  headerMode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaSortInput>;
  interfaceLoRaId?: InputMaybe<SortEnumType>;
  payloadLength?: InputMaybe<SortEnumType>;
  programmedPreamble?: InputMaybe<SortEnumType>;
  totalPreambleLength?: InputMaybe<SortEnumType>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PlatformSettings = {
  __typename?: 'PlatformSettings';
  applicationName: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  mandatory: Scalars['Boolean']['output'];
  regex: Scalars['String']['output'];
  sectionName: Scalars['String']['output'];
  settingName: Scalars['String']['output'];
  settingType: Scalars['String']['output'];
  settingValue: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PlatformSettingsConnection = {
  __typename?: 'PlatformSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PlatformSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PlatformSettings>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlatformSettingsEdge = {
  __typename?: 'PlatformSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlatformSettings;
};

export type PlatformSettingsFilterInput = {
  and?: InputMaybe<Array<PlatformSettingsFilterInput>>;
  applicationName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  mandatory?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PlatformSettingsFilterInput>>;
  regex?: InputMaybe<StringOperationFilterInput>;
  sectionName?: InputMaybe<StringOperationFilterInput>;
  settingName?: InputMaybe<StringOperationFilterInput>;
  settingType?: InputMaybe<StringOperationFilterInput>;
  settingValue?: InputMaybe<StringOperationFilterInput>;
};

export type PlatformSettingsSortInput = {
  applicationName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  mandatory?: InputMaybe<SortEnumType>;
  regex?: InputMaybe<SortEnumType>;
  sectionName?: InputMaybe<SortEnumType>;
  settingName?: InputMaybe<SortEnumType>;
  settingType?: InputMaybe<SortEnumType>;
  settingValue?: InputMaybe<SortEnumType>;
};

export type Port = {
  __typename?: 'Port';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  inputs: Array<Input>;
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  portNumber: Scalars['Int']['output'];
  portType: Port_Type;
};

export type PortFilterInput = {
  and?: InputMaybe<Array<PortFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputs?: InputMaybe<ListFilterInputTypeOfInputFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PortFilterInput>>;
  portNumber?: InputMaybe<IntOperationFilterInput>;
  portType?: InputMaybe<Port_TypeOperationFilterInput>;
};

export type PortSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  portNumber?: InputMaybe<SortEnumType>;
  portType?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PortsConnection = {
  __typename?: 'PortsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PortsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Port>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PortsEdge = {
  __typename?: 'PortsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Port;
};

/** A connection to a list of items. */
export type PowerBusLinesConnection = {
  __typename?: 'PowerBusLinesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PowerBusLinesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Line>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PowerBusLinesEdge = {
  __typename?: 'PowerBusLinesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Line;
};

export type Protocol = {
  __typename?: 'Protocol';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocolType: Protocol_Type;
  version: Scalars['String']['output'];
};

export type ProtocolBluetooth = {
  __typename?: 'ProtocolBluetooth';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  pin: Scalars['String']['output'];
  protocolType: Protocol_Type;
  version: Scalars['String']['output'];
};

export type ProtocolBluetoothFilterInput = {
  and?: InputMaybe<Array<ProtocolBluetoothFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolBluetoothFilterInput>>;
  pin?: InputMaybe<StringOperationFilterInput>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolBluetoothSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pin?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ProtocolDnp3 = {
  __typename?: 'ProtocolDNP3';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocolType: Protocol_Type;
  version: Scalars['String']['output'];
};

export type ProtocolDnp3FilterInput = {
  and?: InputMaybe<Array<ProtocolDnp3FilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolDnp3FilterInput>>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolDnp3SortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ProtocolEneidaLoRa = {
  __typename?: 'ProtocolEneidaLoRa';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocolType: Protocol_Type;
  version: Scalars['String']['output'];
};

export type ProtocolEneidaLoRaFilterInput = {
  and?: InputMaybe<Array<ProtocolEneidaLoRaFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolEneidaLoRaFilterInput>>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolEneidaLoRaSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ProtocolFilterInput = {
  and?: InputMaybe<Array<ProtocolFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolFilterInput>>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolHttp = {
  __typename?: 'ProtocolHTTP';
  createAlarm: Scalars['Boolean']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocolType: Protocol_Type;
  sendRawData: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type ProtocolHttpFilterInput = {
  and?: InputMaybe<Array<ProtocolHttpFilterInput>>;
  createAlarm?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolHttpFilterInput>>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  sendRawData?: InputMaybe<BooleanOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolHttpSortInput = {
  createAlarm?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  sendRawData?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ProtocolMqtt = {
  __typename?: 'ProtocolMqtt';
  certificateUrl?: Maybe<Scalars['String']['output']>;
  createAlarm: Scalars['Boolean']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  protocolType: Protocol_Type;
  sendRawData: Scalars['Boolean']['output'];
  username?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type ProtocolMqttFilterInput = {
  and?: InputMaybe<Array<ProtocolMqttFilterInput>>;
  certificateUrl?: InputMaybe<StringOperationFilterInput>;
  createAlarm?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolMqttFilterInput>>;
  password?: InputMaybe<StringOperationFilterInput>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  sendRawData?: InputMaybe<BooleanOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolMqttSortInput = {
  certificateUrl?: InputMaybe<SortEnumType>;
  createAlarm?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  password?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  sendRawData?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProtocolsBluetoothConnection = {
  __typename?: 'ProtocolsBluetoothConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsBluetoothEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolBluetooth>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsBluetoothEdge = {
  __typename?: 'ProtocolsBluetoothEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolBluetooth;
};

/** A connection to a list of items. */
export type ProtocolsDnp3Connection = {
  __typename?: 'ProtocolsDNP3Connection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsDnp3Edge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolDnp3>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsDnp3Edge = {
  __typename?: 'ProtocolsDNP3Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolDnp3;
};

/** A connection to a list of items. */
export type ProtocolsEneidaLoRaConnection = {
  __typename?: 'ProtocolsEneidaLoRaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsEneidaLoRaEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolEneidaLoRa>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsEneidaLoRaEdge = {
  __typename?: 'ProtocolsEneidaLoRaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolEneidaLoRa;
};

/** A connection to a list of items. */
export type ProtocolsHttpConnection = {
  __typename?: 'ProtocolsHTTPConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsHttpEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolHttp>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsHttpEdge = {
  __typename?: 'ProtocolsHTTPEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolHttp;
};

/** A connection to a list of items. */
export type ProtocolsMqttConnection = {
  __typename?: 'ProtocolsMqttConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsMqttEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolMqtt>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsMqttEdge = {
  __typename?: 'ProtocolsMqttEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolMqtt;
};

export type Query = {
  __typename?: 'Query';
  accessGroups?: Maybe<AccessGroupsConnection>;
  action?: Maybe<ActionConnection>;
  alarmStandardDefinitions?: Maybe<AlarmStandardDefinitionsConnection>;
  alarmStandardVariableDefinitions?: Maybe<AlarmStandardVariableDefinitionsConnection>;
  alarmStandards?: Maybe<AlarmStandardsConnection>;
  alarmTypes?: Maybe<AlarmTypesConnection>;
  alarmVariables?: Maybe<AlarmVariablesConnection>;
  assetBulkConfigurations?: Maybe<AssetBulkConfigurationsConnection>;
  assets?: Maybe<AssetsConnection>;
  authorization?: Maybe<AuthorizationConnection>;
  batchDevices?: Maybe<BatchDevicesConnection>;
  batchIncludes?: Maybe<BatchIncludesConnection>;
  batchSims?: Maybe<BatchSimsConnection>;
  cableTypes?: Maybe<CableTypesConnection>;
  companys?: Maybe<CompanysConnection>;
  conTestDeviceResults?: Maybe<ConTestDeviceResultsConnection>;
  conTests?: Maybe<ConTestsConnection>;
  conTestsExtended?: Maybe<ConTestsExtendedConnection>;
  contacts?: Maybe<ContactsConnection>;
  currentHarmonics?: Maybe<CurrentHarmonicsConnection>;
  customProperties?: Maybe<CustomPropertiesConnection>;
  deviceBulkConfigurations?: Maybe<DeviceBulkConfigurationsConnection>;
  deviceInputNumbers?: Maybe<DeviceInputNumbersConnection>;
  deviceLog?: Maybe<DeviceLogConnection>;
  deviceLogs?: Maybe<DeviceLogsConnection>;
  deviceMessages?: Maybe<DeviceMessagesConnection>;
  deviceTypeConfigurations?: Maybe<DeviceTypeConfigurationsConnection>;
  devices?: Maybe<DevicesConnection>;
  devicesFirmwareDocuments?: Maybe<DevicesFirmwareDocumentsConnection>;
  emailAttachments?: Maybe<EmailAttachmentsConnection>;
  emailStatus?: Maybe<EmailStatusConnection>;
  emails?: Maybe<EmailsConnection>;
  energyBalance?: Maybe<EnergyBalanceConnection>;
  enterprises?: Maybe<EnterprisesConnection>;
  equipments?: Maybe<EquipmentsConnection>;
  equipmentsDevices?: Maybe<EquipmentsDevicesConnection>;
  eventData?: Maybe<EventDataConnection>;
  events?: Maybe<EventsConnection>;
  feeders?: Maybe<FeedersConnection>;
  firmwareTaskLog?: Maybe<FirmwareTaskLogConnection>;
  firmwareTasks?: Maybe<FirmwareTasksConnection>;
  firmwares?: Maybe<FirmwaresConnection>;
  gpsPoints?: Maybe<GpsPointsConnection>;
  inputs?: Maybe<InputsConnection>;
  interfacesBluetooth?: Maybe<InterfacesBluetoothConnection>;
  interfacesEthernet?: Maybe<InterfacesEthernetConnection>;
  interfacesGprs?: Maybe<InterfacesGprsConnection>;
  interfacesLoRa?: Maybe<InterfacesLoRaConnection>;
  keycloakRole?: Maybe<KeycloakRoleConnection>;
  keycloakUser?: Maybe<KeycloakUserConnection>;
  lastContactByTypes?: Maybe<LastContactByTypesConnection>;
  layoutAssets?: Maybe<LayoutAssetsConnection>;
  layoutMessages?: Maybe<LayoutMessagesConnection>;
  menu?: Maybe<MenuConnection>;
  menuRoles?: Maybe<MenuRolesConnection>;
  menuRolesActions?: Maybe<MenuRolesActionsConnection>;
  networkPowerQuality?: Maybe<NetworkPowerQualityConnection>;
  operationalAreas?: Maybe<OperationalAreasConnection>;
  platformSettings?: Maybe<PlatformSettingsConnection>;
  ports?: Maybe<PortsConnection>;
  powerBusLines?: Maybe<PowerBusLinesConnection>;
  protocolsBluetooth?: Maybe<ProtocolsBluetoothConnection>;
  protocolsDNP3?: Maybe<ProtocolsDnp3Connection>;
  protocolsEneidaLoRa?: Maybe<ProtocolsEneidaLoRaConnection>;
  protocolsHTTP?: Maybe<ProtocolsHttpConnection>;
  protocolsMqtt?: Maybe<ProtocolsMqttConnection>;
  regions?: Maybe<RegionsConnection>;
  reports?: Maybe<ReportsConnection>;
  role?: Maybe<RoleConnection>;
  scheduleOperationMode?: Maybe<ScheduleOperationModeConnection>;
  simCards?: Maybe<SimCardsConnection>;
  subscriptions?: Maybe<SubscriptionsConnection>;
  templates?: Maybe<TemplatesConnection>;
  templatesConfig?: Maybe<TemplatesConfigConnection>;
  user?: Maybe<UserConnection>;
  userLogAction?: Maybe<UserLogActionConnection>;
};


export type QueryAccessGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AccessGroupSortInput>>;
  where?: InputMaybe<AccessGroupFilterInput>;
};


export type QueryActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ActionSortInput>>;
  where?: InputMaybe<ActionFilterInput>;
};


export type QueryAlarmStandardDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmStandardDefinitionSortInput>>;
  where?: InputMaybe<AlarmStandardDefinitionFilterInput>;
};


export type QueryAlarmStandardVariableDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmStandardVariableDefinitionSortInput>>;
  where?: InputMaybe<AlarmStandardVariableDefinitionFilterInput>;
};


export type QueryAlarmStandardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmStandardSortInput>>;
  where?: InputMaybe<AlarmStandardFilterInput>;
};


export type QueryAlarmTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmTypeSortInput>>;
  where?: InputMaybe<AlarmTypeFilterInput>;
};


export type QueryAlarmVariablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmVariableSortInput>>;
  where?: InputMaybe<AlarmVariableFilterInput>;
};


export type QueryAssetBulkConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EquipBulkConfigurationSortInput>>;
  where?: InputMaybe<EquipBulkConfigurationFilterInput>;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AssetSortInput>>;
  where?: InputMaybe<AssetFilterInput>;
};


export type QueryAuthorizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AuthorizationSortInput>>;
  where?: InputMaybe<AuthorizationFilterInput>;
};


export type QueryBatchDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BatchDeviceSortInput>>;
  where?: InputMaybe<BatchDeviceFilterInput>;
};


export type QueryBatchIncludesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BatchIncludeSortInput>>;
  where?: InputMaybe<BatchIncludeFilterInput>;
};


export type QueryBatchSimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BatchSimSortInput>>;
  where?: InputMaybe<BatchSimFilterInput>;
};


export type QueryCableTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CableTypeSortInput>>;
  where?: InputMaybe<CableTypeFilterInput>;
};


export type QueryCompanysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CompanySortInput>>;
  where?: InputMaybe<CompanyFilterInput>;
};


export type QueryConTestDeviceResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConTestDeviceResultSortInput>>;
  where?: InputMaybe<ConTestDeviceResultFilterInput>;
};


export type QueryConTestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConTestSortInput>>;
  where?: InputMaybe<ConTestFilterInput>;
};


export type QueryConTestsExtendedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConTestExtendedSortInput>>;
  where?: InputMaybe<ConTestExtendedFilterInput>;
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContactSortInput>>;
  where?: InputMaybe<ContactFilterInput>;
};


export type QueryCurrentHarmonicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CurrentHarmonicsSortInput>>;
  where?: InputMaybe<CurrentHarmonicsFilterInput>;
};


export type QueryCustomPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomPropertiesSortInput>>;
  where?: InputMaybe<CustomPropertiesFilterInput>;
};


export type QueryDeviceBulkConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceBulkConfigurationSortInput>>;
  where?: InputMaybe<DeviceBulkConfigurationFilterInput>;
};


export type QueryDeviceInputNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceInputNumberSortInput>>;
  where?: InputMaybe<DeviceInputNumberFilterInput>;
};


export type QueryDeviceLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceLogSortInput>>;
  where?: InputMaybe<DeviceLogFilterInput>;
};


export type QueryDeviceLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceLogSortInput>>;
  where?: InputMaybe<DeviceLogFilterInput>;
};


export type QueryDeviceMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceMessageSortInput>>;
  where?: InputMaybe<DeviceMessageFilterInput>;
};


export type QueryDeviceTypeConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceTypeConfigurationSortInput>>;
  where?: InputMaybe<DeviceTypeConfigurationFilterInput>;
};


export type QueryDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceSortInput>>;
  where?: InputMaybe<DeviceFilterInput>;
};


export type QueryDevicesFirmwareDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareDocumentSortInput>>;
  where?: InputMaybe<FirmwareDocumentFilterInput>;
};


export type QueryEmailAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailAttachmentSortInput>>;
  where?: InputMaybe<EmailAttachmentFilterInput>;
};


export type QueryEmailStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailStatusSortInput>>;
  where?: InputMaybe<EmailStatusFilterInput>;
};


export type QueryEmailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailSortInput>>;
  where?: InputMaybe<EmailFilterInput>;
};


export type QueryEnergyBalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EnergyBalanceSortInput>>;
  where?: InputMaybe<EnergyBalanceFilterInput>;
};


export type QueryEnterprisesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EnterpriseSortInput>>;
  where?: InputMaybe<EnterpriseFilterInput>;
};


export type QueryEquipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EquipmentSortInput>>;
  where?: InputMaybe<EquipmentFilterInput>;
};


export type QueryEquipmentsDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceSortInput>>;
  where?: InputMaybe<DeviceFilterInput>;
};


export type QueryEventDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventDataSortInput>>;
  where?: InputMaybe<EventDataFilterInput>;
};


export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventSortInput>>;
  where?: InputMaybe<EventFilterInput>;
};


export type QueryFeedersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FeederSortInput>>;
  where?: InputMaybe<FeederFilterInput>;
};


export type QueryFirmwareTaskLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareTaskLogSortInput>>;
  where?: InputMaybe<FirmwareTaskLogFilterInput>;
};


export type QueryFirmwareTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareTaskSortInput>>;
  where?: InputMaybe<FirmwareTaskFilterInput>;
};


export type QueryFirmwaresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareSortInput>>;
  where?: InputMaybe<FirmwareFilterInput>;
};


export type QueryGpsPointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<GpsPointSortInput>>;
  where?: InputMaybe<GpsPointFilterInput>;
};


export type QueryInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputSortInput>>;
  where?: InputMaybe<InputFilterInput>;
};


export type QueryInterfacesBluetoothArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InterfaceBluetoothSortInput>>;
  where?: InputMaybe<InterfaceBluetoothFilterInput>;
};


export type QueryInterfacesEthernetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InterfaceEthernetSortInput>>;
  where?: InputMaybe<InterfaceEthernetFilterInput>;
};


export type QueryInterfacesGprsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InterfaceGprsSortInput>>;
  where?: InputMaybe<InterfaceGprsFilterInput>;
};


export type QueryInterfacesLoRaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InterfaceLoRaSortInput>>;
  where?: InputMaybe<InterfaceLoRaFilterInput>;
};


export type QueryKeycloakRoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<KeycloakRoleSortInput>>;
  where?: InputMaybe<KeycloakRoleFilterInput>;
};


export type QueryKeycloakUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<KeycloakUserSortInput>>;
  where?: InputMaybe<KeycloakUserFilterInput>;
};


export type QueryLastContactByTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LastContactByTypeSortInput>>;
  where?: InputMaybe<LastContactByTypeFilterInput>;
};


export type QueryLayoutAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AssetSortInput>>;
  where?: InputMaybe<AssetFilterInput>;
};


export type QueryLayoutMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LayoutMessageSortInput>>;
  where?: InputMaybe<LayoutMessageFilterInput>;
};


export type QueryMenuArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MenuSortInput>>;
  where?: InputMaybe<MenuFilterInput>;
};


export type QueryMenuRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MenuRolesSortInput>>;
  where?: InputMaybe<MenuRolesFilterInput>;
};


export type QueryMenuRolesActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MenuRolesActionsSortInput>>;
  where?: InputMaybe<MenuRolesActionsFilterInput>;
};


export type QueryNetworkPowerQualityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<NetworkPowerQualitySortInput>>;
  where?: InputMaybe<NetworkPowerQualityFilterInput>;
};


export type QueryOperationalAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OperationalAreaSortInput>>;
  where?: InputMaybe<OperationalAreaFilterInput>;
};


export type QueryPlatformSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PlatformSettingsSortInput>>;
  where?: InputMaybe<PlatformSettingsFilterInput>;
};


export type QueryPortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PortSortInput>>;
  where?: InputMaybe<PortFilterInput>;
};


export type QueryPowerBusLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LineSortInput>>;
  where?: InputMaybe<LineFilterInput>;
};


export type QueryProtocolsBluetoothArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolBluetoothSortInput>>;
  where?: InputMaybe<ProtocolBluetoothFilterInput>;
};


export type QueryProtocolsDnp3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolDnp3SortInput>>;
  where?: InputMaybe<ProtocolDnp3FilterInput>;
};


export type QueryProtocolsEneidaLoRaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolEneidaLoRaSortInput>>;
  where?: InputMaybe<ProtocolEneidaLoRaFilterInput>;
};


export type QueryProtocolsHttpArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolHttpSortInput>>;
  where?: InputMaybe<ProtocolHttpFilterInput>;
};


export type QueryProtocolsMqttArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolMqttSortInput>>;
  where?: InputMaybe<ProtocolMqttFilterInput>;
};


export type QueryRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RegionSortInput>>;
  where?: InputMaybe<RegionFilterInput>;
};


export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportDtoSortInput>>;
  where?: InputMaybe<ReportDtoFilterInput>;
};


export type QueryRoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RoleGraphQlSortInput>>;
  where?: InputMaybe<RoleGraphQlFilterInput>;
};


export type QueryScheduleOperationModeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ScheduleOperationModeSortInput>>;
  where?: InputMaybe<ScheduleOperationModeFilterInput>;
};


export type QuerySimCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SimCardSortInput>>;
  where?: InputMaybe<SimCardFilterInput>;
};


export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubscriptionSortInput>>;
  where?: InputMaybe<SubscriptionFilterInput>;
};


export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TemplateSortInput>>;
  where?: InputMaybe<TemplateFilterInput>;
};


export type QueryTemplatesConfigArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TemplateConfigSortInput>>;
  where?: InputMaybe<TemplateConfigFilterInput>;
};


export type QueryUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserGraphQlSortInput>>;
  where?: InputMaybe<UserGraphQlFilterInput>;
};


export type QueryUserLogActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserLogActionSortInput>>;
  where?: InputMaybe<UserLogActionFilterInput>;
};

export enum Region {
  Empty = 'EMPTY',
  Europe = 'EUROPE'
}

export type RegionOperationFilterInput = {
  eq?: InputMaybe<Region>;
  in?: InputMaybe<Array<Region>>;
  neq?: InputMaybe<Region>;
  nin?: InputMaybe<Array<Region>>;
};

export type RfSettings = {
  __typename?: 'RFSettings';
  centreFrequency: Scalars['Int']['output'];
  frequencyDeviation: Scalars['Int']['output'];
  hardwareImplementation: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  interfaceLoRa: InterfaceLoRa;
  interfaceLoRaId: Scalars['Long']['output'];
  transmitPower: Scalars['Int']['output'];
};

export type RfSettingsFilterInput = {
  and?: InputMaybe<Array<RfSettingsFilterInput>>;
  centreFrequency?: InputMaybe<IntOperationFilterInput>;
  frequencyDeviation?: InputMaybe<IntOperationFilterInput>;
  hardwareImplementation?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaFilterInput>;
  interfaceLoRaId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RfSettingsFilterInput>>;
  transmitPower?: InputMaybe<IntOperationFilterInput>;
};

export type RfSettingsSortInput = {
  centreFrequency?: InputMaybe<SortEnumType>;
  frequencyDeviation?: InputMaybe<SortEnumType>;
  hardwareImplementation?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaSortInput>;
  interfaceLoRaId?: InputMaybe<SortEnumType>;
  transmitPower?: InputMaybe<SortEnumType>;
};

export type Region = {
  __typename?: 'Region';
  accessGroups: Array<AccessGroup>;
  code: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['Long']['output'];
  gpsPoints: Array<GpsPoint>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  operationalAreas: Array<OperationalArea>;
};

export type RegionFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<RegionFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<LongOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  gpsPoints?: InputMaybe<ListFilterInputTypeOfGpsPointFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  operationalAreas?: InputMaybe<ListFilterInputTypeOfOperationalAreaFilterInput>;
  or?: InputMaybe<Array<RegionFilterInput>>;
};

export type RegionSortInput = {
  code?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RegionsConnection = {
  __typename?: 'RegionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RegionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Region>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RegionsEdge = {
  __typename?: 'RegionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Region>;
};

export type ReportDto = {
  __typename?: 'ReportDTO';
  _id: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  equipments: Array<Scalars['Int']['output']>;
  errors: Scalars['String']['output'];
  name: Scalars['String']['output'];
  period_end: Scalars['DateTime']['output'];
  period_start: Scalars['DateTime']['output'];
  periodic: Scalars['Boolean']['output'];
  ready: Scalars['Boolean']['output'];
  report_type: Scalars['String']['output'];
  requested_by: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ReportDtoFilterInput = {
  _id?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ReportDtoFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  equipments?: InputMaybe<ListIntOperationFilterInput>;
  errors?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDtoFilterInput>>;
  period_end?: InputMaybe<DateTimeOperationFilterInput>;
  period_start?: InputMaybe<DateTimeOperationFilterInput>;
  periodic?: InputMaybe<BooleanOperationFilterInput>;
  ready?: InputMaybe<BooleanOperationFilterInput>;
  report_type?: InputMaybe<StringOperationFilterInput>;
  requested_by?: InputMaybe<StringOperationFilterInput>;
  size?: InputMaybe<IntOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type ReportDtoSortInput = {
  _id?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  errors?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  period_end?: InputMaybe<SortEnumType>;
  period_start?: InputMaybe<SortEnumType>;
  periodic?: InputMaybe<SortEnumType>;
  ready?: InputMaybe<SortEnumType>;
  report_type?: InputMaybe<SortEnumType>;
  requested_by?: InputMaybe<SortEnumType>;
  size?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportDto>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportDto;
};

export type Role = {
  __typename?: 'Role';
  authorizations?: Maybe<Array<Authorization>>;
  hasMobileAccess?: Maybe<Scalars['Boolean']['output']>;
  hasWebAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  keycloakId?: Maybe<Scalars['String']['output']>;
  menus?: Maybe<Array<Menu>>;
  name: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export type RoleComposite = {
  __typename?: 'RoleComposite';
  client?: Maybe<Array<KeyValuePairOfStringAndString>>;
  realm?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RoleCompositeFilterInput = {
  and?: InputMaybe<Array<RoleCompositeFilterInput>>;
  client?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput>;
  or?: InputMaybe<Array<RoleCompositeFilterInput>>;
  realm?: InputMaybe<ListStringOperationFilterInput>;
};

/** A connection to a list of items. */
export type RoleConnection = {
  __typename?: 'RoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RoleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RoleGraphQl>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RoleEdge = {
  __typename?: 'RoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RoleGraphQl;
};

export type RoleFilterInput = {
  and?: InputMaybe<Array<RoleFilterInput>>;
  authorizations?: InputMaybe<ListFilterInputTypeOfAuthorizationFilterInput>;
  hasMobileAccess?: InputMaybe<BooleanOperationFilterInput>;
  hasWebAccess?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  keycloakId?: InputMaybe<StringOperationFilterInput>;
  menus?: InputMaybe<ListFilterInputTypeOfMenuFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoleFilterInput>>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
};

export type RoleGraphQl = {
  __typename?: 'RoleGraphQl';
  id?: Maybe<Scalars['Long']['output']>;
  keycloakId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RoleGraphQlFilterInput = {
  and?: InputMaybe<Array<RoleGraphQlFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  keycloakId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoleGraphQlFilterInput>>;
};

export type RoleGraphQlSortInput = {
  id?: InputMaybe<SortEnumType>;
  keycloakId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type RoleSortInput = {
  hasMobileAccess?: InputMaybe<SortEnumType>;
  hasWebAccess?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  keycloakId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum Server_Type {
  Imap = 'IMAP',
  Pop = 'POP'
}

export enum Sim_Status_Type {
  Available = 'AVAILABLE',
  Damaged = 'DAMAGED',
  Used = 'USED'
}

export type Sim_Status_TypeOperationFilterInput = {
  eq?: InputMaybe<Sim_Status_Type>;
  in?: InputMaybe<Array<Sim_Status_Type>>;
  neq?: InputMaybe<Sim_Status_Type>;
  nin?: InputMaybe<Array<Sim_Status_Type>>;
};

export enum Slot_Type {
  Device = 'DEVICE',
  Manual = 'MANUAL',
  Random = 'RANDOM',
  Undefined = 'UNDEFINED'
}

export type Slot_TypeOperationFilterInput = {
  eq?: InputMaybe<Slot_Type>;
  in?: InputMaybe<Array<Slot_Type>>;
  neq?: InputMaybe<Slot_Type>;
  nin?: InputMaybe<Array<Slot_Type>>;
};

export enum Source {
  Deepgrid = 'DEEPGRID',
  Device = 'DEVICE',
  Empty = 'EMPTY'
}

export type SourceOperationFilterInput = {
  eq?: InputMaybe<Source>;
  in?: InputMaybe<Array<Source>>;
  neq?: InputMaybe<Source>;
  nin?: InputMaybe<Array<Source>>;
};

export enum Status {
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Waiting = 'WAITING'
}

export type StatusOperationFilterInput = {
  eq?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  neq?: InputMaybe<Status>;
  nin?: InputMaybe<Array<Status>>;
};

export enum Substation_Type {
  DeliveryPoint = 'DELIVERY_POINT',
  Pds = 'PDS',
  Sds = 'SDS'
}

export type ScheduleOperationMode = {
  __typename?: 'ScheduleOperationMode';
  activationDate: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  currentEndSchedule?: Maybe<Scalars['DateTime']['output']>;
  currentHarmonics?: Maybe<CurrentHarmonics>;
  currentHarmonicsId?: Maybe<Scalars['Long']['output']>;
  currentSchedule?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceBulkConfigurations: Array<DeviceBulkConfiguration>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationType: Duration_Type;
  enable: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  energyBalance?: Maybe<EnergyBalance>;
  energyBalanceId?: Maybe<Scalars['Long']['output']>;
  every?: Maybe<Scalars['Int']['output']>;
  executions: Scalars['Int']['output'];
  forever: Scalars['Boolean']['output'];
  friday?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  lastEndSchedule?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  lastSchedule?: Maybe<Scalars['DateTime']['output']>;
  monday?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  networkPowerQuality?: Maybe<NetworkPowerQuality>;
  networkPowerQualityId?: Maybe<Scalars['Long']['output']>;
  nextEndSchedule?: Maybe<Scalars['DateTime']['output']>;
  nextSchedule?: Maybe<Scalars['DateTime']['output']>;
  ofEvery?: Maybe<Scalars['Int']['output']>;
  ofMonth?: Maybe<Of_Month>;
  onDay?: Maybe<Scalars['Int']['output']>;
  onThe?: Maybe<On_The>;
  onTheItem?: Maybe<On_The_Item>;
  recurrenceType: Duration_Type;
  recurrencyQuantity?: Maybe<Scalars['Int']['output']>;
  saturday?: Maybe<Scalars['Boolean']['output']>;
  startDate: Scalars['DateTime']['output'];
  sunday?: Maybe<Scalars['Boolean']['output']>;
  thursday?: Maybe<Scalars['Boolean']['output']>;
  tuesday?: Maybe<Scalars['Boolean']['output']>;
  wednesday?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type ScheduleOperationModeConnection = {
  __typename?: 'ScheduleOperationModeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ScheduleOperationModeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ScheduleOperationMode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ScheduleOperationModeEdge = {
  __typename?: 'ScheduleOperationModeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduleOperationMode;
};

export type ScheduleOperationModeFilterInput = {
  activationDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ScheduleOperationModeFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  currentEndSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  currentHarmonics?: InputMaybe<CurrentHarmonicsFilterInput>;
  currentHarmonicsId?: InputMaybe<LongOperationFilterInput>;
  currentSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceBulkConfigurations?: InputMaybe<ListFilterInputTypeOfDeviceBulkConfigurationFilterInput>;
  duration?: InputMaybe<IntOperationFilterInput>;
  durationType?: InputMaybe<Duration_TypeOperationFilterInput>;
  enable?: InputMaybe<BooleanOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  energyBalance?: InputMaybe<EnergyBalanceFilterInput>;
  energyBalanceId?: InputMaybe<LongOperationFilterInput>;
  every?: InputMaybe<IntOperationFilterInput>;
  executions?: InputMaybe<IntOperationFilterInput>;
  forever?: InputMaybe<BooleanOperationFilterInput>;
  friday?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastEndSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  monday?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  networkPowerQuality?: InputMaybe<NetworkPowerQualityFilterInput>;
  networkPowerQualityId?: InputMaybe<LongOperationFilterInput>;
  nextEndSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  nextSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  ofEvery?: InputMaybe<IntOperationFilterInput>;
  ofMonth?: InputMaybe<NullableOfOf_MonthOperationFilterInput>;
  onDay?: InputMaybe<IntOperationFilterInput>;
  onThe?: InputMaybe<NullableOfOn_TheOperationFilterInput>;
  onTheItem?: InputMaybe<NullableOfOn_The_ItemOperationFilterInput>;
  or?: InputMaybe<Array<ScheduleOperationModeFilterInput>>;
  recurrenceType?: InputMaybe<Duration_TypeOperationFilterInput>;
  recurrencyQuantity?: InputMaybe<IntOperationFilterInput>;
  saturday?: InputMaybe<BooleanOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  sunday?: InputMaybe<BooleanOperationFilterInput>;
  thursday?: InputMaybe<BooleanOperationFilterInput>;
  tuesday?: InputMaybe<BooleanOperationFilterInput>;
  wednesday?: InputMaybe<BooleanOperationFilterInput>;
};

export type ScheduleOperationModeSortInput = {
  activationDate?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  currentEndSchedule?: InputMaybe<SortEnumType>;
  currentHarmonics?: InputMaybe<CurrentHarmonicsSortInput>;
  currentHarmonicsId?: InputMaybe<SortEnumType>;
  currentSchedule?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  durationType?: InputMaybe<SortEnumType>;
  enable?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  energyBalance?: InputMaybe<EnergyBalanceSortInput>;
  energyBalanceId?: InputMaybe<SortEnumType>;
  every?: InputMaybe<SortEnumType>;
  executions?: InputMaybe<SortEnumType>;
  forever?: InputMaybe<SortEnumType>;
  friday?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastEndSchedule?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  lastSchedule?: InputMaybe<SortEnumType>;
  monday?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  networkPowerQuality?: InputMaybe<NetworkPowerQualitySortInput>;
  networkPowerQualityId?: InputMaybe<SortEnumType>;
  nextEndSchedule?: InputMaybe<SortEnumType>;
  nextSchedule?: InputMaybe<SortEnumType>;
  ofEvery?: InputMaybe<SortEnumType>;
  ofMonth?: InputMaybe<SortEnumType>;
  onDay?: InputMaybe<SortEnumType>;
  onThe?: InputMaybe<SortEnumType>;
  onTheItem?: InputMaybe<SortEnumType>;
  recurrenceType?: InputMaybe<SortEnumType>;
  recurrencyQuantity?: InputMaybe<SortEnumType>;
  saturday?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  sunday?: InputMaybe<SortEnumType>;
  thursday?: InputMaybe<SortEnumType>;
  tuesday?: InputMaybe<SortEnumType>;
  wednesday?: InputMaybe<SortEnumType>;
};

export type Section = {
  __typename?: 'Section';
  i18nKey: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  menus?: Maybe<Array<Menu>>;
  name: Scalars['String']['output'];
};

export type SectionFilterInput = {
  and?: InputMaybe<Array<SectionFilterInput>>;
  i18nKey?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  menus?: InputMaybe<ListFilterInputTypeOfMenuFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SectionFilterInput>>;
};

export type SectionSortInput = {
  i18nKey?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type SimCard = {
  __typename?: 'SimCard';
  apnAuthType: Apn_Auth_Type;
  apnIp?: Maybe<Scalars['String']['output']>;
  apnName: Scalars['String']['output'];
  apnPwd?: Maybe<Scalars['String']['output']>;
  apnUser?: Maybe<Scalars['String']['output']>;
  associationDate?: Maybe<Scalars['DateTime']['output']>;
  associationLog?: Maybe<Scalars['String']['output']>;
  associationSucess?: Maybe<Scalars['Boolean']['output']>;
  batchSim: BatchSim;
  batchSimId: Scalars['Long']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device?: Maybe<Device>;
  filename: Scalars['String']['output'];
  iccid: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  importDate: Scalars['DateTime']['output'];
  imsi?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  simIp?: Maybe<Scalars['String']['output']>;
  simStatusType: Sim_Status_Type;
};

export type SimCardFilterInput = {
  and?: InputMaybe<Array<SimCardFilterInput>>;
  apnAuthType?: InputMaybe<Apn_Auth_TypeOperationFilterInput>;
  apnIp?: InputMaybe<StringOperationFilterInput>;
  apnName?: InputMaybe<StringOperationFilterInput>;
  apnPwd?: InputMaybe<StringOperationFilterInput>;
  apnUser?: InputMaybe<StringOperationFilterInput>;
  associationDate?: InputMaybe<DateTimeOperationFilterInput>;
  associationLog?: InputMaybe<StringOperationFilterInput>;
  associationSucess?: InputMaybe<BooleanOperationFilterInput>;
  batchSim?: InputMaybe<BatchSimFilterInput>;
  batchSimId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  filename?: InputMaybe<StringOperationFilterInput>;
  iccid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  importDate?: InputMaybe<DateTimeOperationFilterInput>;
  imsi?: InputMaybe<StringOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SimCardFilterInput>>;
  simIp?: InputMaybe<StringOperationFilterInput>;
  simStatusType?: InputMaybe<Sim_Status_TypeOperationFilterInput>;
};

export type SimCardSortInput = {
  apnAuthType?: InputMaybe<SortEnumType>;
  apnIp?: InputMaybe<SortEnumType>;
  apnName?: InputMaybe<SortEnumType>;
  apnPwd?: InputMaybe<SortEnumType>;
  apnUser?: InputMaybe<SortEnumType>;
  associationDate?: InputMaybe<SortEnumType>;
  associationLog?: InputMaybe<SortEnumType>;
  associationSucess?: InputMaybe<SortEnumType>;
  batchSim?: InputMaybe<BatchSimSortInput>;
  batchSimId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  filename?: InputMaybe<SortEnumType>;
  iccid?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importDate?: InputMaybe<SortEnumType>;
  imsi?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  simIp?: InputMaybe<SortEnumType>;
  simStatusType?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SimCardsConnection = {
  __typename?: 'SimCardsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SimCardsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SimCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SimCardsEdge = {
  __typename?: 'SimCardsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SimCard;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  contacts?: Maybe<Array<Contact>>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailBcc?: Maybe<Array<Contact>>;
  emailCc?: Maybe<Array<Contact>>;
  emailTo?: Maybe<Array<Contact>>;
  filters?: Maybe<Array<Filter>>;
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  templates?: Maybe<Array<Template>>;
};

export type SubscriptionFilterInput = {
  and?: InputMaybe<Array<SubscriptionFilterInput>>;
  contacts?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  emailBcc?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  emailCc?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  emailTo?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  filters?: InputMaybe<ListFilterInputTypeOfFilterFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubscriptionFilterInput>>;
  templates?: InputMaybe<ListFilterInputTypeOfTemplateFilterInput>;
};

export type SubscriptionSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SubscriptionsConnection = {
  __typename?: 'SubscriptionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SubscriptionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Subscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubscriptionsEdge = {
  __typename?: 'SubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Subscription;
};

export enum Template_Message_Type {
  Html = 'HTML',
  Text = 'TEXT'
}

export type Template_Message_TypeOperationFilterInput = {
  eq?: InputMaybe<Template_Message_Type>;
  in?: InputMaybe<Array<Template_Message_Type>>;
  neq?: InputMaybe<Template_Message_Type>;
  nin?: InputMaybe<Array<Template_Message_Type>>;
};

export enum Time_Server_Type {
  Deepgrid = 'DEEPGRID',
  Htp = 'HTP',
  Ntp = 'NTP'
}

export type Time_Server_TypeOperationFilterInput = {
  eq?: InputMaybe<Time_Server_Type>;
  in?: InputMaybe<Array<Time_Server_Type>>;
  neq?: InputMaybe<Time_Server_Type>;
  nin?: InputMaybe<Array<Time_Server_Type>>;
};

export enum Transformer_Type {
  Interbars = 'INTERBARS',
  Single = 'SINGLE'
}

export type Transformer_TypeOperationFilterInput = {
  eq?: InputMaybe<Transformer_Type>;
  in?: InputMaybe<Array<Transformer_Type>>;
  neq?: InputMaybe<Transformer_Type>;
  nin?: InputMaybe<Array<Transformer_Type>>;
};

export type Template = {
  __typename?: 'Template';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageType: Template_Message_Type;
  name: Scalars['String']['output'];
  notificationType: Notification_Type;
  readOnly: Scalars['Boolean']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  subscriptions: Array<Subscription>;
  templateConfig: TemplateConfig;
  templateConfigId: Scalars['Long']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type TemplateConfig = {
  __typename?: 'TemplateConfig';
  baseTemplate: Scalars['String']['output'];
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  notificationType: Notification_Type;
};

export type TemplateConfigFilterInput = {
  and?: InputMaybe<Array<TemplateConfigFilterInput>>;
  baseTemplate?: InputMaybe<StringOperationFilterInput>;
  footer?: InputMaybe<StringOperationFilterInput>;
  header?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notificationType?: InputMaybe<Notification_TypeOperationFilterInput>;
  or?: InputMaybe<Array<TemplateConfigFilterInput>>;
};

export type TemplateConfigSortInput = {
  baseTemplate?: InputMaybe<SortEnumType>;
  footer?: InputMaybe<SortEnumType>;
  header?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notificationType?: InputMaybe<SortEnumType>;
};

export type TemplateFilterInput = {
  and?: InputMaybe<Array<TemplateFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  messageType?: InputMaybe<Template_Message_TypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notificationType?: InputMaybe<Notification_TypeOperationFilterInput>;
  or?: InputMaybe<Array<TemplateFilterInput>>;
  readOnly?: InputMaybe<BooleanOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  subscriptions?: InputMaybe<ListFilterInputTypeOfSubscriptionFilterInput>;
  templateConfig?: InputMaybe<TemplateConfigFilterInput>;
  templateConfigId?: InputMaybe<LongOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type TemplateSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  messageType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notificationType?: InputMaybe<SortEnumType>;
  readOnly?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SortEnumType>;
  templateConfig?: InputMaybe<TemplateConfigSortInput>;
  templateConfigId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TemplatesConfigConnection = {
  __typename?: 'TemplatesConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TemplatesConfigEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TemplateConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TemplatesConfigEdge = {
  __typename?: 'TemplatesConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TemplateConfig;
};

/** A connection to a list of items. */
export type TemplatesConnection = {
  __typename?: 'TemplatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TemplatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Template>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TemplatesEdge = {
  __typename?: 'TemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Template;
};

export enum TokenType {
  Application = 'APPLICATION',
  Device = 'DEVICE',
  User = 'USER'
}

export type TokenTypeOperationFilterInput = {
  eq?: InputMaybe<TokenType>;
  in?: InputMaybe<Array<TokenType>>;
  neq?: InputMaybe<TokenType>;
  nin?: InputMaybe<Array<TokenType>>;
};

export enum TransferEncoding {
  Base64 = 'BASE64',
  EightBit = 'EIGHT_BIT',
  QuotedPrintable = 'QUOTED_PRINTABLE',
  SevenBit = 'SEVEN_BIT',
  Unknown = 'UNKNOWN'
}

export type TransferEncodingOperationFilterInput = {
  eq?: InputMaybe<TransferEncoding>;
  in?: InputMaybe<Array<TransferEncoding>>;
  neq?: InputMaybe<TransferEncoding>;
  nin?: InputMaybe<Array<TransferEncoding>>;
};

export type User = {
  __typename?: 'User';
  accessGroups: Array<AuthorizationAccessGroup>;
  authorizationTokens?: Maybe<Array<AuthorizationToken>>;
  company: Company;
  companyId: Scalars['Long']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  keycloakId?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  userSettings?: Maybe<Scalars['String']['output']>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  impersonate?: Maybe<Scalars['Boolean']['output']>;
  manage?: Maybe<Scalars['Boolean']['output']>;
  manageGroupMembership?: Maybe<Scalars['Boolean']['output']>;
  mapRoles?: Maybe<Scalars['Boolean']['output']>;
  view?: Maybe<Scalars['Boolean']['output']>;
};

export type UserAccessFilterInput = {
  and?: InputMaybe<Array<UserAccessFilterInput>>;
  impersonate?: InputMaybe<BooleanOperationFilterInput>;
  manage?: InputMaybe<BooleanOperationFilterInput>;
  manageGroupMembership?: InputMaybe<BooleanOperationFilterInput>;
  mapRoles?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<UserAccessFilterInput>>;
  view?: InputMaybe<BooleanOperationFilterInput>;
};

export type UserAccessSortInput = {
  impersonate?: InputMaybe<SortEnumType>;
  manage?: InputMaybe<SortEnumType>;
  manageGroupMembership?: InputMaybe<SortEnumType>;
  mapRoles?: InputMaybe<SortEnumType>;
  view?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserGraphQl>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type UserConsent = {
  __typename?: 'UserConsent';
  clientId?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Long']['output']>;
  grantedClientScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastUpdatedDate?: Maybe<Scalars['Long']['output']>;
};

export type UserConsentFilterInput = {
  and?: InputMaybe<Array<UserConsentFilterInput>>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<LongOperationFilterInput>;
  grantedClientScopes?: InputMaybe<ListStringOperationFilterInput>;
  lastUpdatedDate?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<UserConsentFilterInput>>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserGraphQl;
};

export type UserFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<UserFilterInput>>;
  authorizationTokens?: InputMaybe<ListFilterInputTypeOfAuthorizationTokenFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<LongOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  keycloakId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleFilterInput>;
  userSettings?: InputMaybe<StringOperationFilterInput>;
};

export type UserGraphQl = {
  __typename?: 'UserGraphQl';
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  keycloakId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<RoleGraphQl>>;
  userName?: Maybe<Scalars['String']['output']>;
  userSettings?: Maybe<Scalars['String']['output']>;
};

export type UserGraphQlFilterInput = {
  and?: InputMaybe<Array<UserGraphQlFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  keycloakId?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserGraphQlFilterInput>>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleGraphQlFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
  userSettings?: InputMaybe<StringOperationFilterInput>;
};

export type UserGraphQlSortInput = {
  description?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  keycloakId?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
  userSettings?: InputMaybe<SortEnumType>;
};

export type UserLogAction = {
  __typename?: 'UserLogAction';
  actionDate: Scalars['DateTime']['output'];
  apiTranslation?: Maybe<Scalars['String']['output']>;
  apiUrl: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  responseBody?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  userActionType: ActionLoggingType;
  userId: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type UserLogActionConnection = {
  __typename?: 'UserLogActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserLogActionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserLogAction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserLogActionEdge = {
  __typename?: 'UserLogActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserLogAction;
};

export type UserLogActionFilterInput = {
  actionDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<UserLogActionFilterInput>>;
  apiTranslation?: InputMaybe<StringOperationFilterInput>;
  apiUrl?: InputMaybe<StringOperationFilterInput>;
  data?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UserLogActionFilterInput>>;
  responseBody?: InputMaybe<StringOperationFilterInput>;
  responseCode?: InputMaybe<IntOperationFilterInput>;
  userActionType?: InputMaybe<ActionLoggingTypeOperationFilterInput>;
  userId?: InputMaybe<LongOperationFilterInput>;
};

export type UserLogActionSortInput = {
  actionDate?: InputMaybe<SortEnumType>;
  apiTranslation?: InputMaybe<SortEnumType>;
  apiUrl?: InputMaybe<SortEnumType>;
  data?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  responseBody?: InputMaybe<SortEnumType>;
  responseCode?: InputMaybe<SortEnumType>;
  userActionType?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};

export type StandardsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AlarmStandardFilterInput>;
  order?: InputMaybe<Array<AlarmStandardSortInput> | AlarmStandardSortInput>;
}>;


export type StandardsQuery = { __typename?: 'Query', alarmStandards?: { __typename?: 'AlarmStandardsConnection', totalCount: number, nodes?: Array<{ __typename?: 'AlarmStandard', name: string, id: any, lastModifiedDate?: any | null, lastModifiedBy?: string | null, editable: boolean, createdDate?: any | null, createdBy?: string | null }> | null } | null };

export type AlarmProfileCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AlarmStandardFilterInput>;
}>;


export type AlarmProfileCursorQuery = { __typename?: 'Query', alarmStandards?: { __typename?: 'AlarmStandardsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'AlarmStandardsEdge', cursor: string, node: { __typename?: 'AlarmStandard', name: string, id: any } }> | null } | null };

export type NpqProfilesListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<NetworkPowerQualityFilterInput>;
  order?: InputMaybe<Array<NetworkPowerQualitySortInput> | NetworkPowerQualitySortInput>;
}>;


export type NpqProfilesListQuery = { __typename?: 'Query', networkPowerQuality?: { __typename?: 'NetworkPowerQualityConnection', totalCount: number, nodes?: Array<{ __typename?: 'NetworkPowerQuality', id: any, name: string, description?: string | null, inputReferenceFrequency: number, inputReferenceVoltage: number, negativeVoltageRVCHisterese: number, negativeVoltageRVCThreshold: number, positiveVoltageRVCHisterese: number, positiveVoltageRVCThreshold: number, voltageDipHisterese: number, voltageDipThreshold: number, voltageInterruptHisterese: number, voltageInterruptThreshold: number, voltageSwellHisterese: number, voltageSwellThreshold: number, lastModifiedDate?: any | null, createdDate?: any | null }> | null } | null };

export type NpqSchedulerListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ScheduleOperationModeFilterInput>;
  order?: InputMaybe<Array<ScheduleOperationModeSortInput> | ScheduleOperationModeSortInput>;
}>;


export type NpqSchedulerListQuery = { __typename?: 'Query', scheduleOperationMode?: { __typename?: 'ScheduleOperationModeConnection', totalCount: number, nodes?: Array<{ __typename?: 'ScheduleOperationMode', id: any, name: string, description?: string | null, enable: boolean, startDate: any, activationDate: any, duration?: number | null, recurrenceType: Duration_Type, durationType: Duration_Type, forever: boolean, recurrencyQuantity?: number | null, endDate?: any | null, executions: number, lastSchedule?: any | null, lastEndSchedule?: any | null, currentSchedule?: any | null, currentEndSchedule?: any | null, nextSchedule?: any | null, nextEndSchedule?: any | null, lastModifiedDate?: any | null, createdDate?: any | null, networkPowerQuality?: { __typename?: 'NetworkPowerQuality', id: any, name: string } | null, energyBalance?: { __typename?: 'EnergyBalance', id: any, name: string } | null, currentHarmonics?: { __typename?: 'CurrentHarmonics', id: any, name: string } | null }> | null } | null };

export type DeviceQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<DeviceFilterInput>;
  order?: InputMaybe<Array<DeviceSortInput> | DeviceSortInput>;
}>;


export type DeviceQuery = { __typename?: 'Query', devices?: { __typename?: 'DevicesConnection', totalCount: number, nodes?: Array<{ __typename?: 'Device', id: any, bulkConfigurationId?: any | null, serialNumber: string, deviceType: Device_Type, deviceToken: string, isEnabled?: boolean | null, isDeleted: boolean, acquisitionRate?: number | null, communicationRate?: number | null, lastCommunication?: any | null, configRefreshInterval: number, lastConfigTs?: any | null, createdBy?: string | null, createdDate?: any | null, lastModifiedBy?: string | null, lastModifiedDate?: any | null, firmwareVersion: string, firmwareDeployDate?: any | null, isCommissioned: boolean, assetName?: string | null, comissionDate?: any | null } | null> | null } | null };

export type EnterprisesQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<EnterpriseFilterInput>;
}>;


export type EnterprisesQuery = { __typename?: 'Query', enterprises?: { __typename?: 'EnterprisesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'EnterprisesEdge', cursor: string, node?: { __typename?: 'Enterprise', id: any, name: string } | null }> | null } | null };

export type Regions_By_CompanyIdQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['Long']['input']>;
}>;


export type Regions_By_CompanyIdQuery = { __typename?: 'Query', regions?: { __typename?: 'RegionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Region', id: any, name: string, code: string, companyId: any, operationalAreas: Array<{ __typename?: 'OperationalArea', name: string, code: string, regionId: any, gpsPoints: Array<{ __typename?: 'GpsPoint', longitude: number, latitude: number, designOrder: number }> }>, gpsPoints: Array<{ __typename?: 'GpsPoint', longitude: number, latitude: number, designOrder: number }> } | null> | null } | null };

export type OperationalAreasQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OperationalAreaFilterInput>;
  order?: InputMaybe<Array<OperationalAreaSortInput> | OperationalAreaSortInput>;
}>;


export type OperationalAreasQuery = { __typename?: 'Query', operationalAreas?: { __typename?: 'OperationalAreasConnection', totalCount: number, nodes?: Array<{ __typename?: 'OperationalArea', name: string, code: string, id: any, regionId: any, gpsPoints: Array<{ __typename?: 'GpsPoint', id: any, latitude: number, longitude: number, designOrder: number }> } | null> | null } | null };

export type RegionsCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RegionFilterInput>;
}>;


export type RegionsCursorQuery = { __typename?: 'Query', regions?: { __typename?: 'RegionsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'RegionsEdge', cursor: string, node?: { __typename?: 'Region', id: any, name: string } | null }> | null } | null };

export type RegionListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<RegionFilterInput>;
  order?: InputMaybe<Array<RegionSortInput> | RegionSortInput>;
}>;


export type RegionListQuery = { __typename?: 'Query', regions?: { __typename?: 'RegionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Region', id: any, name: string, code: string, companyId: any, operationalAreas: Array<{ __typename?: 'OperationalArea', id: any, name: string, code: string, regionId: any, gpsPoints: Array<{ __typename?: 'GpsPoint', longitude: number, latitude: number, designOrder: number }> }>, gpsPoints: Array<{ __typename?: 'GpsPoint', longitude: number, latitude: number, designOrder: number }> } | null> | null } | null };

export type CompanysCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CompanyFilterInput>;
}>;


export type CompanysCursorQuery = { __typename?: 'Query', companys?: { __typename?: 'CompanysConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'CompanysEdge', cursor: string, node?: { __typename?: 'Company', country?: string | null, description?: string | null, id: any, name: string, website?: string | null, enterpriseId: any, image?: string | null } | null }> | null } | null };

export type ReportsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ReportDtoFilterInput>;
  order?: InputMaybe<Array<ReportDtoSortInput> | ReportDtoSortInput>;
}>;


export type ReportsQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ReportDTO', created: any, description: string, equipments: Array<number>, errors: string, name: string, period_end: any, period_start: any, periodic: boolean, ready: boolean, report_type: string, requested_by: string, size: number, title: string, _id: string }> | null } | null };

export type ReportQueryVariables = Exact<{
  reportId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportsConnection', nodes?: Array<{ __typename?: 'ReportDTO', created: any, description: string, equipments: Array<number>, errors: string, name: string, period_end: any, period_start: any, periodic: boolean, ready: boolean, report_type: string, requested_by: string, size: number, title: string, _id: string }> | null } | null };

export type AccessGroupsQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AccessGroupFilterInput>;
  order?: InputMaybe<Array<AccessGroupSortInput> | AccessGroupSortInput>;
}>;


export type AccessGroupsQuery = { __typename?: 'Query', accessGroups?: { __typename?: 'AccessGroupsConnection', totalCount: number, nodes?: Array<{ __typename?: 'AccessGroup', id: any, name: string, description?: string | null, isEnabled: boolean, lastModifiedBy?: string | null, lastModifiedDate?: any | null, createdDate?: any | null, createdBy?: string | null, isProtected: boolean, isDefault: boolean } | null> | null } | null };

export type AssetFeedersByNameQueryVariables = Exact<{
  assetName?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssetFeedersByNameQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetsConnection', nodes?: Array<{ __typename?: 'Asset', id: any, name: string, feeders: Array<{ __typename?: 'Feeder', id: any, name: string }> }> | null } | null };

export type AssetTypeQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AssetFilterInput>;
  order?: InputMaybe<Array<AssetSortInput> | AssetSortInput>;
}>;


export type AssetTypeQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetsConnection', nodes?: Array<{ __typename?: 'Asset', id: any, name: string }> | null } | null };

export type AssetParentCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AssetFilterInput>;
}>;


export type AssetParentCursorQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'AssetsEdge', cursor: string, node: { __typename?: 'Asset', name: string, id: any } }> | null } | null };

export type AssetsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AssetSortInput> | AssetSortInput>;
  filter?: InputMaybe<AssetFilterInput>;
}>;


export type AssetsQuery = { __typename?: 'Query', assets?: { __typename: 'AssetsConnection', totalCount: number, nodes?: Array<{ __typename: 'Asset', id: any, parentAssetName?: string | null, parentFeederName?: string | null, assetType: Asset_Type, longitude?: number | null, latitude?: number | null, lastModifiedDate?: any | null, state: Asset_State, registryNumber: string, name: string, isEnabled: boolean, description?: string | null, alarmStandardName?: string | null, createdDate?: any | null, hasEarthData: boolean, hasRawData: boolean, hasEvents: boolean, lastCommissioningDate?: any | null, operationalArea?: { __typename: 'EquipmentsOperationalArea', name: string } | null, region?: { __typename: 'EquipmentsRegion', name: string } | null, devices: Array<{ __typename: 'EquipmentsDevice', serialNumber: string }> }> | null } | null };

export type DeviceBulkConfigurationsListQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  order?: InputMaybe<Array<DeviceBulkConfigurationSortInput> | DeviceBulkConfigurationSortInput>;
}>;


export type DeviceBulkConfigurationsListQuery = { __typename?: 'Query', deviceBulkConfigurations?: { __typename?: 'DeviceBulkConfigurationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeviceBulkConfiguration', id: any, name: string, communicationRate: number, aquisitionRate: number }> | null } | null };

export type ConfigurationProfileCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DeviceBulkConfigurationFilterInput>;
}>;


export type ConfigurationProfileCursorQuery = { __typename?: 'Query', deviceBulkConfigurations?: { __typename?: 'DeviceBulkConfigurationsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'DeviceBulkConfigurationsEdge', cursor: string, node: { __typename?: 'DeviceBulkConfiguration', name: string, communicationRate: number, aquisitionRate: number, id: any } }> | null } | null };

export type CableTypesQueryVariables = Exact<{
  filter?: InputMaybe<CableTypeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CableTypeSortInput> | CableTypeSortInput>;
}>;


export type CableTypesQuery = { __typename?: 'Query', cableTypes?: { __typename?: 'CableTypesConnection', totalCount: number, nodes?: Array<{ __typename?: 'CableType', name: string, id: any, createdDate?: any | null, cores: number, color: string, coreSection: number, createdBy?: string | null, fuseWay?: number | null, lastModifiedBy?: string | null, lastModifiedDate?: any | null }> | null } | null };

export type CompaniesRegionsQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CompanyFilterInput>;
  order?: InputMaybe<Array<CompanySortInput> | CompanySortInput>;
}>;


export type CompaniesRegionsQuery = { __typename?: 'Query', companys?: { __typename?: 'CompanysConnection', totalCount: number, nodes?: Array<{ __typename?: 'Company', id: any, name: string } | null> | null } | null };

export type CompanysQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CompanyFilterInput>;
  order?: InputMaybe<Array<CompanySortInput> | CompanySortInput>;
}>;


export type CompanysQuery = { __typename?: 'Query', companys?: { __typename?: 'CompanysConnection', totalCount: number, nodes?: Array<{ __typename?: 'Company', country?: string | null, description?: string | null, id: any, name: string, website?: string | null, enterpriseId: any, image?: string | null } | null> | null } | null };

export type ConTestConfigurationListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ConTestExtendedFilterInput>;
  order?: InputMaybe<Array<ConTestExtendedSortInput> | ConTestExtendedSortInput>;
}>;


export type ConTestConfigurationListQuery = { __typename?: 'Query', conTestsExtended?: { __typename?: 'ConTestsExtendedConnection', totalCount: number, nodes?: Array<{ __typename?: 'ConTestExtended', id: any, name: string, testedDevices: any, remainingDevices: any, remainingSimCards: any, lastModifiedDate?: any | null, createdDate?: any | null }> | null } | null };

export type ConTestResultsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ConTestDeviceResultFilterInput>;
  order?: InputMaybe<Array<ConTestDeviceResultSortInput> | ConTestDeviceResultSortInput>;
}>;


export type ConTestResultsListQuery = { __typename?: 'Query', conTestDeviceResults?: { __typename?: 'ConTestDeviceResultsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ConTestDeviceResult', id: any, result: Con_Test_Result_Type, lastModifiedDate?: any | null, createdDate?: any | null, device: { __typename?: 'Device', id: any, name?: string | null, serialNumber: string, simCard?: { __typename?: 'SimCard', iccid: string } | null } }> | null } | null };

export type CountersQueryVariables = Exact<{
  assetFilter?: InputMaybe<AssetFilterInput>;
  alarmFilter?: InputMaybe<EventFilterInput>;
  deviceFilter?: InputMaybe<DeviceFilterInput>;
}>;


export type CountersQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetsConnection', totalCount: number } | null, events?: { __typename?: 'EventsConnection', totalCount: number } | null, devices?: { __typename?: 'DevicesConnection', totalCount: number } | null };

export type DeviceBulkConfigurationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  order?: InputMaybe<Array<DeviceBulkConfigurationSortInput> | DeviceBulkConfigurationSortInput>;
}>;


export type DeviceBulkConfigurationsQuery = { __typename?: 'Query', deviceBulkConfigurations?: { __typename?: 'DeviceBulkConfigurationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'DeviceBulkConfiguration', id: any, name: string, aquisitionRate: number, communicationRate: number, isDefault: boolean, timeServerUrl: string, timeServerType: Time_Server_Type, timeServerProtocol: string, timeServerPort: number, serverUrl: string, protectionEarthFrequencyF1: number, protectionEarthFrequencyF2: number, protectionEarthFrequencyF3: number, serviceEarthFrequencyF1: number, serviceEarthFrequencyF2: number, serviceEarthFrequencyF3: number, deviceTypeConfigurations: Array<{ __typename?: 'DeviceTypeConfiguration', id: any }> }> | null } | null };

export type DeviceBatchQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceBatchQuery = { __typename?: 'Query', devices?: { __typename?: 'DevicesConnection', edges?: Array<{ __typename?: 'DevicesEdge', node?: { __typename?: 'Device', batchDevice?: { __typename?: 'BatchDevice', name: string } | null } | null }> | null } | null };

export type EventsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EventFilterInput>;
  order?: InputMaybe<Array<EventSortInput> | EventSortInput>;
}>;


export type EventsQuery = { __typename?: 'Query', events?: { __typename?: 'EventsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Event', id: any, equipmentId?: any | null, endDate?: any | null, hasWFC: boolean, createdBy?: string | null, createdDate?: any | null, lastModifiedBy?: string | null, lastModifiedDate?: any | null, deviceId?: any | null, feederId?: any | null, line?: string | null, portNumber?: number | null, entityType: EventEntityType, status: EventStatus, severity: EventSeverity, startDate?: any | null, notes?: string | null, feederName?: string | null, source: Source, sourceEntityType: Entity_Type, registrationNumber?: string | null, name: string, deviceSerial?: string | null, type: EventType }> | null } | null };

export type Events_By_Equipment_IdQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  equipmentId?: InputMaybe<Scalars['Long']['input']>;
}>;


export type Events_By_Equipment_IdQuery = { __typename?: 'Query', events?: { __typename?: 'EventsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Event', id: any, equipmentId?: any | null, endDate?: any | null, createdBy?: string | null, createdDate?: any | null, lastModifiedBy?: string | null, lastModifiedDate?: any | null, deviceId?: any | null, feederId?: any | null, line?: string | null, portNumber?: number | null, entityType: EventEntityType, status: EventStatus, severity: EventSeverity, startDate?: any | null, notes?: string | null, feederName?: string | null, source: Source, sourceEntityType: Entity_Type, registrationNumber?: string | null, name: string, deviceSerial?: string | null, type: EventType }> | null } | null };

export type EventStatusQueryVariables = Exact<{
  total?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EventStatusQuery = { __typename?: 'Query', events?: { __typename?: 'EventsConnection', totalCount: number, edges?: Array<{ __typename?: 'EventsEdge', node: { __typename?: 'Event', severity: EventSeverity, equipmentId?: any | null, feederId?: any | null, deviceId?: any | null, deviceSerial?: string | null, id: any } }> | null } | null };

export type FeedersQueryVariables = Exact<{
  filter?: InputMaybe<FeederFilterInput>;
}>;


export type FeedersQuery = { __typename?: 'Query', feeders?: { __typename?: 'FeedersConnection', nodes?: Array<{ __typename?: 'Feeder', assetId: any, name: string, id: any }> | null } | null };

export type AssetFeederCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FeederFilterInput>;
}>;


export type AssetFeederCursorQuery = { __typename?: 'Query', feeders?: { __typename?: 'FeedersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'FeedersEdge', cursor: string, node: { __typename?: 'Feeder', name: string, id: any, assetId: any } }> | null } | null };

export type FirmwareTaskLogsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FirmwareTaskLogFilterInput>;
  order?: InputMaybe<Array<FirmwareTaskLogSortInput> | FirmwareTaskLogSortInput>;
}>;


export type FirmwareTaskLogsQuery = { __typename?: 'Query', firmwareTaskLog?: { __typename?: 'FirmwareTaskLogConnection', totalCount: number, nodes?: Array<{ __typename?: 'FirmwareTaskLog', updatedVersion: string, taskLog: string, status: Firmware_Task_Status, startDate: any, progress: number, numberBlocks: number, lastModifiedDate?: any | null, lastModifiedBy?: string | null, id: any, firmwareTaskId?: any | null, endDate?: any | null, downloadAttempts: number, deviceId: any, currentVersion: string, currentBlock: number, createdDate?: any | null, createdBy?: string | null, device: { __typename?: 'Device', id: any, serialNumber: string } }> | null } | null };

export type FirmwareTasksQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FirmwareTaskFilterInput>;
  order?: InputMaybe<Array<FirmwareTaskSortInput> | FirmwareTaskSortInput>;
}>;


export type FirmwareTasksQuery = { __typename?: 'Query', firmwareTasks?: { __typename?: 'FirmwareTasksConnection', totalCount: number, nodes?: Array<{ __typename?: 'FirmwareTask', id: any, cancelDate?: any | null, createdBy?: string | null, createdDate?: any | null, firmwareId: any, lastModifiedBy?: string | null, lastModifiedDate?: any | null, processed: boolean, processedDate?: any | null, scheduleDate: any, taskName: string, devices?: Array<{ __typename?: 'Device', id: any, serialNumber: string }> | null, operationalAreas?: Array<{ __typename?: 'DevicesOperationalArea', id: any, name: string }> | null, regions?: Array<{ __typename?: 'DevicesRegion', id: any, name: string }> | null, companies?: Array<{ __typename?: 'DevicesCompany', id: any, name: string }> | null, firmware: { __typename?: 'Firmware', name: string }, firmwareTaskLogs?: Array<{ __typename?: 'FirmwareTaskLog', createdBy?: string | null, createdDate?: any | null, currentBlock: number, currentVersion: string, deviceId: any, downloadAttempts: number, endDate?: any | null, firmwareTaskId?: any | null, id: any, lastModifiedBy?: string | null, lastModifiedDate?: any | null, numberBlocks: number, progress: number, startDate: any, status: Firmware_Task_Status, taskLog: string, updatedVersion: string, device: { __typename?: 'Device', serialNumber: string } }> | null }> | null } | null };

export type FirmwareTaskQueryVariables = Exact<{
  firmwareTaskId?: InputMaybe<Scalars['Long']['input']>;
}>;


export type FirmwareTaskQuery = { __typename?: 'Query', firmwareTasks?: { __typename?: 'FirmwareTasksConnection', nodes?: Array<{ __typename?: 'FirmwareTask', id: any, cancelDate?: any | null, createdBy?: string | null, createdDate?: any | null, firmwareId: any, lastModifiedBy?: string | null, lastModifiedDate?: any | null, processed: boolean, processedDate?: any | null, scheduleDate: any, taskName: string, devices?: Array<{ __typename?: 'Device', id: any, serialNumber: string }> | null, operationalAreas?: Array<{ __typename?: 'DevicesOperationalArea', id: any, name: string }> | null, regions?: Array<{ __typename?: 'DevicesRegion', id: any, name: string }> | null, companies?: Array<{ __typename?: 'DevicesCompany', id: any, name: string }> | null, firmware: { __typename?: 'Firmware', name: string }, firmwareTaskLogs?: Array<{ __typename?: 'FirmwareTaskLog', createdBy?: string | null, createdDate?: any | null, currentBlock: number, currentVersion: string, deviceId: any, downloadAttempts: number, endDate?: any | null, firmwareTaskId?: any | null, id: any, lastModifiedBy?: string | null, lastModifiedDate?: any | null, numberBlocks: number, progress: number, startDate: any, status: Firmware_Task_Status, taskLog: string, updatedVersion: string, device: { __typename?: 'Device', serialNumber: string } }> | null }> | null } | null };

export type HvSubstationsQueryVariables = Exact<{ [key: string]: never; }>;


export type HvSubstationsQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetsConnection', nodes?: Array<{ __typename?: 'Asset', id: any, name: string, registryNumber: string, feeders: Array<{ __typename?: 'Feeder', id: any, name: string }> }> | null } | null };

export type OperationalAreasCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OperationalAreaFilterInput>;
}>;


export type OperationalAreasCursorQuery = { __typename?: 'Query', operationalAreas?: { __typename?: 'OperationalAreasConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'OperationalAreasEdge', cursor: string, node?: { __typename?: 'OperationalArea', name: string, code: string, id: any } | null }> | null } | null };

export type SimCardsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SimCardSortInput> | SimCardSortInput>;
  filter?: InputMaybe<SimCardFilterInput>;
}>;


export type SimCardsQuery = { __typename?: 'Query', simCards?: { __typename?: 'SimCardsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SimCard', apnAuthType: Apn_Auth_Type, apnName: string, apnPwd?: string | null, apnUser?: string | null, apnIp?: string | null, associationDate?: any | null, associationLog?: string | null, associationSucess?: boolean | null, batchSimId: any, createdBy?: string | null, createdDate?: any | null, filename: string, iccid: string, id: any, importDate: any, imsi?: string | null, lastModifiedBy?: string | null, lastModifiedDate?: any | null, simIp?: string | null, simStatusType: Sim_Status_Type, device?: { __typename?: 'Device', id: any, serialNumber: string } | null, batchSim: { __typename?: 'BatchSim', createdBy?: string | null, createdDate?: any | null, id: any, lastModifiedBy?: string | null, lastModifiedDate?: any | null, name: string } }> | null } | null };

export type SimCardBatchQueryVariables = Exact<{ [key: string]: never; }>;


export type SimCardBatchQuery = { __typename?: 'Query', simCards?: { __typename?: 'SimCardsConnection', edges?: Array<{ __typename?: 'SimCardsEdge', node: { __typename?: 'SimCard', id: any } }> | null } | null };

export type SubscriptionListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SubscriptionFilterInput>;
  order?: InputMaybe<Array<SubscriptionSortInput> | SubscriptionSortInput>;
}>;


export type SubscriptionListQuery = { __typename?: 'Query', subscriptions?: { __typename?: 'SubscriptionsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Subscription', id: any, createdBy?: string | null, createdDate?: any | null, isActive: boolean, lastModifiedBy?: string | null, lastModifiedDate?: any | null, name: string }> | null } | null };

export type SubstationsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Long']['input']>;
}>;


export type SubstationsQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetsConnection', nodes?: Array<{ __typename?: 'Asset', id: any, feeders: Array<{ __typename?: 'Feeder', id: any, name: string, description: string }> }> | null } | null };

export type SubstationsFeedersByNameQueryVariables = Exact<{
  feederName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SubstationsFeedersByNameQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetsConnection', nodes?: Array<{ __typename?: 'Asset', id: any, name: string }> | null } | null };

export type TemplatesQueryVariables = Exact<{
  filter?: InputMaybe<TemplateFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TemplateSortInput> | TemplateSortInput>;
}>;


export type TemplatesQuery = { __typename?: 'Query', templates?: { __typename?: 'TemplatesConnection', totalCount: number, nodes?: Array<{ __typename?: 'Template', id: any, name: string, isDefault: boolean, messageType: Template_Message_Type, notificationType: Notification_Type }> | null } | null };

export type UserRolesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<RoleGraphQlFilterInput>;
  order?: InputMaybe<Array<RoleGraphQlSortInput> | RoleGraphQlSortInput>;
}>;


export type UserRolesQuery = { __typename?: 'Query', role?: { __typename?: 'RoleConnection', totalCount: number, nodes?: Array<{ __typename?: 'RoleGraphQl', id?: any | null, name?: string | null }> | null } | null };

export type UsersQueryVariables = Exact<{
  last?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<UserGraphQlFilterInput>;
  order?: InputMaybe<Array<UserGraphQlSortInput> | UserGraphQlSortInput>;
}>;


export type UsersQuery = { __typename?: 'Query', user?: { __typename?: 'UserConnection', totalCount: number, nodes?: Array<{ __typename?: 'UserGraphQl', id?: any | null, email?: string | null, firstName?: string | null, lastName?: string | null, description?: string | null, roles?: Array<{ __typename?: 'RoleGraphQl', id?: any | null, name?: string | null }> | null }> | null } | null };

export type AssetsCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AssetFilterInput>;
}>;


export type AssetsCursorQuery = { __typename?: 'Query', assets?: { __typename?: 'AssetsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'AssetsEdge', cursor: string, node: { __typename?: 'Asset', id: any, name: string } }> | null } | null };

export type NpqShedulersQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ScheduleOperationModeFilterInput>;
}>;


export type NpqShedulersQuery = { __typename?: 'Query', scheduleOperationMode?: { __typename?: 'ScheduleOperationModeConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ScheduleOperationModeEdge', cursor: string, node: { __typename?: 'ScheduleOperationMode', id: any, name: string } }> | null } | null };

export type ConfigurationProfilesCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DeviceBulkConfigurationFilterInput>;
}>;


export type ConfigurationProfilesCursorQuery = { __typename?: 'Query', deviceBulkConfigurations?: { __typename?: 'DeviceBulkConfigurationsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'DeviceBulkConfigurationsEdge', cursor: string, node: { __typename?: 'DeviceBulkConfiguration', id: any, name: string, aquisitionRate: number, communicationRate: number } }> | null } | null };

export type BatchDevicesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<BatchDeviceFilterInput>;
  order?: InputMaybe<Array<BatchDeviceSortInput> | BatchDeviceSortInput>;
}>;


export type BatchDevicesQuery = { __typename?: 'Query', batchDevices?: { __typename?: 'BatchDevicesConnection', totalCount: number, nodes?: Array<{ __typename?: 'BatchDevice', id: any, name: string, lastModifiedDate?: any | null, createdDate?: any | null }> | null } | null };

export type BatchDevicesLazyQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type BatchDevicesLazyQuery = { __typename?: 'Query', batchDevices?: { __typename?: 'BatchDevicesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'BatchDevicesEdge', cursor: string, node: { __typename?: 'BatchDevice', id: any, name: string } }> | null } | null };

export type BatchSiMsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<BatchSimFilterInput>;
  order?: InputMaybe<Array<BatchSimSortInput> | BatchSimSortInput>;
}>;


export type BatchSiMsQuery = { __typename?: 'Query', batchSims?: { __typename?: 'BatchSimsConnection', totalCount: number, nodes?: Array<{ __typename?: 'BatchSim', id: any, name: string, lastModifiedDate?: any | null, createdDate?: any | null }> | null } | null };

export type ContactsQueryVariables = Exact<{
  filter?: InputMaybe<ContactFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContactSortInput> | ContactSortInput>;
}>;


export type ContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactsConnection', totalCount: number, nodes?: Array<{ __typename?: 'Contact', id: any, firstName?: string | null, lastName?: string | null, email: string, phone?: string | null, url?: string | null, createdBy?: string | null, createdDate?: any | null, lastModifiedBy?: string | null, lastModifiedDate?: any | null }> | null } | null };

export type FirmwareQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FirmwareFilterInput>;
  order?: InputMaybe<Array<FirmwareSortInput> | FirmwareSortInput>;
}>;


export type FirmwareQuery = { __typename?: 'Query', firmwares?: { __typename?: 'FirmwaresConnection', totalCount: number, nodes?: Array<{ __typename?: 'Firmware', id: any, name: string, createdBy?: string | null, createdDate?: any | null, lastModifiedBy?: string | null, lastModifiedDate?: any | null, firmwareTasks?: Array<{ __typename?: 'FirmwareTask', id: any, processed: boolean, taskName: string }> | null }> | null } | null };

export type FirmwareCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FirmwareFilterInput>;
}>;


export type FirmwareCursorQuery = { __typename?: 'Query', firmwares?: { __typename?: 'FirmwaresConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'FirmwaresEdge', cursor: string, node: { __typename?: 'Firmware', id: any, name: string, createdBy?: string | null, createdDate?: any | null, lastModifiedBy?: string | null, lastModifiedDate?: any | null, firmwareTasks?: Array<{ __typename?: 'FirmwareTask', id: any, processed: boolean, taskName: string }> | null } }> | null } | null };

export type FirmwareDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<FirmwareDocumentFilterInput>;
  order?: InputMaybe<Array<FirmwareDocumentSortInput> | FirmwareDocumentSortInput>;
}>;


export type FirmwareDocumentsQuery = { __typename?: 'Query', devicesFirmwareDocuments?: { __typename?: 'DevicesFirmwareDocumentsConnection', totalCount: number, nodes?: Array<{ __typename?: 'DevicesFirmwareDocument', version: string, name: string, microType: Micro_Controller_Type, id: any, externalId: any, deviceType: Device_Type, firmware: { __typename?: 'Firmware', id: any } }> | null } | null };

export type BatchSimCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<BatchSimFilterInput>;
}>;


export type BatchSimCursorQuery = { __typename?: 'Query', batchSims?: { __typename?: 'BatchSimsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'BatchSimsEdge', cursor: string, node: { __typename?: 'BatchSim', id: any, name: string, lastModifiedDate?: any | null, createdDate?: any | null } }> | null } | null };

export type DeviceCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<DeviceFilterInput>;
}>;


export type DeviceCursorQuery = { __typename?: 'Query', devices?: { __typename?: 'DevicesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'DevicesEdge', cursor: string, node?: { __typename?: 'Device', id: any, serialNumber: string, deviceType: Device_Type, deviceToken: string } | null }> | null } | null };

export type AccessGroupsCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AccessGroupFilterInput>;
}>;


export type AccessGroupsCursorQuery = { __typename?: 'Query', accessGroups?: { __typename?: 'AccessGroupsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'AccessGroupsEdge', cursor: string, node?: { __typename?: 'AccessGroup', id: any, name: string } | null }> | null } | null };

export type UserRolesCursorQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<RoleGraphQlFilterInput>;
}>;


export type UserRolesCursorQuery = { __typename?: 'Query', role?: { __typename?: 'RoleConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'RoleEdge', cursor: string, node: { __typename?: 'RoleGraphQl', id?: any | null, name?: string | null } }> | null } | null };


export const StandardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"standards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AlarmStandardFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AlarmStandardSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alarmStandards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"editable"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<StandardsQuery, StandardsQueryVariables>;
export const AlarmProfileCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"alarmProfileCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AlarmStandardFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alarmStandards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AlarmProfileCursorQuery, AlarmProfileCursorQueryVariables>;
export const NpqProfilesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NPQProfilesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NetworkPowerQualityFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NetworkPowerQualitySortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"networkPowerQuality"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"inputReferenceFrequency"}},{"kind":"Field","name":{"kind":"Name","value":"inputReferenceVoltage"}},{"kind":"Field","name":{"kind":"Name","value":"negativeVoltageRVCHisterese"}},{"kind":"Field","name":{"kind":"Name","value":"negativeVoltageRVCThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"positiveVoltageRVCHisterese"}},{"kind":"Field","name":{"kind":"Name","value":"positiveVoltageRVCThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"voltageDipHisterese"}},{"kind":"Field","name":{"kind":"Name","value":"voltageDipThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"voltageInterruptHisterese"}},{"kind":"Field","name":{"kind":"Name","value":"voltageInterruptThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"voltageSwellHisterese"}},{"kind":"Field","name":{"kind":"Name","value":"voltageSwellThreshold"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<NpqProfilesListQuery, NpqProfilesListQueryVariables>;
export const NpqSchedulerListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NPQSchedulerList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleOperationModeFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleOperationModeSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleOperationMode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"enable"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"activationDate"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceType"}},{"kind":"Field","name":{"kind":"Name","value":"durationType"}},{"kind":"Field","name":{"kind":"Name","value":"forever"}},{"kind":"Field","name":{"kind":"Name","value":"recurrencyQuantity"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"executions"}},{"kind":"Field","name":{"kind":"Name","value":"lastSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"lastEndSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"currentEndSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"nextSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"nextEndSchedule"}},{"kind":"Field","name":{"kind":"Name","value":"networkPowerQuality"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"energyBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentHarmonics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<NpqSchedulerListQuery, NpqSchedulerListQueryVariables>;
export const DeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Device"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bulkConfigurationId"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"deviceToken"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"acquisitionRate"}},{"kind":"Field","name":{"kind":"Name","value":"communicationRate"}},{"kind":"Field","name":{"kind":"Name","value":"lastCommunication"}},{"kind":"Field","name":{"kind":"Name","value":"configRefreshInterval"}},{"kind":"Field","name":{"kind":"Name","value":"lastConfigTs"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareVersion"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareDeployDate"}},{"kind":"Field","name":{"kind":"Name","value":"isCommissioned"}},{"kind":"Field","name":{"kind":"Name","value":"assetName"}},{"kind":"Field","name":{"kind":"Name","value":"comissionDate"}}]}}]}}]}}]} as unknown as DocumentNode<DeviceQuery, DeviceQueryVariables>;
export const EnterprisesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"enterprises"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EnterpriseFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enterprises"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EnterprisesQuery, EnterprisesQueryVariables>;
export const Regions_By_CompanyIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Regions_By_CompanyID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"companyId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"operationalAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"gpsPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"designOrder"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gpsPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"designOrder"}}]}}]}}]}}]}}]} as unknown as DocumentNode<Regions_By_CompanyIdQuery, Regions_By_CompanyIdQueryVariables>;
export const OperationalAreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"operationalAreas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OperationalAreaFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OperationalAreaSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationalAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"gpsPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"designOrder"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OperationalAreasQuery, OperationalAreasQueryVariables>;
export const RegionsCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"regionsCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RegionFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegionsCursorQuery, RegionsCursorQueryVariables>;
export const RegionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RegionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RegionFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegionSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"operationalAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}},{"kind":"Field","name":{"kind":"Name","value":"gpsPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"designOrder"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"gpsPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"designOrder"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegionListQuery, RegionListQueryVariables>;
export const CompanysCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companysCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CompanysCursorQuery, CompanysCursorQueryVariables>;
export const ReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Reports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportDTOFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportDTOSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"equipments"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"periodic"}},{"kind":"Field","name":{"kind":"Name","value":"ready"}},{"kind":"Field","name":{"kind":"Name","value":"report_type"}},{"kind":"Field","name":{"kind":"Name","value":"requested_by"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ReportsQuery, ReportsQueryVariables>;
export const ReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Report"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"equipments"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"period_end"}},{"kind":"Field","name":{"kind":"Name","value":"period_start"}},{"kind":"Field","name":{"kind":"Name","value":"periodic"}},{"kind":"Field","name":{"kind":"Name","value":"ready"}},{"kind":"Field","name":{"kind":"Name","value":"report_type"}},{"kind":"Field","name":{"kind":"Name","value":"requested_by"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}}]}}]}}]} as unknown as DocumentNode<ReportQuery, ReportQueryVariables>;
export const AccessGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accessGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGroupFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGroupSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"isProtected"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]}}]} as unknown as DocumentNode<AccessGroupsQuery, AccessGroupsQueryVariables>;
export const AssetFeedersByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssetFeedersByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetName"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"feeders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssetFeedersByNameQuery, AssetFeedersByNameQueryVariables>;
export const AssetTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssetType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AssetTypeQuery, AssetTypeQueryVariables>;
export const AssetParentCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assetParentCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssetParentCursorQuery, AssetParentCursorQueryVariables>;
export const AssetsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Assets"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parentAssetName"}},{"kind":"Field","name":{"kind":"Name","value":"parentFeederName"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"operationalArea"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"registryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"alarmStandardName"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"hasEarthData"}},{"kind":"Field","name":{"kind":"Name","value":"hasRawData"}},{"kind":"Field","name":{"kind":"Name","value":"hasEvents"}},{"kind":"Field","name":{"kind":"Name","value":"lastCommissioningDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<AssetsQuery, AssetsQueryVariables>;
export const DeviceBulkConfigurationsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeviceBulkConfigurationsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceBulkConfigurationFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceBulkConfigurationSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceBulkConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"communicationRate"}},{"kind":"Field","name":{"kind":"Name","value":"aquisitionRate"}}]}}]}}]}}]} as unknown as DocumentNode<DeviceBulkConfigurationsListQuery, DeviceBulkConfigurationsListQueryVariables>;
export const ConfigurationProfileCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"configurationProfileCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceBulkConfigurationFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceBulkConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"communicationRate"}},{"kind":"Field","name":{"kind":"Name","value":"aquisitionRate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfigurationProfileCursorQuery, ConfigurationProfileCursorQueryVariables>;
export const CableTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CableTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CableTypeFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CableTypeSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cableTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"cores"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"coreSection"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"fuseWay"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CableTypesQuery, CableTypesQueryVariables>;
export const CompaniesRegionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompaniesRegions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CompaniesRegionsQuery, CompaniesRegionsQueryVariables>;
export const CompanysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"companys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanySortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]} as unknown as DocumentNode<CompanysQuery, CompanysQueryVariables>;
export const ConTestConfigurationListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConTestConfigurationList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConTestExtendedFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConTestExtendedSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conTestsExtended"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"testedDevices"}},{"kind":"Field","name":{"kind":"Name","value":"remainingDevices"}},{"kind":"Field","name":{"kind":"Name","value":"remainingSimCards"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ConTestConfigurationListQuery, ConTestConfigurationListQueryVariables>;
export const ConTestResultsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConTestResultsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ConTestDeviceResultFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConTestDeviceResultSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conTestDeviceResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"simCard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iccid"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ConTestResultsListQuery, ConTestResultsListQueryVariables>;
export const CountersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Counters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"assetFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"alarmFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"assetFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"alarmFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CountersQuery, CountersQueryVariables>;
export const DeviceBulkConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"deviceBulkConfigurations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceBulkConfigurationFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceBulkConfigurationSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceBulkConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"aquisitionRate"}},{"kind":"Field","name":{"kind":"Name","value":"communicationRate"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"timeServerUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timeServerType"}},{"kind":"Field","name":{"kind":"Name","value":"timeServerProtocol"}},{"kind":"Field","name":{"kind":"Name","value":"timeServerPort"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"deviceTypeConfigurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"protectionEarthFrequencyF1"}},{"kind":"Field","name":{"kind":"Name","value":"protectionEarthFrequencyF2"}},{"kind":"Field","name":{"kind":"Name","value":"protectionEarthFrequencyF3"}},{"kind":"Field","name":{"kind":"Name","value":"serviceEarthFrequencyF1"}},{"kind":"Field","name":{"kind":"Name","value":"serviceEarthFrequencyF2"}},{"kind":"Field","name":{"kind":"Name","value":"serviceEarthFrequencyF3"}}]}}]}}]}}]} as unknown as DocumentNode<DeviceBulkConfigurationsQuery, DeviceBulkConfigurationsQueryVariables>;
export const DeviceBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeviceBatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"batchDeviceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchDevice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeviceBatchQuery, DeviceBatchQueryVariables>;
export const EventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Events"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EventFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EventSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentId"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasWFC"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"feederId"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"portNumber"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"feederName"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"sourceEntityType"}},{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deviceSerial"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EventsQuery, EventsQueryVariables>;
export const Events_By_Equipment_IdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Events_By_Equipment_Id"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"equipmentId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"UNRESOLVED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentId"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"feederId"}},{"kind":"Field","name":{"kind":"Name","value":"line"}},{"kind":"Field","name":{"kind":"Name","value":"portNumber"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"feederName"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"sourceEntityType"}},{"kind":"Field","name":{"kind":"Name","value":"registrationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"deviceSerial"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<Events_By_Equipment_IdQuery, Events_By_Equipment_IdQueryVariables>;
export const EventStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"total"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"UNRESOLVED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"total"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"severity"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"equipmentId"}},{"kind":"Field","name":{"kind":"Name","value":"feederId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceSerial"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EventStatusQuery, EventStatusQueryVariables>;
export const FeedersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Feeders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FeederFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FeedersQuery, FeedersQueryVariables>;
export const AssetFeederCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"assetFeederCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FeederFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"300"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"assetId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AssetFeederCursorQuery, AssetFeederCursorQueryVariables>;
export const FirmwareTaskLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmwareTaskLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareTaskLogFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareTaskLogSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmwareTaskLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatedVersion"}},{"kind":"Field","name":{"kind":"Name","value":"taskLog"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"numberBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"downloadAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"currentBlock"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FirmwareTaskLogsQuery, FirmwareTaskLogsQueryVariables>;
export const FirmwareTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmwareTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareTaskFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareTaskSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmwareTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operationalAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cancelDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareId"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"processedDate"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDate"}},{"kind":"Field","name":{"kind":"Name","value":"taskName"}},{"kind":"Field","name":{"kind":"Name","value":"firmware"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firmwareTaskLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentBlock"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"downloadAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"taskLog"}},{"kind":"Field","name":{"kind":"Name","value":"updatedVersion"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FirmwareTasksQuery, FirmwareTasksQueryVariables>;
export const FirmwareTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmwareTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firmwareTaskId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmwareTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firmwareTaskId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"operationalAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"regions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cancelDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareId"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"processedDate"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleDate"}},{"kind":"Field","name":{"kind":"Name","value":"taskName"}},{"kind":"Field","name":{"kind":"Name","value":"firmware"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firmwareTaskLogs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"currentBlock"}},{"kind":"Field","name":{"kind":"Name","value":"currentVersion"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"downloadAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareTaskId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"numberBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"taskLog"}},{"kind":"Field","name":{"kind":"Name","value":"updatedVersion"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FirmwareTaskQuery, FirmwareTaskQueryVariables>;
export const HvSubstationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HVSubstations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"HV_SUBSTATION"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"registryNumber"}},{"kind":"Field","name":{"kind":"Name","value":"feeders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HvSubstationsQuery, HvSubstationsQueryVariables>;
export const OperationalAreasCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"operationalAreasCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OperationalAreaFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationalAreas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OperationalAreasCursorQuery, OperationalAreasCursorQueryVariables>;
export const SimCardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SimCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SimCardSortInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SimCardFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"simCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apnAuthType"}},{"kind":"Field","name":{"kind":"Name","value":"apnName"}},{"kind":"Field","name":{"kind":"Name","value":"apnPwd"}},{"kind":"Field","name":{"kind":"Name","value":"apnUser"}},{"kind":"Field","name":{"kind":"Name","value":"apnIp"}},{"kind":"Field","name":{"kind":"Name","value":"associationDate"}},{"kind":"Field","name":{"kind":"Name","value":"associationLog"}},{"kind":"Field","name":{"kind":"Name","value":"associationSucess"}},{"kind":"Field","name":{"kind":"Name","value":"batchSimId"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"iccid"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"importDate"}},{"kind":"Field","name":{"kind":"Name","value":"imsi"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"simIp"}},{"kind":"Field","name":{"kind":"Name","value":"simStatusType"}},{"kind":"Field","name":{"kind":"Name","value":"device"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"batchSim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<SimCardsQuery, SimCardsQueryVariables>;
export const SimCardBatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SimCardBatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"simCards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"batchSimId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"neq"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SimCardBatchQuery, SimCardBatchQueryVariables>;
export const SubscriptionListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubscriptionList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubscriptionSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionListQuery, SubscriptionListQueryVariables>;
export const SubstationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Substations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"feeders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubstationsQuery, SubstationsQueryVariables>;
export const SubstationsFeedersByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubstationsFeedersByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feederName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feeders"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"all"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feederName"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<SubstationsFeedersByNameQuery, SubstationsFeedersByNameQueryVariables>;
export const TemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Templates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"messageType"}},{"kind":"Field","name":{"kind":"Name","value":"notificationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<TemplatesQuery, TemplatesQueryVariables>;
export const UserRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserRoles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoleGraphQlFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RoleGraphQlSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserRolesQuery, UserRolesQueryVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGraphQlFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserGraphQlSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"roles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const AssetsCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AssetsCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AssetFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AssetsCursorQuery, AssetsCursorQueryVariables>;
export const NpqShedulersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NpqShedulers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ScheduleOperationModeFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleOperationMode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NpqShedulersQuery, NpqShedulersQueryVariables>;
export const ConfigurationProfilesCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConfigurationProfilesCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceBulkConfigurationFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceBulkConfigurations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"aquisitionRate"}},{"kind":"Field","name":{"kind":"Name","value":"communicationRate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ConfigurationProfilesCursorQuery, ConfigurationProfilesCursorQueryVariables>;
export const BatchDevicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BatchDevices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchDeviceFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchDeviceSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchDevices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BatchDevicesQuery, BatchDevicesQueryVariables>;
export const BatchDevicesLazyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BatchDevicesLazy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchDevices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BatchDevicesLazyQuery, BatchDevicesLazyQueryVariables>;
export const BatchSiMsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BatchSIMs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchSimFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchSimSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchSims"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BatchSiMsQuery, BatchSiMsQueryVariables>;
export const ContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Contacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<ContactsQuery, ContactsQueryVariables>;
export const FirmwareDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Firmware"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmwares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"taskName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}}]}}]}}]}}]} as unknown as DocumentNode<FirmwareQuery, FirmwareQueryVariables>;
export const FirmwareCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmwareCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmwares"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdDate"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firmwareTasks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"processed"}},{"kind":"Field","name":{"kind":"Name","value":"taskName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FirmwareCursorQuery, FirmwareCursorQueryVariables>;
export const FirmwareDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmwareDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareDocumentFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmwareDocumentSortInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devicesFirmwareDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"microType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"firmware"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FirmwareDocumentsQuery, FirmwareDocumentsQueryVariables>;
export const BatchSimCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BatchSIMCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BatchSimFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"batchSims"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastModifiedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<BatchSimCursorQuery, BatchSimCursorQueryVariables>;
export const DeviceCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeviceCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeviceFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"devices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"500"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"serialNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deviceType"}},{"kind":"Field","name":{"kind":"Name","value":"deviceToken"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DeviceCursorQuery, DeviceCursorQueryVariables>;
export const AccessGroupsCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"accessGroupsCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGroupFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccessGroupsCursorQuery, AccessGroupsCursorQueryVariables>;
export const UserRolesCursorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserRolesCursor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RoleGraphQlFilterInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"EnumValue","value":"DESC"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UserRolesCursorQuery, UserRolesCursorQueryVariables>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export enum Action_Method {
  GrpcAlarmPostalarmstandard = 'GRPC_ALARM_POSTALARMSTANDARD',
  GrpcDeviceGetdeviceinfo = 'GRPC_DEVICE_GETDEVICEINFO',
  GrpcDevicePostalarmstandard = 'GRPC_DEVICE_POSTALARMSTANDARD',
  GrpcDevicePostdeviceinstallation = 'GRPC_DEVICE_POSTDEVICEINSTALLATION',
  GrpcDevicePostdeviceuninstalldevice = 'GRPC_DEVICE_POSTDEVICEUNINSTALLDEVICE',
  GrpcDevicePostequipmentports = 'GRPC_DEVICE_POSTEQUIPMENTPORTS',
  GrpcLayoutSubstationgetinfo = 'GRPC_LAYOUT_SUBSTATIONGETINFO',
  GrpcLayoutSubstationinstallation = 'GRPC_LAYOUT_SUBSTATIONINSTALLATION',
  GrpcLayoutSubstationremove = 'GRPC_LAYOUT_SUBSTATIONREMOVE',
  GrpcLayoutSubstationupdate = 'GRPC_LAYOUT_SUBSTATIONUPDATE'
}

export type Action_MethodOperationFilterInput = {
  eq?: InputMaybe<Action_Method>;
  in?: InputMaybe<Array<Action_Method>>;
  neq?: InputMaybe<Action_Method>;
  nin?: InputMaybe<Array<Action_Method>>;
};

export enum Action_Proto {
  Broker = 'BROKER',
  Grpc = 'GRPC'
}

export type Action_ProtoOperationFilterInput = {
  eq?: InputMaybe<Action_Proto>;
  in?: InputMaybe<Array<Action_Proto>>;
  neq?: InputMaybe<Action_Proto>;
  nin?: InputMaybe<Array<Action_Proto>>;
};

export enum Action_Type {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type Action_TypeOperationFilterInput = {
  eq?: InputMaybe<Action_Type>;
  in?: InputMaybe<Array<Action_Type>>;
  neq?: InputMaybe<Action_Type>;
  nin?: InputMaybe<Array<Action_Type>>;
};

export enum Alarm_Group_Name {
  BrokenNeutral = 'BROKEN_NEUTRAL',
  BusbarLineNullVoltage = 'BUSBAR_LINE_NULL_VOLTAGE',
  BusbarOverVoltage = 'BUSBAR_OVER_VOLTAGE',
  BusbarUnderVoltage = 'BUSBAR_UNDER_VOLTAGE',
  DevicePowerFail = 'DEVICE_POWER_FAIL',
  Empty = 'EMPTY',
  FeederLineFuseBlown = 'FEEDER_LINE_FUSE_BLOWN',
  FeederLineNullCurrent = 'FEEDER_LINE_NULL_CURRENT',
  FeederLineOvercurrent = 'FEEDER_LINE_OVERCURRENT',
  FeederLinePreFault = 'FEEDER_LINE_PRE_FAULT',
  HvLineDown = 'HV_LINE_DOWN',
  HvPhaseLoss = 'HV_PHASE_LOSS',
  Uint = 'UINT',
  Voltage = 'VOLTAGE',
  Wfc = 'WFC'
}

export type Alarm_Group_NameOperationFilterInput = {
  eq?: InputMaybe<Alarm_Group_Name>;
  in?: InputMaybe<Array<Alarm_Group_Name>>;
  neq?: InputMaybe<Alarm_Group_Name>;
  nin?: InputMaybe<Array<Alarm_Group_Name>>;
};

export enum Alarm_Type {
  BrokenNeutral = 'BROKEN_NEUTRAL',
  BusbarLineNullVoltage = 'BUSBAR_LINE_NULL_VOLTAGE',
  BusbarNeutralOpenCircuit = 'BUSBAR_NEUTRAL_OPEN_CIRCUIT',
  BusbarOverloadAgg = 'BUSBAR_OVERLOAD_AGG',
  BusbarOverVoltage = 'BUSBAR_OVER_VOLTAGE',
  BusbarOverVoltageAgg = 'BUSBAR_OVER_VOLTAGE_AGG',
  BusbarUnderVoltage = 'BUSBAR_UNDER_VOLTAGE',
  BusbarUnderVoltageAgg = 'BUSBAR_UNDER_VOLTAGE_AGG',
  DevicePowerFail = 'DEVICE_POWER_FAIL',
  Empty = 'EMPTY',
  FeederLineFuseBlown = 'FEEDER_LINE_FUSE_BLOWN',
  FeederLineNullCurrent = 'FEEDER_LINE_NULL_CURRENT',
  FeederLineOvercurrent = 'FEEDER_LINE_OVERCURRENT',
  FeederLineOverloadAgg = 'FEEDER_LINE_OVERLOAD_AGG',
  FeederLinePreFault = 'FEEDER_LINE_PRE_FAULT',
  FeederLineReversePowerAgg = 'FEEDER_LINE_REVERSE_POWER_AGG',
  FeederNeutralOvercurrentAgg = 'FEEDER_NEUTRAL_OVERCURRENT_AGG',
  HvPhaseLoss = 'HV_PHASE_LOSS',
  InstallReactivePowerCheck = 'INSTALL_REACTIVE_POWER_CHECK',
  InstallReversePowerCheck = 'INSTALL_REVERSE_POWER_CHECK',
  InstallVoltageCheck = 'INSTALL_VOLTAGE_CHECK',
  NewHvLineDown = 'NEW_HV_LINE_DOWN',
  Uint = 'UINT',
  Wfc = 'WFC'
}

export type Alarm_TypeOperationFilterInput = {
  eq?: InputMaybe<Alarm_Type>;
  in?: InputMaybe<Array<Alarm_Type>>;
  neq?: InputMaybe<Alarm_Type>;
  nin?: InputMaybe<Array<Alarm_Type>>;
};

export enum Anchor_Type {
  Double = 'DOUBLE',
  Single = 'SINGLE'
}

export enum Apn_Auth_Type {
  Chap = 'CHAP',
  None = 'NONE',
  Pap = 'PAP',
  PapOrChap = 'PAP_OR_CHAP'
}

export type Apn_Auth_TypeOperationFilterInput = {
  eq?: InputMaybe<Apn_Auth_Type>;
  in?: InputMaybe<Array<Apn_Auth_Type>>;
  neq?: InputMaybe<Apn_Auth_Type>;
  nin?: InputMaybe<Array<Apn_Auth_Type>>;
};

export enum Asset_State {
  Archived = 'ARCHIVED',
  Installed = 'INSTALLED',
  NotInstalled = 'NOT_INSTALLED'
}

export type Asset_StateOperationFilterInput = {
  eq?: InputMaybe<Asset_State>;
  in?: InputMaybe<Array<Asset_State>>;
  neq?: InputMaybe<Asset_State>;
  nin?: InputMaybe<Array<Asset_State>>;
};

export enum Asset_Type {
  DistributionBox = 'DISTRIBUTION_BOX',
  Error = 'ERROR',
  EvChargeStation = 'EV_CHARGE_STATION',
  HvDistributionBox = 'HV_DISTRIBUTION_BOX',
  HvPole = 'HV_POLE',
  HvSubstation = 'HV_SUBSTATION',
  LvGroundSubstation = 'LV_GROUND_SUBSTATION',
  LvPoleMounted = 'LV_POLE_MOUNTED',
  Meter = 'METER'
}

export type Asset_TypeOperationFilterInput = {
  eq?: InputMaybe<Asset_Type>;
  in?: InputMaybe<Array<Asset_Type>>;
  neq?: InputMaybe<Asset_Type>;
  nin?: InputMaybe<Array<Asset_Type>>;
};

export type AccessGroup = {
  __typename?: 'AccessGroup';
  assets: Array<LayoutEquipment>;
  companies: Array<Company>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enterprises: Array<Enterprise>;
  id: Scalars['Long']['output'];
  isDefault: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isProtected: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  operationalAreas: Array<OperationalArea>;
  regions: Array<Region>;
  users: Array<User>;
  workingOperationalAreas: Array<OperationalArea>;
};

export type AccessGroupFilterInput = {
  and?: InputMaybe<Array<AccessGroupFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  companies?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  enterprises?: InputMaybe<ListFilterInputTypeOfEnterpriseFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isProtected?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  operationalAreas?: InputMaybe<ListFilterInputTypeOfOperationalAreaFilterInput>;
  or?: InputMaybe<Array<AccessGroupFilterInput>>;
  regions?: InputMaybe<ListFilterInputTypeOfRegionFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
  workingOperationalAreas?: InputMaybe<ListFilterInputTypeOfOperationalAreaFilterInput>;
};

export type AccessGroupSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  isProtected?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AccessGroupToAsset = {
  __typename?: 'AccessGroupToAsset';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  asset: LayoutEquipment;
  assetId: Scalars['Long']['output'];
};

export type AccessGroupToCompany = {
  __typename?: 'AccessGroupToCompany';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  company: Company;
  companyId: Scalars['Long']['output'];
};

export type AccessGroupToOperationalArea = {
  __typename?: 'AccessGroupToOperationalArea';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  operationalArea: OperationalArea;
  operationalAreaId: Scalars['Long']['output'];
};

export type AccessGroupToRegion = {
  __typename?: 'AccessGroupToRegion';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  region: Region;
  regionId: Scalars['Long']['output'];
};

export type AccessGroupToUser = {
  __typename?: 'AccessGroupToUser';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  user: User;
  userId: Scalars['Long']['output'];
};

export type AccessGroupToWorkingOperationalArea = {
  __typename?: 'AccessGroupToWorkingOperationalArea';
  accessGroup: AccessGroup;
  accessGroupId: Scalars['Long']['output'];
  operationalArea: OperationalArea;
  operationalAreaId: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type AccessGroupsConnection = {
  __typename?: 'AccessGroupsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AccessGroupsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<AccessGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccessGroupsEdge = {
  __typename?: 'AccessGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AccessGroup>;
};

export type Action = {
  __typename?: 'Action';
  id: Scalars['Long']['output'];
  menuRoles?: Maybe<Array<MenuRoles>>;
  type: ActionType;
};

/** A connection to a list of items. */
export type ActionConnection = {
  __typename?: 'ActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ActionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Action>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActionEdge = {
  __typename?: 'ActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Action;
};

export type ActionFilterInput = {
  and?: InputMaybe<Array<ActionFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  menuRoles?: InputMaybe<ListFilterInputTypeOfMenuRolesFilterInput>;
  or?: InputMaybe<Array<ActionFilterInput>>;
  type?: InputMaybe<ActionTypeOperationFilterInput>;
};

export enum ActionLoggingType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Unknown = 'UNKNOWN',
  Update = 'UPDATE'
}

export type ActionLoggingTypeOperationFilterInput = {
  eq?: InputMaybe<ActionLoggingType>;
  in?: InputMaybe<Array<ActionLoggingType>>;
  neq?: InputMaybe<ActionLoggingType>;
  nin?: InputMaybe<Array<ActionLoggingType>>;
};

export type ActionSortInput = {
  id?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum ActionType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Update = 'UPDATE'
}

export type ActionTypeOperationFilterInput = {
  eq?: InputMaybe<ActionType>;
  in?: InputMaybe<Array<ActionType>>;
  neq?: InputMaybe<ActionType>;
  nin?: InputMaybe<Array<ActionType>>;
};

export type AlarmStandard = {
  __typename?: 'AlarmStandard';
  alarmStandardDefinitions: Array<AlarmStandardDefinition>;
  alarmStandardVariableDefinitions: Array<AlarmStandardVariableDefinition>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type AlarmStandardDefinition = {
  __typename?: 'AlarmStandardDefinition';
  alarmStandard: AlarmStandard;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  alarmType: AlarmType;
  alarmTypeId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  enable: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type AlarmStandardDefinitionFilterInput = {
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  alarmType?: InputMaybe<AlarmTypeFilterInput>;
  alarmTypeId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<AlarmStandardDefinitionFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  enable?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<AlarmStandardDefinitionFilterInput>>;
};

export type AlarmStandardDefinitionSortInput = {
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  alarmType?: InputMaybe<AlarmTypeSortInput>;
  alarmTypeId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  enable?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlarmStandardDefinitionsConnection = {
  __typename?: 'AlarmStandardDefinitionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmStandardDefinitionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmStandardDefinition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmStandardDefinitionsEdge = {
  __typename?: 'AlarmStandardDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmStandardDefinition;
};

export type AlarmStandardFilterInput = {
  alarmStandardDefinitions?: InputMaybe<ListFilterInputTypeOfAlarmStandardDefinitionFilterInput>;
  alarmStandardVariableDefinitions?: InputMaybe<ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput>;
  and?: InputMaybe<Array<AlarmStandardFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  device?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  editable?: InputMaybe<BooleanOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  feeders?: InputMaybe<ListFilterInputTypeOfFeederFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmStandardFilterInput>>;
};

export type AlarmStandardSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  editable?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AlarmStandardVariableAggregation = {
  __typename?: 'AlarmStandardVariableAggregation';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AlarmStandardVariableAggregationByAlarm = {
  __typename?: 'AlarmStandardVariableAggregationByAlarm';
  name: Scalars['String']['output'];
  value: Array<AlarmStandardVariableAggregation>;
};

export type AlarmStandardVariableAggregationByAlarmFilterInput = {
  and?: InputMaybe<Array<AlarmStandardVariableAggregationByAlarmFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmStandardVariableAggregationByAlarmFilterInput>>;
  value?: InputMaybe<ListFilterInputTypeOfAlarmStandardVariableAggregationFilterInput>;
};

export type AlarmStandardVariableAggregationByAlarmInput = {
  name: Scalars['String']['input'];
  value: Array<AlarmStandardVariableAggregationInput>;
};

export type AlarmStandardVariableAggregationFilterInput = {
  and?: InputMaybe<Array<AlarmStandardVariableAggregationFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmStandardVariableAggregationFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type AlarmStandardVariableAggregationInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AlarmStandardVariableDefinition = {
  __typename?: 'AlarmStandardVariableDefinition';
  alarmStandard: AlarmStandard;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  alarmVariable: AlarmVariable;
  alarmVariableId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  isValidAlarmStandardVariableAggregationDefinition?: Maybe<Array<KeyValuePairOfStringAndString>>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  listAlarmsStandardAggregation?: Maybe<Array<AlarmStandardVariableAggregationByAlarm>>;
  value: Scalars['String']['output'];
};


export type AlarmStandardVariableDefinitionIsValidAlarmStandardVariableAggregationDefinitionArgs = {
  lines: Array<AlarmStandardVariableAggregationByAlarmInput>;
};

export type AlarmStandardVariableDefinitionFilterInput = {
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  alarmVariable?: InputMaybe<AlarmVariableFilterInput>;
  alarmVariableId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<AlarmStandardVariableDefinitionFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  listAlarmsStandardAggregation?: InputMaybe<ListFilterInputTypeOfAlarmStandardVariableAggregationByAlarmFilterInput>;
  or?: InputMaybe<Array<AlarmStandardVariableDefinitionFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type AlarmStandardVariableDefinitionSortInput = {
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  alarmVariable?: InputMaybe<AlarmVariableSortInput>;
  alarmVariableId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlarmStandardVariableDefinitionsConnection = {
  __typename?: 'AlarmStandardVariableDefinitionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmStandardVariableDefinitionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmStandardVariableDefinition>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmStandardVariableDefinitionsEdge = {
  __typename?: 'AlarmStandardVariableDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmStandardVariableDefinition;
};

/** A connection to a list of items. */
export type AlarmStandardsConnection = {
  __typename?: 'AlarmStandardsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmStandardsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmStandard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmStandardsEdge = {
  __typename?: 'AlarmStandardsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmStandard;
};

export type AlarmType = {
  __typename?: 'AlarmType';
  alarmStandardDefinitions: Array<AlarmStandardDefinition>;
  alarmVariables: Array<AlarmVariable>;
  defaultStatus: Scalars['Boolean']['output'];
  entityType: Entity_Type;
  id: Scalars['Long']['output'];
  source: Source;
  type: Alarm_Type;
};

export type AlarmTypeFilterInput = {
  alarmStandardDefinitions?: InputMaybe<ListFilterInputTypeOfAlarmStandardDefinitionFilterInput>;
  alarmVariables?: InputMaybe<ListFilterInputTypeOfAlarmVariableFilterInput>;
  and?: InputMaybe<Array<AlarmTypeFilterInput>>;
  defaultStatus?: InputMaybe<BooleanOperationFilterInput>;
  entityType?: InputMaybe<Entity_TypeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AlarmTypeFilterInput>>;
  source?: InputMaybe<SourceOperationFilterInput>;
  type?: InputMaybe<Alarm_TypeOperationFilterInput>;
};

export type AlarmTypeSortInput = {
  defaultStatus?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlarmTypesConnection = {
  __typename?: 'AlarmTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmTypesEdge = {
  __typename?: 'AlarmTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmType;
};

export type AlarmVariable = {
  __typename?: 'AlarmVariable';
  alarmStandardVariableDefinitions: Array<AlarmStandardVariableDefinition>;
  alarmType: AlarmType;
  alarmTypeId?: Maybe<Scalars['Long']['output']>;
  defaultValue: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  groupName: Alarm_Group_Name;
  id: Scalars['Long']['output'];
  jsonConstrains?: Maybe<Scalars['String']['output']>;
  listAlarmsVariablesAggregation?: Maybe<Array<AlarmVariableAggregation>>;
  name: Scalars['String']['output'];
  region: Region;
  type: Scalars['String']['output'];
};

export type AlarmVariableAggregation = {
  __typename?: 'AlarmVariableAggregation';
  defaultValue: Scalars['String']['output'];
  jsonConstraints?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AlarmVariableAggregationFilterInput = {
  and?: InputMaybe<Array<AlarmVariableAggregationFilterInput>>;
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  jsonConstraints?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmVariableAggregationFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type AlarmVariableFilterInput = {
  alarmStandardVariableDefinitions?: InputMaybe<ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput>;
  alarmType?: InputMaybe<AlarmTypeFilterInput>;
  alarmTypeId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<AlarmVariableFilterInput>>;
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  deviceName?: InputMaybe<StringOperationFilterInput>;
  groupName?: InputMaybe<Alarm_Group_NameOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  jsonConstrains?: InputMaybe<StringOperationFilterInput>;
  listAlarmsVariablesAggregation?: InputMaybe<ListFilterInputTypeOfAlarmVariableAggregationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AlarmVariableFilterInput>>;
  region?: InputMaybe<RegionOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type AlarmVariableSortInput = {
  alarmType?: InputMaybe<AlarmTypeSortInput>;
  alarmTypeId?: InputMaybe<SortEnumType>;
  defaultValue?: InputMaybe<SortEnumType>;
  deviceName?: InputMaybe<SortEnumType>;
  groupName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jsonConstrains?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  region?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AlarmVariablesConnection = {
  __typename?: 'AlarmVariablesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AlarmVariablesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<AlarmVariable>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AlarmVariablesEdge = {
  __typename?: 'AlarmVariablesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlarmVariable;
};

export type Application = {
  __typename?: 'Application';
  authorizationTokens: Array<AuthorizationToken>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ApplicationFilterInput = {
  and?: InputMaybe<Array<ApplicationFilterInput>>;
  authorizationTokens?: InputMaybe<ListFilterInputTypeOfAuthorizationTokenFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ApplicationFilterInput>>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type Asset = {
  __typename?: 'Asset';
  alarmStandard?: Maybe<EquipmentsAlarmStandard>;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  alarmStandardName?: Maybe<Scalars['String']['output']>;
  assetType: Asset_Type;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  customProperties: Array<CustomProperties>;
  description?: Maybe<Scalars['String']['output']>;
  devices: Array<EquipmentsDevice>;
  equipBulkConfiguration?: Maybe<EquipmentsBulkConfiguration>;
  equipBulkConfigurationId?: Maybe<Scalars['Long']['output']>;
  equipBulkConfigurationName?: Maybe<Scalars['String']['output']>;
  equipments: Array<Equipment>;
  feeders: Array<Feeder>;
  hasAbscenceOfVoltage: Scalars['Boolean']['output'];
  hasData: Scalars['Boolean']['output'];
  hasEarthData: Scalars['Boolean']['output'];
  hasEvents: Scalars['Boolean']['output'];
  hasHvLineDown: Scalars['Boolean']['output'];
  hasPhaseLoss: Scalars['Boolean']['output'];
  hasRawData: Scalars['Boolean']['output'];
  hvLineDownProperties?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastCommissioningDate?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  lines: Array<Line>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  operationalArea?: Maybe<EquipmentsOperationalArea>;
  operationalAreaId?: Maybe<Scalars['Long']['output']>;
  operationalAreaV2Id?: Maybe<Scalars['Long']['output']>;
  parentAssetId?: Maybe<Scalars['Long']['output']>;
  parentAssetName?: Maybe<Scalars['String']['output']>;
  parentAssetV2Id?: Maybe<Scalars['Long']['output']>;
  parentFeederId?: Maybe<Scalars['Long']['output']>;
  parentFeederName?: Maybe<Scalars['String']['output']>;
  parentFeederV2Id?: Maybe<Scalars['Long']['output']>;
  region?: Maybe<EquipmentsRegion>;
  regionId?: Maybe<Scalars['Long']['output']>;
  regionV2Id?: Maybe<Scalars['Long']['output']>;
  registryNumber: Scalars['String']['output'];
  sdsType?: Maybe<Substation_Type>;
  state: Asset_State;
  transformerType: Transformer_Type;
  xGeometricPosition: Scalars['Int']['output'];
  yGeometricPosition: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type AssetBulkConfigurationsConnection = {
  __typename?: 'AssetBulkConfigurationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AssetBulkConfigurationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EquipmentsBulkConfiguration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetBulkConfigurationsEdge = {
  __typename?: 'AssetBulkConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EquipmentsBulkConfiguration;
};

export type AssetFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  alarmStandardName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<AssetFilterInput>>;
  assetType?: InputMaybe<Asset_TypeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  customProperties?: InputMaybe<ListFilterInputTypeOfCustomPropertiesFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  equipBulkConfiguration?: InputMaybe<EquipBulkConfigurationFilterInput>;
  equipBulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  equipBulkConfigurationName?: InputMaybe<StringOperationFilterInput>;
  equipments?: InputMaybe<ListFilterInputTypeOfEquipmentFilterInput>;
  externalAssetId?: InputMaybe<LongOperationFilterInput>;
  feeders?: InputMaybe<ListFilterInputTypeOfFeederFilterInput>;
  gpsPoint?: InputMaybe<GpsPointFilterInput>;
  hasAbscenceOfVoltage?: InputMaybe<BooleanOperationFilterInput>;
  hasData?: InputMaybe<BooleanOperationFilterInput>;
  hasEarthData?: InputMaybe<BooleanOperationFilterInput>;
  hasEvents?: InputMaybe<BooleanOperationFilterInput>;
  hasHvLineDown?: InputMaybe<BooleanOperationFilterInput>;
  hasPhaseLoss?: InputMaybe<BooleanOperationFilterInput>;
  hasRawData?: InputMaybe<BooleanOperationFilterInput>;
  hvLineDownProperties?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastCommissioningDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  lines?: InputMaybe<ListFilterInputTypeOfLineFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  operationalArea?: InputMaybe<OperationalAreaFilterInput>;
  operationalAreaId?: InputMaybe<LongOperationFilterInput>;
  operationalAreaV2Id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<AssetFilterInput>>;
  parentAssetId?: InputMaybe<LongOperationFilterInput>;
  parentAssetName?: InputMaybe<StringOperationFilterInput>;
  parentAssetV2Id?: InputMaybe<LongOperationFilterInput>;
  parentFeederId?: InputMaybe<LongOperationFilterInput>;
  parentFeederName?: InputMaybe<StringOperationFilterInput>;
  parentFeederV2Id?: InputMaybe<LongOperationFilterInput>;
  region?: InputMaybe<RegionFilterInput>;
  regionId?: InputMaybe<LongOperationFilterInput>;
  regionV2Id?: InputMaybe<LongOperationFilterInput>;
  registrationNumber?: InputMaybe<StringOperationFilterInput>;
  registryNumber?: InputMaybe<StringOperationFilterInput>;
  sdsType?: InputMaybe<NullableOfSubstation_TypeOperationFilterInput>;
  state?: InputMaybe<Asset_StateOperationFilterInput>;
  transformerType?: InputMaybe<Transformer_TypeOperationFilterInput>;
  xGeometricPosition?: InputMaybe<IntOperationFilterInput>;
  yGeometricPosition?: InputMaybe<IntOperationFilterInput>;
};

export type AssetSortInput = {
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  alarmStandardName?: InputMaybe<SortEnumType>;
  assetType?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  equipBulkConfiguration?: InputMaybe<EquipBulkConfigurationSortInput>;
  equipBulkConfigurationId?: InputMaybe<SortEnumType>;
  equipBulkConfigurationName?: InputMaybe<SortEnumType>;
  externalAssetId?: InputMaybe<SortEnumType>;
  gpsPoint?: InputMaybe<GpsPointSortInput>;
  hasAbscenceOfVoltage?: InputMaybe<SortEnumType>;
  hasData?: InputMaybe<SortEnumType>;
  hasEarthData?: InputMaybe<SortEnumType>;
  hasEvents?: InputMaybe<SortEnumType>;
  hasHvLineDown?: InputMaybe<SortEnumType>;
  hasPhaseLoss?: InputMaybe<SortEnumType>;
  hasRawData?: InputMaybe<SortEnumType>;
  hvLineDownProperties?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastCommissioningDate?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  operationalArea?: InputMaybe<OperationalAreaSortInput>;
  operationalAreaId?: InputMaybe<SortEnumType>;
  operationalAreaV2Id?: InputMaybe<SortEnumType>;
  parentAssetId?: InputMaybe<SortEnumType>;
  parentAssetName?: InputMaybe<SortEnumType>;
  parentAssetV2Id?: InputMaybe<SortEnumType>;
  parentFeederId?: InputMaybe<SortEnumType>;
  parentFeederName?: InputMaybe<SortEnumType>;
  parentFeederV2Id?: InputMaybe<SortEnumType>;
  region?: InputMaybe<RegionSortInput>;
  regionId?: InputMaybe<SortEnumType>;
  regionV2Id?: InputMaybe<SortEnumType>;
  registrationNumber?: InputMaybe<SortEnumType>;
  registryNumber?: InputMaybe<SortEnumType>;
  sdsType?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  transformerType?: InputMaybe<SortEnumType>;
  xGeometricPosition?: InputMaybe<SortEnumType>;
  yGeometricPosition?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type AssetsConnection = {
  __typename?: 'AssetsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AssetsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Asset>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetsEdge = {
  __typename?: 'AssetsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

export type Authorization = {
  __typename?: 'Authorization';
  id: Scalars['Long']['output'];
  method: Scalars['String']['output'];
  roles?: Maybe<Array<Role>>;
  scope: Scalars['String']['output'];
};

export type AuthorizationAccessGroup = {
  __typename?: 'AuthorizationAccessGroup';
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  users: Array<User>;
};

/** A connection to a list of items. */
export type AuthorizationConnection = {
  __typename?: 'AuthorizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<AuthorizationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Authorization>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type AuthorizationDevice = {
  __typename?: 'AuthorizationDevice';
  authorizationTokens: Array<AuthorizationToken>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  serialNumber: Scalars['String']['output'];
};

/** An edge in a connection. */
export type AuthorizationEdge = {
  __typename?: 'AuthorizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Authorization;
};

export type AuthorizationFilterInput = {
  and?: InputMaybe<Array<AuthorizationFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  method?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AuthorizationFilterInput>>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleFilterInput>;
  scope?: InputMaybe<StringOperationFilterInput>;
};

export type AuthorizationSortInput = {
  id?: InputMaybe<SortEnumType>;
  method?: InputMaybe<SortEnumType>;
  scope?: InputMaybe<SortEnumType>;
};

export type AuthorizationToken = {
  __typename?: 'AuthorizationToken';
  application?: Maybe<Application>;
  applicationId?: Maybe<Scalars['Long']['output']>;
  devices: Array<AuthorizationDevice>;
  expirationDate?: Maybe<Scalars['DateTime']['output']>;
  expirationType: ExpirationType;
  guid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  key?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
  tokenType: TokenType;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Long']['output']>;
};

export type AuthorizationTokenFilterInput = {
  and?: InputMaybe<Array<AuthorizationTokenFilterInput>>;
  application?: InputMaybe<ApplicationFilterInput>;
  applicationId?: InputMaybe<LongOperationFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  expirationDate?: InputMaybe<DateTimeOperationFilterInput>;
  expirationType?: InputMaybe<ExpirationTypeOperationFilterInput>;
  guid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AuthorizationTokenFilterInput>>;
  token?: InputMaybe<StringOperationFilterInput>;
  tokenType?: InputMaybe<TokenTypeOperationFilterInput>;
  user?: InputMaybe<UserFilterInput>;
  userId?: InputMaybe<LongOperationFilterInput>;
};

export type BatchDevice = {
  __typename?: 'BatchDevice';
  batchIncludes: Array<BatchInclude>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  devices: Array<Device>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type BatchDeviceFilterInput = {
  and?: InputMaybe<Array<BatchDeviceFilterInput>>;
  batchIncludes?: InputMaybe<ListFilterInputTypeOfBatchIncludeFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BatchDeviceFilterInput>>;
};

export type BatchDeviceSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BatchDevicesConnection = {
  __typename?: 'BatchDevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BatchDevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BatchDevice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BatchDevicesEdge = {
  __typename?: 'BatchDevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BatchDevice;
};

export type BatchInclude = {
  __typename?: 'BatchInclude';
  batchDevice: BatchDevice;
  batchDeviceId: Scalars['Long']['output'];
  batchSim: BatchSim;
  batchSimId: Scalars['Long']['output'];
  conTest: ConTest;
  conTestId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
};

export type BatchIncludeFilterInput = {
  and?: InputMaybe<Array<BatchIncludeFilterInput>>;
  batchDevice?: InputMaybe<BatchDeviceFilterInput>;
  batchDeviceId?: InputMaybe<LongOperationFilterInput>;
  batchSim?: InputMaybe<BatchSimFilterInput>;
  batchSimId?: InputMaybe<LongOperationFilterInput>;
  conTest?: InputMaybe<ConTestFilterInput>;
  conTestId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<BatchIncludeFilterInput>>;
};

export type BatchIncludeSortInput = {
  batchDevice?: InputMaybe<BatchDeviceSortInput>;
  batchDeviceId?: InputMaybe<SortEnumType>;
  batchSim?: InputMaybe<BatchSimSortInput>;
  batchSimId?: InputMaybe<SortEnumType>;
  conTest?: InputMaybe<ConTestSortInput>;
  conTestId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BatchIncludesConnection = {
  __typename?: 'BatchIncludesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BatchIncludesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BatchInclude>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BatchIncludesEdge = {
  __typename?: 'BatchIncludesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BatchInclude;
};

export type BatchSim = {
  __typename?: 'BatchSim';
  batchIncludes: Array<BatchInclude>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  simCards: Array<SimCard>;
};

export type BatchSimFilterInput = {
  and?: InputMaybe<Array<BatchSimFilterInput>>;
  batchIncludes?: InputMaybe<ListFilterInputTypeOfBatchIncludeFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BatchSimFilterInput>>;
  simCards?: InputMaybe<ListFilterInputTypeOfSimCardFilterInput>;
};

export type BatchSimSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type BatchSimsConnection = {
  __typename?: 'BatchSimsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<BatchSimsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<BatchSim>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BatchSimsEdge = {
  __typename?: 'BatchSimsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BatchSim;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']['input']>;
  gt?: InputMaybe<Scalars['Byte']['input']>;
  gte?: InputMaybe<Scalars['Byte']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  lt?: InputMaybe<Scalars['Byte']['input']>;
  lte?: InputMaybe<Scalars['Byte']['input']>;
  neq?: InputMaybe<Scalars['Byte']['input']>;
  ngt?: InputMaybe<Scalars['Byte']['input']>;
  ngte?: InputMaybe<Scalars['Byte']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Byte']['input']>>>;
  nlt?: InputMaybe<Scalars['Byte']['input']>;
  nlte?: InputMaybe<Scalars['Byte']['input']>;
};

export enum Connection_Type {
  LashedDown = 'LASHED_DOWN',
  Suspended = 'SUSPENDED'
}

export enum Constraint_Type {
  Custom = 'CUSTOM',
  System = 'SYSTEM'
}

export type Constraint_TypeOperationFilterInput = {
  eq?: InputMaybe<Constraint_Type>;
  in?: InputMaybe<Array<Constraint_Type>>;
  neq?: InputMaybe<Constraint_Type>;
  nin?: InputMaybe<Array<Constraint_Type>>;
};

export enum Con_Test_Result_Type {
  Error = 'ERROR',
  Null = 'NULL',
  Ok = 'OK',
  Unknown = 'UNKNOWN',
  Waiting = 'WAITING'
}

export type Con_Test_Result_TypeOperationFilterInput = {
  eq?: InputMaybe<Con_Test_Result_Type>;
  in?: InputMaybe<Array<Con_Test_Result_Type>>;
  neq?: InputMaybe<Con_Test_Result_Type>;
  nin?: InputMaybe<Array<Con_Test_Result_Type>>;
};

export type CableType = {
  __typename?: 'CableType';
  color: Scalars['String']['output'];
  coreSection: Scalars['Float']['output'];
  cores: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  fuseWay?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type CableTypeFilterInput = {
  and?: InputMaybe<Array<CableTypeFilterInput>>;
  color?: InputMaybe<StringOperationFilterInput>;
  coreSection?: InputMaybe<FloatOperationFilterInput>;
  cores?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  fuseWay?: InputMaybe<FloatOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CableTypeFilterInput>>;
};

export type CableTypeSortInput = {
  color?: InputMaybe<SortEnumType>;
  coreSection?: InputMaybe<SortEnumType>;
  cores?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  fuseWay?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CableTypesConnection = {
  __typename?: 'CableTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CableTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CableType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CableTypesEdge = {
  __typename?: 'CableTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CableType;
};

export type Company = {
  __typename?: 'Company';
  accessGroups: Array<AccessGroup>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enterprise: Enterprise;
  enterpriseId: Scalars['Long']['output'];
  gpsPoints: Array<GpsPoint>;
  id: Scalars['Long']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  regions: Array<Region>;
  users: Array<User>;
  website?: Maybe<Scalars['String']['output']>;
};

export type CompanyFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<CompanyFilterInput>>;
  country?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  enterprise?: InputMaybe<EnterpriseFilterInput>;
  enterpriseId?: InputMaybe<LongOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  gpsPoints?: InputMaybe<ListFilterInputTypeOfGpsPointFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  image?: InputMaybe<StringOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CompanyFilterInput>>;
  regions?: InputMaybe<ListFilterInputTypeOfRegionFilterInput>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
  website?: InputMaybe<StringOperationFilterInput>;
};

export type CompanySortInput = {
  country?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  enterprise?: InputMaybe<EnterpriseSortInput>;
  enterpriseId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  image?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  website?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type CompanysConnection = {
  __typename?: 'CompanysConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CompanysEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Company>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CompanysEdge = {
  __typename?: 'CompanysEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Company>;
};

export type ConTest = {
  __typename?: 'ConTest';
  batchIncludes: Array<BatchInclude>;
  checkTimeOut?: Maybe<Scalars['Int']['output']>;
  conTestDeviceResults: Array<ConTestDeviceResult>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceBulkConfiguration: DeviceBulkConfiguration;
  deviceBulkConfigurationId: Scalars['Long']['output'];
  hasConnectivity: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type ConTestDeviceResult = {
  __typename?: 'ConTestDeviceResult';
  conTest: ConTest;
  conTestId: Scalars['Long']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  externalResult: Con_Test_Result_Type;
  externalResultTime?: Maybe<Scalars['DateTime']['output']>;
  hasRawData: Scalars['Boolean']['output'];
  hasStateField: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  result: Con_Test_Result_Type;
  resultLog?: Maybe<Scalars['String']['output']>;
};

export type ConTestDeviceResultFilterInput = {
  and?: InputMaybe<Array<ConTestDeviceResultFilterInput>>;
  conTest?: InputMaybe<ConTestFilterInput>;
  conTestId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  externalResult?: InputMaybe<Con_Test_Result_TypeOperationFilterInput>;
  externalResultTime?: InputMaybe<DateTimeOperationFilterInput>;
  hasRawData?: InputMaybe<BooleanOperationFilterInput>;
  hasStateField?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ConTestDeviceResultFilterInput>>;
  result?: InputMaybe<Con_Test_Result_TypeOperationFilterInput>;
  resultLog?: InputMaybe<StringOperationFilterInput>;
};

export type ConTestDeviceResultSortInput = {
  conTest?: InputMaybe<ConTestSortInput>;
  conTestId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  externalResult?: InputMaybe<SortEnumType>;
  externalResultTime?: InputMaybe<SortEnumType>;
  hasRawData?: InputMaybe<SortEnumType>;
  hasStateField?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  result?: InputMaybe<SortEnumType>;
  resultLog?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ConTestDeviceResultsConnection = {
  __typename?: 'ConTestDeviceResultsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConTestDeviceResultsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConTestDeviceResult>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConTestDeviceResultsEdge = {
  __typename?: 'ConTestDeviceResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConTestDeviceResult;
};

export type ConTestExtended = {
  __typename?: 'ConTestExtended';
  batchIncludes: Array<BatchInclude>;
  checkTimeOut?: Maybe<Scalars['Int']['output']>;
  conTestDeviceResults: Array<ConTestDeviceResult>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceBulkConfiguration: DeviceBulkConfiguration;
  deviceBulkConfigurationId: Scalars['Long']['output'];
  hasConnectivity: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isDeleted: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  remainingDevices: Scalars['Long']['output'];
  remainingSimCards: Scalars['Long']['output'];
  testedDevices: Scalars['Long']['output'];
};

export type ConTestExtendedFilterInput = {
  and?: InputMaybe<Array<ConTestExtendedFilterInput>>;
  batchIncludes?: InputMaybe<ListFilterInputTypeOfBatchIncludeFilterInput>;
  checkTimeOut?: InputMaybe<IntOperationFilterInput>;
  conTestDeviceResults?: InputMaybe<ListFilterInputTypeOfConTestDeviceResultFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  deviceBulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  hasConnectivity?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConTestExtendedFilterInput>>;
  remainingDevices?: InputMaybe<LongOperationFilterInput>;
  remainingSimCards?: InputMaybe<LongOperationFilterInput>;
  testedDevices?: InputMaybe<LongOperationFilterInput>;
};

export type ConTestExtendedSortInput = {
  checkTimeOut?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  deviceBulkConfigurationId?: InputMaybe<SortEnumType>;
  hasConnectivity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  remainingDevices?: InputMaybe<SortEnumType>;
  remainingSimCards?: InputMaybe<SortEnumType>;
  testedDevices?: InputMaybe<SortEnumType>;
};

export type ConTestFilterInput = {
  and?: InputMaybe<Array<ConTestFilterInput>>;
  batchIncludes?: InputMaybe<ListFilterInputTypeOfBatchIncludeFilterInput>;
  checkTimeOut?: InputMaybe<IntOperationFilterInput>;
  conTestDeviceResults?: InputMaybe<ListFilterInputTypeOfConTestDeviceResultFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  deviceBulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  hasConnectivity?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConTestFilterInput>>;
};

export type ConTestSortInput = {
  checkTimeOut?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  deviceBulkConfigurationId?: InputMaybe<SortEnumType>;
  hasConnectivity?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ConTestsConnection = {
  __typename?: 'ConTestsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConTestsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConTest>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConTestsEdge = {
  __typename?: 'ConTestsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConTest;
};

/** A connection to a list of items. */
export type ConTestsExtendedConnection = {
  __typename?: 'ConTestsExtendedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ConTestsExtendedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ConTestExtended>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConTestsExtendedEdge = {
  __typename?: 'ConTestsExtendedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ConTestExtended;
};

export type Contact = {
  __typename?: 'Contact';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<Subscription>>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Long']['output']>;
};

export type ContactFilterInput = {
  and?: InputMaybe<Array<ContactFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ContactFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  subscriptions?: InputMaybe<ListFilterInputTypeOfSubscriptionFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<LongOperationFilterInput>;
};

export type ContactSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ContactsConnection = {
  __typename?: 'ContactsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ContactsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Contact>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ContactsEdge = {
  __typename?: 'ContactsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Contact;
};

export type Credentials = {
  __typename?: 'Credentials';
  algorithm?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Array<KeyValuePairOfStringAndString>>;
  counter?: Maybe<Scalars['Int']['output']>;
  createdDate?: Maybe<Scalars['Long']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  digits?: Maybe<Scalars['Int']['output']>;
  hashIterations?: Maybe<Scalars['Int']['output']>;
  hashSaltedValue?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['Int']['output']>;
  salt?: Maybe<Scalars['String']['output']>;
  temporary?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CredentialsFilterInput = {
  algorithm?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CredentialsFilterInput>>;
  config?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput>;
  counter?: InputMaybe<IntOperationFilterInput>;
  createdDate?: InputMaybe<LongOperationFilterInput>;
  device?: InputMaybe<StringOperationFilterInput>;
  digits?: InputMaybe<IntOperationFilterInput>;
  hashIterations?: InputMaybe<IntOperationFilterInput>;
  hashSaltedValue?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CredentialsFilterInput>>;
  period?: InputMaybe<IntOperationFilterInput>;
  salt?: InputMaybe<StringOperationFilterInput>;
  temporary?: InputMaybe<BooleanOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type CurrentHarmonics = {
  __typename?: 'CurrentHarmonics';
  aggregatedInterval: Scalars['Int']['output'];
  angles: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endType: Scalars['Int']['output'];
  endTypeValue: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  scheduleOperationModes: Array<ScheduleOperationMode>;
};

/** A connection to a list of items. */
export type CurrentHarmonicsConnection = {
  __typename?: 'CurrentHarmonicsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CurrentHarmonicsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CurrentHarmonics>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CurrentHarmonicsEdge = {
  __typename?: 'CurrentHarmonicsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CurrentHarmonics;
};

export type CurrentHarmonicsFilterInput = {
  aggregatedInterval?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<CurrentHarmonicsFilterInput>>;
  angles?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endType?: InputMaybe<IntOperationFilterInput>;
  endTypeValue?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CurrentHarmonicsFilterInput>>;
  order?: InputMaybe<IntOperationFilterInput>;
  scheduleOperationModes?: InputMaybe<ListFilterInputTypeOfScheduleOperationModeFilterInput>;
};

export type CurrentHarmonicsSortInput = {
  aggregatedInterval?: InputMaybe<SortEnumType>;
  angles?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endType?: InputMaybe<SortEnumType>;
  endTypeValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  order?: InputMaybe<SortEnumType>;
};

export type CustomProperties = {
  __typename?: 'CustomProperties';
  asset: Asset;
  assetId: Scalars['Long']['output'];
  constraintType: Constraint_Type;
  dataType: Data_Type;
  defaultValue: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  jsonConstraints?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type CustomPropertiesConnection = {
  __typename?: 'CustomPropertiesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<CustomPropertiesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<CustomProperties>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomPropertiesEdge = {
  __typename?: 'CustomPropertiesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomProperties;
};

export type CustomPropertiesFilterInput = {
  and?: InputMaybe<Array<CustomPropertiesFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  constraintType?: InputMaybe<Constraint_TypeOperationFilterInput>;
  dataType?: InputMaybe<Data_TypeOperationFilterInput>;
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  jsonConstraints?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomPropertiesFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type CustomPropertiesSortInput = {
  asset?: InputMaybe<AssetSortInput>;
  assetId?: InputMaybe<SortEnumType>;
  constraintType?: InputMaybe<SortEnumType>;
  dataType?: InputMaybe<SortEnumType>;
  defaultValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  jsonConstraints?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  value?: InputMaybe<SortEnumType>;
};

export enum Data_Type {
  DateTime = 'DATE_TIME',
  Float = 'FLOAT',
  Int = 'INT',
  String = 'STRING'
}

export type Data_TypeOperationFilterInput = {
  eq?: InputMaybe<Data_Type>;
  in?: InputMaybe<Array<Data_Type>>;
  neq?: InputMaybe<Data_Type>;
  nin?: InputMaybe<Array<Data_Type>>;
};

export enum Device_Type {
  Dte = 'DTE',
  Dtvi4G = 'DTVI4G',
  Dtvi4Gpmt = 'DTVI4GPMT',
  Dtvi4Gpmt2 = 'DTVI4GPMT2',
  Dtvig = 'DTVIG',
  Dtvigpmt = 'DTVIGPMT',
  Dtvigpmt2 = 'DTVIGPMT2',
  Dtvim = 'DTVIM',
  Hvii = 'HVII',
  Ingrid90 = 'INGRID90',
  Ingrid91 = 'INGRID91',
  Ingrid92 = 'INGRID92'
}

export type Device_TypeOperationFilterInput = {
  eq?: InputMaybe<Device_Type>;
  in?: InputMaybe<Array<Device_Type>>;
  neq?: InputMaybe<Device_Type>;
  nin?: InputMaybe<Array<Device_Type>>;
};

export enum Duration_Type {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  None = 'NONE',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Duration_TypeOperationFilterInput = {
  eq?: InputMaybe<Duration_Type>;
  in?: InputMaybe<Array<Duration_Type>>;
  neq?: InputMaybe<Duration_Type>;
  nin?: InputMaybe<Array<Duration_Type>>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Device = {
  __typename?: 'Device';
  acquisitionRate?: Maybe<Scalars['Int']['output']>;
  alarmLastConfigTs?: Maybe<Scalars['DateTime']['output']>;
  alarmStandard: DevicesAlarmStandard;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  alarmsConfig: Scalars['String']['output'];
  assetId?: Maybe<Scalars['Long']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  batchDevice?: Maybe<BatchDevice>;
  batchDeviceId?: Maybe<Scalars['Long']['output']>;
  bulkConfiguration?: Maybe<DeviceBulkConfiguration>;
  bulkConfigurationConfig: Scalars['String']['output'];
  bulkConfigurationId?: Maybe<Scalars['Long']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  comissionDate?: Maybe<Scalars['DateTime']['output']>;
  communicationRate?: Maybe<Scalars['Int']['output']>;
  conTestDeviceResults?: Maybe<Array<ConTestDeviceResult>>;
  configRefreshInterval: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  decomissionDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceSlot?: Maybe<Scalars['Long']['output']>;
  deviceSpecificConfig: Scalars['String']['output'];
  deviceTags: Array<DeviceTag>;
  deviceToken: Scalars['String']['output'];
  deviceType: Device_Type;
  externalReference?: Maybe<Scalars['String']['output']>;
  firmwareDeployDate?: Maybe<Scalars['DateTime']['output']>;
  firmwareTasks?: Maybe<Array<FirmwareTask>>;
  firmwareTasksLogs: Array<FirmwareTaskLog>;
  firmwareVersion: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  interfaces: Array<Interface>;
  isCommissioned: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastAddress?: Maybe<Scalars['String']['output']>;
  lastCommunication?: Maybe<Scalars['DateTime']['output']>;
  lastConfigTs?: Maybe<Scalars['DateTime']['output']>;
  lastContacts: Array<LastContactByType>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  micros: Array<Micro_Controller_Type>;
  name?: Maybe<Scalars['String']['output']>;
  ports: Array<Port>;
  serialNumber: Scalars['String']['output'];
  simCard?: Maybe<SimCard>;
  simCardId?: Maybe<Scalars['Long']['output']>;
};

export type DeviceBulkConfiguration = {
  __typename?: 'DeviceBulkConfiguration';
  aquisitionRate: Scalars['Int']['output'];
  aquisitionRateEarth: Scalars['Int']['output'];
  bluetoothTimeout: Scalars['Int']['output'];
  communicationRate: Scalars['Int']['output'];
  communicationRateEarth: Scalars['Int']['output'];
  conTests: Array<ConTest>;
  customDnsEnabled: Scalars['Boolean']['output'];
  device: Array<Device>;
  deviceTypeConfigurations: Array<DeviceTypeConfiguration>;
  dnsServerName1?: Maybe<Scalars['String']['output']>;
  dnsServerName2?: Maybe<Scalars['String']['output']>;
  emailSettings?: Maybe<EmailSettings>;
  httpCreateAlarm: Scalars['Boolean']['output'];
  httpRawData: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  isDefault: Scalars['Boolean']['output'];
  maxSlots?: Maybe<Scalars['Long']['output']>;
  mqttCertificateUrl: Scalars['String']['output'];
  mqttCreateAlarm: Scalars['Boolean']['output'];
  mqttGroupId: Scalars['String']['output'];
  mqttPassword: Scalars['String']['output'];
  mqttRawData: Scalars['Boolean']['output'];
  mqttServerUrl: Scalars['String']['output'];
  mqttUsername: Scalars['String']['output'];
  name: Scalars['String']['output'];
  protectionEarthFrequencyF1: Scalars['Int']['output'];
  protectionEarthFrequencyF2: Scalars['Int']['output'];
  protectionEarthFrequencyF3: Scalars['Int']['output'];
  proxyEnabled: Scalars['Boolean']['output'];
  proxyPort?: Maybe<Scalars['Int']['output']>;
  proxyUrl?: Maybe<Scalars['String']['output']>;
  scheduleOperationModes: Array<ScheduleOperationMode>;
  serverUrl: Scalars['String']['output'];
  serviceEarthFrequencyF1: Scalars['Int']['output'];
  serviceEarthFrequencyF2: Scalars['Int']['output'];
  serviceEarthFrequencyF3: Scalars['Int']['output'];
  slotType: Slot_Type;
  timeServerPort: Scalars['Int']['output'];
  timeServerProtocol: Scalars['String']['output'];
  timeServerType: Time_Server_Type;
  timeServerUrl: Scalars['String']['output'];
};

export type DeviceBulkConfigurationFilterInput = {
  and?: InputMaybe<Array<DeviceBulkConfigurationFilterInput>>;
  aquisitionRate?: InputMaybe<IntOperationFilterInput>;
  aquisitionRateEarth?: InputMaybe<IntOperationFilterInput>;
  bluetoothTimeout?: InputMaybe<IntOperationFilterInput>;
  communicationRate?: InputMaybe<IntOperationFilterInput>;
  communicationRateEarth?: InputMaybe<IntOperationFilterInput>;
  conTests?: InputMaybe<ListFilterInputTypeOfConTestFilterInput>;
  customDnsEnabled?: InputMaybe<BooleanOperationFilterInput>;
  device?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  deviceTypeConfigurations?: InputMaybe<ListFilterInputTypeOfDeviceTypeConfigurationFilterInput>;
  dnsServerName1?: InputMaybe<StringOperationFilterInput>;
  dnsServerName2?: InputMaybe<StringOperationFilterInput>;
  emailSettings?: InputMaybe<EmailSettingsFilterInput>;
  httpCreateAlarm?: InputMaybe<BooleanOperationFilterInput>;
  httpRawData?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  maxSlots?: InputMaybe<LongOperationFilterInput>;
  mqttCertificateUrl?: InputMaybe<StringOperationFilterInput>;
  mqttCreateAlarm?: InputMaybe<BooleanOperationFilterInput>;
  mqttGroupId?: InputMaybe<StringOperationFilterInput>;
  mqttPassword?: InputMaybe<StringOperationFilterInput>;
  mqttRawData?: InputMaybe<BooleanOperationFilterInput>;
  mqttServerUrl?: InputMaybe<StringOperationFilterInput>;
  mqttUsername?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceBulkConfigurationFilterInput>>;
  protectionEarthFrequencyF1?: InputMaybe<IntOperationFilterInput>;
  protectionEarthFrequencyF2?: InputMaybe<IntOperationFilterInput>;
  protectionEarthFrequencyF3?: InputMaybe<IntOperationFilterInput>;
  proxyEnabled?: InputMaybe<BooleanOperationFilterInput>;
  proxyPort?: InputMaybe<IntOperationFilterInput>;
  proxyUrl?: InputMaybe<StringOperationFilterInput>;
  scheduleOperationModes?: InputMaybe<ListFilterInputTypeOfScheduleOperationModeFilterInput>;
  serverUrl?: InputMaybe<StringOperationFilterInput>;
  serviceEarthFrequencyF1?: InputMaybe<IntOperationFilterInput>;
  serviceEarthFrequencyF2?: InputMaybe<IntOperationFilterInput>;
  serviceEarthFrequencyF3?: InputMaybe<IntOperationFilterInput>;
  slotType?: InputMaybe<Slot_TypeOperationFilterInput>;
  timeServerPort?: InputMaybe<IntOperationFilterInput>;
  timeServerProtocol?: InputMaybe<StringOperationFilterInput>;
  timeServerType?: InputMaybe<Time_Server_TypeOperationFilterInput>;
  timeServerUrl?: InputMaybe<StringOperationFilterInput>;
};

export type DeviceBulkConfigurationSortInput = {
  aquisitionRate?: InputMaybe<SortEnumType>;
  aquisitionRateEarth?: InputMaybe<SortEnumType>;
  bluetoothTimeout?: InputMaybe<SortEnumType>;
  communicationRate?: InputMaybe<SortEnumType>;
  communicationRateEarth?: InputMaybe<SortEnumType>;
  customDnsEnabled?: InputMaybe<SortEnumType>;
  dnsServerName1?: InputMaybe<SortEnumType>;
  dnsServerName2?: InputMaybe<SortEnumType>;
  emailSettings?: InputMaybe<EmailSettingsSortInput>;
  httpCreateAlarm?: InputMaybe<SortEnumType>;
  httpRawData?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  maxSlots?: InputMaybe<SortEnumType>;
  mqttCertificateUrl?: InputMaybe<SortEnumType>;
  mqttCreateAlarm?: InputMaybe<SortEnumType>;
  mqttGroupId?: InputMaybe<SortEnumType>;
  mqttPassword?: InputMaybe<SortEnumType>;
  mqttRawData?: InputMaybe<SortEnumType>;
  mqttServerUrl?: InputMaybe<SortEnumType>;
  mqttUsername?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  protectionEarthFrequencyF1?: InputMaybe<SortEnumType>;
  protectionEarthFrequencyF2?: InputMaybe<SortEnumType>;
  protectionEarthFrequencyF3?: InputMaybe<SortEnumType>;
  proxyEnabled?: InputMaybe<SortEnumType>;
  proxyPort?: InputMaybe<SortEnumType>;
  proxyUrl?: InputMaybe<SortEnumType>;
  serverUrl?: InputMaybe<SortEnumType>;
  serviceEarthFrequencyF1?: InputMaybe<SortEnumType>;
  serviceEarthFrequencyF2?: InputMaybe<SortEnumType>;
  serviceEarthFrequencyF3?: InputMaybe<SortEnumType>;
  slotType?: InputMaybe<SortEnumType>;
  timeServerPort?: InputMaybe<SortEnumType>;
  timeServerProtocol?: InputMaybe<SortEnumType>;
  timeServerType?: InputMaybe<SortEnumType>;
  timeServerUrl?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceBulkConfigurationsConnection = {
  __typename?: 'DeviceBulkConfigurationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceBulkConfigurationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceBulkConfiguration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceBulkConfigurationsEdge = {
  __typename?: 'DeviceBulkConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceBulkConfiguration;
};

export type DeviceFilterInput = {
  acquisitionRate?: InputMaybe<IntOperationFilterInput>;
  alarmLastConfigTs?: InputMaybe<DateTimeOperationFilterInput>;
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  alarmsConfig?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<DeviceFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  assetName?: InputMaybe<StringOperationFilterInput>;
  authorizationTokens?: InputMaybe<ListFilterInputTypeOfAuthorizationTokenFilterInput>;
  batchDevice?: InputMaybe<BatchDeviceFilterInput>;
  batchDeviceId?: InputMaybe<LongOperationFilterInput>;
  bulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  bulkConfigurationConfig?: InputMaybe<StringOperationFilterInput>;
  bulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  comissionDate?: InputMaybe<DateTimeOperationFilterInput>;
  communicationRate?: InputMaybe<IntOperationFilterInput>;
  conTestDeviceResults?: InputMaybe<ListFilterInputTypeOfConTestDeviceResultFilterInput>;
  configRefreshInterval?: InputMaybe<IntOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  decomissionDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceInputs?: InputMaybe<ListFilterInputTypeOfDeviceInputNumberFilterInput>;
  deviceSlot?: InputMaybe<LongOperationFilterInput>;
  deviceSpecificConfig?: InputMaybe<StringOperationFilterInput>;
  deviceTags?: InputMaybe<ListFilterInputTypeOfDeviceTagFilterInput>;
  deviceToken?: InputMaybe<StringOperationFilterInput>;
  deviceType?: InputMaybe<Device_TypeOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  externalReference?: InputMaybe<StringOperationFilterInput>;
  firmwareDeployDate?: InputMaybe<DateTimeOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  firmwareTasksLogs?: InputMaybe<ListFilterInputTypeOfFirmwareTaskLogFilterInput>;
  firmwareVersion?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  interfaces?: InputMaybe<ListFilterInputTypeOfInterfaceFilterInput>;
  isCommissioned?: InputMaybe<BooleanOperationFilterInput>;
  isDeleted?: InputMaybe<BooleanOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastAddress?: InputMaybe<StringOperationFilterInput>;
  lastCommunication?: InputMaybe<DateTimeOperationFilterInput>;
  lastConfigTs?: InputMaybe<DateTimeOperationFilterInput>;
  lastContacts?: InputMaybe<ListFilterInputTypeOfLastContactByTypeFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceFilterInput>>;
  ports?: InputMaybe<ListFilterInputTypeOfPortFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  simCard?: InputMaybe<SimCardFilterInput>;
  simCardId?: InputMaybe<LongOperationFilterInput>;
};

export type DeviceInputNumberFilterInput = {
  and?: InputMaybe<Array<DeviceInputNumberFilterInput>>;
  deviceExternalId?: InputMaybe<LongOperationFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  devicePortId?: InputMaybe<LongOperationFilterInput>;
  deviceSerialNumber?: InputMaybe<StringOperationFilterInput>;
  equipmentId?: InputMaybe<LongOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  feederId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputNumber?: InputMaybe<IntOperationFilterInput>;
  inputType?: InputMaybe<Input_TypeOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  masterBusLineId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DeviceInputNumberFilterInput>>;
  portNumber?: InputMaybe<IntOperationFilterInput>;
  powerBusLineId?: InputMaybe<LongOperationFilterInput>;
  typeId?: InputMaybe<IntOperationFilterInput>;
};

export type DeviceInputNumberSortInput = {
  deviceExternalId?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  devicePortId?: InputMaybe<SortEnumType>;
  deviceSerialNumber?: InputMaybe<SortEnumType>;
  equipmentId?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  feederId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputNumber?: InputMaybe<SortEnumType>;
  inputType?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  masterBusLineId?: InputMaybe<SortEnumType>;
  portNumber?: InputMaybe<SortEnumType>;
  powerBusLineId?: InputMaybe<SortEnumType>;
  typeId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceInputNumbersConnection = {
  __typename?: 'DeviceInputNumbersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceInputNumbersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EquipmentsDeviceInputNumber>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceInputNumbersEdge = {
  __typename?: 'DeviceInputNumbersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EquipmentsDeviceInputNumber;
};

export type DeviceLog = {
  __typename?: 'DeviceLog';
  body?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['Long']['output'];
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  method?: Maybe<Scalars['String']['output']>;
  requestDate: Scalars['DateTime']['output'];
  requestType: Lastcontact_Type;
  serialNumber: Scalars['String']['output'];
  serverIp?: Maybe<Scalars['String']['output']>;
  serverPort?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type DeviceLogConnection = {
  __typename?: 'DeviceLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceLogEdge = {
  __typename?: 'DeviceLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceLog;
};

export type DeviceLogFilterInput = {
  and?: InputMaybe<Array<DeviceLogFilterInput>>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  body?: InputMaybe<StringOperationFilterInput>;
  comissionDate?: InputMaybe<DateTimeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deComissionDate?: InputMaybe<DateTimeOperationFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  host?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  method?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceLogFilterInput>>;
  requestDate?: InputMaybe<DateTimeOperationFilterInput>;
  requestType?: InputMaybe<Lastcontact_TypeOperationFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  serverIp?: InputMaybe<StringOperationFilterInput>;
  serverPort?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type DeviceLogSortInput = {
  assetId?: InputMaybe<SortEnumType>;
  body?: InputMaybe<SortEnumType>;
  comissionDate?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deComissionDate?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  host?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  method?: InputMaybe<SortEnumType>;
  requestDate?: InputMaybe<SortEnumType>;
  requestType?: InputMaybe<SortEnumType>;
  serialNumber?: InputMaybe<SortEnumType>;
  serverIp?: InputMaybe<SortEnumType>;
  serverPort?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceLogsConnection = {
  __typename?: 'DeviceLogsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceLogsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EquipmentsDeviceLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceLogsEdge = {
  __typename?: 'DeviceLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EquipmentsDeviceLog;
};

export type DeviceMessage = {
  __typename?: 'DeviceMessage';
  actionMethod: Action_Method;
  actionProto: Action_Proto;
  actionType: Action_Type;
  errorMessage: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  inputData: Scalars['String']['output'];
  result?: Maybe<Scalars['Boolean']['output']>;
  resultData: Scalars['String']['output'];
};

export type DeviceMessageFilterInput = {
  actionMethod?: InputMaybe<Action_MethodOperationFilterInput>;
  actionProto?: InputMaybe<Action_ProtoOperationFilterInput>;
  actionType?: InputMaybe<Action_TypeOperationFilterInput>;
  and?: InputMaybe<Array<DeviceMessageFilterInput>>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputData?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceMessageFilterInput>>;
  result?: InputMaybe<BooleanOperationFilterInput>;
  resultData?: InputMaybe<StringOperationFilterInput>;
};

export type DeviceMessageSortInput = {
  actionMethod?: InputMaybe<SortEnumType>;
  actionProto?: InputMaybe<SortEnumType>;
  actionType?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputData?: InputMaybe<SortEnumType>;
  result?: InputMaybe<SortEnumType>;
  resultData?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceMessagesConnection = {
  __typename?: 'DeviceMessagesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceMessagesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceMessagesEdge = {
  __typename?: 'DeviceMessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceMessage;
};

export type DeviceSortInput = {
  acquisitionRate?: InputMaybe<SortEnumType>;
  alarmLastConfigTs?: InputMaybe<SortEnumType>;
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  alarmsConfig?: InputMaybe<SortEnumType>;
  asset?: InputMaybe<AssetSortInput>;
  assetId?: InputMaybe<SortEnumType>;
  assetName?: InputMaybe<SortEnumType>;
  batchDevice?: InputMaybe<BatchDeviceSortInput>;
  batchDeviceId?: InputMaybe<SortEnumType>;
  bulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  bulkConfigurationConfig?: InputMaybe<SortEnumType>;
  bulkConfigurationId?: InputMaybe<SortEnumType>;
  clientId?: InputMaybe<SortEnumType>;
  comissionDate?: InputMaybe<SortEnumType>;
  communicationRate?: InputMaybe<SortEnumType>;
  configRefreshInterval?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  decomissionDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceSlot?: InputMaybe<SortEnumType>;
  deviceSpecificConfig?: InputMaybe<SortEnumType>;
  deviceToken?: InputMaybe<SortEnumType>;
  deviceType?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  externalReference?: InputMaybe<SortEnumType>;
  firmwareDeployDate?: InputMaybe<SortEnumType>;
  firmwareVersion?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  isCommissioned?: InputMaybe<SortEnumType>;
  isDeleted?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastAddress?: InputMaybe<SortEnumType>;
  lastCommunication?: InputMaybe<SortEnumType>;
  lastConfigTs?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  serialNumber?: InputMaybe<SortEnumType>;
  simCard?: InputMaybe<SimCardSortInput>;
  simCardId?: InputMaybe<SortEnumType>;
};

export type DeviceTag = {
  __typename?: 'DeviceTag';
  devices: Array<Device>;
  firmwareTasks: Array<FirmwareTask>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DeviceTagFilterInput = {
  and?: InputMaybe<Array<DeviceTagFilterInput>>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DeviceTagFilterInput>>;
};

export type DeviceTypeConfiguration = {
  __typename?: 'DeviceTypeConfiguration';
  bulkConfigurationId: Scalars['Long']['output'];
  deviceBulkConfiguration: DeviceBulkConfiguration;
  deviceType: Device_Type;
  id: Scalars['Long']['output'];
};

export type DeviceTypeConfigurationFilterInput = {
  and?: InputMaybe<Array<DeviceTypeConfigurationFilterInput>>;
  bulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  deviceType?: InputMaybe<Device_TypeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<DeviceTypeConfigurationFilterInput>>;
};

export type DeviceTypeConfigurationSortInput = {
  bulkConfigurationId?: InputMaybe<SortEnumType>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  deviceType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type DeviceTypeConfigurationsConnection = {
  __typename?: 'DeviceTypeConfigurationsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DeviceTypeConfigurationsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DeviceTypeConfiguration>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeviceTypeConfigurationsEdge = {
  __typename?: 'DeviceTypeConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeviceTypeConfiguration;
};

export type DevicesAccessGroup = {
  __typename?: 'DevicesAccessGroup';
  externalId: Scalars['Long']['output'];
  firmwareTasks?: Maybe<Array<FirmwareTask>>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DevicesAlarmStandard = {
  __typename?: 'DevicesAlarmStandard';
  device: Array<Device>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DevicesCompany = {
  __typename?: 'DevicesCompany';
  externalId: Scalars['Long']['output'];
  firmwareTasks: Array<FirmwareTask>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type DevicesConnection = {
  __typename?: 'DevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Device>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DevicesEdge = {
  __typename?: 'DevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Device>;
};

export type DevicesFirmwareDocument = {
  __typename?: 'DevicesFirmwareDocument';
  deviceType: Device_Type;
  externalId: Scalars['Long']['output'];
  firmware: Firmware;
  id: Scalars['Long']['output'];
  microType: Micro_Controller_Type;
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type DevicesFirmwareDocumentsConnection = {
  __typename?: 'DevicesFirmwareDocumentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<DevicesFirmwareDocumentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<DevicesFirmwareDocument>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DevicesFirmwareDocumentsEdge = {
  __typename?: 'DevicesFirmwareDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DevicesFirmwareDocument;
};

export type DevicesOperationalArea = {
  __typename?: 'DevicesOperationalArea';
  externalId: Scalars['Long']['output'];
  firmwareTasks: Array<FirmwareTask>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type DevicesRegion = {
  __typename?: 'DevicesRegion';
  externalId: Scalars['Long']['output'];
  firmwareTasks: Array<FirmwareTask>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export enum Encryption_Type {
  Ssl = 'SSL',
  Tls = 'TLS'
}

export enum Entity_Type {
  Asset = 'ASSET',
  AssetBusbar = 'ASSET_BUSBAR',
  Device = 'DEVICE',
  Empty = 'EMPTY',
  Feeder = 'FEEDER'
}

export type Entity_TypeOperationFilterInput = {
  eq?: InputMaybe<Entity_Type>;
  in?: InputMaybe<Array<Entity_Type>>;
  neq?: InputMaybe<Entity_Type>;
  nin?: InputMaybe<Array<Entity_Type>>;
};

export enum Equipment_Type {
  BaseHvPole = 'BASE_HV_POLE',
  DeliveryPoint = 'DELIVERY_POINT',
  DistributionBox = 'DISTRIBUTION_BOX',
  HvIsolator = 'HV_ISOLATOR',
  Substation = 'SUBSTATION',
  TranformerHm = 'TRANFORMER_HM',
  TransformerMl = 'TRANSFORMER_ML'
}

export type Equipment_TypeOperationFilterInput = {
  eq?: InputMaybe<Equipment_Type>;
  in?: InputMaybe<Array<Equipment_Type>>;
  neq?: InputMaybe<Equipment_Type>;
  nin?: InputMaybe<Array<Equipment_Type>>;
};

export type Email = {
  __typename?: 'Email';
  bcc?: Maybe<Scalars['String']['output']>;
  bccName?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  bodyEncoding?: Maybe<Scalars['String']['output']>;
  bodyPlainText?: Maybe<Scalars['String']['output']>;
  bodyTransferEncoding: TransferEncoding;
  cc?: Maybe<Scalars['String']['output']>;
  ccName?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deliverDate: Scalars['DateTime']['output'];
  emailAttachments?: Maybe<Array<EmailAttachment>>;
  emailStatus?: Maybe<Array<EmailStatus>>;
  errorMsg?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  headers?: Maybe<Scalars['String']['output']>;
  headersEncoding?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  isBodyHtml: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  messageSent: Scalars['Boolean']['output'];
  receptionDate: Scalars['DateTime']['output'];
  replyToList?: Maybe<Scalars['String']['output']>;
  replyToListName?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subjectEncoding?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
};

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  documentManagerId: Scalars['Long']['output'];
  email?: Maybe<Email>;
  emailId: Scalars['Long']['output'];
  fileData?: Maybe<Array<Scalars['Byte']['output']>>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type EmailAttachmentFilterInput = {
  and?: InputMaybe<Array<EmailAttachmentFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  documentManagerId?: InputMaybe<LongOperationFilterInput>;
  email?: InputMaybe<EmailFilterInput>;
  emailId?: InputMaybe<LongOperationFilterInput>;
  fileData?: InputMaybe<ListByteOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailAttachmentFilterInput>>;
};

export type EmailAttachmentSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  documentManagerId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<EmailSortInput>;
  emailId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EmailAttachmentsConnection = {
  __typename?: 'EmailAttachmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailAttachmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EmailAttachment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailAttachmentsEdge = {
  __typename?: 'EmailAttachmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EmailAttachment;
};

export type EmailFilterInput = {
  and?: InputMaybe<Array<EmailFilterInput>>;
  bcc?: InputMaybe<StringOperationFilterInput>;
  bccName?: InputMaybe<StringOperationFilterInput>;
  body?: InputMaybe<StringOperationFilterInput>;
  bodyEncoding?: InputMaybe<StringOperationFilterInput>;
  bodyPlainText?: InputMaybe<StringOperationFilterInput>;
  bodyTransferEncoding?: InputMaybe<TransferEncodingOperationFilterInput>;
  cc?: InputMaybe<StringOperationFilterInput>;
  ccName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deliverDate?: InputMaybe<DateTimeOperationFilterInput>;
  emailAttachments?: InputMaybe<ListFilterInputTypeOfEmailAttachmentFilterInput>;
  emailStatus?: InputMaybe<ListFilterInputTypeOfEmailStatusFilterInput>;
  errorMsg?: InputMaybe<StringOperationFilterInput>;
  from?: InputMaybe<StringOperationFilterInput>;
  fromName?: InputMaybe<StringOperationFilterInput>;
  headers?: InputMaybe<StringOperationFilterInput>;
  headersEncoding?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isBodyHtml?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  messageSent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<EmailFilterInput>>;
  receptionDate?: InputMaybe<DateTimeOperationFilterInput>;
  replyToList?: InputMaybe<StringOperationFilterInput>;
  replyToListName?: InputMaybe<StringOperationFilterInput>;
  sender?: InputMaybe<StringOperationFilterInput>;
  senderName?: InputMaybe<StringOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  subjectEncoding?: InputMaybe<StringOperationFilterInput>;
  to?: InputMaybe<StringOperationFilterInput>;
  toName?: InputMaybe<StringOperationFilterInput>;
};

export type EmailSettings = {
  __typename?: 'EmailSettings';
  checkIntervalEmail?: Maybe<Scalars['Int']['output']>;
  deviceBulkConfiguration?: Maybe<DeviceBulkConfiguration>;
  deviceBulkConfigurationId?: Maybe<Scalars['Long']['output']>;
  emailBodyExpression?: Maybe<Scalars['String']['output']>;
  emailEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailPassword?: Maybe<Array<Scalars['Byte']['output']>>;
  emailServerType?: Maybe<Server_Type>;
  emailServerUrl?: Maybe<Scalars['String']['output']>;
  emailSubjectExpression?: Maybe<Scalars['String']['output']>;
  emailUsername?: Maybe<Scalars['String']['output']>;
  encryptionType?: Maybe<Encryption_Type>;
  id: Scalars['Long']['output'];
  maxChecksEmail?: Maybe<Scalars['Int']['output']>;
  serverEmailPort?: Maybe<Scalars['Int']['output']>;
};

export type EmailSettingsFilterInput = {
  and?: InputMaybe<Array<EmailSettingsFilterInput>>;
  checkIntervalEmail?: InputMaybe<IntOperationFilterInput>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  deviceBulkConfigurationId?: InputMaybe<LongOperationFilterInput>;
  emailBodyExpression?: InputMaybe<StringOperationFilterInput>;
  emailEnabled?: InputMaybe<BooleanOperationFilterInput>;
  emailPassword?: InputMaybe<ListByteOperationFilterInput>;
  emailServerType?: InputMaybe<NullableOfServer_TypeOperationFilterInput>;
  emailServerUrl?: InputMaybe<StringOperationFilterInput>;
  emailSubjectExpression?: InputMaybe<StringOperationFilterInput>;
  emailUsername?: InputMaybe<StringOperationFilterInput>;
  encryptionType?: InputMaybe<NullableOfEncryption_TypeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  maxChecksEmail?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<EmailSettingsFilterInput>>;
  serverEmailPort?: InputMaybe<IntOperationFilterInput>;
};

export type EmailSettingsSortInput = {
  checkIntervalEmail?: InputMaybe<SortEnumType>;
  deviceBulkConfiguration?: InputMaybe<DeviceBulkConfigurationSortInput>;
  deviceBulkConfigurationId?: InputMaybe<SortEnumType>;
  emailBodyExpression?: InputMaybe<SortEnumType>;
  emailEnabled?: InputMaybe<SortEnumType>;
  emailServerType?: InputMaybe<SortEnumType>;
  emailServerUrl?: InputMaybe<SortEnumType>;
  emailSubjectExpression?: InputMaybe<SortEnumType>;
  emailUsername?: InputMaybe<SortEnumType>;
  encryptionType?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  maxChecksEmail?: InputMaybe<SortEnumType>;
  serverEmailPort?: InputMaybe<SortEnumType>;
};

export type EmailSortInput = {
  bcc?: InputMaybe<SortEnumType>;
  bccName?: InputMaybe<SortEnumType>;
  body?: InputMaybe<SortEnumType>;
  bodyEncoding?: InputMaybe<SortEnumType>;
  bodyPlainText?: InputMaybe<SortEnumType>;
  bodyTransferEncoding?: InputMaybe<SortEnumType>;
  cc?: InputMaybe<SortEnumType>;
  ccName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deliverDate?: InputMaybe<SortEnumType>;
  errorMsg?: InputMaybe<SortEnumType>;
  from?: InputMaybe<SortEnumType>;
  fromName?: InputMaybe<SortEnumType>;
  headers?: InputMaybe<SortEnumType>;
  headersEncoding?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isBodyHtml?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  messageSent?: InputMaybe<SortEnumType>;
  receptionDate?: InputMaybe<SortEnumType>;
  replyToList?: InputMaybe<SortEnumType>;
  replyToListName?: InputMaybe<SortEnumType>;
  sender?: InputMaybe<SortEnumType>;
  senderName?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SortEnumType>;
  subjectEncoding?: InputMaybe<SortEnumType>;
  to?: InputMaybe<SortEnumType>;
  toName?: InputMaybe<SortEnumType>;
};

export type EmailStatus = {
  __typename?: 'EmailStatus';
  appNoteId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deliverDate: Scalars['DateTime']['output'];
  email?: Maybe<Email>;
  emailId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  messageSent: Scalars['Boolean']['output'];
  receptionDate: Scalars['DateTime']['output'];
  smsId?: Maybe<Scalars['Long']['output']>;
  status: Status;
  statusMessage?: Maybe<Scalars['String']['output']>;
  webhookId?: Maybe<Scalars['Long']['output']>;
};

/** A connection to a list of items. */
export type EmailStatusConnection = {
  __typename?: 'EmailStatusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailStatusEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EmailStatus>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailStatusEdge = {
  __typename?: 'EmailStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EmailStatus;
};

export type EmailStatusFilterInput = {
  and?: InputMaybe<Array<EmailStatusFilterInput>>;
  appNoteId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deliverDate?: InputMaybe<DateTimeOperationFilterInput>;
  email?: InputMaybe<EmailFilterInput>;
  emailId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  messageSent?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<EmailStatusFilterInput>>;
  receptionDate?: InputMaybe<DateTimeOperationFilterInput>;
  smsId?: InputMaybe<LongOperationFilterInput>;
  status?: InputMaybe<StatusOperationFilterInput>;
  statusMessage?: InputMaybe<StringOperationFilterInput>;
  webhookId?: InputMaybe<LongOperationFilterInput>;
};

export type EmailStatusSortInput = {
  appNoteId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deliverDate?: InputMaybe<SortEnumType>;
  email?: InputMaybe<EmailSortInput>;
  emailId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  messageSent?: InputMaybe<SortEnumType>;
  receptionDate?: InputMaybe<SortEnumType>;
  smsId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  statusMessage?: InputMaybe<SortEnumType>;
  webhookId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EmailsConnection = {
  __typename?: 'EmailsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EmailsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Email>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EmailsEdge = {
  __typename?: 'EmailsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Email;
};

export type EnergyBalance = {
  __typename?: 'EnergyBalance';
  aggregatedInterval: Scalars['Int']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endType: Scalars['Int']['output'];
  endTypeValue: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  scheduleOperationModes: Array<ScheduleOperationMode>;
};

/** A connection to a list of items. */
export type EnergyBalanceConnection = {
  __typename?: 'EnergyBalanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EnergyBalanceEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EnergyBalance>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnergyBalanceEdge = {
  __typename?: 'EnergyBalanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EnergyBalance;
};

export type EnergyBalanceFilterInput = {
  aggregatedInterval?: InputMaybe<IntOperationFilterInput>;
  and?: InputMaybe<Array<EnergyBalanceFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endType?: InputMaybe<IntOperationFilterInput>;
  endTypeValue?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnergyBalanceFilterInput>>;
  scheduleOperationModes?: InputMaybe<ListFilterInputTypeOfScheduleOperationModeFilterInput>;
};

export type EnergyBalanceSortInput = {
  aggregatedInterval?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  endType?: InputMaybe<SortEnumType>;
  endTypeValue?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Enterprise = {
  __typename?: 'Enterprise';
  accessGroups: Array<AccessGroup>;
  companies: Array<Company>;
  description: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type EnterpriseFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<EnterpriseFilterInput>>;
  companies?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EnterpriseFilterInput>>;
};

export type EnterpriseSortInput = {
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type EnterprisesConnection = {
  __typename?: 'EnterprisesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EnterprisesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Enterprise>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterprisesEdge = {
  __typename?: 'EnterprisesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Enterprise>;
};

export type EquipBulkConfigurationFilterInput = {
  and?: InputMaybe<Array<EquipBulkConfigurationFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EquipBulkConfigurationFilterInput>>;
};

export type EquipBulkConfigurationSortInput = {
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Equipment = {
  __typename?: 'Equipment';
  anchorType?: Maybe<Anchor_Type>;
  asset?: Maybe<Asset>;
  assetId?: Maybe<Scalars['Long']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  connectionType?: Maybe<Connection_Type>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  equipmentType: Equipment_Type;
  feederName?: Maybe<Scalars['String']['output']>;
  feeders?: Maybe<Array<Feeder>>;
  id: Scalars['Long']['output'];
  inputType?: Maybe<Input_Type>;
  installationType?: Maybe<Installation_Type>;
  interbarTransformer?: Maybe<Equipment>;
  interbarTransformerId?: Maybe<Scalars['Long']['output']>;
  interbarTransformers?: Maybe<Array<Equipment>>;
  isMainDeviceConnected?: Maybe<Scalars['Boolean']['output']>;
  isMainTransformer: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  manufactureDate?: Maybe<Scalars['DateTime']['output']>;
  masterBusLines?: Maybe<Array<Line>>;
  materialType?: Maybe<Material_Type>;
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentAsset?: Maybe<Asset>;
  parentAssetId?: Maybe<Scalars['Long']['output']>;
  parentFeeder?: Maybe<Feeder>;
  parentFeederId?: Maybe<Scalars['Long']['output']>;
  phaseRotation: Phase_Rotation;
  phaseType: Phase_Type;
  power: Scalars['Int']['output'];
  serviceEntryDate?: Maybe<Scalars['DateTime']['output']>;
  transformerType: Transformer_Type;
};

export type EquipmentFilterInput = {
  anchorType?: InputMaybe<NullableOfAnchor_TypeOperationFilterInput>;
  and?: InputMaybe<Array<EquipmentFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  brand?: InputMaybe<StringOperationFilterInput>;
  connectionType?: InputMaybe<NullableOfConnection_TypeOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  enable?: InputMaybe<BooleanOperationFilterInput>;
  equipmentType?: InputMaybe<Equipment_TypeOperationFilterInput>;
  feederName?: InputMaybe<StringOperationFilterInput>;
  feeders?: InputMaybe<ListFilterInputTypeOfFeederFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputType?: InputMaybe<NullableOfInput_TypeOperationFilterInput>;
  installationType?: InputMaybe<NullableOfInstallation_TypeOperationFilterInput>;
  interbarTransformer?: InputMaybe<EquipmentFilterInput>;
  interbarTransformerId?: InputMaybe<LongOperationFilterInput>;
  interbarTransformers?: InputMaybe<ListFilterInputTypeOfEquipmentFilterInput>;
  isMainDeviceConnected?: InputMaybe<BooleanOperationFilterInput>;
  isMainTransformer?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  manufactureDate?: InputMaybe<DateTimeOperationFilterInput>;
  masterBusLines?: InputMaybe<ListFilterInputTypeOfLineFilterInput>;
  materialType?: InputMaybe<NullableOfMaterial_TypeOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EquipmentFilterInput>>;
  parentAsset?: InputMaybe<AssetFilterInput>;
  parentAssetId?: InputMaybe<LongOperationFilterInput>;
  parentFeeder?: InputMaybe<FeederFilterInput>;
  parentFeederId?: InputMaybe<LongOperationFilterInput>;
  phaseRotation?: InputMaybe<Phase_RotationOperationFilterInput>;
  phaseType?: InputMaybe<Phase_TypeOperationFilterInput>;
  power?: InputMaybe<IntOperationFilterInput>;
  serviceEntryDate?: InputMaybe<DateTimeOperationFilterInput>;
  transformerType?: InputMaybe<Transformer_TypeOperationFilterInput>;
};

export type EquipmentSortInput = {
  anchorType?: InputMaybe<SortEnumType>;
  asset?: InputMaybe<AssetSortInput>;
  assetId?: InputMaybe<SortEnumType>;
  brand?: InputMaybe<SortEnumType>;
  connectionType?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  enable?: InputMaybe<SortEnumType>;
  equipmentType?: InputMaybe<SortEnumType>;
  feederName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputType?: InputMaybe<SortEnumType>;
  installationType?: InputMaybe<SortEnumType>;
  interbarTransformer?: InputMaybe<EquipmentSortInput>;
  interbarTransformerId?: InputMaybe<SortEnumType>;
  isMainDeviceConnected?: InputMaybe<SortEnumType>;
  isMainTransformer?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  manufactureDate?: InputMaybe<SortEnumType>;
  materialType?: InputMaybe<SortEnumType>;
  model?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentAsset?: InputMaybe<AssetSortInput>;
  parentAssetId?: InputMaybe<SortEnumType>;
  parentFeeder?: InputMaybe<FeederSortInput>;
  parentFeederId?: InputMaybe<SortEnumType>;
  phaseRotation?: InputMaybe<SortEnumType>;
  phaseType?: InputMaybe<SortEnumType>;
  power?: InputMaybe<SortEnumType>;
  serviceEntryDate?: InputMaybe<SortEnumType>;
  transformerType?: InputMaybe<SortEnumType>;
};

export type EquipmentsAlarmStandard = {
  __typename?: 'EquipmentsAlarmStandard';
  assets: Array<Asset>;
  editable: Scalars['Boolean']['output'];
  externalId: Scalars['Long']['output'];
  feeders: Array<Feeder>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type EquipmentsBulkConfiguration = {
  __typename?: 'EquipmentsBulkConfiguration';
  assets: Array<Asset>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type EquipmentsConnection = {
  __typename?: 'EquipmentsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EquipmentsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Equipment>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type EquipmentsDevice = {
  __typename?: 'EquipmentsDevice';
  asset: Asset;
  assetId: Scalars['Long']['output'];
  createdDate: Scalars['DateTime']['output'];
  deviceInputs: Array<EquipmentsDeviceInputNumber>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  serialNumber: Scalars['String']['output'];
};

export type EquipmentsDeviceInputNumber = {
  __typename?: 'EquipmentsDeviceInputNumber';
  deviceExternalId: Scalars['Long']['output'];
  deviceId: Scalars['Long']['output'];
  devicePortId?: Maybe<Scalars['Long']['output']>;
  deviceSerialNumber: Scalars['String']['output'];
  equipmentId?: Maybe<Scalars['Long']['output']>;
  externalId: Scalars['Long']['output'];
  feederId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  inputNumber: Scalars['Int']['output'];
  inputType: Input_Type;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  masterBusLineId?: Maybe<Scalars['Long']['output']>;
  portNumber: Scalars['Int']['output'];
  powerBusLineId?: Maybe<Scalars['Long']['output']>;
  typeId?: Maybe<Scalars['Int']['output']>;
};

export type EquipmentsDeviceLog = {
  __typename?: 'EquipmentsDeviceLog';
  assetId: Scalars['Long']['output'];
  comissionDate: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deComissionDate: Scalars['DateTime']['output'];
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  serialNumber: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type EquipmentsDevicesConnection = {
  __typename?: 'EquipmentsDevicesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EquipmentsDevicesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EquipmentsDevice>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EquipmentsDevicesEdge = {
  __typename?: 'EquipmentsDevicesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EquipmentsDevice;
};

/** An edge in a connection. */
export type EquipmentsEdge = {
  __typename?: 'EquipmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Equipment;
};

export type EquipmentsOperationalArea = {
  __typename?: 'EquipmentsOperationalArea';
  assets: Array<Asset>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type EquipmentsRegion = {
  __typename?: 'EquipmentsRegion';
  assets: Array<Asset>;
  externalId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  assetId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deviceEventId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['Long']['output']>;
  deviceSerial?: Maybe<Scalars['String']['output']>;
  deviceStatus?: Maybe<EventDataStatus>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  entityType: EventEntityType;
  equipmentId?: Maybe<Scalars['Long']['output']>;
  eventData: Array<EventData>;
  feederId?: Maybe<Scalars['Long']['output']>;
  feederName?: Maybe<Scalars['String']['output']>;
  fuseRating?: Maybe<Scalars['Float']['output']>;
  fuseWay?: Maybe<Scalars['Float']['output']>;
  hasWFC: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  line?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  portNumber?: Maybe<Scalars['Int']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  severity: EventSeverity;
  source: Source;
  sourceEntityType: Entity_Type;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: EventStatus;
  type: EventType;
};

export type EventData = {
  __typename?: 'EventData';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  delta_T?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceStatus?: Maybe<EventDataStatus>;
  event: Event;
  eventId: Scalars['Long']['output'];
  iavg?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Long']['output'];
  imax?: Maybe<Scalars['Int']['output']>;
  imin?: Maybe<Scalars['Int']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ratio?: Maybe<Scalars['Float']['output']>;
  status: EventStatus;
  timeStamp?: Maybe<Scalars['DateTime']['output']>;
};

/** A connection to a list of items. */
export type EventDataConnection = {
  __typename?: 'EventDataConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventDataEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<EventData>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventDataEdge = {
  __typename?: 'EventDataEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EventData;
};

export type EventDataFilterInput = {
  and?: InputMaybe<Array<EventDataFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  data?: InputMaybe<StringOperationFilterInput>;
  delta_T?: InputMaybe<IntOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceStatus?: InputMaybe<NullableOfEventDataStatusOperationFilterInput>;
  event?: InputMaybe<EventFilterInput>;
  eventId?: InputMaybe<LongOperationFilterInput>;
  iavg?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  imax?: InputMaybe<IntOperationFilterInput>;
  imin?: InputMaybe<IntOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventDataFilterInput>>;
  ratio?: InputMaybe<FloatOperationFilterInput>;
  status?: InputMaybe<EventStatusOperationFilterInput>;
  timeStamp?: InputMaybe<DateTimeOperationFilterInput>;
};

export type EventDataSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  data?: InputMaybe<SortEnumType>;
  delta_T?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  deviceStatus?: InputMaybe<SortEnumType>;
  event?: InputMaybe<EventSortInput>;
  eventId?: InputMaybe<SortEnumType>;
  iavg?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  imax?: InputMaybe<SortEnumType>;
  imin?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  ratio?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  timeStamp?: InputMaybe<SortEnumType>;
};

export enum EventDataStatus {
  Resolved = 'RESOLVED',
  Unresolved = 'UNRESOLVED'
}

export enum EventEntityType {
  Asset = 'ASSET',
  AssetHv = 'ASSET_HV',
  AssetHvFeeder = 'ASSET_HV_FEEDER',
  AssetLvBusbar = 'ASSET_LV_BUSBAR',
  AssetLvFeeder = 'ASSET_LV_FEEDER',
  AssetLvLine = 'ASSET_LV_LINE',
  Device = 'DEVICE',
  Empty = 'EMPTY',
  Grid = 'GRID'
}

export type EventEntityTypeOperationFilterInput = {
  eq?: InputMaybe<EventEntityType>;
  in?: InputMaybe<Array<EventEntityType>>;
  neq?: InputMaybe<EventEntityType>;
  nin?: InputMaybe<Array<EventEntityType>>;
};

export type EventFilterInput = {
  and?: InputMaybe<Array<EventFilterInput>>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deviceEventId?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  deviceSerial?: InputMaybe<StringOperationFilterInput>;
  deviceStatus?: InputMaybe<NullableOfEventDataStatusOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  entityType?: InputMaybe<EventEntityTypeOperationFilterInput>;
  equipmentId?: InputMaybe<LongOperationFilterInput>;
  eventData?: InputMaybe<ListFilterInputTypeOfEventDataFilterInput>;
  feederId?: InputMaybe<LongOperationFilterInput>;
  feederName?: InputMaybe<StringOperationFilterInput>;
  fuseRating?: InputMaybe<FloatOperationFilterInput>;
  fuseWay?: InputMaybe<FloatOperationFilterInput>;
  hasWFC?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  line?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EventFilterInput>>;
  portNumber?: InputMaybe<IntOperationFilterInput>;
  registrationNumber?: InputMaybe<StringOperationFilterInput>;
  severity?: InputMaybe<EventSeverityOperationFilterInput>;
  source?: InputMaybe<SourceOperationFilterInput>;
  sourceEntityType?: InputMaybe<Entity_TypeOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<EventStatusOperationFilterInput>;
  type?: InputMaybe<EventTypeOperationFilterInput>;
};

export enum EventSeverity {
  Critical = 'CRITICAL',
  Empty = 'EMPTY',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type EventSeverityOperationFilterInput = {
  eq?: InputMaybe<EventSeverity>;
  in?: InputMaybe<Array<EventSeverity>>;
  neq?: InputMaybe<EventSeverity>;
  nin?: InputMaybe<Array<EventSeverity>>;
};

export type EventSortInput = {
  assetId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  deviceEventId?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  deviceSerial?: InputMaybe<SortEnumType>;
  deviceStatus?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  entityType?: InputMaybe<SortEnumType>;
  equipmentId?: InputMaybe<SortEnumType>;
  feederId?: InputMaybe<SortEnumType>;
  feederName?: InputMaybe<SortEnumType>;
  fuseRating?: InputMaybe<SortEnumType>;
  fuseWay?: InputMaybe<SortEnumType>;
  hasWFC?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  line?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  portNumber?: InputMaybe<SortEnumType>;
  registrationNumber?: InputMaybe<SortEnumType>;
  severity?: InputMaybe<SortEnumType>;
  source?: InputMaybe<SortEnumType>;
  sourceEntityType?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum EventStatus {
  Acknowledge = 'ACKNOWLEDGE',
  Empty = 'EMPTY',
  Presist = 'PRESIST',
  Resolved = 'RESOLVED',
  Resolving = 'RESOLVING',
  Unresolved = 'UNRESOLVED'
}

export type EventStatusOperationFilterInput = {
  eq?: InputMaybe<EventStatus>;
  in?: InputMaybe<Array<EventStatus>>;
  neq?: InputMaybe<EventStatus>;
  nin?: InputMaybe<Array<EventStatus>>;
};

export enum EventType {
  BrokenNeutral = 'BROKEN_NEUTRAL',
  BusbarLineNullVoltage = 'BUSBAR_LINE_NULL_VOLTAGE',
  BusbarNeutralOpenCircuit = 'BUSBAR_NEUTRAL_OPEN_CIRCUIT',
  BusbarOverloadAgg = 'BUSBAR_OVERLOAD_AGG',
  BusbarOverVoltage = 'BUSBAR_OVER_VOLTAGE',
  BusbarOverVoltageAgg = 'BUSBAR_OVER_VOLTAGE_AGG',
  BusbarUnderVoltage = 'BUSBAR_UNDER_VOLTAGE',
  BusbarUnderVoltageAgg = 'BUSBAR_UNDER_VOLTAGE_AGG',
  DevicePowerFail = 'DEVICE_POWER_FAIL',
  DeviceReport = 'DEVICE_REPORT',
  DeviceWithoutCommunications = 'DEVICE_WITHOUT_COMMUNICATIONS',
  Dip = 'DIP',
  Empty = 'EMPTY',
  FeederLineCurrentLevel = 'FEEDER_LINE_CURRENT_LEVEL',
  FeederLineCurrentLevelOptimization = 'FEEDER_LINE_CURRENT_LEVEL_OPTIMIZATION',
  FeederLineFuseBlown = 'FEEDER_LINE_FUSE_BLOWN',
  FeederLineNullCurrent = 'FEEDER_LINE_NULL_CURRENT',
  FeederLineOvercurrent = 'FEEDER_LINE_OVERCURRENT',
  FeederLineOverloadAgg = 'FEEDER_LINE_OVERLOAD_AGG',
  FeederLinePreFault = 'FEEDER_LINE_PRE_FAULT',
  FeederLineReversePowerAgg = 'FEEDER_LINE_REVERSE_POWER_AGG',
  FeederNeutralCurrentLevel = 'FEEDER_NEUTRAL_CURRENT_LEVEL',
  FeederNeutralOvercurrentAgg = 'FEEDER_NEUTRAL_OVERCURRENT_AGG',
  HvLineDown = 'HV_LINE_DOWN',
  HvPhaseLoss = 'HV_PHASE_LOSS',
  InstallReactivePowerCheck = 'INSTALL_REACTIVE_POWER_CHECK',
  InstallReversePowerCheck = 'INSTALL_REVERSE_POWER_CHECK',
  InstallVoltageCheck = 'INSTALL_VOLTAGE_CHECK',
  NewHvLineDown = 'NEW_HV_LINE_DOWN',
  PlatformFeederLineNullCurrent = 'PLATFORM_FEEDER_LINE_NULL_CURRENT',
  Rvc = 'RVC',
  SdsEarthingVoltageLevel = 'SDS_EARTHING_VOLTAGE_LEVEL',
  SdsMvDeadSection = 'SDS_MV_DEAD_SECTION',
  SdsMvDeadSectionVect = 'SDS_MV_DEAD_SECTION_VECT',
  SdsProtectiveEarthLevel = 'SDS_PROTECTIVE_EARTH_LEVEL',
  SdsVoltageFreqViolation = 'SDS_VOLTAGE_FREQ_VIOLATION',
  SdsVoltagePhaseUnbalance = 'SDS_VOLTAGE_PHASE_UNBALANCE',
  SdsVoltageUnbalance = 'SDS_VOLTAGE_UNBALANCE',
  SdsVoltageViolation = 'SDS_VOLTAGE_VIOLATION',
  Swell = 'SWELL',
  Uint = 'UINT',
  Wfc = 'WFC'
}

export type EventTypeOperationFilterInput = {
  eq?: InputMaybe<EventType>;
  in?: InputMaybe<Array<EventType>>;
  neq?: InputMaybe<EventType>;
  nin?: InputMaybe<Array<EventType>>;
};

/** A connection to a list of items. */
export type EventsConnection = {
  __typename?: 'EventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<EventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Event>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EventsEdge = {
  __typename?: 'EventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Event;
};

export enum ExpirationType {
  Month = 'MONTH',
  Never = 'NEVER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ExpirationTypeOperationFilterInput = {
  eq?: InputMaybe<ExpirationType>;
  in?: InputMaybe<Array<ExpirationType>>;
  neq?: InputMaybe<ExpirationType>;
  nin?: InputMaybe<Array<ExpirationType>>;
};

export enum Feeder_Type {
  Busbar = 'BUSBAR',
  EarthProtectionLine = 'EARTH_PROTECTION_LINE',
  EarthServiceLine = 'EARTH_SERVICE_LINE',
  HvFeeder = 'HV_FEEDER',
  NeutralLine = 'NEUTRAL_LINE',
  NotDefined = 'NOT_DEFINED',
  Powerbusline = 'POWERBUSLINE'
}

export type Feeder_TypeOperationFilterInput = {
  eq?: InputMaybe<Feeder_Type>;
  in?: InputMaybe<Array<Feeder_Type>>;
  neq?: InputMaybe<Feeder_Type>;
  nin?: InputMaybe<Array<Feeder_Type>>;
};

export enum Firmware_Task_Status {
  Canceled = 'CANCELED',
  Done = 'DONE',
  Error = 'ERROR',
  Updating = 'UPDATING'
}

export type Firmware_Task_StatusOperationFilterInput = {
  eq?: InputMaybe<Firmware_Task_Status>;
  in?: InputMaybe<Array<Firmware_Task_Status>>;
  neq?: InputMaybe<Firmware_Task_Status>;
  nin?: InputMaybe<Array<Firmware_Task_Status>>;
};

export type FederatedIdentity = {
  __typename?: 'FederatedIdentity';
  identityProvider?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type FederatedIdentityFilterInput = {
  and?: InputMaybe<Array<FederatedIdentityFilterInput>>;
  identityProvider?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FederatedIdentityFilterInput>>;
  userId?: InputMaybe<StringOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type Feeder = {
  __typename?: 'Feeder';
  alarmStandard: EquipmentsAlarmStandard;
  alarmStandardId?: Maybe<Scalars['Long']['output']>;
  assetId: Scalars['Long']['output'];
  cableType: CableType;
  cableTypeId?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  equipmentId: Scalars['Long']['output'];
  feederType: Feeder_Type;
  fuseRating: Scalars['Float']['output'];
  hasData?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  isActive: Scalars['Boolean']['output'];
  isCommissioned: Scalars['Boolean']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  lines: Array<Line>;
  name: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  parentEquipments?: Maybe<Array<Equipment>>;
};

export type FeederFilterInput = {
  alarmStandard?: InputMaybe<AlarmStandardFilterInput>;
  alarmStandardId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<FeederFilterInput>>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  cableType?: InputMaybe<CableTypeFilterInput>;
  cableTypeId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  equipmentId?: InputMaybe<LongOperationFilterInput>;
  feederType?: InputMaybe<Feeder_TypeOperationFilterInput>;
  fuseRating?: InputMaybe<FloatOperationFilterInput>;
  hasData?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  isCommissioned?: InputMaybe<BooleanOperationFilterInput>;
  isReadOnly?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lines?: InputMaybe<ListFilterInputTypeOfLineFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FeederFilterInput>>;
  parentEquipments?: InputMaybe<ListFilterInputTypeOfEquipmentFilterInput>;
};

export type FeederSortInput = {
  alarmStandard?: InputMaybe<AlarmStandardSortInput>;
  alarmStandardId?: InputMaybe<SortEnumType>;
  assetId?: InputMaybe<SortEnumType>;
  cableType?: InputMaybe<CableTypeSortInput>;
  cableTypeId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  equipmentId?: InputMaybe<SortEnumType>;
  feederType?: InputMaybe<SortEnumType>;
  fuseRating?: InputMaybe<SortEnumType>;
  hasData?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  isCommissioned?: InputMaybe<SortEnumType>;
  isReadOnly?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FeedersConnection = {
  __typename?: 'FeedersConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FeedersEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Feeder>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FeedersEdge = {
  __typename?: 'FeedersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Feeder;
};

export type Filter = {
  __typename?: 'Filter';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  joinOperator: Join_Operator;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  operator: Scalars['String']['output'];
  propertyName: Scalars['String']['output'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['Long']['output']>;
  value: Scalars['String']['output'];
};

export type FilterFilterInput = {
  and?: InputMaybe<Array<FilterFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  joinOperator?: InputMaybe<Join_OperatorOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  operator?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FilterFilterInput>>;
  propertyName?: InputMaybe<StringOperationFilterInput>;
  subscription?: InputMaybe<SubscriptionFilterInput>;
  subscriptionId?: InputMaybe<LongOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type Firmware = {
  __typename?: 'Firmware';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  firmwareDocument: DevicesFirmwareDocument;
  firmwareDocumentId: Scalars['Long']['output'];
  firmwareTasks?: Maybe<Array<FirmwareTask>>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
};

export type FirmwareDocumentFilterInput = {
  and?: InputMaybe<Array<FirmwareDocumentFilterInput>>;
  deviceType?: InputMaybe<Device_TypeOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmware?: InputMaybe<FirmwareFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  microType?: InputMaybe<Micro_Controller_TypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareDocumentFilterInput>>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type FirmwareDocumentSortInput = {
  deviceType?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  firmware?: InputMaybe<FirmwareSortInput>;
  id?: InputMaybe<SortEnumType>;
  microType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type FirmwareFilterInput = {
  and?: InputMaybe<Array<FirmwareFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  firmwareDocument?: InputMaybe<FirmwareDocumentFilterInput>;
  firmwareDocumentId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareFilterInput>>;
};

export type FirmwareSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  firmwareDocument?: InputMaybe<FirmwareDocumentSortInput>;
  firmwareDocumentId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type FirmwareTask = {
  __typename?: 'FirmwareTask';
  accessGroups?: Maybe<Array<DevicesAccessGroup>>;
  cancelDate?: Maybe<Scalars['DateTime']['output']>;
  companies?: Maybe<Array<DevicesCompany>>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  deviceTags?: Maybe<Array<DeviceTag>>;
  devices?: Maybe<Array<Device>>;
  downloadAttempts: Scalars['Int']['output'];
  firmware: Firmware;
  firmwareId: Scalars['Long']['output'];
  firmwareTaskLogs?: Maybe<Array<FirmwareTaskLog>>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  operationalAreas?: Maybe<Array<DevicesOperationalArea>>;
  processed: Scalars['Boolean']['output'];
  processedDate?: Maybe<Scalars['DateTime']['output']>;
  regions?: Maybe<Array<DevicesRegion>>;
  scheduleDate: Scalars['DateTime']['output'];
  taskName: Scalars['String']['output'];
};

export type FirmwareTaskFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<FirmwareTaskFilterInput>>;
  cancelDate?: InputMaybe<DateTimeOperationFilterInput>;
  companies?: InputMaybe<ListFilterInputTypeOfCompanyFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  deviceTags?: InputMaybe<ListFilterInputTypeOfDeviceTagFilterInput>;
  devices?: InputMaybe<ListFilterInputTypeOfDeviceFilterInput>;
  downloadAttempts?: InputMaybe<IntOperationFilterInput>;
  firmware?: InputMaybe<FirmwareFilterInput>;
  firmwareId?: InputMaybe<LongOperationFilterInput>;
  firmwareTaskLogs?: InputMaybe<ListFilterInputTypeOfFirmwareTaskLogFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  operationalAreas?: InputMaybe<ListFilterInputTypeOfOperationalAreaFilterInput>;
  or?: InputMaybe<Array<FirmwareTaskFilterInput>>;
  processed?: InputMaybe<BooleanOperationFilterInput>;
  processedDate?: InputMaybe<DateTimeOperationFilterInput>;
  regions?: InputMaybe<ListFilterInputTypeOfRegionFilterInput>;
  scheduleDate?: InputMaybe<DateTimeOperationFilterInput>;
  taskName?: InputMaybe<StringOperationFilterInput>;
};

export type FirmwareTaskLog = {
  __typename?: 'FirmwareTaskLog';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  currentBlock: Scalars['Int']['output'];
  currentVersion: Scalars['String']['output'];
  device: Device;
  deviceId: Scalars['Long']['output'];
  downloadAttempts: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  firmwareTask: FirmwareTask;
  firmwareTaskId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  numberBlocks: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Firmware_Task_Status;
  taskLog: Scalars['String']['output'];
  updatedVersion: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type FirmwareTaskLogConnection = {
  __typename?: 'FirmwareTaskLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwareTaskLogEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmwareTaskLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FirmwareTaskLogEdge = {
  __typename?: 'FirmwareTaskLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FirmwareTaskLog;
};

export type FirmwareTaskLogFilterInput = {
  and?: InputMaybe<Array<FirmwareTaskLogFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  currentBlock?: InputMaybe<IntOperationFilterInput>;
  currentVersion?: InputMaybe<StringOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  downloadAttempts?: InputMaybe<IntOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  firmwareTask?: InputMaybe<FirmwareTaskFilterInput>;
  firmwareTaskId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  numberBlocks?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<FirmwareTaskLogFilterInput>>;
  progress?: InputMaybe<IntOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  status?: InputMaybe<Firmware_Task_StatusOperationFilterInput>;
  taskLog?: InputMaybe<StringOperationFilterInput>;
  updatedVersion?: InputMaybe<StringOperationFilterInput>;
};

export type FirmwareTaskLogSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  currentBlock?: InputMaybe<SortEnumType>;
  currentVersion?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  downloadAttempts?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  firmwareTask?: InputMaybe<FirmwareTaskSortInput>;
  firmwareTaskId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  numberBlocks?: InputMaybe<SortEnumType>;
  progress?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  taskLog?: InputMaybe<SortEnumType>;
  updatedVersion?: InputMaybe<SortEnumType>;
};

export type FirmwareTaskSortInput = {
  cancelDate?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  downloadAttempts?: InputMaybe<SortEnumType>;
  firmware?: InputMaybe<FirmwareSortInput>;
  firmwareId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  processed?: InputMaybe<SortEnumType>;
  processedDate?: InputMaybe<SortEnumType>;
  scheduleDate?: InputMaybe<SortEnumType>;
  taskName?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type FirmwareTasksConnection = {
  __typename?: 'FirmwareTasksConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwareTasksEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<FirmwareTask>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FirmwareTasksEdge = {
  __typename?: 'FirmwareTasksEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FirmwareTask;
};

/** A connection to a list of items. */
export type FirmwaresConnection = {
  __typename?: 'FirmwaresConnection';
  /** A list of edges. */
  edges?: Maybe<Array<FirmwaresEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Firmware>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FirmwaresEdge = {
  __typename?: 'FirmwaresEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Firmware;
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type GeneralSettings = {
  __typename?: 'GeneralSettings';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  groupName: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  settings: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GpsPoint = {
  __typename?: 'GpsPoint';
  asset?: Maybe<LayoutEquipment>;
  assetId?: Maybe<Scalars['Long']['output']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Long']['output']>;
  designOrder: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  operationalArea?: Maybe<OperationalArea>;
  operationalAreaId?: Maybe<Scalars['Long']['output']>;
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['Long']['output']>;
};

export type GpsPointFilterInput = {
  and?: InputMaybe<Array<GpsPointFilterInput>>;
  asset?: InputMaybe<AssetFilterInput>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<LongOperationFilterInput>;
  designOrder?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  operationalArea?: InputMaybe<OperationalAreaFilterInput>;
  operationalAreaId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<GpsPointFilterInput>>;
  region?: InputMaybe<RegionFilterInput>;
  regionId?: InputMaybe<LongOperationFilterInput>;
};

export type GpsPointSortInput = {
  asset?: InputMaybe<AssetSortInput>;
  assetId?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  designOrder?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  operationalArea?: InputMaybe<OperationalAreaSortInput>;
  operationalAreaId?: InputMaybe<SortEnumType>;
  region?: InputMaybe<RegionSortInput>;
  regionId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type GpsPointsConnection = {
  __typename?: 'GpsPointsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<GpsPointsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<GpsPoint>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GpsPointsEdge = {
  __typename?: 'GpsPointsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GpsPoint>;
};

export enum Input_Type {
  Agg = 'AGG',
  All = 'ALL',
  Earth = 'EARTH',
  EarthProtection = 'EARTH_PROTECTION',
  EarthService = 'EARTH_SERVICE',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  Neutral = 'NEUTRAL',
  NotDefined = 'NOT_DEFINED'
}

export type Input_TypeOperationFilterInput = {
  eq?: InputMaybe<Input_Type>;
  in?: InputMaybe<Array<Input_Type>>;
  neq?: InputMaybe<Input_Type>;
  nin?: InputMaybe<Array<Input_Type>>;
};

export enum Installation_Type {
  Downstream = 'DOWNSTREAM',
  Upstream = 'UPSTREAM',
  Vertical = 'VERTICAL'
}

export enum Interface_Type {
  Bluetooth = 'BLUETOOTH',
  Ethernet = 'ETHERNET',
  Gprs = 'GPRS',
  LoRa = 'LO_RA'
}

export type Interface_TypeOperationFilterInput = {
  eq?: InputMaybe<Interface_Type>;
  in?: InputMaybe<Array<Interface_Type>>;
  neq?: InputMaybe<Interface_Type>;
  nin?: InputMaybe<Array<Interface_Type>>;
};

export type Input = {
  __typename?: 'Input';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  devicePortId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  inputType: Input_Type;
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  number: Scalars['Int']['output'];
  port: Port;
};

export type InputFilterInput = {
  and?: InputMaybe<Array<InputFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  devicePortId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputType?: InputMaybe<Input_TypeOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  number?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<InputFilterInput>>;
  port?: InputMaybe<PortFilterInput>;
};

export type InputSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  devicePortId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputType?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  number?: InputMaybe<SortEnumType>;
  port?: InputMaybe<PortSortInput>;
};

/** A connection to a list of items. */
export type InputsConnection = {
  __typename?: 'InputsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InputsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Input>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InputsEdge = {
  __typename?: 'InputsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Input;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type Interface = {
  __typename?: 'Interface';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocols: Array<Protocol>;
};

export type InterfaceBluetooth = {
  __typename?: 'InterfaceBluetooth';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  lastStateChange?: Maybe<Scalars['DateTime']['output']>;
  protocols: Array<Protocol>;
  state: Scalars['Int']['output'];
};

export type InterfaceBluetoothFilterInput = {
  and?: InputMaybe<Array<InterfaceBluetoothFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastStateChange?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceBluetoothFilterInput>>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
  state?: InputMaybe<IntOperationFilterInput>;
};

export type InterfaceBluetoothSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  lastStateChange?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
};

export type InterfaceEthernet = {
  __typename?: 'InterfaceEthernet';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceAddress: Scalars['String']['output'];
  deviceId: Scalars['Long']['output'];
  deviceMac: Scalars['String']['output'];
  deviceMasc: Scalars['String']['output'];
  ethDutyCycle?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocols: Array<Protocol>;
};

export type InterfaceEthernetFilterInput = {
  and?: InputMaybe<Array<InterfaceEthernetFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceAddress?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  deviceMac?: InputMaybe<StringOperationFilterInput>;
  deviceMasc?: InputMaybe<StringOperationFilterInput>;
  ethDutyCycle?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceEthernetFilterInput>>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
};

export type InterfaceEthernetSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceAddress?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  deviceMac?: InputMaybe<SortEnumType>;
  deviceMasc?: InputMaybe<SortEnumType>;
  ethDutyCycle?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
};

export type InterfaceFilterInput = {
  and?: InputMaybe<Array<InterfaceFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceFilterInput>>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
};

export type InterfaceGprs = {
  __typename?: 'InterfaceGprs';
  apnAuthType: Apn_Auth_Type;
  apnName: Scalars['String']['output'];
  apnPwd: Scalars['String']['output'];
  apnUser: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  iccid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastCommunication?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocols: Array<Protocol>;
  simId?: Maybe<Scalars['String']['output']>;
  simIp?: Maybe<Scalars['String']['output']>;
};

export type InterfaceGprsFilterInput = {
  and?: InputMaybe<Array<InterfaceGprsFilterInput>>;
  apnAuthType?: InputMaybe<Apn_Auth_TypeOperationFilterInput>;
  apnName?: InputMaybe<StringOperationFilterInput>;
  apnPwd?: InputMaybe<StringOperationFilterInput>;
  apnUser?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  iccid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastCommunication?: InputMaybe<DateTimeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceGprsFilterInput>>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
  simId?: InputMaybe<StringOperationFilterInput>;
  simIp?: InputMaybe<StringOperationFilterInput>;
};

export type InterfaceGprsSortInput = {
  apnAuthType?: InputMaybe<SortEnumType>;
  apnName?: InputMaybe<SortEnumType>;
  apnPwd?: InputMaybe<SortEnumType>;
  apnUser?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  iccid?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastCommunication?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  simId?: InputMaybe<SortEnumType>;
  simIp?: InputMaybe<SortEnumType>;
};

export type InterfaceLoRa = {
  __typename?: 'InterfaceLoRa';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  interfaceType: Interface_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  modemSettings: ModemSettings;
  modemSettingsId: Scalars['Long']['output'];
  packetConfiguration: PacketConfiguration;
  packetConfigurationId: Scalars['Long']['output'];
  protocols: Array<Protocol>;
  rfSettings: RfSettings;
  rfSettingsId: Scalars['Long']['output'];
};

export type InterfaceLoRaFilterInput = {
  and?: InputMaybe<Array<InterfaceLoRaFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceType?: InputMaybe<Interface_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  modemSettings?: InputMaybe<ModemSettingsFilterInput>;
  modemSettingsId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<InterfaceLoRaFilterInput>>;
  packetConfiguration?: InputMaybe<PacketConfigurationFilterInput>;
  packetConfigurationId?: InputMaybe<LongOperationFilterInput>;
  protocols?: InputMaybe<ListFilterInputTypeOfProtocolFilterInput>;
  rfSettings?: InputMaybe<RfSettingsFilterInput>;
  rfSettingsId?: InputMaybe<LongOperationFilterInput>;
};

export type InterfaceLoRaSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  modemSettings?: InputMaybe<ModemSettingsSortInput>;
  modemSettingsId?: InputMaybe<SortEnumType>;
  packetConfiguration?: InputMaybe<PacketConfigurationSortInput>;
  packetConfigurationId?: InputMaybe<SortEnumType>;
  rfSettings?: InputMaybe<RfSettingsSortInput>;
  rfSettingsId?: InputMaybe<SortEnumType>;
};

export type InterfaceSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type InterfacesBluetoothConnection = {
  __typename?: 'InterfacesBluetoothConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InterfacesBluetoothEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InterfaceBluetooth>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterfacesBluetoothEdge = {
  __typename?: 'InterfacesBluetoothEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InterfaceBluetooth;
};

/** A connection to a list of items. */
export type InterfacesEthernetConnection = {
  __typename?: 'InterfacesEthernetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InterfacesEthernetEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InterfaceEthernet>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterfacesEthernetEdge = {
  __typename?: 'InterfacesEthernetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InterfaceEthernet;
};

/** A connection to a list of items. */
export type InterfacesGprsConnection = {
  __typename?: 'InterfacesGprsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InterfacesGprsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InterfaceGprs>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterfacesGprsEdge = {
  __typename?: 'InterfacesGprsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InterfaceGprs;
};

/** A connection to a list of items. */
export type InterfacesLoRaConnection = {
  __typename?: 'InterfacesLoRaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<InterfacesLoRaEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<InterfaceLoRa>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InterfacesLoRaEdge = {
  __typename?: 'InterfacesLoRaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: InterfaceLoRa;
};

export enum Join_Operator {
  And = 'AND',
  Or = 'OR'
}

export type Join_OperatorOperationFilterInput = {
  eq?: InputMaybe<Join_Operator>;
  in?: InputMaybe<Array<Join_Operator>>;
  neq?: InputMaybe<Join_Operator>;
  nin?: InputMaybe<Array<Join_Operator>>;
};

export type KeyValuePairOfStringAndIEnumerableOfString = {
  __typename?: 'KeyValuePairOfStringAndIEnumerableOfString';
  key: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type KeyValuePairOfStringAndIEnumerableOfStringFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>>;
  value?: InputMaybe<ListStringOperationFilterInput>;
};

export type KeyValuePairOfStringAndObject = {
  __typename?: 'KeyValuePairOfStringAndObject';
  key: Scalars['String']['output'];
};

export type KeyValuePairOfStringAndObjectFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndObjectFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndObjectFilterInput>>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type KeyValuePairOfStringAndStringFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type KeycloakRole = {
  __typename?: 'KeycloakRole';
  attributes?: Maybe<Array<KeyValuePairOfStringAndObject>>;
  clientRole?: Maybe<Scalars['Boolean']['output']>;
  composite?: Maybe<Scalars['Boolean']['output']>;
  composites?: Maybe<RoleComposite>;
  containerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type KeycloakRoleConnection = {
  __typename?: 'KeycloakRoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<KeycloakRoleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<KeycloakRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KeycloakRoleEdge = {
  __typename?: 'KeycloakRoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KeycloakRole;
};

export type KeycloakRoleFilterInput = {
  and?: InputMaybe<Array<KeycloakRoleFilterInput>>;
  attributes?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  clientRole?: InputMaybe<BooleanOperationFilterInput>;
  composite?: InputMaybe<BooleanOperationFilterInput>;
  composites?: InputMaybe<RoleCompositeFilterInput>;
  containerId?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeycloakRoleFilterInput>>;
};

export type KeycloakRoleSortInput = {
  clientRole?: InputMaybe<SortEnumType>;
  composite?: InputMaybe<SortEnumType>;
  containerId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type KeycloakUser = {
  __typename?: 'KeycloakUser';
  access?: Maybe<UserAccess>;
  attributes?: Maybe<Array<KeyValuePairOfStringAndIEnumerableOfString>>;
  clientConsents?: Maybe<Array<Maybe<UserConsent>>>;
  clientRoles?: Maybe<Array<KeyValuePairOfStringAndObject>>;
  createdTimestamp: Scalars['Long']['output'];
  credentials?: Maybe<Array<Maybe<Credentials>>>;
  disableableCredentialTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  federatedIdentities?: Maybe<Array<Maybe<FederatedIdentity>>>;
  federationLink?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  notBefore?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  realmRoles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requiredActions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  self?: Maybe<Scalars['String']['output']>;
  serviceAccountClientId?: Maybe<Scalars['String']['output']>;
  totp?: Maybe<Scalars['Boolean']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type KeycloakUserConnection = {
  __typename?: 'KeycloakUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<KeycloakUserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<KeycloakUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type KeycloakUserEdge = {
  __typename?: 'KeycloakUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KeycloakUser;
};

export type KeycloakUserFilterInput = {
  access?: InputMaybe<UserAccessFilterInput>;
  and?: InputMaybe<Array<KeycloakUserFilterInput>>;
  attributes?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndIEnumerableOfStringFilterInput>;
  clientConsents?: InputMaybe<ListFilterInputTypeOfUserConsentFilterInput>;
  clientRoles?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput>;
  createdTimestamp?: InputMaybe<LongOperationFilterInput>;
  credentials?: InputMaybe<ListFilterInputTypeOfCredentialsFilterInput>;
  disableableCredentialTypes?: InputMaybe<ListStringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailVerified?: InputMaybe<BooleanOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  federatedIdentities?: InputMaybe<ListFilterInputTypeOfFederatedIdentityFilterInput>;
  federationLink?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  groups?: InputMaybe<ListStringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  notBefore?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<KeycloakUserFilterInput>>;
  origin?: InputMaybe<StringOperationFilterInput>;
  realmRoles?: InputMaybe<ListStringOperationFilterInput>;
  requiredActions?: InputMaybe<ListStringOperationFilterInput>;
  self?: InputMaybe<StringOperationFilterInput>;
  serviceAccountClientId?: InputMaybe<StringOperationFilterInput>;
  totp?: InputMaybe<BooleanOperationFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
};

export type KeycloakUserSortInput = {
  access?: InputMaybe<UserAccessSortInput>;
  createdTimestamp?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailVerified?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  federationLink?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  notBefore?: InputMaybe<SortEnumType>;
  origin?: InputMaybe<SortEnumType>;
  self?: InputMaybe<SortEnumType>;
  serviceAccountClientId?: InputMaybe<SortEnumType>;
  totp?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
};

export enum Lastcontact_Type {
  Alarm = 'ALARM',
  AlarmSet = 'ALARM_SET',
  AlarmStatus = 'ALARM_STATUS',
  LogParameter = 'LOG_PARAMETER',
  RawData = 'RAW_DATA',
  StateField = 'STATE_FIELD',
  StateFieldAck = 'STATE_FIELD_ACK',
  StateFirmware = 'STATE_FIRMWARE',
  StateFirmwareAck = 'STATE_FIRMWARE_ACK',
  StateInstallation = 'STATE_INSTALLATION',
  StateParameter = 'STATE_PARAMETER',
  TestResult = 'TEST_RESULT'
}

export type Lastcontact_TypeOperationFilterInput = {
  eq?: InputMaybe<Lastcontact_Type>;
  in?: InputMaybe<Array<Lastcontact_Type>>;
  neq?: InputMaybe<Lastcontact_Type>;
  nin?: InputMaybe<Array<Lastcontact_Type>>;
};

export enum Line_Type {
  MasterBusLine = 'MASTER_BUS_LINE',
  PowerBusLine = 'POWER_BUS_LINE'
}

export type Line_TypeOperationFilterInput = {
  eq?: InputMaybe<Line_Type>;
  in?: InputMaybe<Array<Line_Type>>;
  neq?: InputMaybe<Line_Type>;
  nin?: InputMaybe<Array<Line_Type>>;
};

export type LastContactByType = {
  __typename?: 'LastContactByType';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  lastContact: Scalars['DateTime']['output'];
  lastContactType: Lastcontact_Type;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  remoteIp?: Maybe<Scalars['String']['output']>;
};

export type LastContactByTypeFilterInput = {
  and?: InputMaybe<Array<LastContactByTypeFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastContact?: InputMaybe<DateTimeOperationFilterInput>;
  lastContactType?: InputMaybe<Lastcontact_TypeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<LastContactByTypeFilterInput>>;
  remoteIp?: InputMaybe<StringOperationFilterInput>;
};

export type LastContactByTypeSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastContact?: InputMaybe<SortEnumType>;
  lastContactType?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  remoteIp?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LastContactByTypesConnection = {
  __typename?: 'LastContactByTypesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LastContactByTypesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LastContactByType>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LastContactByTypesEdge = {
  __typename?: 'LastContactByTypesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LastContactByType;
};

export type LayoutAsset = {
  __typename?: 'LayoutAsset';
  accessGroups: Array<AccessGroup>;
  externalAssetId: Scalars['Long']['output'];
  gpsPoint?: Maybe<GpsPoint>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  operationalArea?: Maybe<OperationalArea>;
  operationalAreaId?: Maybe<Scalars['Long']['output']>;
  registrationNumber: Scalars['String']['output'];
  updateAsset: Scalars['Boolean']['output'];
};


export type LayoutAssetUpdateAssetArgs = {
  name: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
};

/** A connection to a list of items. */
export type LayoutAssetsConnection = {
  __typename?: 'LayoutAssetsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LayoutAssetsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<LayoutEquipment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LayoutAssetsEdge = {
  __typename?: 'LayoutAssetsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LayoutEquipment>;
};

export type LayoutEquipment = {
  __typename?: 'LayoutEquipment';
  accessGroups: Array<AccessGroup>;
  externalAssetId: Scalars['Long']['output'];
  gpsPoint?: Maybe<GpsPoint>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  operationalArea?: Maybe<OperationalArea>;
  operationalAreaId?: Maybe<Scalars['Long']['output']>;
  registrationNumber: Scalars['String']['output'];
  updateAsset: Scalars['Boolean']['output'];
};


export type LayoutEquipmentUpdateAssetArgs = {
  name: Scalars['String']['input'];
  registrationNumber: Scalars['String']['input'];
};

export type LayoutMessage = {
  __typename?: 'LayoutMessage';
  actionMethod: Action_Method;
  actionProto: Action_Proto;
  actionType: Action_Type;
  errorMessage: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  inputData: Scalars['String']['output'];
  result?: Maybe<Scalars['Boolean']['output']>;
  resultData: Scalars['String']['output'];
};

export type LayoutMessageFilterInput = {
  actionMethod?: InputMaybe<Action_MethodOperationFilterInput>;
  actionProto?: InputMaybe<Action_ProtoOperationFilterInput>;
  actionType?: InputMaybe<Action_TypeOperationFilterInput>;
  and?: InputMaybe<Array<LayoutMessageFilterInput>>;
  errorMessage?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputData?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LayoutMessageFilterInput>>;
  result?: InputMaybe<BooleanOperationFilterInput>;
  resultData?: InputMaybe<StringOperationFilterInput>;
};

export type LayoutMessageSortInput = {
  actionMethod?: InputMaybe<SortEnumType>;
  actionProto?: InputMaybe<SortEnumType>;
  actionType?: InputMaybe<SortEnumType>;
  errorMessage?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputData?: InputMaybe<SortEnumType>;
  result?: InputMaybe<SortEnumType>;
  resultData?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type LayoutMessagesConnection = {
  __typename?: 'LayoutMessagesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<LayoutMessagesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<LayoutMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LayoutMessagesEdge = {
  __typename?: 'LayoutMessagesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LayoutMessage;
};

export type Line = {
  __typename?: 'Line';
  assetId?: Maybe<Scalars['Long']['output']>;
  childLines?: Maybe<Array<Line>>;
  equipmentId?: Maybe<Scalars['Long']['output']>;
  feederId?: Maybe<Scalars['Long']['output']>;
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  inputType: Input_Type;
  lineType: Line_Type;
  oldId?: Maybe<Scalars['Long']['output']>;
  parentLine?: Maybe<Line>;
  parentLineId?: Maybe<Scalars['Long']['output']>;
  referenceAngle?: Maybe<Scalars['Float']['output']>;
};

export type LineFilterInput = {
  and?: InputMaybe<Array<LineFilterInput>>;
  assetId?: InputMaybe<LongOperationFilterInput>;
  childLines?: InputMaybe<ListFilterInputTypeOfLineFilterInput>;
  equipmentId?: InputMaybe<LongOperationFilterInput>;
  feederId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  inputType?: InputMaybe<Input_TypeOperationFilterInput>;
  lineType?: InputMaybe<Line_TypeOperationFilterInput>;
  oldId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<LineFilterInput>>;
  parentLine?: InputMaybe<LineFilterInput>;
  parentLineId?: InputMaybe<LongOperationFilterInput>;
  referenceAngle?: InputMaybe<FloatOperationFilterInput>;
};

export type LineSortInput = {
  assetId?: InputMaybe<SortEnumType>;
  equipmentId?: InputMaybe<SortEnumType>;
  feederId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  inputType?: InputMaybe<SortEnumType>;
  lineType?: InputMaybe<SortEnumType>;
  oldId?: InputMaybe<SortEnumType>;
  parentLine?: InputMaybe<LineSortInput>;
  parentLineId?: InputMaybe<SortEnumType>;
  referenceAngle?: InputMaybe<SortEnumType>;
};

export type ListByteOperationFilterInput = {
  all?: InputMaybe<ByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ByteOperationFilterInput>;
  some?: InputMaybe<ByteOperationFilterInput>;
};

export type ListFilterInputTypeOfAccessGroupFilterInput = {
  all?: InputMaybe<AccessGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AccessGroupFilterInput>;
  some?: InputMaybe<AccessGroupFilterInput>;
};

export type ListFilterInputTypeOfActionFilterInput = {
  all?: InputMaybe<ActionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ActionFilterInput>;
  some?: InputMaybe<ActionFilterInput>;
};

export type ListFilterInputTypeOfAlarmStandardDefinitionFilterInput = {
  all?: InputMaybe<AlarmStandardDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmStandardDefinitionFilterInput>;
  some?: InputMaybe<AlarmStandardDefinitionFilterInput>;
};

export type ListFilterInputTypeOfAlarmStandardVariableAggregationByAlarmFilterInput = {
  all?: InputMaybe<AlarmStandardVariableAggregationByAlarmFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmStandardVariableAggregationByAlarmFilterInput>;
  some?: InputMaybe<AlarmStandardVariableAggregationByAlarmFilterInput>;
};

export type ListFilterInputTypeOfAlarmStandardVariableAggregationFilterInput = {
  all?: InputMaybe<AlarmStandardVariableAggregationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmStandardVariableAggregationFilterInput>;
  some?: InputMaybe<AlarmStandardVariableAggregationFilterInput>;
};

export type ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput = {
  all?: InputMaybe<AlarmStandardVariableDefinitionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmStandardVariableDefinitionFilterInput>;
  some?: InputMaybe<AlarmStandardVariableDefinitionFilterInput>;
};

export type ListFilterInputTypeOfAlarmVariableAggregationFilterInput = {
  all?: InputMaybe<AlarmVariableAggregationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmVariableAggregationFilterInput>;
  some?: InputMaybe<AlarmVariableAggregationFilterInput>;
};

export type ListFilterInputTypeOfAlarmVariableFilterInput = {
  all?: InputMaybe<AlarmVariableFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AlarmVariableFilterInput>;
  some?: InputMaybe<AlarmVariableFilterInput>;
};

export type ListFilterInputTypeOfAssetFilterInput = {
  all?: InputMaybe<AssetFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AssetFilterInput>;
  some?: InputMaybe<AssetFilterInput>;
};

export type ListFilterInputTypeOfAuthorizationFilterInput = {
  all?: InputMaybe<AuthorizationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AuthorizationFilterInput>;
  some?: InputMaybe<AuthorizationFilterInput>;
};

export type ListFilterInputTypeOfAuthorizationTokenFilterInput = {
  all?: InputMaybe<AuthorizationTokenFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AuthorizationTokenFilterInput>;
  some?: InputMaybe<AuthorizationTokenFilterInput>;
};

export type ListFilterInputTypeOfBatchIncludeFilterInput = {
  all?: InputMaybe<BatchIncludeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<BatchIncludeFilterInput>;
  some?: InputMaybe<BatchIncludeFilterInput>;
};

export type ListFilterInputTypeOfCompanyFilterInput = {
  all?: InputMaybe<CompanyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CompanyFilterInput>;
  some?: InputMaybe<CompanyFilterInput>;
};

export type ListFilterInputTypeOfConTestDeviceResultFilterInput = {
  all?: InputMaybe<ConTestDeviceResultFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConTestDeviceResultFilterInput>;
  some?: InputMaybe<ConTestDeviceResultFilterInput>;
};

export type ListFilterInputTypeOfConTestFilterInput = {
  all?: InputMaybe<ConTestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ConTestFilterInput>;
  some?: InputMaybe<ConTestFilterInput>;
};

export type ListFilterInputTypeOfContactFilterInput = {
  all?: InputMaybe<ContactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ContactFilterInput>;
  some?: InputMaybe<ContactFilterInput>;
};

export type ListFilterInputTypeOfCredentialsFilterInput = {
  all?: InputMaybe<CredentialsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CredentialsFilterInput>;
  some?: InputMaybe<CredentialsFilterInput>;
};

export type ListFilterInputTypeOfCustomPropertiesFilterInput = {
  all?: InputMaybe<CustomPropertiesFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CustomPropertiesFilterInput>;
  some?: InputMaybe<CustomPropertiesFilterInput>;
};

export type ListFilterInputTypeOfDeviceBulkConfigurationFilterInput = {
  all?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceBulkConfigurationFilterInput>;
  some?: InputMaybe<DeviceBulkConfigurationFilterInput>;
};

export type ListFilterInputTypeOfDeviceFilterInput = {
  all?: InputMaybe<DeviceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceFilterInput>;
  some?: InputMaybe<DeviceFilterInput>;
};

export type ListFilterInputTypeOfDeviceInputNumberFilterInput = {
  all?: InputMaybe<DeviceInputNumberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceInputNumberFilterInput>;
  some?: InputMaybe<DeviceInputNumberFilterInput>;
};

export type ListFilterInputTypeOfDeviceTagFilterInput = {
  all?: InputMaybe<DeviceTagFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceTagFilterInput>;
  some?: InputMaybe<DeviceTagFilterInput>;
};

export type ListFilterInputTypeOfDeviceTypeConfigurationFilterInput = {
  all?: InputMaybe<DeviceTypeConfigurationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<DeviceTypeConfigurationFilterInput>;
  some?: InputMaybe<DeviceTypeConfigurationFilterInput>;
};

export type ListFilterInputTypeOfEmailAttachmentFilterInput = {
  all?: InputMaybe<EmailAttachmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmailAttachmentFilterInput>;
  some?: InputMaybe<EmailAttachmentFilterInput>;
};

export type ListFilterInputTypeOfEmailStatusFilterInput = {
  all?: InputMaybe<EmailStatusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EmailStatusFilterInput>;
  some?: InputMaybe<EmailStatusFilterInput>;
};

export type ListFilterInputTypeOfEnterpriseFilterInput = {
  all?: InputMaybe<EnterpriseFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EnterpriseFilterInput>;
  some?: InputMaybe<EnterpriseFilterInput>;
};

export type ListFilterInputTypeOfEquipmentFilterInput = {
  all?: InputMaybe<EquipmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EquipmentFilterInput>;
  some?: InputMaybe<EquipmentFilterInput>;
};

export type ListFilterInputTypeOfEventDataFilterInput = {
  all?: InputMaybe<EventDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<EventDataFilterInput>;
  some?: InputMaybe<EventDataFilterInput>;
};

export type ListFilterInputTypeOfFederatedIdentityFilterInput = {
  all?: InputMaybe<FederatedIdentityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FederatedIdentityFilterInput>;
  some?: InputMaybe<FederatedIdentityFilterInput>;
};

export type ListFilterInputTypeOfFeederFilterInput = {
  all?: InputMaybe<FeederFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FeederFilterInput>;
  some?: InputMaybe<FeederFilterInput>;
};

export type ListFilterInputTypeOfFilterFilterInput = {
  all?: InputMaybe<FilterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FilterFilterInput>;
  some?: InputMaybe<FilterFilterInput>;
};

export type ListFilterInputTypeOfFirmwareTaskFilterInput = {
  all?: InputMaybe<FirmwareTaskFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FirmwareTaskFilterInput>;
  some?: InputMaybe<FirmwareTaskFilterInput>;
};

export type ListFilterInputTypeOfFirmwareTaskLogFilterInput = {
  all?: InputMaybe<FirmwareTaskLogFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<FirmwareTaskLogFilterInput>;
  some?: InputMaybe<FirmwareTaskLogFilterInput>;
};

export type ListFilterInputTypeOfGpsPointFilterInput = {
  all?: InputMaybe<GpsPointFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<GpsPointFilterInput>;
  some?: InputMaybe<GpsPointFilterInput>;
};

export type ListFilterInputTypeOfInputFilterInput = {
  all?: InputMaybe<InputFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InputFilterInput>;
  some?: InputMaybe<InputFilterInput>;
};

export type ListFilterInputTypeOfInterfaceFilterInput = {
  all?: InputMaybe<InterfaceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<InterfaceFilterInput>;
  some?: InputMaybe<InterfaceFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndIEnumerableOfStringFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndIEnumerableOfStringFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndObjectFilterInput>;
};

export type ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput = {
  all?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
  some?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
};

export type ListFilterInputTypeOfLastContactByTypeFilterInput = {
  all?: InputMaybe<LastContactByTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LastContactByTypeFilterInput>;
  some?: InputMaybe<LastContactByTypeFilterInput>;
};

export type ListFilterInputTypeOfLineFilterInput = {
  all?: InputMaybe<LineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LineFilterInput>;
  some?: InputMaybe<LineFilterInput>;
};

export type ListFilterInputTypeOfMenuFilterInput = {
  all?: InputMaybe<MenuFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MenuFilterInput>;
  some?: InputMaybe<MenuFilterInput>;
};

export type ListFilterInputTypeOfMenuRolesFilterInput = {
  all?: InputMaybe<MenuRolesFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<MenuRolesFilterInput>;
  some?: InputMaybe<MenuRolesFilterInput>;
};

export type ListFilterInputTypeOfOperationalAreaFilterInput = {
  all?: InputMaybe<OperationalAreaFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<OperationalAreaFilterInput>;
  some?: InputMaybe<OperationalAreaFilterInput>;
};

export type ListFilterInputTypeOfPortFilterInput = {
  all?: InputMaybe<PortFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<PortFilterInput>;
  some?: InputMaybe<PortFilterInput>;
};

export type ListFilterInputTypeOfProtocolFilterInput = {
  all?: InputMaybe<ProtocolFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ProtocolFilterInput>;
  some?: InputMaybe<ProtocolFilterInput>;
};

export type ListFilterInputTypeOfRegionFilterInput = {
  all?: InputMaybe<RegionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RegionFilterInput>;
  some?: InputMaybe<RegionFilterInput>;
};

export type ListFilterInputTypeOfRoleFilterInput = {
  all?: InputMaybe<RoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RoleFilterInput>;
  some?: InputMaybe<RoleFilterInput>;
};

export type ListFilterInputTypeOfRoleGraphQlFilterInput = {
  all?: InputMaybe<RoleGraphQlFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<RoleGraphQlFilterInput>;
  some?: InputMaybe<RoleGraphQlFilterInput>;
};

export type ListFilterInputTypeOfScheduleOperationModeFilterInput = {
  all?: InputMaybe<ScheduleOperationModeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ScheduleOperationModeFilterInput>;
  some?: InputMaybe<ScheduleOperationModeFilterInput>;
};

export type ListFilterInputTypeOfSimCardFilterInput = {
  all?: InputMaybe<SimCardFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SimCardFilterInput>;
  some?: InputMaybe<SimCardFilterInput>;
};

export type ListFilterInputTypeOfSubscriptionFilterInput = {
  all?: InputMaybe<SubscriptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<SubscriptionFilterInput>;
  some?: InputMaybe<SubscriptionFilterInput>;
};

export type ListFilterInputTypeOfTemplateFilterInput = {
  all?: InputMaybe<TemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<TemplateFilterInput>;
  some?: InputMaybe<TemplateFilterInput>;
};

export type ListFilterInputTypeOfUserConsentFilterInput = {
  all?: InputMaybe<UserConsentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserConsentFilterInput>;
  some?: InputMaybe<UserConsentFilterInput>;
};

export type ListFilterInputTypeOfUserFilterInput = {
  all?: InputMaybe<UserFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<UserFilterInput>;
  some?: InputMaybe<UserFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  neq?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export enum Material_Type {
  Composite = 'COMPOSITE',
  Glass = 'GLASS'
}

export enum Micro_Controller_Type {
  Com = 'COM',
  Esp = 'ESP',
  Ingrid = 'INGRID',
  Mea = 'MEA',
  Msp = 'MSP',
  Pic = 'PIC'
}

export type Micro_Controller_TypeOperationFilterInput = {
  eq?: InputMaybe<Micro_Controller_Type>;
  in?: InputMaybe<Array<Micro_Controller_Type>>;
  neq?: InputMaybe<Micro_Controller_Type>;
  nin?: InputMaybe<Array<Micro_Controller_Type>>;
};

export type Menu = {
  __typename?: 'Menu';
  breadcrumbs: Scalars['Boolean']['output'];
  children?: Maybe<Array<Menu>>;
  element?: Maybe<Scalars['String']['output']>;
  enable: Scalars['Boolean']['output'];
  externalUrl?: Maybe<Scalars['Boolean']['output']>;
  i18nKey: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Menu>;
  parentId?: Maybe<Scalars['Long']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  section?: Maybe<Section>;
  sectionId?: Maybe<Scalars['Long']['output']>;
  type: MenuType;
  url?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type MenuConnection = {
  __typename?: 'MenuConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MenuEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Menu>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuEdge = {
  __typename?: 'MenuEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Menu;
};

export type MenuFilterInput = {
  and?: InputMaybe<Array<MenuFilterInput>>;
  breadcrumbs?: InputMaybe<BooleanOperationFilterInput>;
  children?: InputMaybe<ListFilterInputTypeOfMenuFilterInput>;
  element?: InputMaybe<StringOperationFilterInput>;
  enable?: InputMaybe<BooleanOperationFilterInput>;
  externalUrl?: InputMaybe<BooleanOperationFilterInput>;
  i18nKey?: InputMaybe<StringOperationFilterInput>;
  icon?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<MenuFilterInput>>;
  parent?: InputMaybe<MenuFilterInput>;
  parentId?: InputMaybe<LongOperationFilterInput>;
  path?: InputMaybe<StringOperationFilterInput>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleFilterInput>;
  section?: InputMaybe<SectionFilterInput>;
  sectionId?: InputMaybe<LongOperationFilterInput>;
  type?: InputMaybe<MenuTypeOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
};

export type MenuRoles = {
  __typename?: 'MenuRoles';
  actions?: Maybe<Array<Action>>;
  id: Scalars['Long']['output'];
  menu?: Maybe<Menu>;
  menuId: Scalars['Long']['output'];
  role?: Maybe<Role>;
  roleId: Scalars['Long']['output'];
};

export type MenuRolesActions = {
  __typename?: 'MenuRolesActions';
  action?: Maybe<Action>;
  actionId: Scalars['Long']['output'];
  menuId: Scalars['Long']['output'];
  menuRoles?: Maybe<MenuRoles>;
  roleId: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type MenuRolesActionsConnection = {
  __typename?: 'MenuRolesActionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MenuRolesActionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MenuRolesActions>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuRolesActionsEdge = {
  __typename?: 'MenuRolesActionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MenuRolesActions;
};

export type MenuRolesActionsFilterInput = {
  action?: InputMaybe<ActionFilterInput>;
  actionId?: InputMaybe<LongOperationFilterInput>;
  and?: InputMaybe<Array<MenuRolesActionsFilterInput>>;
  menuId?: InputMaybe<LongOperationFilterInput>;
  menuRoles?: InputMaybe<MenuRolesFilterInput>;
  or?: InputMaybe<Array<MenuRolesActionsFilterInput>>;
  roleId?: InputMaybe<LongOperationFilterInput>;
};

export type MenuRolesActionsSortInput = {
  action?: InputMaybe<ActionSortInput>;
  actionId?: InputMaybe<SortEnumType>;
  menuId?: InputMaybe<SortEnumType>;
  menuRoles?: InputMaybe<MenuRolesSortInput>;
  roleId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type MenuRolesConnection = {
  __typename?: 'MenuRolesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<MenuRolesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<MenuRoles>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MenuRolesEdge = {
  __typename?: 'MenuRolesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MenuRoles;
};

export type MenuRolesFilterInput = {
  actions?: InputMaybe<ListFilterInputTypeOfActionFilterInput>;
  and?: InputMaybe<Array<MenuRolesFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  menu?: InputMaybe<MenuFilterInput>;
  menuId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<MenuRolesFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<LongOperationFilterInput>;
};

export type MenuRolesSortInput = {
  id?: InputMaybe<SortEnumType>;
  menu?: InputMaybe<MenuSortInput>;
  menuId?: InputMaybe<SortEnumType>;
  role?: InputMaybe<RoleSortInput>;
  roleId?: InputMaybe<SortEnumType>;
};

export type MenuSortInput = {
  breadcrumbs?: InputMaybe<SortEnumType>;
  element?: InputMaybe<SortEnumType>;
  enable?: InputMaybe<SortEnumType>;
  externalUrl?: InputMaybe<SortEnumType>;
  i18nKey?: InputMaybe<SortEnumType>;
  icon?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<MenuSortInput>;
  parentId?: InputMaybe<SortEnumType>;
  path?: InputMaybe<SortEnumType>;
  section?: InputMaybe<SectionSortInput>;
  sectionId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
  url?: InputMaybe<SortEnumType>;
};

export enum MenuType {
  Collapse = 'COLLAPSE',
  Item = 'ITEM'
}

export type MenuTypeOperationFilterInput = {
  eq?: InputMaybe<MenuType>;
  in?: InputMaybe<Array<MenuType>>;
  neq?: InputMaybe<MenuType>;
  nin?: InputMaybe<Array<MenuType>>;
};

export type ModemSettings = {
  __typename?: 'ModemSettings';
  bandWidth: Scalars['Float']['output'];
  codingRate: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  interfaceLoRa: InterfaceLoRa;
  interfaceLoRaId: Scalars['Long']['output'];
  lowDataRate: Scalars['Int']['output'];
  spreadingFactor: Scalars['Int']['output'];
};

export type ModemSettingsFilterInput = {
  and?: InputMaybe<Array<ModemSettingsFilterInput>>;
  bandWidth?: InputMaybe<FloatOperationFilterInput>;
  codingRate?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaFilterInput>;
  interfaceLoRaId?: InputMaybe<LongOperationFilterInput>;
  lowDataRate?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ModemSettingsFilterInput>>;
  spreadingFactor?: InputMaybe<IntOperationFilterInput>;
};

export type ModemSettingsSortInput = {
  bandWidth?: InputMaybe<SortEnumType>;
  codingRate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaSortInput>;
  interfaceLoRaId?: InputMaybe<SortEnumType>;
  lowDataRate?: InputMaybe<SortEnumType>;
  spreadingFactor?: InputMaybe<SortEnumType>;
};

export enum Notification_Type {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

export type Notification_TypeOperationFilterInput = {
  eq?: InputMaybe<Notification_Type>;
  in?: InputMaybe<Array<Notification_Type>>;
  neq?: InputMaybe<Notification_Type>;
  nin?: InputMaybe<Array<Notification_Type>>;
};

export type NetworkPowerQuality = {
  __typename?: 'NetworkPowerQuality';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  inputReferenceFrequency: Scalars['Int']['output'];
  inputReferenceVoltage: Scalars['Int']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  negativeVoltageRVCHisterese: Scalars['Int']['output'];
  negativeVoltageRVCThreshold: Scalars['Int']['output'];
  positiveVoltageRVCHisterese: Scalars['Int']['output'];
  positiveVoltageRVCThreshold: Scalars['Int']['output'];
  scheduleOperationModes: Array<ScheduleOperationMode>;
  voltageDipHisterese: Scalars['Int']['output'];
  voltageDipThreshold: Scalars['Int']['output'];
  voltageInterruptHisterese: Scalars['Int']['output'];
  voltageInterruptThreshold: Scalars['Int']['output'];
  voltageSwellHisterese: Scalars['Int']['output'];
  voltageSwellThreshold: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type NetworkPowerQualityConnection = {
  __typename?: 'NetworkPowerQualityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<NetworkPowerQualityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<NetworkPowerQuality>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NetworkPowerQualityEdge = {
  __typename?: 'NetworkPowerQualityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NetworkPowerQuality;
};

export type NetworkPowerQualityFilterInput = {
  and?: InputMaybe<Array<NetworkPowerQualityFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputReferenceFrequency?: InputMaybe<IntOperationFilterInput>;
  inputReferenceVoltage?: InputMaybe<IntOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  negativeVoltageRVCHisterese?: InputMaybe<IntOperationFilterInput>;
  negativeVoltageRVCThreshold?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<NetworkPowerQualityFilterInput>>;
  positiveVoltageRVCHisterese?: InputMaybe<IntOperationFilterInput>;
  positiveVoltageRVCThreshold?: InputMaybe<IntOperationFilterInput>;
  scheduleOperationModes?: InputMaybe<ListFilterInputTypeOfScheduleOperationModeFilterInput>;
  voltageDipHisterese?: InputMaybe<IntOperationFilterInput>;
  voltageDipThreshold?: InputMaybe<IntOperationFilterInput>;
  voltageInterruptHisterese?: InputMaybe<IntOperationFilterInput>;
  voltageInterruptThreshold?: InputMaybe<IntOperationFilterInput>;
  voltageSwellHisterese?: InputMaybe<IntOperationFilterInput>;
  voltageSwellThreshold?: InputMaybe<IntOperationFilterInput>;
};

export type NetworkPowerQualitySortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  inputReferenceFrequency?: InputMaybe<SortEnumType>;
  inputReferenceVoltage?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  negativeVoltageRVCHisterese?: InputMaybe<SortEnumType>;
  negativeVoltageRVCThreshold?: InputMaybe<SortEnumType>;
  positiveVoltageRVCHisterese?: InputMaybe<SortEnumType>;
  positiveVoltageRVCThreshold?: InputMaybe<SortEnumType>;
  voltageDipHisterese?: InputMaybe<SortEnumType>;
  voltageDipThreshold?: InputMaybe<SortEnumType>;
  voltageInterruptHisterese?: InputMaybe<SortEnumType>;
  voltageInterruptThreshold?: InputMaybe<SortEnumType>;
  voltageSwellHisterese?: InputMaybe<SortEnumType>;
  voltageSwellThreshold?: InputMaybe<SortEnumType>;
};

export type NullableOfAnchor_TypeOperationFilterInput = {
  eq?: InputMaybe<Anchor_Type>;
  in?: InputMaybe<Array<InputMaybe<Anchor_Type>>>;
  neq?: InputMaybe<Anchor_Type>;
  nin?: InputMaybe<Array<InputMaybe<Anchor_Type>>>;
};

export type NullableOfConnection_TypeOperationFilterInput = {
  eq?: InputMaybe<Connection_Type>;
  in?: InputMaybe<Array<InputMaybe<Connection_Type>>>;
  neq?: InputMaybe<Connection_Type>;
  nin?: InputMaybe<Array<InputMaybe<Connection_Type>>>;
};

export type NullableOfEncryption_TypeOperationFilterInput = {
  eq?: InputMaybe<Encryption_Type>;
  in?: InputMaybe<Array<InputMaybe<Encryption_Type>>>;
  neq?: InputMaybe<Encryption_Type>;
  nin?: InputMaybe<Array<InputMaybe<Encryption_Type>>>;
};

export type NullableOfEventDataStatusOperationFilterInput = {
  eq?: InputMaybe<EventDataStatus>;
  in?: InputMaybe<Array<InputMaybe<EventDataStatus>>>;
  neq?: InputMaybe<EventDataStatus>;
  nin?: InputMaybe<Array<InputMaybe<EventDataStatus>>>;
};

export type NullableOfInput_TypeOperationFilterInput = {
  eq?: InputMaybe<Input_Type>;
  in?: InputMaybe<Array<InputMaybe<Input_Type>>>;
  neq?: InputMaybe<Input_Type>;
  nin?: InputMaybe<Array<InputMaybe<Input_Type>>>;
};

export type NullableOfInstallation_TypeOperationFilterInput = {
  eq?: InputMaybe<Installation_Type>;
  in?: InputMaybe<Array<InputMaybe<Installation_Type>>>;
  neq?: InputMaybe<Installation_Type>;
  nin?: InputMaybe<Array<InputMaybe<Installation_Type>>>;
};

export type NullableOfMaterial_TypeOperationFilterInput = {
  eq?: InputMaybe<Material_Type>;
  in?: InputMaybe<Array<InputMaybe<Material_Type>>>;
  neq?: InputMaybe<Material_Type>;
  nin?: InputMaybe<Array<InputMaybe<Material_Type>>>;
};

export type NullableOfOf_MonthOperationFilterInput = {
  eq?: InputMaybe<Of_Month>;
  in?: InputMaybe<Array<InputMaybe<Of_Month>>>;
  neq?: InputMaybe<Of_Month>;
  nin?: InputMaybe<Array<InputMaybe<Of_Month>>>;
};

export type NullableOfOn_TheOperationFilterInput = {
  eq?: InputMaybe<On_The>;
  in?: InputMaybe<Array<InputMaybe<On_The>>>;
  neq?: InputMaybe<On_The>;
  nin?: InputMaybe<Array<InputMaybe<On_The>>>;
};

export type NullableOfOn_The_ItemOperationFilterInput = {
  eq?: InputMaybe<On_The_Item>;
  in?: InputMaybe<Array<InputMaybe<On_The_Item>>>;
  neq?: InputMaybe<On_The_Item>;
  nin?: InputMaybe<Array<InputMaybe<On_The_Item>>>;
};

export type NullableOfServer_TypeOperationFilterInput = {
  eq?: InputMaybe<Server_Type>;
  in?: InputMaybe<Array<InputMaybe<Server_Type>>>;
  neq?: InputMaybe<Server_Type>;
  nin?: InputMaybe<Array<InputMaybe<Server_Type>>>;
};

export type NullableOfSubstation_TypeOperationFilterInput = {
  eq?: InputMaybe<Substation_Type>;
  in?: InputMaybe<Array<InputMaybe<Substation_Type>>>;
  neq?: InputMaybe<Substation_Type>;
  nin?: InputMaybe<Array<InputMaybe<Substation_Type>>>;
};

export enum Of_Month {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  None = 'NONE',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

export enum On_The {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  None = 'NONE',
  Second = 'SECOND',
  Third = 'THIRD'
}

export enum On_The_Item {
  Day = 'DAY',
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  None = 'NONE',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Week = 'WEEK',
  Weekend = 'WEEKEND'
}

export type OperationalArea = {
  __typename?: 'OperationalArea';
  accessGroups: Array<AccessGroup>;
  accessGroupsWorkingOP: Array<AccessGroup>;
  assets: Array<LayoutEquipment>;
  code: Scalars['String']['output'];
  gpsPoints: Array<GpsPoint>;
  id: Scalars['Long']['output'];
  idv2?: Maybe<Scalars['Long']['output']>;
  name: Scalars['String']['output'];
  region: Region;
  regionId: Scalars['Long']['output'];
};

export type OperationalAreaFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  accessGroupsWorkingOP?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<OperationalAreaFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  gpsPoints?: InputMaybe<ListFilterInputTypeOfGpsPointFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  idv2?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OperationalAreaFilterInput>>;
  region?: InputMaybe<RegionFilterInput>;
  regionId?: InputMaybe<LongOperationFilterInput>;
};

export type OperationalAreaSortInput = {
  code?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  idv2?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  region?: InputMaybe<RegionSortInput>;
  regionId?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type OperationalAreasConnection = {
  __typename?: 'OperationalAreasConnection';
  /** A list of edges. */
  edges?: Maybe<Array<OperationalAreasEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<OperationalArea>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OperationalAreasEdge = {
  __typename?: 'OperationalAreasEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OperationalArea>;
};

export enum Phase_Rotation {
  Anticlockwise = 'ANTICLOCKWISE',
  Clockwise = 'CLOCKWISE',
  Undefined = 'UNDEFINED'
}

export type Phase_RotationOperationFilterInput = {
  eq?: InputMaybe<Phase_Rotation>;
  in?: InputMaybe<Array<Phase_Rotation>>;
  neq?: InputMaybe<Phase_Rotation>;
  nin?: InputMaybe<Array<Phase_Rotation>>;
};

export enum Phase_Type {
  Biphasic = 'BIPHASIC',
  Monophasic = 'MONOPHASIC',
  Triphasic = 'TRIPHASIC'
}

export type Phase_TypeOperationFilterInput = {
  eq?: InputMaybe<Phase_Type>;
  in?: InputMaybe<Array<Phase_Type>>;
  neq?: InputMaybe<Phase_Type>;
  nin?: InputMaybe<Array<Phase_Type>>;
};

export enum Port_Type {
  EnergyMeter = 'ENERGY_METER',
  EnergyMeterNeutral = 'ENERGY_METER_NEUTRAL',
  Generic = 'GENERIC',
  ImpedanceMeter = 'IMPEDANCE_METER'
}

export type Port_TypeOperationFilterInput = {
  eq?: InputMaybe<Port_Type>;
  in?: InputMaybe<Array<Port_Type>>;
  neq?: InputMaybe<Port_Type>;
  nin?: InputMaybe<Array<Port_Type>>;
};

export enum Protocol_Type {
  Bluetooth = 'BLUETOOTH',
  Dnp3 = 'DNP3',
  EneidaLoRa = 'ENEIDA_LO_RA',
  Http = 'HTTP',
  Mqtt = 'MQTT'
}

export type Protocol_TypeOperationFilterInput = {
  eq?: InputMaybe<Protocol_Type>;
  in?: InputMaybe<Array<Protocol_Type>>;
  neq?: InputMaybe<Protocol_Type>;
  nin?: InputMaybe<Array<Protocol_Type>>;
};

export type PacketConfiguration = {
  __typename?: 'PacketConfiguration';
  crcEnabled: Scalars['Int']['output'];
  headerMode: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  interfaceLoRa: InterfaceLoRa;
  interfaceLoRaId: Scalars['Long']['output'];
  payloadLength: Scalars['Int']['output'];
  programmedPreamble: Scalars['Int']['output'];
  totalPreambleLength: Scalars['Int']['output'];
};

export type PacketConfigurationFilterInput = {
  and?: InputMaybe<Array<PacketConfigurationFilterInput>>;
  crcEnabled?: InputMaybe<IntOperationFilterInput>;
  headerMode?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaFilterInput>;
  interfaceLoRaId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<PacketConfigurationFilterInput>>;
  payloadLength?: InputMaybe<IntOperationFilterInput>;
  programmedPreamble?: InputMaybe<IntOperationFilterInput>;
  totalPreambleLength?: InputMaybe<IntOperationFilterInput>;
};

export type PacketConfigurationSortInput = {
  crcEnabled?: InputMaybe<SortEnumType>;
  headerMode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaSortInput>;
  interfaceLoRaId?: InputMaybe<SortEnumType>;
  payloadLength?: InputMaybe<SortEnumType>;
  programmedPreamble?: InputMaybe<SortEnumType>;
  totalPreambleLength?: InputMaybe<SortEnumType>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PlatformSettings = {
  __typename?: 'PlatformSettings';
  applicationName: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  mandatory: Scalars['Boolean']['output'];
  regex: Scalars['String']['output'];
  sectionName: Scalars['String']['output'];
  settingName: Scalars['String']['output'];
  settingType: Scalars['String']['output'];
  settingValue: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PlatformSettingsConnection = {
  __typename?: 'PlatformSettingsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PlatformSettingsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<PlatformSettings>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PlatformSettingsEdge = {
  __typename?: 'PlatformSettingsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlatformSettings;
};

export type PlatformSettingsFilterInput = {
  and?: InputMaybe<Array<PlatformSettingsFilterInput>>;
  applicationName?: InputMaybe<StringOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  mandatory?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<PlatformSettingsFilterInput>>;
  regex?: InputMaybe<StringOperationFilterInput>;
  sectionName?: InputMaybe<StringOperationFilterInput>;
  settingName?: InputMaybe<StringOperationFilterInput>;
  settingType?: InputMaybe<StringOperationFilterInput>;
  settingValue?: InputMaybe<StringOperationFilterInput>;
};

export type PlatformSettingsSortInput = {
  applicationName?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  mandatory?: InputMaybe<SortEnumType>;
  regex?: InputMaybe<SortEnumType>;
  sectionName?: InputMaybe<SortEnumType>;
  settingName?: InputMaybe<SortEnumType>;
  settingType?: InputMaybe<SortEnumType>;
  settingValue?: InputMaybe<SortEnumType>;
};

export type Port = {
  __typename?: 'Port';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device: Device;
  deviceId: Scalars['Long']['output'];
  id: Scalars['Long']['output'];
  inputs: Array<Input>;
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  portNumber: Scalars['Int']['output'];
  portType: Port_Type;
};

export type PortFilterInput = {
  and?: InputMaybe<Array<PortFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  deviceId?: InputMaybe<LongOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  inputs?: InputMaybe<ListFilterInputTypeOfInputFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PortFilterInput>>;
  portNumber?: InputMaybe<IntOperationFilterInput>;
  portType?: InputMaybe<Port_TypeOperationFilterInput>;
};

export type PortSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  deviceId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  portNumber?: InputMaybe<SortEnumType>;
  portType?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type PortsConnection = {
  __typename?: 'PortsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PortsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Port>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PortsEdge = {
  __typename?: 'PortsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Port;
};

/** A connection to a list of items. */
export type PowerBusLinesConnection = {
  __typename?: 'PowerBusLinesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<PowerBusLinesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Line>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PowerBusLinesEdge = {
  __typename?: 'PowerBusLinesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Line;
};

export type Protocol = {
  __typename?: 'Protocol';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocolType: Protocol_Type;
  version: Scalars['String']['output'];
};

export type ProtocolBluetooth = {
  __typename?: 'ProtocolBluetooth';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  pin: Scalars['String']['output'];
  protocolType: Protocol_Type;
  version: Scalars['String']['output'];
};

export type ProtocolBluetoothFilterInput = {
  and?: InputMaybe<Array<ProtocolBluetoothFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolBluetoothFilterInput>>;
  pin?: InputMaybe<StringOperationFilterInput>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolBluetoothSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pin?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ProtocolDnp3 = {
  __typename?: 'ProtocolDNP3';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocolType: Protocol_Type;
  version: Scalars['String']['output'];
};

export type ProtocolDnp3FilterInput = {
  and?: InputMaybe<Array<ProtocolDnp3FilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolDnp3FilterInput>>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolDnp3SortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ProtocolEneidaLoRa = {
  __typename?: 'ProtocolEneidaLoRa';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocolType: Protocol_Type;
  version: Scalars['String']['output'];
};

export type ProtocolEneidaLoRaFilterInput = {
  and?: InputMaybe<Array<ProtocolEneidaLoRaFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolEneidaLoRaFilterInput>>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolEneidaLoRaSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ProtocolFilterInput = {
  and?: InputMaybe<Array<ProtocolFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolFilterInput>>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolHttp = {
  __typename?: 'ProtocolHTTP';
  createAlarm: Scalars['Boolean']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  protocolType: Protocol_Type;
  sendRawData: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type ProtocolHttpFilterInput = {
  and?: InputMaybe<Array<ProtocolHttpFilterInput>>;
  createAlarm?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolHttpFilterInput>>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  sendRawData?: InputMaybe<BooleanOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolHttpSortInput = {
  createAlarm?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  sendRawData?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

export type ProtocolMqtt = {
  __typename?: 'ProtocolMqtt';
  certificateUrl?: Maybe<Scalars['String']['output']>;
  createAlarm: Scalars['Boolean']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  interface: Interface;
  interfaceId: Scalars['Long']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  protocolType: Protocol_Type;
  sendRawData: Scalars['Boolean']['output'];
  username?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type ProtocolMqttFilterInput = {
  and?: InputMaybe<Array<ProtocolMqttFilterInput>>;
  certificateUrl?: InputMaybe<StringOperationFilterInput>;
  createAlarm?: InputMaybe<BooleanOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interface?: InputMaybe<InterfaceFilterInput>;
  interfaceId?: InputMaybe<LongOperationFilterInput>;
  isEnabled?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProtocolMqttFilterInput>>;
  password?: InputMaybe<StringOperationFilterInput>;
  protocolType?: InputMaybe<Protocol_TypeOperationFilterInput>;
  sendRawData?: InputMaybe<BooleanOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
};

export type ProtocolMqttSortInput = {
  certificateUrl?: InputMaybe<SortEnumType>;
  createAlarm?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interface?: InputMaybe<InterfaceSortInput>;
  interfaceId?: InputMaybe<SortEnumType>;
  isEnabled?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  password?: InputMaybe<SortEnumType>;
  protocolType?: InputMaybe<SortEnumType>;
  sendRawData?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
  version?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ProtocolsBluetoothConnection = {
  __typename?: 'ProtocolsBluetoothConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsBluetoothEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolBluetooth>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsBluetoothEdge = {
  __typename?: 'ProtocolsBluetoothEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolBluetooth;
};

/** A connection to a list of items. */
export type ProtocolsDnp3Connection = {
  __typename?: 'ProtocolsDNP3Connection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsDnp3Edge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolDnp3>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsDnp3Edge = {
  __typename?: 'ProtocolsDNP3Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolDnp3;
};

/** A connection to a list of items. */
export type ProtocolsEneidaLoRaConnection = {
  __typename?: 'ProtocolsEneidaLoRaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsEneidaLoRaEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolEneidaLoRa>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsEneidaLoRaEdge = {
  __typename?: 'ProtocolsEneidaLoRaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolEneidaLoRa;
};

/** A connection to a list of items. */
export type ProtocolsHttpConnection = {
  __typename?: 'ProtocolsHTTPConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsHttpEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolHttp>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsHttpEdge = {
  __typename?: 'ProtocolsHTTPEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolHttp;
};

/** A connection to a list of items. */
export type ProtocolsMqttConnection = {
  __typename?: 'ProtocolsMqttConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ProtocolsMqttEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ProtocolMqtt>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProtocolsMqttEdge = {
  __typename?: 'ProtocolsMqttEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProtocolMqtt;
};

export type Query = {
  __typename?: 'Query';
  accessGroups?: Maybe<AccessGroupsConnection>;
  action?: Maybe<ActionConnection>;
  alarmStandardDefinitions?: Maybe<AlarmStandardDefinitionsConnection>;
  alarmStandardVariableDefinitions?: Maybe<AlarmStandardVariableDefinitionsConnection>;
  alarmStandards?: Maybe<AlarmStandardsConnection>;
  alarmTypes?: Maybe<AlarmTypesConnection>;
  alarmVariables?: Maybe<AlarmVariablesConnection>;
  assetBulkConfigurations?: Maybe<AssetBulkConfigurationsConnection>;
  assets?: Maybe<AssetsConnection>;
  authorization?: Maybe<AuthorizationConnection>;
  batchDevices?: Maybe<BatchDevicesConnection>;
  batchIncludes?: Maybe<BatchIncludesConnection>;
  batchSims?: Maybe<BatchSimsConnection>;
  cableTypes?: Maybe<CableTypesConnection>;
  companys?: Maybe<CompanysConnection>;
  conTestDeviceResults?: Maybe<ConTestDeviceResultsConnection>;
  conTests?: Maybe<ConTestsConnection>;
  conTestsExtended?: Maybe<ConTestsExtendedConnection>;
  contacts?: Maybe<ContactsConnection>;
  currentHarmonics?: Maybe<CurrentHarmonicsConnection>;
  customProperties?: Maybe<CustomPropertiesConnection>;
  deviceBulkConfigurations?: Maybe<DeviceBulkConfigurationsConnection>;
  deviceInputNumbers?: Maybe<DeviceInputNumbersConnection>;
  deviceLog?: Maybe<DeviceLogConnection>;
  deviceLogs?: Maybe<DeviceLogsConnection>;
  deviceMessages?: Maybe<DeviceMessagesConnection>;
  deviceTypeConfigurations?: Maybe<DeviceTypeConfigurationsConnection>;
  devices?: Maybe<DevicesConnection>;
  devicesFirmwareDocuments?: Maybe<DevicesFirmwareDocumentsConnection>;
  emailAttachments?: Maybe<EmailAttachmentsConnection>;
  emailStatus?: Maybe<EmailStatusConnection>;
  emails?: Maybe<EmailsConnection>;
  energyBalance?: Maybe<EnergyBalanceConnection>;
  enterprises?: Maybe<EnterprisesConnection>;
  equipments?: Maybe<EquipmentsConnection>;
  equipmentsDevices?: Maybe<EquipmentsDevicesConnection>;
  eventData?: Maybe<EventDataConnection>;
  events?: Maybe<EventsConnection>;
  feeders?: Maybe<FeedersConnection>;
  firmwareTaskLog?: Maybe<FirmwareTaskLogConnection>;
  firmwareTasks?: Maybe<FirmwareTasksConnection>;
  firmwares?: Maybe<FirmwaresConnection>;
  gpsPoints?: Maybe<GpsPointsConnection>;
  inputs?: Maybe<InputsConnection>;
  interfacesBluetooth?: Maybe<InterfacesBluetoothConnection>;
  interfacesEthernet?: Maybe<InterfacesEthernetConnection>;
  interfacesGprs?: Maybe<InterfacesGprsConnection>;
  interfacesLoRa?: Maybe<InterfacesLoRaConnection>;
  keycloakRole?: Maybe<KeycloakRoleConnection>;
  keycloakUser?: Maybe<KeycloakUserConnection>;
  lastContactByTypes?: Maybe<LastContactByTypesConnection>;
  layoutAssets?: Maybe<LayoutAssetsConnection>;
  layoutMessages?: Maybe<LayoutMessagesConnection>;
  menu?: Maybe<MenuConnection>;
  menuRoles?: Maybe<MenuRolesConnection>;
  menuRolesActions?: Maybe<MenuRolesActionsConnection>;
  networkPowerQuality?: Maybe<NetworkPowerQualityConnection>;
  operationalAreas?: Maybe<OperationalAreasConnection>;
  platformSettings?: Maybe<PlatformSettingsConnection>;
  ports?: Maybe<PortsConnection>;
  powerBusLines?: Maybe<PowerBusLinesConnection>;
  protocolsBluetooth?: Maybe<ProtocolsBluetoothConnection>;
  protocolsDNP3?: Maybe<ProtocolsDnp3Connection>;
  protocolsEneidaLoRa?: Maybe<ProtocolsEneidaLoRaConnection>;
  protocolsHTTP?: Maybe<ProtocolsHttpConnection>;
  protocolsMqtt?: Maybe<ProtocolsMqttConnection>;
  regions?: Maybe<RegionsConnection>;
  reports?: Maybe<ReportsConnection>;
  role?: Maybe<RoleConnection>;
  scheduleOperationMode?: Maybe<ScheduleOperationModeConnection>;
  simCards?: Maybe<SimCardsConnection>;
  subscriptions?: Maybe<SubscriptionsConnection>;
  templates?: Maybe<TemplatesConnection>;
  templatesConfig?: Maybe<TemplatesConfigConnection>;
  user?: Maybe<UserConnection>;
  userLogAction?: Maybe<UserLogActionConnection>;
};


export type QueryAccessGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AccessGroupSortInput>>;
  where?: InputMaybe<AccessGroupFilterInput>;
};


export type QueryActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ActionSortInput>>;
  where?: InputMaybe<ActionFilterInput>;
};


export type QueryAlarmStandardDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmStandardDefinitionSortInput>>;
  where?: InputMaybe<AlarmStandardDefinitionFilterInput>;
};


export type QueryAlarmStandardVariableDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmStandardVariableDefinitionSortInput>>;
  where?: InputMaybe<AlarmStandardVariableDefinitionFilterInput>;
};


export type QueryAlarmStandardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmStandardSortInput>>;
  where?: InputMaybe<AlarmStandardFilterInput>;
};


export type QueryAlarmTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmTypeSortInput>>;
  where?: InputMaybe<AlarmTypeFilterInput>;
};


export type QueryAlarmVariablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AlarmVariableSortInput>>;
  where?: InputMaybe<AlarmVariableFilterInput>;
};


export type QueryAssetBulkConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EquipBulkConfigurationSortInput>>;
  where?: InputMaybe<EquipBulkConfigurationFilterInput>;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AssetSortInput>>;
  where?: InputMaybe<AssetFilterInput>;
};


export type QueryAuthorizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AuthorizationSortInput>>;
  where?: InputMaybe<AuthorizationFilterInput>;
};


export type QueryBatchDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BatchDeviceSortInput>>;
  where?: InputMaybe<BatchDeviceFilterInput>;
};


export type QueryBatchIncludesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BatchIncludeSortInput>>;
  where?: InputMaybe<BatchIncludeFilterInput>;
};


export type QueryBatchSimsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<BatchSimSortInput>>;
  where?: InputMaybe<BatchSimFilterInput>;
};


export type QueryCableTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CableTypeSortInput>>;
  where?: InputMaybe<CableTypeFilterInput>;
};


export type QueryCompanysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CompanySortInput>>;
  where?: InputMaybe<CompanyFilterInput>;
};


export type QueryConTestDeviceResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConTestDeviceResultSortInput>>;
  where?: InputMaybe<ConTestDeviceResultFilterInput>;
};


export type QueryConTestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConTestSortInput>>;
  where?: InputMaybe<ConTestFilterInput>;
};


export type QueryConTestsExtendedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ConTestExtendedSortInput>>;
  where?: InputMaybe<ConTestExtendedFilterInput>;
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ContactSortInput>>;
  where?: InputMaybe<ContactFilterInput>;
};


export type QueryCurrentHarmonicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CurrentHarmonicsSortInput>>;
  where?: InputMaybe<CurrentHarmonicsFilterInput>;
};


export type QueryCustomPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<CustomPropertiesSortInput>>;
  where?: InputMaybe<CustomPropertiesFilterInput>;
};


export type QueryDeviceBulkConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceBulkConfigurationSortInput>>;
  where?: InputMaybe<DeviceBulkConfigurationFilterInput>;
};


export type QueryDeviceInputNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceInputNumberSortInput>>;
  where?: InputMaybe<DeviceInputNumberFilterInput>;
};


export type QueryDeviceLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceLogSortInput>>;
  where?: InputMaybe<DeviceLogFilterInput>;
};


export type QueryDeviceLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceLogSortInput>>;
  where?: InputMaybe<DeviceLogFilterInput>;
};


export type QueryDeviceMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceMessageSortInput>>;
  where?: InputMaybe<DeviceMessageFilterInput>;
};


export type QueryDeviceTypeConfigurationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceTypeConfigurationSortInput>>;
  where?: InputMaybe<DeviceTypeConfigurationFilterInput>;
};


export type QueryDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceSortInput>>;
  where?: InputMaybe<DeviceFilterInput>;
};


export type QueryDevicesFirmwareDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareDocumentSortInput>>;
  where?: InputMaybe<FirmwareDocumentFilterInput>;
};


export type QueryEmailAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailAttachmentSortInput>>;
  where?: InputMaybe<EmailAttachmentFilterInput>;
};


export type QueryEmailStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailStatusSortInput>>;
  where?: InputMaybe<EmailStatusFilterInput>;
};


export type QueryEmailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EmailSortInput>>;
  where?: InputMaybe<EmailFilterInput>;
};


export type QueryEnergyBalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EnergyBalanceSortInput>>;
  where?: InputMaybe<EnergyBalanceFilterInput>;
};


export type QueryEnterprisesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EnterpriseSortInput>>;
  where?: InputMaybe<EnterpriseFilterInput>;
};


export type QueryEquipmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EquipmentSortInput>>;
  where?: InputMaybe<EquipmentFilterInput>;
};


export type QueryEquipmentsDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<DeviceSortInput>>;
  where?: InputMaybe<DeviceFilterInput>;
};


export type QueryEventDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventDataSortInput>>;
  where?: InputMaybe<EventDataFilterInput>;
};


export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<EventSortInput>>;
  where?: InputMaybe<EventFilterInput>;
};


export type QueryFeedersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FeederSortInput>>;
  where?: InputMaybe<FeederFilterInput>;
};


export type QueryFirmwareTaskLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareTaskLogSortInput>>;
  where?: InputMaybe<FirmwareTaskLogFilterInput>;
};


export type QueryFirmwareTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareTaskSortInput>>;
  where?: InputMaybe<FirmwareTaskFilterInput>;
};


export type QueryFirmwaresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<FirmwareSortInput>>;
  where?: InputMaybe<FirmwareFilterInput>;
};


export type QueryGpsPointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<GpsPointSortInput>>;
  where?: InputMaybe<GpsPointFilterInput>;
};


export type QueryInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputSortInput>>;
  where?: InputMaybe<InputFilterInput>;
};


export type QueryInterfacesBluetoothArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InterfaceBluetoothSortInput>>;
  where?: InputMaybe<InterfaceBluetoothFilterInput>;
};


export type QueryInterfacesEthernetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InterfaceEthernetSortInput>>;
  where?: InputMaybe<InterfaceEthernetFilterInput>;
};


export type QueryInterfacesGprsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InterfaceGprsSortInput>>;
  where?: InputMaybe<InterfaceGprsFilterInput>;
};


export type QueryInterfacesLoRaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InterfaceLoRaSortInput>>;
  where?: InputMaybe<InterfaceLoRaFilterInput>;
};


export type QueryKeycloakRoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<KeycloakRoleSortInput>>;
  where?: InputMaybe<KeycloakRoleFilterInput>;
};


export type QueryKeycloakUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<KeycloakUserSortInput>>;
  where?: InputMaybe<KeycloakUserFilterInput>;
};


export type QueryLastContactByTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LastContactByTypeSortInput>>;
  where?: InputMaybe<LastContactByTypeFilterInput>;
};


export type QueryLayoutAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<AssetSortInput>>;
  where?: InputMaybe<AssetFilterInput>;
};


export type QueryLayoutMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LayoutMessageSortInput>>;
  where?: InputMaybe<LayoutMessageFilterInput>;
};


export type QueryMenuArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MenuSortInput>>;
  where?: InputMaybe<MenuFilterInput>;
};


export type QueryMenuRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MenuRolesSortInput>>;
  where?: InputMaybe<MenuRolesFilterInput>;
};


export type QueryMenuRolesActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<MenuRolesActionsSortInput>>;
  where?: InputMaybe<MenuRolesActionsFilterInput>;
};


export type QueryNetworkPowerQualityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<NetworkPowerQualitySortInput>>;
  where?: InputMaybe<NetworkPowerQualityFilterInput>;
};


export type QueryOperationalAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<OperationalAreaSortInput>>;
  where?: InputMaybe<OperationalAreaFilterInput>;
};


export type QueryPlatformSettingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PlatformSettingsSortInput>>;
  where?: InputMaybe<PlatformSettingsFilterInput>;
};


export type QueryPortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<PortSortInput>>;
  where?: InputMaybe<PortFilterInput>;
};


export type QueryPowerBusLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<LineSortInput>>;
  where?: InputMaybe<LineFilterInput>;
};


export type QueryProtocolsBluetoothArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolBluetoothSortInput>>;
  where?: InputMaybe<ProtocolBluetoothFilterInput>;
};


export type QueryProtocolsDnp3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolDnp3SortInput>>;
  where?: InputMaybe<ProtocolDnp3FilterInput>;
};


export type QueryProtocolsEneidaLoRaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolEneidaLoRaSortInput>>;
  where?: InputMaybe<ProtocolEneidaLoRaFilterInput>;
};


export type QueryProtocolsHttpArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolHttpSortInput>>;
  where?: InputMaybe<ProtocolHttpFilterInput>;
};


export type QueryProtocolsMqttArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ProtocolMqttSortInput>>;
  where?: InputMaybe<ProtocolMqttFilterInput>;
};


export type QueryRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RegionSortInput>>;
  where?: InputMaybe<RegionFilterInput>;
};


export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ReportDtoSortInput>>;
  where?: InputMaybe<ReportDtoFilterInput>;
};


export type QueryRoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<RoleGraphQlSortInput>>;
  where?: InputMaybe<RoleGraphQlFilterInput>;
};


export type QueryScheduleOperationModeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<ScheduleOperationModeSortInput>>;
  where?: InputMaybe<ScheduleOperationModeFilterInput>;
};


export type QuerySimCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SimCardSortInput>>;
  where?: InputMaybe<SimCardFilterInput>;
};


export type QuerySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<SubscriptionSortInput>>;
  where?: InputMaybe<SubscriptionFilterInput>;
};


export type QueryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TemplateSortInput>>;
  where?: InputMaybe<TemplateFilterInput>;
};


export type QueryTemplatesConfigArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<TemplateConfigSortInput>>;
  where?: InputMaybe<TemplateConfigFilterInput>;
};


export type QueryUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserGraphQlSortInput>>;
  where?: InputMaybe<UserGraphQlFilterInput>;
};


export type QueryUserLogActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<UserLogActionSortInput>>;
  where?: InputMaybe<UserLogActionFilterInput>;
};

export enum Region {
  Empty = 'EMPTY',
  Europe = 'EUROPE'
}

export type RegionOperationFilterInput = {
  eq?: InputMaybe<Region>;
  in?: InputMaybe<Array<Region>>;
  neq?: InputMaybe<Region>;
  nin?: InputMaybe<Array<Region>>;
};

export type RfSettings = {
  __typename?: 'RFSettings';
  centreFrequency: Scalars['Int']['output'];
  frequencyDeviation: Scalars['Int']['output'];
  hardwareImplementation: Scalars['Int']['output'];
  id: Scalars['Long']['output'];
  interfaceLoRa: InterfaceLoRa;
  interfaceLoRaId: Scalars['Long']['output'];
  transmitPower: Scalars['Int']['output'];
};

export type RfSettingsFilterInput = {
  and?: InputMaybe<Array<RfSettingsFilterInput>>;
  centreFrequency?: InputMaybe<IntOperationFilterInput>;
  frequencyDeviation?: InputMaybe<IntOperationFilterInput>;
  hardwareImplementation?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaFilterInput>;
  interfaceLoRaId?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<RfSettingsFilterInput>>;
  transmitPower?: InputMaybe<IntOperationFilterInput>;
};

export type RfSettingsSortInput = {
  centreFrequency?: InputMaybe<SortEnumType>;
  frequencyDeviation?: InputMaybe<SortEnumType>;
  hardwareImplementation?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  interfaceLoRa?: InputMaybe<InterfaceLoRaSortInput>;
  interfaceLoRaId?: InputMaybe<SortEnumType>;
  transmitPower?: InputMaybe<SortEnumType>;
};

export type Region = {
  __typename?: 'Region';
  accessGroups: Array<AccessGroup>;
  code: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['Long']['output'];
  gpsPoints: Array<GpsPoint>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  operationalAreas: Array<OperationalArea>;
};

export type RegionFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<RegionFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<LongOperationFilterInput>;
  externalId?: InputMaybe<LongOperationFilterInput>;
  firmwareTasks?: InputMaybe<ListFilterInputTypeOfFirmwareTaskFilterInput>;
  gpsPoints?: InputMaybe<ListFilterInputTypeOfGpsPointFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  operationalAreas?: InputMaybe<ListFilterInputTypeOfOperationalAreaFilterInput>;
  or?: InputMaybe<Array<RegionFilterInput>>;
};

export type RegionSortInput = {
  code?: InputMaybe<SortEnumType>;
  company?: InputMaybe<CompanySortInput>;
  companyId?: InputMaybe<SortEnumType>;
  externalId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type RegionsConnection = {
  __typename?: 'RegionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RegionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Maybe<Region>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RegionsEdge = {
  __typename?: 'RegionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Region>;
};

export type ReportDto = {
  __typename?: 'ReportDTO';
  _id: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  equipments: Array<Scalars['Int']['output']>;
  errors: Scalars['String']['output'];
  name: Scalars['String']['output'];
  period_end: Scalars['DateTime']['output'];
  period_start: Scalars['DateTime']['output'];
  periodic: Scalars['Boolean']['output'];
  ready: Scalars['Boolean']['output'];
  report_type: Scalars['String']['output'];
  requested_by: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ReportDtoFilterInput = {
  _id?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ReportDtoFilterInput>>;
  created?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  equipments?: InputMaybe<ListIntOperationFilterInput>;
  errors?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportDtoFilterInput>>;
  period_end?: InputMaybe<DateTimeOperationFilterInput>;
  period_start?: InputMaybe<DateTimeOperationFilterInput>;
  periodic?: InputMaybe<BooleanOperationFilterInput>;
  ready?: InputMaybe<BooleanOperationFilterInput>;
  report_type?: InputMaybe<StringOperationFilterInput>;
  requested_by?: InputMaybe<StringOperationFilterInput>;
  size?: InputMaybe<IntOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type ReportDtoSortInput = {
  _id?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  errors?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  period_end?: InputMaybe<SortEnumType>;
  period_start?: InputMaybe<SortEnumType>;
  periodic?: InputMaybe<SortEnumType>;
  ready?: InputMaybe<SortEnumType>;
  report_type?: InputMaybe<SortEnumType>;
  requested_by?: InputMaybe<SortEnumType>;
  size?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ReportsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ReportDto>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ReportDto;
};

export type Role = {
  __typename?: 'Role';
  authorizations?: Maybe<Array<Authorization>>;
  hasMobileAccess?: Maybe<Scalars['Boolean']['output']>;
  hasWebAccess?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  keycloakId?: Maybe<Scalars['String']['output']>;
  menus?: Maybe<Array<Menu>>;
  name: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export type RoleComposite = {
  __typename?: 'RoleComposite';
  client?: Maybe<Array<KeyValuePairOfStringAndString>>;
  realm?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type RoleCompositeFilterInput = {
  and?: InputMaybe<Array<RoleCompositeFilterInput>>;
  client?: InputMaybe<ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput>;
  or?: InputMaybe<Array<RoleCompositeFilterInput>>;
  realm?: InputMaybe<ListStringOperationFilterInput>;
};

/** A connection to a list of items. */
export type RoleConnection = {
  __typename?: 'RoleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<RoleEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<RoleGraphQl>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RoleEdge = {
  __typename?: 'RoleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RoleGraphQl;
};

export type RoleFilterInput = {
  and?: InputMaybe<Array<RoleFilterInput>>;
  authorizations?: InputMaybe<ListFilterInputTypeOfAuthorizationFilterInput>;
  hasMobileAccess?: InputMaybe<BooleanOperationFilterInput>;
  hasWebAccess?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  keycloakId?: InputMaybe<StringOperationFilterInput>;
  menus?: InputMaybe<ListFilterInputTypeOfMenuFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoleFilterInput>>;
  users?: InputMaybe<ListFilterInputTypeOfUserFilterInput>;
};

export type RoleGraphQl = {
  __typename?: 'RoleGraphQl';
  id?: Maybe<Scalars['Long']['output']>;
  keycloakId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RoleGraphQlFilterInput = {
  and?: InputMaybe<Array<RoleGraphQlFilterInput>>;
  id?: InputMaybe<LongOperationFilterInput>;
  keycloakId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoleGraphQlFilterInput>>;
};

export type RoleGraphQlSortInput = {
  id?: InputMaybe<SortEnumType>;
  keycloakId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type RoleSortInput = {
  hasMobileAccess?: InputMaybe<SortEnumType>;
  hasWebAccess?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  keycloakId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export enum Server_Type {
  Imap = 'IMAP',
  Pop = 'POP'
}

export enum Sim_Status_Type {
  Available = 'AVAILABLE',
  Damaged = 'DAMAGED',
  Used = 'USED'
}

export type Sim_Status_TypeOperationFilterInput = {
  eq?: InputMaybe<Sim_Status_Type>;
  in?: InputMaybe<Array<Sim_Status_Type>>;
  neq?: InputMaybe<Sim_Status_Type>;
  nin?: InputMaybe<Array<Sim_Status_Type>>;
};

export enum Slot_Type {
  Device = 'DEVICE',
  Manual = 'MANUAL',
  Random = 'RANDOM',
  Undefined = 'UNDEFINED'
}

export type Slot_TypeOperationFilterInput = {
  eq?: InputMaybe<Slot_Type>;
  in?: InputMaybe<Array<Slot_Type>>;
  neq?: InputMaybe<Slot_Type>;
  nin?: InputMaybe<Array<Slot_Type>>;
};

export enum Source {
  Deepgrid = 'DEEPGRID',
  Device = 'DEVICE',
  Empty = 'EMPTY'
}

export type SourceOperationFilterInput = {
  eq?: InputMaybe<Source>;
  in?: InputMaybe<Array<Source>>;
  neq?: InputMaybe<Source>;
  nin?: InputMaybe<Array<Source>>;
};

export enum Status {
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Waiting = 'WAITING'
}

export type StatusOperationFilterInput = {
  eq?: InputMaybe<Status>;
  in?: InputMaybe<Array<Status>>;
  neq?: InputMaybe<Status>;
  nin?: InputMaybe<Array<Status>>;
};

export enum Substation_Type {
  DeliveryPoint = 'DELIVERY_POINT',
  Pds = 'PDS',
  Sds = 'SDS'
}

export type ScheduleOperationMode = {
  __typename?: 'ScheduleOperationMode';
  activationDate: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  currentEndSchedule?: Maybe<Scalars['DateTime']['output']>;
  currentHarmonics?: Maybe<CurrentHarmonics>;
  currentHarmonicsId?: Maybe<Scalars['Long']['output']>;
  currentSchedule?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  deviceBulkConfigurations: Array<DeviceBulkConfiguration>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationType: Duration_Type;
  enable: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  energyBalance?: Maybe<EnergyBalance>;
  energyBalanceId?: Maybe<Scalars['Long']['output']>;
  every?: Maybe<Scalars['Int']['output']>;
  executions: Scalars['Int']['output'];
  forever: Scalars['Boolean']['output'];
  friday?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Long']['output'];
  lastEndSchedule?: Maybe<Scalars['DateTime']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  lastSchedule?: Maybe<Scalars['DateTime']['output']>;
  monday?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  networkPowerQuality?: Maybe<NetworkPowerQuality>;
  networkPowerQualityId?: Maybe<Scalars['Long']['output']>;
  nextEndSchedule?: Maybe<Scalars['DateTime']['output']>;
  nextSchedule?: Maybe<Scalars['DateTime']['output']>;
  ofEvery?: Maybe<Scalars['Int']['output']>;
  ofMonth?: Maybe<Of_Month>;
  onDay?: Maybe<Scalars['Int']['output']>;
  onThe?: Maybe<On_The>;
  onTheItem?: Maybe<On_The_Item>;
  recurrenceType: Duration_Type;
  recurrencyQuantity?: Maybe<Scalars['Int']['output']>;
  saturday?: Maybe<Scalars['Boolean']['output']>;
  startDate: Scalars['DateTime']['output'];
  sunday?: Maybe<Scalars['Boolean']['output']>;
  thursday?: Maybe<Scalars['Boolean']['output']>;
  tuesday?: Maybe<Scalars['Boolean']['output']>;
  wednesday?: Maybe<Scalars['Boolean']['output']>;
};

/** A connection to a list of items. */
export type ScheduleOperationModeConnection = {
  __typename?: 'ScheduleOperationModeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<ScheduleOperationModeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<ScheduleOperationMode>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ScheduleOperationModeEdge = {
  __typename?: 'ScheduleOperationModeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduleOperationMode;
};

export type ScheduleOperationModeFilterInput = {
  activationDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ScheduleOperationModeFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  currentEndSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  currentHarmonics?: InputMaybe<CurrentHarmonicsFilterInput>;
  currentHarmonicsId?: InputMaybe<LongOperationFilterInput>;
  currentSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  deviceBulkConfigurations?: InputMaybe<ListFilterInputTypeOfDeviceBulkConfigurationFilterInput>;
  duration?: InputMaybe<IntOperationFilterInput>;
  durationType?: InputMaybe<Duration_TypeOperationFilterInput>;
  enable?: InputMaybe<BooleanOperationFilterInput>;
  endDate?: InputMaybe<DateTimeOperationFilterInput>;
  energyBalance?: InputMaybe<EnergyBalanceFilterInput>;
  energyBalanceId?: InputMaybe<LongOperationFilterInput>;
  every?: InputMaybe<IntOperationFilterInput>;
  executions?: InputMaybe<IntOperationFilterInput>;
  forever?: InputMaybe<BooleanOperationFilterInput>;
  friday?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  lastEndSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  lastSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  monday?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  networkPowerQuality?: InputMaybe<NetworkPowerQualityFilterInput>;
  networkPowerQualityId?: InputMaybe<LongOperationFilterInput>;
  nextEndSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  nextSchedule?: InputMaybe<DateTimeOperationFilterInput>;
  ofEvery?: InputMaybe<IntOperationFilterInput>;
  ofMonth?: InputMaybe<NullableOfOf_MonthOperationFilterInput>;
  onDay?: InputMaybe<IntOperationFilterInput>;
  onThe?: InputMaybe<NullableOfOn_TheOperationFilterInput>;
  onTheItem?: InputMaybe<NullableOfOn_The_ItemOperationFilterInput>;
  or?: InputMaybe<Array<ScheduleOperationModeFilterInput>>;
  recurrenceType?: InputMaybe<Duration_TypeOperationFilterInput>;
  recurrencyQuantity?: InputMaybe<IntOperationFilterInput>;
  saturday?: InputMaybe<BooleanOperationFilterInput>;
  startDate?: InputMaybe<DateTimeOperationFilterInput>;
  sunday?: InputMaybe<BooleanOperationFilterInput>;
  thursday?: InputMaybe<BooleanOperationFilterInput>;
  tuesday?: InputMaybe<BooleanOperationFilterInput>;
  wednesday?: InputMaybe<BooleanOperationFilterInput>;
};

export type ScheduleOperationModeSortInput = {
  activationDate?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  currentEndSchedule?: InputMaybe<SortEnumType>;
  currentHarmonics?: InputMaybe<CurrentHarmonicsSortInput>;
  currentHarmonicsId?: InputMaybe<SortEnumType>;
  currentSchedule?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  duration?: InputMaybe<SortEnumType>;
  durationType?: InputMaybe<SortEnumType>;
  enable?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  energyBalance?: InputMaybe<EnergyBalanceSortInput>;
  energyBalanceId?: InputMaybe<SortEnumType>;
  every?: InputMaybe<SortEnumType>;
  executions?: InputMaybe<SortEnumType>;
  forever?: InputMaybe<SortEnumType>;
  friday?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastEndSchedule?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  lastSchedule?: InputMaybe<SortEnumType>;
  monday?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  networkPowerQuality?: InputMaybe<NetworkPowerQualitySortInput>;
  networkPowerQualityId?: InputMaybe<SortEnumType>;
  nextEndSchedule?: InputMaybe<SortEnumType>;
  nextSchedule?: InputMaybe<SortEnumType>;
  ofEvery?: InputMaybe<SortEnumType>;
  ofMonth?: InputMaybe<SortEnumType>;
  onDay?: InputMaybe<SortEnumType>;
  onThe?: InputMaybe<SortEnumType>;
  onTheItem?: InputMaybe<SortEnumType>;
  recurrenceType?: InputMaybe<SortEnumType>;
  recurrencyQuantity?: InputMaybe<SortEnumType>;
  saturday?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  sunday?: InputMaybe<SortEnumType>;
  thursday?: InputMaybe<SortEnumType>;
  tuesday?: InputMaybe<SortEnumType>;
  wednesday?: InputMaybe<SortEnumType>;
};

export type Section = {
  __typename?: 'Section';
  i18nKey: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  menus?: Maybe<Array<Menu>>;
  name: Scalars['String']['output'];
};

export type SectionFilterInput = {
  and?: InputMaybe<Array<SectionFilterInput>>;
  i18nKey?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  menus?: InputMaybe<ListFilterInputTypeOfMenuFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SectionFilterInput>>;
};

export type SectionSortInput = {
  i18nKey?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type SimCard = {
  __typename?: 'SimCard';
  apnAuthType: Apn_Auth_Type;
  apnIp?: Maybe<Scalars['String']['output']>;
  apnName: Scalars['String']['output'];
  apnPwd?: Maybe<Scalars['String']['output']>;
  apnUser?: Maybe<Scalars['String']['output']>;
  associationDate?: Maybe<Scalars['DateTime']['output']>;
  associationLog?: Maybe<Scalars['String']['output']>;
  associationSucess?: Maybe<Scalars['Boolean']['output']>;
  batchSim: BatchSim;
  batchSimId: Scalars['Long']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  device?: Maybe<Device>;
  filename: Scalars['String']['output'];
  iccid: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  importDate: Scalars['DateTime']['output'];
  imsi?: Maybe<Scalars['String']['output']>;
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  simIp?: Maybe<Scalars['String']['output']>;
  simStatusType: Sim_Status_Type;
};

export type SimCardFilterInput = {
  and?: InputMaybe<Array<SimCardFilterInput>>;
  apnAuthType?: InputMaybe<Apn_Auth_TypeOperationFilterInput>;
  apnIp?: InputMaybe<StringOperationFilterInput>;
  apnName?: InputMaybe<StringOperationFilterInput>;
  apnPwd?: InputMaybe<StringOperationFilterInput>;
  apnUser?: InputMaybe<StringOperationFilterInput>;
  associationDate?: InputMaybe<DateTimeOperationFilterInput>;
  associationLog?: InputMaybe<StringOperationFilterInput>;
  associationSucess?: InputMaybe<BooleanOperationFilterInput>;
  batchSim?: InputMaybe<BatchSimFilterInput>;
  batchSimId?: InputMaybe<LongOperationFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  device?: InputMaybe<DeviceFilterInput>;
  filename?: InputMaybe<StringOperationFilterInput>;
  iccid?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  importDate?: InputMaybe<DateTimeOperationFilterInput>;
  imsi?: InputMaybe<StringOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SimCardFilterInput>>;
  simIp?: InputMaybe<StringOperationFilterInput>;
  simStatusType?: InputMaybe<Sim_Status_TypeOperationFilterInput>;
};

export type SimCardSortInput = {
  apnAuthType?: InputMaybe<SortEnumType>;
  apnIp?: InputMaybe<SortEnumType>;
  apnName?: InputMaybe<SortEnumType>;
  apnPwd?: InputMaybe<SortEnumType>;
  apnUser?: InputMaybe<SortEnumType>;
  associationDate?: InputMaybe<SortEnumType>;
  associationLog?: InputMaybe<SortEnumType>;
  associationSucess?: InputMaybe<SortEnumType>;
  batchSim?: InputMaybe<BatchSimSortInput>;
  batchSimId?: InputMaybe<SortEnumType>;
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  device?: InputMaybe<DeviceSortInput>;
  filename?: InputMaybe<SortEnumType>;
  iccid?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  importDate?: InputMaybe<SortEnumType>;
  imsi?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  simIp?: InputMaybe<SortEnumType>;
  simStatusType?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SimCardsConnection = {
  __typename?: 'SimCardsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SimCardsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<SimCard>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SimCardsEdge = {
  __typename?: 'SimCardsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SimCard;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  contacts?: Maybe<Array<Contact>>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  emailBcc?: Maybe<Array<Contact>>;
  emailCc?: Maybe<Array<Contact>>;
  emailTo?: Maybe<Array<Contact>>;
  filters?: Maybe<Array<Filter>>;
  id: Scalars['Long']['output'];
  isActive: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  templates?: Maybe<Array<Template>>;
};

export type SubscriptionFilterInput = {
  and?: InputMaybe<Array<SubscriptionFilterInput>>;
  contacts?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  emailBcc?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  emailCc?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  emailTo?: InputMaybe<ListFilterInputTypeOfContactFilterInput>;
  filters?: InputMaybe<ListFilterInputTypeOfFilterFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubscriptionFilterInput>>;
  templates?: InputMaybe<ListFilterInputTypeOfTemplateFilterInput>;
};

export type SubscriptionSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isActive?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type SubscriptionsConnection = {
  __typename?: 'SubscriptionsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<SubscriptionsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Subscription>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubscriptionsEdge = {
  __typename?: 'SubscriptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Subscription;
};

export enum Template_Message_Type {
  Html = 'HTML',
  Text = 'TEXT'
}

export type Template_Message_TypeOperationFilterInput = {
  eq?: InputMaybe<Template_Message_Type>;
  in?: InputMaybe<Array<Template_Message_Type>>;
  neq?: InputMaybe<Template_Message_Type>;
  nin?: InputMaybe<Array<Template_Message_Type>>;
};

export enum Time_Server_Type {
  Deepgrid = 'DEEPGRID',
  Htp = 'HTP',
  Ntp = 'NTP'
}

export type Time_Server_TypeOperationFilterInput = {
  eq?: InputMaybe<Time_Server_Type>;
  in?: InputMaybe<Array<Time_Server_Type>>;
  neq?: InputMaybe<Time_Server_Type>;
  nin?: InputMaybe<Array<Time_Server_Type>>;
};

export enum Transformer_Type {
  Interbars = 'INTERBARS',
  Single = 'SINGLE'
}

export type Transformer_TypeOperationFilterInput = {
  eq?: InputMaybe<Transformer_Type>;
  in?: InputMaybe<Array<Transformer_Type>>;
  neq?: InputMaybe<Transformer_Type>;
  nin?: InputMaybe<Array<Transformer_Type>>;
};

export type Template = {
  __typename?: 'Template';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Long']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastModifiedBy?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageType: Template_Message_Type;
  name: Scalars['String']['output'];
  notificationType: Notification_Type;
  readOnly: Scalars['Boolean']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  subscriptions: Array<Subscription>;
  templateConfig: TemplateConfig;
  templateConfigId: Scalars['Long']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type TemplateConfig = {
  __typename?: 'TemplateConfig';
  baseTemplate: Scalars['String']['output'];
  footer?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  notificationType: Notification_Type;
};

export type TemplateConfigFilterInput = {
  and?: InputMaybe<Array<TemplateConfigFilterInput>>;
  baseTemplate?: InputMaybe<StringOperationFilterInput>;
  footer?: InputMaybe<StringOperationFilterInput>;
  header?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notificationType?: InputMaybe<Notification_TypeOperationFilterInput>;
  or?: InputMaybe<Array<TemplateConfigFilterInput>>;
};

export type TemplateConfigSortInput = {
  baseTemplate?: InputMaybe<SortEnumType>;
  footer?: InputMaybe<SortEnumType>;
  header?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notificationType?: InputMaybe<SortEnumType>;
};

export type TemplateFilterInput = {
  and?: InputMaybe<Array<TemplateFilterInput>>;
  createdBy?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  isDefault?: InputMaybe<BooleanOperationFilterInput>;
  lastModifiedBy?: InputMaybe<StringOperationFilterInput>;
  lastModifiedDate?: InputMaybe<DateTimeOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  messageType?: InputMaybe<Template_Message_TypeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notificationType?: InputMaybe<Notification_TypeOperationFilterInput>;
  or?: InputMaybe<Array<TemplateFilterInput>>;
  readOnly?: InputMaybe<BooleanOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  subscriptions?: InputMaybe<ListFilterInputTypeOfSubscriptionFilterInput>;
  templateConfig?: InputMaybe<TemplateConfigFilterInput>;
  templateConfigId?: InputMaybe<LongOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
};

export type TemplateSortInput = {
  createdBy?: InputMaybe<SortEnumType>;
  createdDate?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefault?: InputMaybe<SortEnumType>;
  lastModifiedBy?: InputMaybe<SortEnumType>;
  lastModifiedDate?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
  messageType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notificationType?: InputMaybe<SortEnumType>;
  readOnly?: InputMaybe<SortEnumType>;
  subject?: InputMaybe<SortEnumType>;
  templateConfig?: InputMaybe<TemplateConfigSortInput>;
  templateConfigId?: InputMaybe<SortEnumType>;
  title?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type TemplatesConfigConnection = {
  __typename?: 'TemplatesConfigConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TemplatesConfigEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<TemplateConfig>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TemplatesConfigEdge = {
  __typename?: 'TemplatesConfigEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TemplateConfig;
};

/** A connection to a list of items. */
export type TemplatesConnection = {
  __typename?: 'TemplatesConnection';
  /** A list of edges. */
  edges?: Maybe<Array<TemplatesEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Template>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TemplatesEdge = {
  __typename?: 'TemplatesEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Template;
};

export enum TokenType {
  Application = 'APPLICATION',
  Device = 'DEVICE',
  User = 'USER'
}

export type TokenTypeOperationFilterInput = {
  eq?: InputMaybe<TokenType>;
  in?: InputMaybe<Array<TokenType>>;
  neq?: InputMaybe<TokenType>;
  nin?: InputMaybe<Array<TokenType>>;
};

export enum TransferEncoding {
  Base64 = 'BASE64',
  EightBit = 'EIGHT_BIT',
  QuotedPrintable = 'QUOTED_PRINTABLE',
  SevenBit = 'SEVEN_BIT',
  Unknown = 'UNKNOWN'
}

export type TransferEncodingOperationFilterInput = {
  eq?: InputMaybe<TransferEncoding>;
  in?: InputMaybe<Array<TransferEncoding>>;
  neq?: InputMaybe<TransferEncoding>;
  nin?: InputMaybe<Array<TransferEncoding>>;
};

export type User = {
  __typename?: 'User';
  accessGroups: Array<AuthorizationAccessGroup>;
  authorizationTokens?: Maybe<Array<AuthorizationToken>>;
  company: Company;
  companyId: Scalars['Long']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  keycloakId?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  userSettings?: Maybe<Scalars['String']['output']>;
};

export type UserAccess = {
  __typename?: 'UserAccess';
  impersonate?: Maybe<Scalars['Boolean']['output']>;
  manage?: Maybe<Scalars['Boolean']['output']>;
  manageGroupMembership?: Maybe<Scalars['Boolean']['output']>;
  mapRoles?: Maybe<Scalars['Boolean']['output']>;
  view?: Maybe<Scalars['Boolean']['output']>;
};

export type UserAccessFilterInput = {
  and?: InputMaybe<Array<UserAccessFilterInput>>;
  impersonate?: InputMaybe<BooleanOperationFilterInput>;
  manage?: InputMaybe<BooleanOperationFilterInput>;
  manageGroupMembership?: InputMaybe<BooleanOperationFilterInput>;
  mapRoles?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<UserAccessFilterInput>>;
  view?: InputMaybe<BooleanOperationFilterInput>;
};

export type UserAccessSortInput = {
  impersonate?: InputMaybe<SortEnumType>;
  manage?: InputMaybe<SortEnumType>;
  manageGroupMembership?: InputMaybe<SortEnumType>;
  mapRoles?: InputMaybe<SortEnumType>;
  view?: InputMaybe<SortEnumType>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserGraphQl>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

export type UserConsent = {
  __typename?: 'UserConsent';
  clientId?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['Long']['output']>;
  grantedClientScopes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastUpdatedDate?: Maybe<Scalars['Long']['output']>;
};

export type UserConsentFilterInput = {
  and?: InputMaybe<Array<UserConsentFilterInput>>;
  clientId?: InputMaybe<StringOperationFilterInput>;
  createdDate?: InputMaybe<LongOperationFilterInput>;
  grantedClientScopes?: InputMaybe<ListStringOperationFilterInput>;
  lastUpdatedDate?: InputMaybe<LongOperationFilterInput>;
  or?: InputMaybe<Array<UserConsentFilterInput>>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserGraphQl;
};

export type UserFilterInput = {
  accessGroups?: InputMaybe<ListFilterInputTypeOfAccessGroupFilterInput>;
  and?: InputMaybe<Array<UserFilterInput>>;
  authorizationTokens?: InputMaybe<ListFilterInputTypeOfAuthorizationTokenFilterInput>;
  company?: InputMaybe<CompanyFilterInput>;
  companyId?: InputMaybe<LongOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  keycloakId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserFilterInput>>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleFilterInput>;
  userSettings?: InputMaybe<StringOperationFilterInput>;
};

export type UserGraphQl = {
  __typename?: 'UserGraphQl';
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Long']['output']>;
  keycloakId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<RoleGraphQl>>;
  userName?: Maybe<Scalars['String']['output']>;
  userSettings?: Maybe<Scalars['String']['output']>;
};

export type UserGraphQlFilterInput = {
  and?: InputMaybe<Array<UserGraphQlFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<LongOperationFilterInput>;
  keycloakId?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserGraphQlFilterInput>>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleGraphQlFilterInput>;
  userName?: InputMaybe<StringOperationFilterInput>;
  userSettings?: InputMaybe<StringOperationFilterInput>;
};

export type UserGraphQlSortInput = {
  description?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  keycloakId?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  userName?: InputMaybe<SortEnumType>;
  userSettings?: InputMaybe<SortEnumType>;
};

export type UserLogAction = {
  __typename?: 'UserLogAction';
  actionDate: Scalars['DateTime']['output'];
  apiTranslation?: Maybe<Scalars['String']['output']>;
  apiUrl: Scalars['String']['output'];
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  responseBody?: Maybe<Scalars['String']['output']>;
  responseCode?: Maybe<Scalars['Int']['output']>;
  userActionType: ActionLoggingType;
  userId: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type UserLogActionConnection = {
  __typename?: 'UserLogActionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<UserLogActionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<UserLogAction>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserLogActionEdge = {
  __typename?: 'UserLogActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: UserLogAction;
};

export type UserLogActionFilterInput = {
  actionDate?: InputMaybe<DateTimeOperationFilterInput>;
  and?: InputMaybe<Array<UserLogActionFilterInput>>;
  apiTranslation?: InputMaybe<StringOperationFilterInput>;
  apiUrl?: InputMaybe<StringOperationFilterInput>;
  data?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<UuidOperationFilterInput>;
  or?: InputMaybe<Array<UserLogActionFilterInput>>;
  responseBody?: InputMaybe<StringOperationFilterInput>;
  responseCode?: InputMaybe<IntOperationFilterInput>;
  userActionType?: InputMaybe<ActionLoggingTypeOperationFilterInput>;
  userId?: InputMaybe<LongOperationFilterInput>;
};

export type UserLogActionSortInput = {
  actionDate?: InputMaybe<SortEnumType>;
  apiTranslation?: InputMaybe<SortEnumType>;
  apiUrl?: InputMaybe<SortEnumType>;
  data?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  responseBody?: InputMaybe<SortEnumType>;
  responseCode?: InputMaybe<SortEnumType>;
  userActionType?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
};

export type UuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  gt?: InputMaybe<Scalars['UUID']['input']>;
  gte?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  lt?: InputMaybe<Scalars['UUID']['input']>;
  lte?: InputMaybe<Scalars['UUID']['input']>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
  ngt?: InputMaybe<Scalars['UUID']['input']>;
  ngte?: InputMaybe<Scalars['UUID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  nlt?: InputMaybe<Scalars['UUID']['input']>;
  nlte?: InputMaybe<Scalars['UUID']['input']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ACTION_METHOD: Action_Method;
  ACTION_METHODOperationFilterInput: Action_MethodOperationFilterInput;
  ACTION_PROTO: Action_Proto;
  ACTION_PROTOOperationFilterInput: Action_ProtoOperationFilterInput;
  ACTION_TYPE: Action_Type;
  ACTION_TYPEOperationFilterInput: Action_TypeOperationFilterInput;
  ALARM_GROUP_NAME: Alarm_Group_Name;
  ALARM_GROUP_NAMEOperationFilterInput: Alarm_Group_NameOperationFilterInput;
  ALARM_TYPE: Alarm_Type;
  ALARM_TYPEOperationFilterInput: Alarm_TypeOperationFilterInput;
  ANCHOR_TYPE: Anchor_Type;
  APN_AUTH_TYPE: Apn_Auth_Type;
  APN_AUTH_TYPEOperationFilterInput: Apn_Auth_TypeOperationFilterInput;
  ASSET_STATE: Asset_State;
  ASSET_STATEOperationFilterInput: Asset_StateOperationFilterInput;
  ASSET_TYPE: Asset_Type;
  ASSET_TYPEOperationFilterInput: Asset_TypeOperationFilterInput;
  AccessGroup: ResolverTypeWrapper<AccessGroup>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  AccessGroupFilterInput: AccessGroupFilterInput;
  AccessGroupSortInput: AccessGroupSortInput;
  AccessGroupToAsset: ResolverTypeWrapper<AccessGroupToAsset>;
  AccessGroupToCompany: ResolverTypeWrapper<AccessGroupToCompany>;
  AccessGroupToOperationalArea: ResolverTypeWrapper<AccessGroupToOperationalArea>;
  AccessGroupToRegion: ResolverTypeWrapper<AccessGroupToRegion>;
  AccessGroupToUser: ResolverTypeWrapper<AccessGroupToUser>;
  AccessGroupToWorkingOperationalArea: ResolverTypeWrapper<AccessGroupToWorkingOperationalArea>;
  AccessGroupsConnection: ResolverTypeWrapper<AccessGroupsConnection>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  AccessGroupsEdge: ResolverTypeWrapper<AccessGroupsEdge>;
  Action: ResolverTypeWrapper<Action>;
  ActionConnection: ResolverTypeWrapper<ActionConnection>;
  ActionEdge: ResolverTypeWrapper<ActionEdge>;
  ActionFilterInput: ActionFilterInput;
  ActionLoggingType: ActionLoggingType;
  ActionLoggingTypeOperationFilterInput: ActionLoggingTypeOperationFilterInput;
  ActionSortInput: ActionSortInput;
  ActionType: ActionType;
  ActionTypeOperationFilterInput: ActionTypeOperationFilterInput;
  AlarmStandard: ResolverTypeWrapper<AlarmStandard>;
  AlarmStandardDefinition: ResolverTypeWrapper<AlarmStandardDefinition>;
  AlarmStandardDefinitionFilterInput: AlarmStandardDefinitionFilterInput;
  AlarmStandardDefinitionSortInput: AlarmStandardDefinitionSortInput;
  AlarmStandardDefinitionsConnection: ResolverTypeWrapper<AlarmStandardDefinitionsConnection>;
  AlarmStandardDefinitionsEdge: ResolverTypeWrapper<AlarmStandardDefinitionsEdge>;
  AlarmStandardFilterInput: AlarmStandardFilterInput;
  AlarmStandardSortInput: AlarmStandardSortInput;
  AlarmStandardVariableAggregation: ResolverTypeWrapper<AlarmStandardVariableAggregation>;
  AlarmStandardVariableAggregationByAlarm: ResolverTypeWrapper<AlarmStandardVariableAggregationByAlarm>;
  AlarmStandardVariableAggregationByAlarmFilterInput: AlarmStandardVariableAggregationByAlarmFilterInput;
  AlarmStandardVariableAggregationByAlarmInput: AlarmStandardVariableAggregationByAlarmInput;
  AlarmStandardVariableAggregationFilterInput: AlarmStandardVariableAggregationFilterInput;
  AlarmStandardVariableAggregationInput: AlarmStandardVariableAggregationInput;
  AlarmStandardVariableDefinition: ResolverTypeWrapper<AlarmStandardVariableDefinition>;
  AlarmStandardVariableDefinitionFilterInput: AlarmStandardVariableDefinitionFilterInput;
  AlarmStandardVariableDefinitionSortInput: AlarmStandardVariableDefinitionSortInput;
  AlarmStandardVariableDefinitionsConnection: ResolverTypeWrapper<AlarmStandardVariableDefinitionsConnection>;
  AlarmStandardVariableDefinitionsEdge: ResolverTypeWrapper<AlarmStandardVariableDefinitionsEdge>;
  AlarmStandardsConnection: ResolverTypeWrapper<AlarmStandardsConnection>;
  AlarmStandardsEdge: ResolverTypeWrapper<AlarmStandardsEdge>;
  AlarmType: ResolverTypeWrapper<AlarmType>;
  AlarmTypeFilterInput: AlarmTypeFilterInput;
  AlarmTypeSortInput: AlarmTypeSortInput;
  AlarmTypesConnection: ResolverTypeWrapper<AlarmTypesConnection>;
  AlarmTypesEdge: ResolverTypeWrapper<AlarmTypesEdge>;
  AlarmVariable: ResolverTypeWrapper<AlarmVariable>;
  AlarmVariableAggregation: ResolverTypeWrapper<AlarmVariableAggregation>;
  AlarmVariableAggregationFilterInput: AlarmVariableAggregationFilterInput;
  AlarmVariableFilterInput: AlarmVariableFilterInput;
  AlarmVariableSortInput: AlarmVariableSortInput;
  AlarmVariablesConnection: ResolverTypeWrapper<AlarmVariablesConnection>;
  AlarmVariablesEdge: ResolverTypeWrapper<AlarmVariablesEdge>;
  Application: ResolverTypeWrapper<Application>;
  ApplicationFilterInput: ApplicationFilterInput;
  Asset: ResolverTypeWrapper<Asset>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  AssetBulkConfigurationsConnection: ResolverTypeWrapper<AssetBulkConfigurationsConnection>;
  AssetBulkConfigurationsEdge: ResolverTypeWrapper<AssetBulkConfigurationsEdge>;
  AssetFilterInput: AssetFilterInput;
  AssetSortInput: AssetSortInput;
  AssetsConnection: ResolverTypeWrapper<AssetsConnection>;
  AssetsEdge: ResolverTypeWrapper<AssetsEdge>;
  Authorization: ResolverTypeWrapper<Authorization>;
  AuthorizationAccessGroup: ResolverTypeWrapper<AuthorizationAccessGroup>;
  AuthorizationConnection: ResolverTypeWrapper<AuthorizationConnection>;
  AuthorizationDevice: ResolverTypeWrapper<AuthorizationDevice>;
  AuthorizationEdge: ResolverTypeWrapper<AuthorizationEdge>;
  AuthorizationFilterInput: AuthorizationFilterInput;
  AuthorizationSortInput: AuthorizationSortInput;
  AuthorizationToken: ResolverTypeWrapper<AuthorizationToken>;
  AuthorizationTokenFilterInput: AuthorizationTokenFilterInput;
  BatchDevice: ResolverTypeWrapper<BatchDevice>;
  BatchDeviceFilterInput: BatchDeviceFilterInput;
  BatchDeviceSortInput: BatchDeviceSortInput;
  BatchDevicesConnection: ResolverTypeWrapper<BatchDevicesConnection>;
  BatchDevicesEdge: ResolverTypeWrapper<BatchDevicesEdge>;
  BatchInclude: ResolverTypeWrapper<BatchInclude>;
  BatchIncludeFilterInput: BatchIncludeFilterInput;
  BatchIncludeSortInput: BatchIncludeSortInput;
  BatchIncludesConnection: ResolverTypeWrapper<BatchIncludesConnection>;
  BatchIncludesEdge: ResolverTypeWrapper<BatchIncludesEdge>;
  BatchSim: ResolverTypeWrapper<BatchSim>;
  BatchSimFilterInput: BatchSimFilterInput;
  BatchSimSortInput: BatchSimSortInput;
  BatchSimsConnection: ResolverTypeWrapper<BatchSimsConnection>;
  BatchSimsEdge: ResolverTypeWrapper<BatchSimsEdge>;
  BooleanOperationFilterInput: BooleanOperationFilterInput;
  Byte: ResolverTypeWrapper<Scalars['Byte']['output']>;
  ByteOperationFilterInput: ByteOperationFilterInput;
  CONNECTION_TYPE: Connection_Type;
  CONSTRAINT_TYPE: Constraint_Type;
  CONSTRAINT_TYPEOperationFilterInput: Constraint_TypeOperationFilterInput;
  CON_TEST_RESULT_TYPE: Con_Test_Result_Type;
  CON_TEST_RESULT_TYPEOperationFilterInput: Con_Test_Result_TypeOperationFilterInput;
  CableType: ResolverTypeWrapper<CableType>;
  CableTypeFilterInput: CableTypeFilterInput;
  CableTypeSortInput: CableTypeSortInput;
  CableTypesConnection: ResolverTypeWrapper<CableTypesConnection>;
  CableTypesEdge: ResolverTypeWrapper<CableTypesEdge>;
  Company: ResolverTypeWrapper<Company>;
  CompanyFilterInput: CompanyFilterInput;
  CompanySortInput: CompanySortInput;
  CompanysConnection: ResolverTypeWrapper<CompanysConnection>;
  CompanysEdge: ResolverTypeWrapper<CompanysEdge>;
  ConTest: ResolverTypeWrapper<ConTest>;
  ConTestDeviceResult: ResolverTypeWrapper<ConTestDeviceResult>;
  ConTestDeviceResultFilterInput: ConTestDeviceResultFilterInput;
  ConTestDeviceResultSortInput: ConTestDeviceResultSortInput;
  ConTestDeviceResultsConnection: ResolverTypeWrapper<ConTestDeviceResultsConnection>;
  ConTestDeviceResultsEdge: ResolverTypeWrapper<ConTestDeviceResultsEdge>;
  ConTestExtended: ResolverTypeWrapper<ConTestExtended>;
  ConTestExtendedFilterInput: ConTestExtendedFilterInput;
  ConTestExtendedSortInput: ConTestExtendedSortInput;
  ConTestFilterInput: ConTestFilterInput;
  ConTestSortInput: ConTestSortInput;
  ConTestsConnection: ResolverTypeWrapper<ConTestsConnection>;
  ConTestsEdge: ResolverTypeWrapper<ConTestsEdge>;
  ConTestsExtendedConnection: ResolverTypeWrapper<ConTestsExtendedConnection>;
  ConTestsExtendedEdge: ResolverTypeWrapper<ConTestsExtendedEdge>;
  Contact: ResolverTypeWrapper<Contact>;
  ContactFilterInput: ContactFilterInput;
  ContactSortInput: ContactSortInput;
  ContactsConnection: ResolverTypeWrapper<ContactsConnection>;
  ContactsEdge: ResolverTypeWrapper<ContactsEdge>;
  Credentials: ResolverTypeWrapper<Credentials>;
  CredentialsFilterInput: CredentialsFilterInput;
  CurrentHarmonics: ResolverTypeWrapper<CurrentHarmonics>;
  CurrentHarmonicsConnection: ResolverTypeWrapper<CurrentHarmonicsConnection>;
  CurrentHarmonicsEdge: ResolverTypeWrapper<CurrentHarmonicsEdge>;
  CurrentHarmonicsFilterInput: CurrentHarmonicsFilterInput;
  CurrentHarmonicsSortInput: CurrentHarmonicsSortInput;
  CustomProperties: ResolverTypeWrapper<CustomProperties>;
  CustomPropertiesConnection: ResolverTypeWrapper<CustomPropertiesConnection>;
  CustomPropertiesEdge: ResolverTypeWrapper<CustomPropertiesEdge>;
  CustomPropertiesFilterInput: CustomPropertiesFilterInput;
  CustomPropertiesSortInput: CustomPropertiesSortInput;
  DATA_TYPE: Data_Type;
  DATA_TYPEOperationFilterInput: Data_TypeOperationFilterInput;
  DEVICE_TYPE: Device_Type;
  DEVICE_TYPEOperationFilterInput: Device_TypeOperationFilterInput;
  DURATION_TYPE: Duration_Type;
  DURATION_TYPEOperationFilterInput: Duration_TypeOperationFilterInput;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DateTimeOperationFilterInput: DateTimeOperationFilterInput;
  Device: ResolverTypeWrapper<Device>;
  DeviceBulkConfiguration: ResolverTypeWrapper<DeviceBulkConfiguration>;
  DeviceBulkConfigurationFilterInput: DeviceBulkConfigurationFilterInput;
  DeviceBulkConfigurationSortInput: DeviceBulkConfigurationSortInput;
  DeviceBulkConfigurationsConnection: ResolverTypeWrapper<DeviceBulkConfigurationsConnection>;
  DeviceBulkConfigurationsEdge: ResolverTypeWrapper<DeviceBulkConfigurationsEdge>;
  DeviceFilterInput: DeviceFilterInput;
  DeviceInputNumberFilterInput: DeviceInputNumberFilterInput;
  DeviceInputNumberSortInput: DeviceInputNumberSortInput;
  DeviceInputNumbersConnection: ResolverTypeWrapper<DeviceInputNumbersConnection>;
  DeviceInputNumbersEdge: ResolverTypeWrapper<DeviceInputNumbersEdge>;
  DeviceLog: ResolverTypeWrapper<DeviceLog>;
  DeviceLogConnection: ResolverTypeWrapper<DeviceLogConnection>;
  DeviceLogEdge: ResolverTypeWrapper<DeviceLogEdge>;
  DeviceLogFilterInput: DeviceLogFilterInput;
  DeviceLogSortInput: DeviceLogSortInput;
  DeviceLogsConnection: ResolverTypeWrapper<DeviceLogsConnection>;
  DeviceLogsEdge: ResolverTypeWrapper<DeviceLogsEdge>;
  DeviceMessage: ResolverTypeWrapper<DeviceMessage>;
  DeviceMessageFilterInput: DeviceMessageFilterInput;
  DeviceMessageSortInput: DeviceMessageSortInput;
  DeviceMessagesConnection: ResolverTypeWrapper<DeviceMessagesConnection>;
  DeviceMessagesEdge: ResolverTypeWrapper<DeviceMessagesEdge>;
  DeviceSortInput: DeviceSortInput;
  DeviceTag: ResolverTypeWrapper<DeviceTag>;
  DeviceTagFilterInput: DeviceTagFilterInput;
  DeviceTypeConfiguration: ResolverTypeWrapper<DeviceTypeConfiguration>;
  DeviceTypeConfigurationFilterInput: DeviceTypeConfigurationFilterInput;
  DeviceTypeConfigurationSortInput: DeviceTypeConfigurationSortInput;
  DeviceTypeConfigurationsConnection: ResolverTypeWrapper<DeviceTypeConfigurationsConnection>;
  DeviceTypeConfigurationsEdge: ResolverTypeWrapper<DeviceTypeConfigurationsEdge>;
  DevicesAccessGroup: ResolverTypeWrapper<DevicesAccessGroup>;
  DevicesAlarmStandard: ResolverTypeWrapper<DevicesAlarmStandard>;
  DevicesCompany: ResolverTypeWrapper<DevicesCompany>;
  DevicesConnection: ResolverTypeWrapper<DevicesConnection>;
  DevicesEdge: ResolverTypeWrapper<DevicesEdge>;
  DevicesFirmwareDocument: ResolverTypeWrapper<DevicesFirmwareDocument>;
  DevicesFirmwareDocumentsConnection: ResolverTypeWrapper<DevicesFirmwareDocumentsConnection>;
  DevicesFirmwareDocumentsEdge: ResolverTypeWrapper<DevicesFirmwareDocumentsEdge>;
  DevicesOperationalArea: ResolverTypeWrapper<DevicesOperationalArea>;
  DevicesRegion: ResolverTypeWrapper<DevicesRegion>;
  ENCRYPTION_TYPE: Encryption_Type;
  ENTITY_TYPE: Entity_Type;
  ENTITY_TYPEOperationFilterInput: Entity_TypeOperationFilterInput;
  EQUIPMENT_TYPE: Equipment_Type;
  EQUIPMENT_TYPEOperationFilterInput: Equipment_TypeOperationFilterInput;
  Email: ResolverTypeWrapper<Email>;
  EmailAttachment: ResolverTypeWrapper<EmailAttachment>;
  EmailAttachmentFilterInput: EmailAttachmentFilterInput;
  EmailAttachmentSortInput: EmailAttachmentSortInput;
  EmailAttachmentsConnection: ResolverTypeWrapper<EmailAttachmentsConnection>;
  EmailAttachmentsEdge: ResolverTypeWrapper<EmailAttachmentsEdge>;
  EmailFilterInput: EmailFilterInput;
  EmailSettings: ResolverTypeWrapper<EmailSettings>;
  EmailSettingsFilterInput: EmailSettingsFilterInput;
  EmailSettingsSortInput: EmailSettingsSortInput;
  EmailSortInput: EmailSortInput;
  EmailStatus: ResolverTypeWrapper<EmailStatus>;
  EmailStatusConnection: ResolverTypeWrapper<EmailStatusConnection>;
  EmailStatusEdge: ResolverTypeWrapper<EmailStatusEdge>;
  EmailStatusFilterInput: EmailStatusFilterInput;
  EmailStatusSortInput: EmailStatusSortInput;
  EmailsConnection: ResolverTypeWrapper<EmailsConnection>;
  EmailsEdge: ResolverTypeWrapper<EmailsEdge>;
  EnergyBalance: ResolverTypeWrapper<EnergyBalance>;
  EnergyBalanceConnection: ResolverTypeWrapper<EnergyBalanceConnection>;
  EnergyBalanceEdge: ResolverTypeWrapper<EnergyBalanceEdge>;
  EnergyBalanceFilterInput: EnergyBalanceFilterInput;
  EnergyBalanceSortInput: EnergyBalanceSortInput;
  Enterprise: ResolverTypeWrapper<Enterprise>;
  EnterpriseFilterInput: EnterpriseFilterInput;
  EnterpriseSortInput: EnterpriseSortInput;
  EnterprisesConnection: ResolverTypeWrapper<EnterprisesConnection>;
  EnterprisesEdge: ResolverTypeWrapper<EnterprisesEdge>;
  EquipBulkConfigurationFilterInput: EquipBulkConfigurationFilterInput;
  EquipBulkConfigurationSortInput: EquipBulkConfigurationSortInput;
  Equipment: ResolverTypeWrapper<Equipment>;
  EquipmentFilterInput: EquipmentFilterInput;
  EquipmentSortInput: EquipmentSortInput;
  EquipmentsAlarmStandard: ResolverTypeWrapper<EquipmentsAlarmStandard>;
  EquipmentsBulkConfiguration: ResolverTypeWrapper<EquipmentsBulkConfiguration>;
  EquipmentsConnection: ResolverTypeWrapper<EquipmentsConnection>;
  EquipmentsDevice: ResolverTypeWrapper<EquipmentsDevice>;
  EquipmentsDeviceInputNumber: ResolverTypeWrapper<EquipmentsDeviceInputNumber>;
  EquipmentsDeviceLog: ResolverTypeWrapper<EquipmentsDeviceLog>;
  EquipmentsDevicesConnection: ResolverTypeWrapper<EquipmentsDevicesConnection>;
  EquipmentsDevicesEdge: ResolverTypeWrapper<EquipmentsDevicesEdge>;
  EquipmentsEdge: ResolverTypeWrapper<EquipmentsEdge>;
  EquipmentsOperationalArea: ResolverTypeWrapper<EquipmentsOperationalArea>;
  EquipmentsRegion: ResolverTypeWrapper<EquipmentsRegion>;
  Event: ResolverTypeWrapper<Event>;
  EventData: ResolverTypeWrapper<EventData>;
  EventDataConnection: ResolverTypeWrapper<EventDataConnection>;
  EventDataEdge: ResolverTypeWrapper<EventDataEdge>;
  EventDataFilterInput: EventDataFilterInput;
  EventDataSortInput: EventDataSortInput;
  EventDataStatus: EventDataStatus;
  EventEntityType: EventEntityType;
  EventEntityTypeOperationFilterInput: EventEntityTypeOperationFilterInput;
  EventFilterInput: EventFilterInput;
  EventSeverity: EventSeverity;
  EventSeverityOperationFilterInput: EventSeverityOperationFilterInput;
  EventSortInput: EventSortInput;
  EventStatus: EventStatus;
  EventStatusOperationFilterInput: EventStatusOperationFilterInput;
  EventType: EventType;
  EventTypeOperationFilterInput: EventTypeOperationFilterInput;
  EventsConnection: ResolverTypeWrapper<EventsConnection>;
  EventsEdge: ResolverTypeWrapper<EventsEdge>;
  ExpirationType: ExpirationType;
  ExpirationTypeOperationFilterInput: ExpirationTypeOperationFilterInput;
  FEEDER_TYPE: Feeder_Type;
  FEEDER_TYPEOperationFilterInput: Feeder_TypeOperationFilterInput;
  FIRMWARE_TASK_STATUS: Firmware_Task_Status;
  FIRMWARE_TASK_STATUSOperationFilterInput: Firmware_Task_StatusOperationFilterInput;
  FederatedIdentity: ResolverTypeWrapper<FederatedIdentity>;
  FederatedIdentityFilterInput: FederatedIdentityFilterInput;
  Feeder: ResolverTypeWrapper<Feeder>;
  FeederFilterInput: FeederFilterInput;
  FeederSortInput: FeederSortInput;
  FeedersConnection: ResolverTypeWrapper<FeedersConnection>;
  FeedersEdge: ResolverTypeWrapper<FeedersEdge>;
  Filter: ResolverTypeWrapper<Filter>;
  FilterFilterInput: FilterFilterInput;
  Firmware: ResolverTypeWrapper<Firmware>;
  FirmwareDocumentFilterInput: FirmwareDocumentFilterInput;
  FirmwareDocumentSortInput: FirmwareDocumentSortInput;
  FirmwareFilterInput: FirmwareFilterInput;
  FirmwareSortInput: FirmwareSortInput;
  FirmwareTask: ResolverTypeWrapper<FirmwareTask>;
  FirmwareTaskFilterInput: FirmwareTaskFilterInput;
  FirmwareTaskLog: ResolverTypeWrapper<FirmwareTaskLog>;
  FirmwareTaskLogConnection: ResolverTypeWrapper<FirmwareTaskLogConnection>;
  FirmwareTaskLogEdge: ResolverTypeWrapper<FirmwareTaskLogEdge>;
  FirmwareTaskLogFilterInput: FirmwareTaskLogFilterInput;
  FirmwareTaskLogSortInput: FirmwareTaskLogSortInput;
  FirmwareTaskSortInput: FirmwareTaskSortInput;
  FirmwareTasksConnection: ResolverTypeWrapper<FirmwareTasksConnection>;
  FirmwareTasksEdge: ResolverTypeWrapper<FirmwareTasksEdge>;
  FirmwaresConnection: ResolverTypeWrapper<FirmwaresConnection>;
  FirmwaresEdge: ResolverTypeWrapper<FirmwaresEdge>;
  FloatOperationFilterInput: FloatOperationFilterInput;
  GeneralSettings: ResolverTypeWrapper<GeneralSettings>;
  GpsPoint: ResolverTypeWrapper<GpsPoint>;
  GpsPointFilterInput: GpsPointFilterInput;
  GpsPointSortInput: GpsPointSortInput;
  GpsPointsConnection: ResolverTypeWrapper<GpsPointsConnection>;
  GpsPointsEdge: ResolverTypeWrapper<GpsPointsEdge>;
  INPUT_TYPE: Input_Type;
  INPUT_TYPEOperationFilterInput: Input_TypeOperationFilterInput;
  INSTALLATION_TYPE: Installation_Type;
  INTERFACE_TYPE: Interface_Type;
  INTERFACE_TYPEOperationFilterInput: Interface_TypeOperationFilterInput;
  Input: ResolverTypeWrapper<Input>;
  InputFilterInput: InputFilterInput;
  InputSortInput: InputSortInput;
  InputsConnection: ResolverTypeWrapper<InputsConnection>;
  InputsEdge: ResolverTypeWrapper<InputsEdge>;
  IntOperationFilterInput: IntOperationFilterInput;
  Interface: ResolverTypeWrapper<Interface>;
  InterfaceBluetooth: ResolverTypeWrapper<InterfaceBluetooth>;
  InterfaceBluetoothFilterInput: InterfaceBluetoothFilterInput;
  InterfaceBluetoothSortInput: InterfaceBluetoothSortInput;
  InterfaceEthernet: ResolverTypeWrapper<InterfaceEthernet>;
  InterfaceEthernetFilterInput: InterfaceEthernetFilterInput;
  InterfaceEthernetSortInput: InterfaceEthernetSortInput;
  InterfaceFilterInput: InterfaceFilterInput;
  InterfaceGprs: ResolverTypeWrapper<InterfaceGprs>;
  InterfaceGprsFilterInput: InterfaceGprsFilterInput;
  InterfaceGprsSortInput: InterfaceGprsSortInput;
  InterfaceLoRa: ResolverTypeWrapper<InterfaceLoRa>;
  InterfaceLoRaFilterInput: InterfaceLoRaFilterInput;
  InterfaceLoRaSortInput: InterfaceLoRaSortInput;
  InterfaceSortInput: InterfaceSortInput;
  InterfacesBluetoothConnection: ResolverTypeWrapper<InterfacesBluetoothConnection>;
  InterfacesBluetoothEdge: ResolverTypeWrapper<InterfacesBluetoothEdge>;
  InterfacesEthernetConnection: ResolverTypeWrapper<InterfacesEthernetConnection>;
  InterfacesEthernetEdge: ResolverTypeWrapper<InterfacesEthernetEdge>;
  InterfacesGprsConnection: ResolverTypeWrapper<InterfacesGprsConnection>;
  InterfacesGprsEdge: ResolverTypeWrapper<InterfacesGprsEdge>;
  InterfacesLoRaConnection: ResolverTypeWrapper<InterfacesLoRaConnection>;
  InterfacesLoRaEdge: ResolverTypeWrapper<InterfacesLoRaEdge>;
  JOIN_OPERATOR: Join_Operator;
  JOIN_OPERATOROperationFilterInput: Join_OperatorOperationFilterInput;
  KeyValuePairOfStringAndIEnumerableOfString: ResolverTypeWrapper<KeyValuePairOfStringAndIEnumerableOfString>;
  KeyValuePairOfStringAndIEnumerableOfStringFilterInput: KeyValuePairOfStringAndIEnumerableOfStringFilterInput;
  KeyValuePairOfStringAndObject: ResolverTypeWrapper<KeyValuePairOfStringAndObject>;
  KeyValuePairOfStringAndObjectFilterInput: KeyValuePairOfStringAndObjectFilterInput;
  KeyValuePairOfStringAndString: ResolverTypeWrapper<KeyValuePairOfStringAndString>;
  KeyValuePairOfStringAndStringFilterInput: KeyValuePairOfStringAndStringFilterInput;
  KeycloakRole: ResolverTypeWrapper<KeycloakRole>;
  KeycloakRoleConnection: ResolverTypeWrapper<KeycloakRoleConnection>;
  KeycloakRoleEdge: ResolverTypeWrapper<KeycloakRoleEdge>;
  KeycloakRoleFilterInput: KeycloakRoleFilterInput;
  KeycloakRoleSortInput: KeycloakRoleSortInput;
  KeycloakUser: ResolverTypeWrapper<KeycloakUser>;
  KeycloakUserConnection: ResolverTypeWrapper<KeycloakUserConnection>;
  KeycloakUserEdge: ResolverTypeWrapper<KeycloakUserEdge>;
  KeycloakUserFilterInput: KeycloakUserFilterInput;
  KeycloakUserSortInput: KeycloakUserSortInput;
  LASTCONTACT_TYPE: Lastcontact_Type;
  LASTCONTACT_TYPEOperationFilterInput: Lastcontact_TypeOperationFilterInput;
  LINE_TYPE: Line_Type;
  LINE_TYPEOperationFilterInput: Line_TypeOperationFilterInput;
  LastContactByType: ResolverTypeWrapper<LastContactByType>;
  LastContactByTypeFilterInput: LastContactByTypeFilterInput;
  LastContactByTypeSortInput: LastContactByTypeSortInput;
  LastContactByTypesConnection: ResolverTypeWrapper<LastContactByTypesConnection>;
  LastContactByTypesEdge: ResolverTypeWrapper<LastContactByTypesEdge>;
  LayoutAsset: ResolverTypeWrapper<LayoutAsset>;
  LayoutAssetsConnection: ResolverTypeWrapper<LayoutAssetsConnection>;
  LayoutAssetsEdge: ResolverTypeWrapper<LayoutAssetsEdge>;
  LayoutEquipment: ResolverTypeWrapper<LayoutEquipment>;
  LayoutMessage: ResolverTypeWrapper<LayoutMessage>;
  LayoutMessageFilterInput: LayoutMessageFilterInput;
  LayoutMessageSortInput: LayoutMessageSortInput;
  LayoutMessagesConnection: ResolverTypeWrapper<LayoutMessagesConnection>;
  LayoutMessagesEdge: ResolverTypeWrapper<LayoutMessagesEdge>;
  Line: ResolverTypeWrapper<Line>;
  LineFilterInput: LineFilterInput;
  LineSortInput: LineSortInput;
  ListByteOperationFilterInput: ListByteOperationFilterInput;
  ListFilterInputTypeOfAccessGroupFilterInput: ListFilterInputTypeOfAccessGroupFilterInput;
  ListFilterInputTypeOfActionFilterInput: ListFilterInputTypeOfActionFilterInput;
  ListFilterInputTypeOfAlarmStandardDefinitionFilterInput: ListFilterInputTypeOfAlarmStandardDefinitionFilterInput;
  ListFilterInputTypeOfAlarmStandardVariableAggregationByAlarmFilterInput: ListFilterInputTypeOfAlarmStandardVariableAggregationByAlarmFilterInput;
  ListFilterInputTypeOfAlarmStandardVariableAggregationFilterInput: ListFilterInputTypeOfAlarmStandardVariableAggregationFilterInput;
  ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput: ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput;
  ListFilterInputTypeOfAlarmVariableAggregationFilterInput: ListFilterInputTypeOfAlarmVariableAggregationFilterInput;
  ListFilterInputTypeOfAlarmVariableFilterInput: ListFilterInputTypeOfAlarmVariableFilterInput;
  ListFilterInputTypeOfAssetFilterInput: ListFilterInputTypeOfAssetFilterInput;
  ListFilterInputTypeOfAuthorizationFilterInput: ListFilterInputTypeOfAuthorizationFilterInput;
  ListFilterInputTypeOfAuthorizationTokenFilterInput: ListFilterInputTypeOfAuthorizationTokenFilterInput;
  ListFilterInputTypeOfBatchIncludeFilterInput: ListFilterInputTypeOfBatchIncludeFilterInput;
  ListFilterInputTypeOfCompanyFilterInput: ListFilterInputTypeOfCompanyFilterInput;
  ListFilterInputTypeOfConTestDeviceResultFilterInput: ListFilterInputTypeOfConTestDeviceResultFilterInput;
  ListFilterInputTypeOfConTestFilterInput: ListFilterInputTypeOfConTestFilterInput;
  ListFilterInputTypeOfContactFilterInput: ListFilterInputTypeOfContactFilterInput;
  ListFilterInputTypeOfCredentialsFilterInput: ListFilterInputTypeOfCredentialsFilterInput;
  ListFilterInputTypeOfCustomPropertiesFilterInput: ListFilterInputTypeOfCustomPropertiesFilterInput;
  ListFilterInputTypeOfDeviceBulkConfigurationFilterInput: ListFilterInputTypeOfDeviceBulkConfigurationFilterInput;
  ListFilterInputTypeOfDeviceFilterInput: ListFilterInputTypeOfDeviceFilterInput;
  ListFilterInputTypeOfDeviceInputNumberFilterInput: ListFilterInputTypeOfDeviceInputNumberFilterInput;
  ListFilterInputTypeOfDeviceTagFilterInput: ListFilterInputTypeOfDeviceTagFilterInput;
  ListFilterInputTypeOfDeviceTypeConfigurationFilterInput: ListFilterInputTypeOfDeviceTypeConfigurationFilterInput;
  ListFilterInputTypeOfEmailAttachmentFilterInput: ListFilterInputTypeOfEmailAttachmentFilterInput;
  ListFilterInputTypeOfEmailStatusFilterInput: ListFilterInputTypeOfEmailStatusFilterInput;
  ListFilterInputTypeOfEnterpriseFilterInput: ListFilterInputTypeOfEnterpriseFilterInput;
  ListFilterInputTypeOfEquipmentFilterInput: ListFilterInputTypeOfEquipmentFilterInput;
  ListFilterInputTypeOfEventDataFilterInput: ListFilterInputTypeOfEventDataFilterInput;
  ListFilterInputTypeOfFederatedIdentityFilterInput: ListFilterInputTypeOfFederatedIdentityFilterInput;
  ListFilterInputTypeOfFeederFilterInput: ListFilterInputTypeOfFeederFilterInput;
  ListFilterInputTypeOfFilterFilterInput: ListFilterInputTypeOfFilterFilterInput;
  ListFilterInputTypeOfFirmwareTaskFilterInput: ListFilterInputTypeOfFirmwareTaskFilterInput;
  ListFilterInputTypeOfFirmwareTaskLogFilterInput: ListFilterInputTypeOfFirmwareTaskLogFilterInput;
  ListFilterInputTypeOfGpsPointFilterInput: ListFilterInputTypeOfGpsPointFilterInput;
  ListFilterInputTypeOfInputFilterInput: ListFilterInputTypeOfInputFilterInput;
  ListFilterInputTypeOfInterfaceFilterInput: ListFilterInputTypeOfInterfaceFilterInput;
  ListFilterInputTypeOfKeyValuePairOfStringAndIEnumerableOfStringFilterInput: ListFilterInputTypeOfKeyValuePairOfStringAndIEnumerableOfStringFilterInput;
  ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput: ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput;
  ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput: ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput;
  ListFilterInputTypeOfLastContactByTypeFilterInput: ListFilterInputTypeOfLastContactByTypeFilterInput;
  ListFilterInputTypeOfLineFilterInput: ListFilterInputTypeOfLineFilterInput;
  ListFilterInputTypeOfMenuFilterInput: ListFilterInputTypeOfMenuFilterInput;
  ListFilterInputTypeOfMenuRolesFilterInput: ListFilterInputTypeOfMenuRolesFilterInput;
  ListFilterInputTypeOfOperationalAreaFilterInput: ListFilterInputTypeOfOperationalAreaFilterInput;
  ListFilterInputTypeOfPortFilterInput: ListFilterInputTypeOfPortFilterInput;
  ListFilterInputTypeOfProtocolFilterInput: ListFilterInputTypeOfProtocolFilterInput;
  ListFilterInputTypeOfRegionFilterInput: ListFilterInputTypeOfRegionFilterInput;
  ListFilterInputTypeOfRoleFilterInput: ListFilterInputTypeOfRoleFilterInput;
  ListFilterInputTypeOfRoleGraphQlFilterInput: ListFilterInputTypeOfRoleGraphQlFilterInput;
  ListFilterInputTypeOfScheduleOperationModeFilterInput: ListFilterInputTypeOfScheduleOperationModeFilterInput;
  ListFilterInputTypeOfSimCardFilterInput: ListFilterInputTypeOfSimCardFilterInput;
  ListFilterInputTypeOfSubscriptionFilterInput: ListFilterInputTypeOfSubscriptionFilterInput;
  ListFilterInputTypeOfTemplateFilterInput: ListFilterInputTypeOfTemplateFilterInput;
  ListFilterInputTypeOfUserConsentFilterInput: ListFilterInputTypeOfUserConsentFilterInput;
  ListFilterInputTypeOfUserFilterInput: ListFilterInputTypeOfUserFilterInput;
  ListIntOperationFilterInput: ListIntOperationFilterInput;
  ListStringOperationFilterInput: ListStringOperationFilterInput;
  Long: ResolverTypeWrapper<Scalars['Long']['output']>;
  LongOperationFilterInput: LongOperationFilterInput;
  MATERIAL_TYPE: Material_Type;
  MICRO_CONTROLLER_TYPE: Micro_Controller_Type;
  MICRO_CONTROLLER_TYPEOperationFilterInput: Micro_Controller_TypeOperationFilterInput;
  Menu: ResolverTypeWrapper<Menu>;
  MenuConnection: ResolverTypeWrapper<MenuConnection>;
  MenuEdge: ResolverTypeWrapper<MenuEdge>;
  MenuFilterInput: MenuFilterInput;
  MenuRoles: ResolverTypeWrapper<MenuRoles>;
  MenuRolesActions: ResolverTypeWrapper<MenuRolesActions>;
  MenuRolesActionsConnection: ResolverTypeWrapper<MenuRolesActionsConnection>;
  MenuRolesActionsEdge: ResolverTypeWrapper<MenuRolesActionsEdge>;
  MenuRolesActionsFilterInput: MenuRolesActionsFilterInput;
  MenuRolesActionsSortInput: MenuRolesActionsSortInput;
  MenuRolesConnection: ResolverTypeWrapper<MenuRolesConnection>;
  MenuRolesEdge: ResolverTypeWrapper<MenuRolesEdge>;
  MenuRolesFilterInput: MenuRolesFilterInput;
  MenuRolesSortInput: MenuRolesSortInput;
  MenuSortInput: MenuSortInput;
  MenuType: MenuType;
  MenuTypeOperationFilterInput: MenuTypeOperationFilterInput;
  ModemSettings: ResolverTypeWrapper<ModemSettings>;
  ModemSettingsFilterInput: ModemSettingsFilterInput;
  ModemSettingsSortInput: ModemSettingsSortInput;
  NOTIFICATION_TYPE: Notification_Type;
  NOTIFICATION_TYPEOperationFilterInput: Notification_TypeOperationFilterInput;
  NetworkPowerQuality: ResolverTypeWrapper<NetworkPowerQuality>;
  NetworkPowerQualityConnection: ResolverTypeWrapper<NetworkPowerQualityConnection>;
  NetworkPowerQualityEdge: ResolverTypeWrapper<NetworkPowerQualityEdge>;
  NetworkPowerQualityFilterInput: NetworkPowerQualityFilterInput;
  NetworkPowerQualitySortInput: NetworkPowerQualitySortInput;
  NullableOfANCHOR_TYPEOperationFilterInput: NullableOfAnchor_TypeOperationFilterInput;
  NullableOfCONNECTION_TYPEOperationFilterInput: NullableOfConnection_TypeOperationFilterInput;
  NullableOfENCRYPTION_TYPEOperationFilterInput: NullableOfEncryption_TypeOperationFilterInput;
  NullableOfEventDataStatusOperationFilterInput: NullableOfEventDataStatusOperationFilterInput;
  NullableOfINPUT_TYPEOperationFilterInput: NullableOfInput_TypeOperationFilterInput;
  NullableOfINSTALLATION_TYPEOperationFilterInput: NullableOfInstallation_TypeOperationFilterInput;
  NullableOfMATERIAL_TYPEOperationFilterInput: NullableOfMaterial_TypeOperationFilterInput;
  NullableOfOF_MONTHOperationFilterInput: NullableOfOf_MonthOperationFilterInput;
  NullableOfON_THEOperationFilterInput: NullableOfOn_TheOperationFilterInput;
  NullableOfON_THE_ITEMOperationFilterInput: NullableOfOn_The_ItemOperationFilterInput;
  NullableOfSERVER_TYPEOperationFilterInput: NullableOfServer_TypeOperationFilterInput;
  NullableOfSUBSTATION_TYPEOperationFilterInput: NullableOfSubstation_TypeOperationFilterInput;
  OF_MONTH: Of_Month;
  ON_THE: On_The;
  ON_THE_ITEM: On_The_Item;
  OperationalArea: ResolverTypeWrapper<OperationalArea>;
  OperationalAreaFilterInput: OperationalAreaFilterInput;
  OperationalAreaSortInput: OperationalAreaSortInput;
  OperationalAreasConnection: ResolverTypeWrapper<OperationalAreasConnection>;
  OperationalAreasEdge: ResolverTypeWrapper<OperationalAreasEdge>;
  PHASE_ROTATION: Phase_Rotation;
  PHASE_ROTATIONOperationFilterInput: Phase_RotationOperationFilterInput;
  PHASE_TYPE: Phase_Type;
  PHASE_TYPEOperationFilterInput: Phase_TypeOperationFilterInput;
  PORT_TYPE: Port_Type;
  PORT_TYPEOperationFilterInput: Port_TypeOperationFilterInput;
  PROTOCOL_TYPE: Protocol_Type;
  PROTOCOL_TYPEOperationFilterInput: Protocol_TypeOperationFilterInput;
  PacketConfiguration: ResolverTypeWrapper<PacketConfiguration>;
  PacketConfigurationFilterInput: PacketConfigurationFilterInput;
  PacketConfigurationSortInput: PacketConfigurationSortInput;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PlatformSettings: ResolverTypeWrapper<PlatformSettings>;
  PlatformSettingsConnection: ResolverTypeWrapper<PlatformSettingsConnection>;
  PlatformSettingsEdge: ResolverTypeWrapper<PlatformSettingsEdge>;
  PlatformSettingsFilterInput: PlatformSettingsFilterInput;
  PlatformSettingsSortInput: PlatformSettingsSortInput;
  Port: ResolverTypeWrapper<Port>;
  PortFilterInput: PortFilterInput;
  PortSortInput: PortSortInput;
  PortsConnection: ResolverTypeWrapper<PortsConnection>;
  PortsEdge: ResolverTypeWrapper<PortsEdge>;
  PowerBusLinesConnection: ResolverTypeWrapper<PowerBusLinesConnection>;
  PowerBusLinesEdge: ResolverTypeWrapper<PowerBusLinesEdge>;
  Protocol: ResolverTypeWrapper<Protocol>;
  ProtocolBluetooth: ResolverTypeWrapper<ProtocolBluetooth>;
  ProtocolBluetoothFilterInput: ProtocolBluetoothFilterInput;
  ProtocolBluetoothSortInput: ProtocolBluetoothSortInput;
  ProtocolDNP3: ResolverTypeWrapper<ProtocolDnp3>;
  ProtocolDNP3FilterInput: ProtocolDnp3FilterInput;
  ProtocolDNP3SortInput: ProtocolDnp3SortInput;
  ProtocolEneidaLoRa: ResolverTypeWrapper<ProtocolEneidaLoRa>;
  ProtocolEneidaLoRaFilterInput: ProtocolEneidaLoRaFilterInput;
  ProtocolEneidaLoRaSortInput: ProtocolEneidaLoRaSortInput;
  ProtocolFilterInput: ProtocolFilterInput;
  ProtocolHTTP: ResolverTypeWrapper<ProtocolHttp>;
  ProtocolHTTPFilterInput: ProtocolHttpFilterInput;
  ProtocolHTTPSortInput: ProtocolHttpSortInput;
  ProtocolMqtt: ResolverTypeWrapper<ProtocolMqtt>;
  ProtocolMqttFilterInput: ProtocolMqttFilterInput;
  ProtocolMqttSortInput: ProtocolMqttSortInput;
  ProtocolsBluetoothConnection: ResolverTypeWrapper<ProtocolsBluetoothConnection>;
  ProtocolsBluetoothEdge: ResolverTypeWrapper<ProtocolsBluetoothEdge>;
  ProtocolsDNP3Connection: ResolverTypeWrapper<ProtocolsDnp3Connection>;
  ProtocolsDNP3Edge: ResolverTypeWrapper<ProtocolsDnp3Edge>;
  ProtocolsEneidaLoRaConnection: ResolverTypeWrapper<ProtocolsEneidaLoRaConnection>;
  ProtocolsEneidaLoRaEdge: ResolverTypeWrapper<ProtocolsEneidaLoRaEdge>;
  ProtocolsHTTPConnection: ResolverTypeWrapper<ProtocolsHttpConnection>;
  ProtocolsHTTPEdge: ResolverTypeWrapper<ProtocolsHttpEdge>;
  ProtocolsMqttConnection: ResolverTypeWrapper<ProtocolsMqttConnection>;
  ProtocolsMqttEdge: ResolverTypeWrapper<ProtocolsMqttEdge>;
  Query: ResolverTypeWrapper<{}>;
  REGION: Region;
  REGIONOperationFilterInput: RegionOperationFilterInput;
  RFSettings: ResolverTypeWrapper<RfSettings>;
  RFSettingsFilterInput: RfSettingsFilterInput;
  RFSettingsSortInput: RfSettingsSortInput;
  Region: ResolverTypeWrapper<Region>;
  RegionFilterInput: RegionFilterInput;
  RegionSortInput: RegionSortInput;
  RegionsConnection: ResolverTypeWrapper<RegionsConnection>;
  RegionsEdge: ResolverTypeWrapper<RegionsEdge>;
  ReportDTO: ResolverTypeWrapper<ReportDto>;
  ReportDTOFilterInput: ReportDtoFilterInput;
  ReportDTOSortInput: ReportDtoSortInput;
  ReportsConnection: ResolverTypeWrapper<ReportsConnection>;
  ReportsEdge: ResolverTypeWrapper<ReportsEdge>;
  Role: ResolverTypeWrapper<Role>;
  RoleComposite: ResolverTypeWrapper<RoleComposite>;
  RoleCompositeFilterInput: RoleCompositeFilterInput;
  RoleConnection: ResolverTypeWrapper<RoleConnection>;
  RoleEdge: ResolverTypeWrapper<RoleEdge>;
  RoleFilterInput: RoleFilterInput;
  RoleGraphQl: ResolverTypeWrapper<RoleGraphQl>;
  RoleGraphQlFilterInput: RoleGraphQlFilterInput;
  RoleGraphQlSortInput: RoleGraphQlSortInput;
  RoleSortInput: RoleSortInput;
  SERVER_TYPE: Server_Type;
  SIM_STATUS_TYPE: Sim_Status_Type;
  SIM_STATUS_TYPEOperationFilterInput: Sim_Status_TypeOperationFilterInput;
  SLOT_TYPE: Slot_Type;
  SLOT_TYPEOperationFilterInput: Slot_TypeOperationFilterInput;
  SOURCE: Source;
  SOURCEOperationFilterInput: SourceOperationFilterInput;
  STATUS: Status;
  STATUSOperationFilterInput: StatusOperationFilterInput;
  SUBSTATION_TYPE: Substation_Type;
  ScheduleOperationMode: ResolverTypeWrapper<ScheduleOperationMode>;
  ScheduleOperationModeConnection: ResolverTypeWrapper<ScheduleOperationModeConnection>;
  ScheduleOperationModeEdge: ResolverTypeWrapper<ScheduleOperationModeEdge>;
  ScheduleOperationModeFilterInput: ScheduleOperationModeFilterInput;
  ScheduleOperationModeSortInput: ScheduleOperationModeSortInput;
  Section: ResolverTypeWrapper<Section>;
  SectionFilterInput: SectionFilterInput;
  SectionSortInput: SectionSortInput;
  SimCard: ResolverTypeWrapper<SimCard>;
  SimCardFilterInput: SimCardFilterInput;
  SimCardSortInput: SimCardSortInput;
  SimCardsConnection: ResolverTypeWrapper<SimCardsConnection>;
  SimCardsEdge: ResolverTypeWrapper<SimCardsEdge>;
  SortEnumType: SortEnumType;
  StringOperationFilterInput: StringOperationFilterInput;
  Subscription: ResolverTypeWrapper<{}>;
  SubscriptionFilterInput: SubscriptionFilterInput;
  SubscriptionSortInput: SubscriptionSortInput;
  SubscriptionsConnection: ResolverTypeWrapper<SubscriptionsConnection>;
  SubscriptionsEdge: ResolverTypeWrapper<SubscriptionsEdge>;
  TEMPLATE_MESSAGE_TYPE: Template_Message_Type;
  TEMPLATE_MESSAGE_TYPEOperationFilterInput: Template_Message_TypeOperationFilterInput;
  TIME_SERVER_TYPE: Time_Server_Type;
  TIME_SERVER_TYPEOperationFilterInput: Time_Server_TypeOperationFilterInput;
  TRANSFORMER_TYPE: Transformer_Type;
  TRANSFORMER_TYPEOperationFilterInput: Transformer_TypeOperationFilterInput;
  Template: ResolverTypeWrapper<Template>;
  TemplateConfig: ResolverTypeWrapper<TemplateConfig>;
  TemplateConfigFilterInput: TemplateConfigFilterInput;
  TemplateConfigSortInput: TemplateConfigSortInput;
  TemplateFilterInput: TemplateFilterInput;
  TemplateSortInput: TemplateSortInput;
  TemplatesConfigConnection: ResolverTypeWrapper<TemplatesConfigConnection>;
  TemplatesConfigEdge: ResolverTypeWrapper<TemplatesConfigEdge>;
  TemplatesConnection: ResolverTypeWrapper<TemplatesConnection>;
  TemplatesEdge: ResolverTypeWrapper<TemplatesEdge>;
  TokenType: TokenType;
  TokenTypeOperationFilterInput: TokenTypeOperationFilterInput;
  TransferEncoding: TransferEncoding;
  TransferEncodingOperationFilterInput: TransferEncodingOperationFilterInput;
  UUID: ResolverTypeWrapper<Scalars['UUID']['output']>;
  User: ResolverTypeWrapper<User>;
  UserAccess: ResolverTypeWrapper<UserAccess>;
  UserAccessFilterInput: UserAccessFilterInput;
  UserAccessSortInput: UserAccessSortInput;
  UserConnection: ResolverTypeWrapper<UserConnection>;
  UserConsent: ResolverTypeWrapper<UserConsent>;
  UserConsentFilterInput: UserConsentFilterInput;
  UserEdge: ResolverTypeWrapper<UserEdge>;
  UserFilterInput: UserFilterInput;
  UserGraphQl: ResolverTypeWrapper<UserGraphQl>;
  UserGraphQlFilterInput: UserGraphQlFilterInput;
  UserGraphQlSortInput: UserGraphQlSortInput;
  UserLogAction: ResolverTypeWrapper<UserLogAction>;
  UserLogActionConnection: ResolverTypeWrapper<UserLogActionConnection>;
  UserLogActionEdge: ResolverTypeWrapper<UserLogActionEdge>;
  UserLogActionFilterInput: UserLogActionFilterInput;
  UserLogActionSortInput: UserLogActionSortInput;
  UuidOperationFilterInput: UuidOperationFilterInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ACTION_METHODOperationFilterInput: Action_MethodOperationFilterInput;
  ACTION_PROTOOperationFilterInput: Action_ProtoOperationFilterInput;
  ACTION_TYPEOperationFilterInput: Action_TypeOperationFilterInput;
  ALARM_GROUP_NAMEOperationFilterInput: Alarm_Group_NameOperationFilterInput;
  ALARM_TYPEOperationFilterInput: Alarm_TypeOperationFilterInput;
  APN_AUTH_TYPEOperationFilterInput: Apn_Auth_TypeOperationFilterInput;
  ASSET_STATEOperationFilterInput: Asset_StateOperationFilterInput;
  ASSET_TYPEOperationFilterInput: Asset_TypeOperationFilterInput;
  AccessGroup: AccessGroup;
  String: Scalars['String']['output'];
  Boolean: Scalars['Boolean']['output'];
  AccessGroupFilterInput: AccessGroupFilterInput;
  AccessGroupSortInput: AccessGroupSortInput;
  AccessGroupToAsset: AccessGroupToAsset;
  AccessGroupToCompany: AccessGroupToCompany;
  AccessGroupToOperationalArea: AccessGroupToOperationalArea;
  AccessGroupToRegion: AccessGroupToRegion;
  AccessGroupToUser: AccessGroupToUser;
  AccessGroupToWorkingOperationalArea: AccessGroupToWorkingOperationalArea;
  AccessGroupsConnection: AccessGroupsConnection;
  Int: Scalars['Int']['output'];
  AccessGroupsEdge: AccessGroupsEdge;
  Action: Action;
  ActionConnection: ActionConnection;
  ActionEdge: ActionEdge;
  ActionFilterInput: ActionFilterInput;
  ActionLoggingTypeOperationFilterInput: ActionLoggingTypeOperationFilterInput;
  ActionSortInput: ActionSortInput;
  ActionTypeOperationFilterInput: ActionTypeOperationFilterInput;
  AlarmStandard: AlarmStandard;
  AlarmStandardDefinition: AlarmStandardDefinition;
  AlarmStandardDefinitionFilterInput: AlarmStandardDefinitionFilterInput;
  AlarmStandardDefinitionSortInput: AlarmStandardDefinitionSortInput;
  AlarmStandardDefinitionsConnection: AlarmStandardDefinitionsConnection;
  AlarmStandardDefinitionsEdge: AlarmStandardDefinitionsEdge;
  AlarmStandardFilterInput: AlarmStandardFilterInput;
  AlarmStandardSortInput: AlarmStandardSortInput;
  AlarmStandardVariableAggregation: AlarmStandardVariableAggregation;
  AlarmStandardVariableAggregationByAlarm: AlarmStandardVariableAggregationByAlarm;
  AlarmStandardVariableAggregationByAlarmFilterInput: AlarmStandardVariableAggregationByAlarmFilterInput;
  AlarmStandardVariableAggregationByAlarmInput: AlarmStandardVariableAggregationByAlarmInput;
  AlarmStandardVariableAggregationFilterInput: AlarmStandardVariableAggregationFilterInput;
  AlarmStandardVariableAggregationInput: AlarmStandardVariableAggregationInput;
  AlarmStandardVariableDefinition: AlarmStandardVariableDefinition;
  AlarmStandardVariableDefinitionFilterInput: AlarmStandardVariableDefinitionFilterInput;
  AlarmStandardVariableDefinitionSortInput: AlarmStandardVariableDefinitionSortInput;
  AlarmStandardVariableDefinitionsConnection: AlarmStandardVariableDefinitionsConnection;
  AlarmStandardVariableDefinitionsEdge: AlarmStandardVariableDefinitionsEdge;
  AlarmStandardsConnection: AlarmStandardsConnection;
  AlarmStandardsEdge: AlarmStandardsEdge;
  AlarmType: AlarmType;
  AlarmTypeFilterInput: AlarmTypeFilterInput;
  AlarmTypeSortInput: AlarmTypeSortInput;
  AlarmTypesConnection: AlarmTypesConnection;
  AlarmTypesEdge: AlarmTypesEdge;
  AlarmVariable: AlarmVariable;
  AlarmVariableAggregation: AlarmVariableAggregation;
  AlarmVariableAggregationFilterInput: AlarmVariableAggregationFilterInput;
  AlarmVariableFilterInput: AlarmVariableFilterInput;
  AlarmVariableSortInput: AlarmVariableSortInput;
  AlarmVariablesConnection: AlarmVariablesConnection;
  AlarmVariablesEdge: AlarmVariablesEdge;
  Application: Application;
  ApplicationFilterInput: ApplicationFilterInput;
  Asset: Asset;
  Float: Scalars['Float']['output'];
  AssetBulkConfigurationsConnection: AssetBulkConfigurationsConnection;
  AssetBulkConfigurationsEdge: AssetBulkConfigurationsEdge;
  AssetFilterInput: AssetFilterInput;
  AssetSortInput: AssetSortInput;
  AssetsConnection: AssetsConnection;
  AssetsEdge: AssetsEdge;
  Authorization: Authorization;
  AuthorizationAccessGroup: AuthorizationAccessGroup;
  AuthorizationConnection: AuthorizationConnection;
  AuthorizationDevice: AuthorizationDevice;
  AuthorizationEdge: AuthorizationEdge;
  AuthorizationFilterInput: AuthorizationFilterInput;
  AuthorizationSortInput: AuthorizationSortInput;
  AuthorizationToken: AuthorizationToken;
  AuthorizationTokenFilterInput: AuthorizationTokenFilterInput;
  BatchDevice: BatchDevice;
  BatchDeviceFilterInput: BatchDeviceFilterInput;
  BatchDeviceSortInput: BatchDeviceSortInput;
  BatchDevicesConnection: BatchDevicesConnection;
  BatchDevicesEdge: BatchDevicesEdge;
  BatchInclude: BatchInclude;
  BatchIncludeFilterInput: BatchIncludeFilterInput;
  BatchIncludeSortInput: BatchIncludeSortInput;
  BatchIncludesConnection: BatchIncludesConnection;
  BatchIncludesEdge: BatchIncludesEdge;
  BatchSim: BatchSim;
  BatchSimFilterInput: BatchSimFilterInput;
  BatchSimSortInput: BatchSimSortInput;
  BatchSimsConnection: BatchSimsConnection;
  BatchSimsEdge: BatchSimsEdge;
  BooleanOperationFilterInput: BooleanOperationFilterInput;
  Byte: Scalars['Byte']['output'];
  ByteOperationFilterInput: ByteOperationFilterInput;
  CONSTRAINT_TYPEOperationFilterInput: Constraint_TypeOperationFilterInput;
  CON_TEST_RESULT_TYPEOperationFilterInput: Con_Test_Result_TypeOperationFilterInput;
  CableType: CableType;
  CableTypeFilterInput: CableTypeFilterInput;
  CableTypeSortInput: CableTypeSortInput;
  CableTypesConnection: CableTypesConnection;
  CableTypesEdge: CableTypesEdge;
  Company: Company;
  CompanyFilterInput: CompanyFilterInput;
  CompanySortInput: CompanySortInput;
  CompanysConnection: CompanysConnection;
  CompanysEdge: CompanysEdge;
  ConTest: ConTest;
  ConTestDeviceResult: ConTestDeviceResult;
  ConTestDeviceResultFilterInput: ConTestDeviceResultFilterInput;
  ConTestDeviceResultSortInput: ConTestDeviceResultSortInput;
  ConTestDeviceResultsConnection: ConTestDeviceResultsConnection;
  ConTestDeviceResultsEdge: ConTestDeviceResultsEdge;
  ConTestExtended: ConTestExtended;
  ConTestExtendedFilterInput: ConTestExtendedFilterInput;
  ConTestExtendedSortInput: ConTestExtendedSortInput;
  ConTestFilterInput: ConTestFilterInput;
  ConTestSortInput: ConTestSortInput;
  ConTestsConnection: ConTestsConnection;
  ConTestsEdge: ConTestsEdge;
  ConTestsExtendedConnection: ConTestsExtendedConnection;
  ConTestsExtendedEdge: ConTestsExtendedEdge;
  Contact: Contact;
  ContactFilterInput: ContactFilterInput;
  ContactSortInput: ContactSortInput;
  ContactsConnection: ContactsConnection;
  ContactsEdge: ContactsEdge;
  Credentials: Credentials;
  CredentialsFilterInput: CredentialsFilterInput;
  CurrentHarmonics: CurrentHarmonics;
  CurrentHarmonicsConnection: CurrentHarmonicsConnection;
  CurrentHarmonicsEdge: CurrentHarmonicsEdge;
  CurrentHarmonicsFilterInput: CurrentHarmonicsFilterInput;
  CurrentHarmonicsSortInput: CurrentHarmonicsSortInput;
  CustomProperties: CustomProperties;
  CustomPropertiesConnection: CustomPropertiesConnection;
  CustomPropertiesEdge: CustomPropertiesEdge;
  CustomPropertiesFilterInput: CustomPropertiesFilterInput;
  CustomPropertiesSortInput: CustomPropertiesSortInput;
  DATA_TYPEOperationFilterInput: Data_TypeOperationFilterInput;
  DEVICE_TYPEOperationFilterInput: Device_TypeOperationFilterInput;
  DURATION_TYPEOperationFilterInput: Duration_TypeOperationFilterInput;
  DateTime: Scalars['DateTime']['output'];
  DateTimeOperationFilterInput: DateTimeOperationFilterInput;
  Device: Device;
  DeviceBulkConfiguration: DeviceBulkConfiguration;
  DeviceBulkConfigurationFilterInput: DeviceBulkConfigurationFilterInput;
  DeviceBulkConfigurationSortInput: DeviceBulkConfigurationSortInput;
  DeviceBulkConfigurationsConnection: DeviceBulkConfigurationsConnection;
  DeviceBulkConfigurationsEdge: DeviceBulkConfigurationsEdge;
  DeviceFilterInput: DeviceFilterInput;
  DeviceInputNumberFilterInput: DeviceInputNumberFilterInput;
  DeviceInputNumberSortInput: DeviceInputNumberSortInput;
  DeviceInputNumbersConnection: DeviceInputNumbersConnection;
  DeviceInputNumbersEdge: DeviceInputNumbersEdge;
  DeviceLog: DeviceLog;
  DeviceLogConnection: DeviceLogConnection;
  DeviceLogEdge: DeviceLogEdge;
  DeviceLogFilterInput: DeviceLogFilterInput;
  DeviceLogSortInput: DeviceLogSortInput;
  DeviceLogsConnection: DeviceLogsConnection;
  DeviceLogsEdge: DeviceLogsEdge;
  DeviceMessage: DeviceMessage;
  DeviceMessageFilterInput: DeviceMessageFilterInput;
  DeviceMessageSortInput: DeviceMessageSortInput;
  DeviceMessagesConnection: DeviceMessagesConnection;
  DeviceMessagesEdge: DeviceMessagesEdge;
  DeviceSortInput: DeviceSortInput;
  DeviceTag: DeviceTag;
  DeviceTagFilterInput: DeviceTagFilterInput;
  DeviceTypeConfiguration: DeviceTypeConfiguration;
  DeviceTypeConfigurationFilterInput: DeviceTypeConfigurationFilterInput;
  DeviceTypeConfigurationSortInput: DeviceTypeConfigurationSortInput;
  DeviceTypeConfigurationsConnection: DeviceTypeConfigurationsConnection;
  DeviceTypeConfigurationsEdge: DeviceTypeConfigurationsEdge;
  DevicesAccessGroup: DevicesAccessGroup;
  DevicesAlarmStandard: DevicesAlarmStandard;
  DevicesCompany: DevicesCompany;
  DevicesConnection: DevicesConnection;
  DevicesEdge: DevicesEdge;
  DevicesFirmwareDocument: DevicesFirmwareDocument;
  DevicesFirmwareDocumentsConnection: DevicesFirmwareDocumentsConnection;
  DevicesFirmwareDocumentsEdge: DevicesFirmwareDocumentsEdge;
  DevicesOperationalArea: DevicesOperationalArea;
  DevicesRegion: DevicesRegion;
  ENTITY_TYPEOperationFilterInput: Entity_TypeOperationFilterInput;
  EQUIPMENT_TYPEOperationFilterInput: Equipment_TypeOperationFilterInput;
  Email: Email;
  EmailAttachment: EmailAttachment;
  EmailAttachmentFilterInput: EmailAttachmentFilterInput;
  EmailAttachmentSortInput: EmailAttachmentSortInput;
  EmailAttachmentsConnection: EmailAttachmentsConnection;
  EmailAttachmentsEdge: EmailAttachmentsEdge;
  EmailFilterInput: EmailFilterInput;
  EmailSettings: EmailSettings;
  EmailSettingsFilterInput: EmailSettingsFilterInput;
  EmailSettingsSortInput: EmailSettingsSortInput;
  EmailSortInput: EmailSortInput;
  EmailStatus: EmailStatus;
  EmailStatusConnection: EmailStatusConnection;
  EmailStatusEdge: EmailStatusEdge;
  EmailStatusFilterInput: EmailStatusFilterInput;
  EmailStatusSortInput: EmailStatusSortInput;
  EmailsConnection: EmailsConnection;
  EmailsEdge: EmailsEdge;
  EnergyBalance: EnergyBalance;
  EnergyBalanceConnection: EnergyBalanceConnection;
  EnergyBalanceEdge: EnergyBalanceEdge;
  EnergyBalanceFilterInput: EnergyBalanceFilterInput;
  EnergyBalanceSortInput: EnergyBalanceSortInput;
  Enterprise: Enterprise;
  EnterpriseFilterInput: EnterpriseFilterInput;
  EnterpriseSortInput: EnterpriseSortInput;
  EnterprisesConnection: EnterprisesConnection;
  EnterprisesEdge: EnterprisesEdge;
  EquipBulkConfigurationFilterInput: EquipBulkConfigurationFilterInput;
  EquipBulkConfigurationSortInput: EquipBulkConfigurationSortInput;
  Equipment: Equipment;
  EquipmentFilterInput: EquipmentFilterInput;
  EquipmentSortInput: EquipmentSortInput;
  EquipmentsAlarmStandard: EquipmentsAlarmStandard;
  EquipmentsBulkConfiguration: EquipmentsBulkConfiguration;
  EquipmentsConnection: EquipmentsConnection;
  EquipmentsDevice: EquipmentsDevice;
  EquipmentsDeviceInputNumber: EquipmentsDeviceInputNumber;
  EquipmentsDeviceLog: EquipmentsDeviceLog;
  EquipmentsDevicesConnection: EquipmentsDevicesConnection;
  EquipmentsDevicesEdge: EquipmentsDevicesEdge;
  EquipmentsEdge: EquipmentsEdge;
  EquipmentsOperationalArea: EquipmentsOperationalArea;
  EquipmentsRegion: EquipmentsRegion;
  Event: Event;
  EventData: EventData;
  EventDataConnection: EventDataConnection;
  EventDataEdge: EventDataEdge;
  EventDataFilterInput: EventDataFilterInput;
  EventDataSortInput: EventDataSortInput;
  EventEntityTypeOperationFilterInput: EventEntityTypeOperationFilterInput;
  EventFilterInput: EventFilterInput;
  EventSeverityOperationFilterInput: EventSeverityOperationFilterInput;
  EventSortInput: EventSortInput;
  EventStatusOperationFilterInput: EventStatusOperationFilterInput;
  EventTypeOperationFilterInput: EventTypeOperationFilterInput;
  EventsConnection: EventsConnection;
  EventsEdge: EventsEdge;
  ExpirationTypeOperationFilterInput: ExpirationTypeOperationFilterInput;
  FEEDER_TYPEOperationFilterInput: Feeder_TypeOperationFilterInput;
  FIRMWARE_TASK_STATUSOperationFilterInput: Firmware_Task_StatusOperationFilterInput;
  FederatedIdentity: FederatedIdentity;
  FederatedIdentityFilterInput: FederatedIdentityFilterInput;
  Feeder: Feeder;
  FeederFilterInput: FeederFilterInput;
  FeederSortInput: FeederSortInput;
  FeedersConnection: FeedersConnection;
  FeedersEdge: FeedersEdge;
  Filter: Filter;
  FilterFilterInput: FilterFilterInput;
  Firmware: Firmware;
  FirmwareDocumentFilterInput: FirmwareDocumentFilterInput;
  FirmwareDocumentSortInput: FirmwareDocumentSortInput;
  FirmwareFilterInput: FirmwareFilterInput;
  FirmwareSortInput: FirmwareSortInput;
  FirmwareTask: FirmwareTask;
  FirmwareTaskFilterInput: FirmwareTaskFilterInput;
  FirmwareTaskLog: FirmwareTaskLog;
  FirmwareTaskLogConnection: FirmwareTaskLogConnection;
  FirmwareTaskLogEdge: FirmwareTaskLogEdge;
  FirmwareTaskLogFilterInput: FirmwareTaskLogFilterInput;
  FirmwareTaskLogSortInput: FirmwareTaskLogSortInput;
  FirmwareTaskSortInput: FirmwareTaskSortInput;
  FirmwareTasksConnection: FirmwareTasksConnection;
  FirmwareTasksEdge: FirmwareTasksEdge;
  FirmwaresConnection: FirmwaresConnection;
  FirmwaresEdge: FirmwaresEdge;
  FloatOperationFilterInput: FloatOperationFilterInput;
  GeneralSettings: GeneralSettings;
  GpsPoint: GpsPoint;
  GpsPointFilterInput: GpsPointFilterInput;
  GpsPointSortInput: GpsPointSortInput;
  GpsPointsConnection: GpsPointsConnection;
  GpsPointsEdge: GpsPointsEdge;
  INPUT_TYPEOperationFilterInput: Input_TypeOperationFilterInput;
  INTERFACE_TYPEOperationFilterInput: Interface_TypeOperationFilterInput;
  Input: Input;
  InputFilterInput: InputFilterInput;
  InputSortInput: InputSortInput;
  InputsConnection: InputsConnection;
  InputsEdge: InputsEdge;
  IntOperationFilterInput: IntOperationFilterInput;
  Interface: Interface;
  InterfaceBluetooth: InterfaceBluetooth;
  InterfaceBluetoothFilterInput: InterfaceBluetoothFilterInput;
  InterfaceBluetoothSortInput: InterfaceBluetoothSortInput;
  InterfaceEthernet: InterfaceEthernet;
  InterfaceEthernetFilterInput: InterfaceEthernetFilterInput;
  InterfaceEthernetSortInput: InterfaceEthernetSortInput;
  InterfaceFilterInput: InterfaceFilterInput;
  InterfaceGprs: InterfaceGprs;
  InterfaceGprsFilterInput: InterfaceGprsFilterInput;
  InterfaceGprsSortInput: InterfaceGprsSortInput;
  InterfaceLoRa: InterfaceLoRa;
  InterfaceLoRaFilterInput: InterfaceLoRaFilterInput;
  InterfaceLoRaSortInput: InterfaceLoRaSortInput;
  InterfaceSortInput: InterfaceSortInput;
  InterfacesBluetoothConnection: InterfacesBluetoothConnection;
  InterfacesBluetoothEdge: InterfacesBluetoothEdge;
  InterfacesEthernetConnection: InterfacesEthernetConnection;
  InterfacesEthernetEdge: InterfacesEthernetEdge;
  InterfacesGprsConnection: InterfacesGprsConnection;
  InterfacesGprsEdge: InterfacesGprsEdge;
  InterfacesLoRaConnection: InterfacesLoRaConnection;
  InterfacesLoRaEdge: InterfacesLoRaEdge;
  JOIN_OPERATOROperationFilterInput: Join_OperatorOperationFilterInput;
  KeyValuePairOfStringAndIEnumerableOfString: KeyValuePairOfStringAndIEnumerableOfString;
  KeyValuePairOfStringAndIEnumerableOfStringFilterInput: KeyValuePairOfStringAndIEnumerableOfStringFilterInput;
  KeyValuePairOfStringAndObject: KeyValuePairOfStringAndObject;
  KeyValuePairOfStringAndObjectFilterInput: KeyValuePairOfStringAndObjectFilterInput;
  KeyValuePairOfStringAndString: KeyValuePairOfStringAndString;
  KeyValuePairOfStringAndStringFilterInput: KeyValuePairOfStringAndStringFilterInput;
  KeycloakRole: KeycloakRole;
  KeycloakRoleConnection: KeycloakRoleConnection;
  KeycloakRoleEdge: KeycloakRoleEdge;
  KeycloakRoleFilterInput: KeycloakRoleFilterInput;
  KeycloakRoleSortInput: KeycloakRoleSortInput;
  KeycloakUser: KeycloakUser;
  KeycloakUserConnection: KeycloakUserConnection;
  KeycloakUserEdge: KeycloakUserEdge;
  KeycloakUserFilterInput: KeycloakUserFilterInput;
  KeycloakUserSortInput: KeycloakUserSortInput;
  LASTCONTACT_TYPEOperationFilterInput: Lastcontact_TypeOperationFilterInput;
  LINE_TYPEOperationFilterInput: Line_TypeOperationFilterInput;
  LastContactByType: LastContactByType;
  LastContactByTypeFilterInput: LastContactByTypeFilterInput;
  LastContactByTypeSortInput: LastContactByTypeSortInput;
  LastContactByTypesConnection: LastContactByTypesConnection;
  LastContactByTypesEdge: LastContactByTypesEdge;
  LayoutAsset: LayoutAsset;
  LayoutAssetsConnection: LayoutAssetsConnection;
  LayoutAssetsEdge: LayoutAssetsEdge;
  LayoutEquipment: LayoutEquipment;
  LayoutMessage: LayoutMessage;
  LayoutMessageFilterInput: LayoutMessageFilterInput;
  LayoutMessageSortInput: LayoutMessageSortInput;
  LayoutMessagesConnection: LayoutMessagesConnection;
  LayoutMessagesEdge: LayoutMessagesEdge;
  Line: Line;
  LineFilterInput: LineFilterInput;
  LineSortInput: LineSortInput;
  ListByteOperationFilterInput: ListByteOperationFilterInput;
  ListFilterInputTypeOfAccessGroupFilterInput: ListFilterInputTypeOfAccessGroupFilterInput;
  ListFilterInputTypeOfActionFilterInput: ListFilterInputTypeOfActionFilterInput;
  ListFilterInputTypeOfAlarmStandardDefinitionFilterInput: ListFilterInputTypeOfAlarmStandardDefinitionFilterInput;
  ListFilterInputTypeOfAlarmStandardVariableAggregationByAlarmFilterInput: ListFilterInputTypeOfAlarmStandardVariableAggregationByAlarmFilterInput;
  ListFilterInputTypeOfAlarmStandardVariableAggregationFilterInput: ListFilterInputTypeOfAlarmStandardVariableAggregationFilterInput;
  ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput: ListFilterInputTypeOfAlarmStandardVariableDefinitionFilterInput;
  ListFilterInputTypeOfAlarmVariableAggregationFilterInput: ListFilterInputTypeOfAlarmVariableAggregationFilterInput;
  ListFilterInputTypeOfAlarmVariableFilterInput: ListFilterInputTypeOfAlarmVariableFilterInput;
  ListFilterInputTypeOfAssetFilterInput: ListFilterInputTypeOfAssetFilterInput;
  ListFilterInputTypeOfAuthorizationFilterInput: ListFilterInputTypeOfAuthorizationFilterInput;
  ListFilterInputTypeOfAuthorizationTokenFilterInput: ListFilterInputTypeOfAuthorizationTokenFilterInput;
  ListFilterInputTypeOfBatchIncludeFilterInput: ListFilterInputTypeOfBatchIncludeFilterInput;
  ListFilterInputTypeOfCompanyFilterInput: ListFilterInputTypeOfCompanyFilterInput;
  ListFilterInputTypeOfConTestDeviceResultFilterInput: ListFilterInputTypeOfConTestDeviceResultFilterInput;
  ListFilterInputTypeOfConTestFilterInput: ListFilterInputTypeOfConTestFilterInput;
  ListFilterInputTypeOfContactFilterInput: ListFilterInputTypeOfContactFilterInput;
  ListFilterInputTypeOfCredentialsFilterInput: ListFilterInputTypeOfCredentialsFilterInput;
  ListFilterInputTypeOfCustomPropertiesFilterInput: ListFilterInputTypeOfCustomPropertiesFilterInput;
  ListFilterInputTypeOfDeviceBulkConfigurationFilterInput: ListFilterInputTypeOfDeviceBulkConfigurationFilterInput;
  ListFilterInputTypeOfDeviceFilterInput: ListFilterInputTypeOfDeviceFilterInput;
  ListFilterInputTypeOfDeviceInputNumberFilterInput: ListFilterInputTypeOfDeviceInputNumberFilterInput;
  ListFilterInputTypeOfDeviceTagFilterInput: ListFilterInputTypeOfDeviceTagFilterInput;
  ListFilterInputTypeOfDeviceTypeConfigurationFilterInput: ListFilterInputTypeOfDeviceTypeConfigurationFilterInput;
  ListFilterInputTypeOfEmailAttachmentFilterInput: ListFilterInputTypeOfEmailAttachmentFilterInput;
  ListFilterInputTypeOfEmailStatusFilterInput: ListFilterInputTypeOfEmailStatusFilterInput;
  ListFilterInputTypeOfEnterpriseFilterInput: ListFilterInputTypeOfEnterpriseFilterInput;
  ListFilterInputTypeOfEquipmentFilterInput: ListFilterInputTypeOfEquipmentFilterInput;
  ListFilterInputTypeOfEventDataFilterInput: ListFilterInputTypeOfEventDataFilterInput;
  ListFilterInputTypeOfFederatedIdentityFilterInput: ListFilterInputTypeOfFederatedIdentityFilterInput;
  ListFilterInputTypeOfFeederFilterInput: ListFilterInputTypeOfFeederFilterInput;
  ListFilterInputTypeOfFilterFilterInput: ListFilterInputTypeOfFilterFilterInput;
  ListFilterInputTypeOfFirmwareTaskFilterInput: ListFilterInputTypeOfFirmwareTaskFilterInput;
  ListFilterInputTypeOfFirmwareTaskLogFilterInput: ListFilterInputTypeOfFirmwareTaskLogFilterInput;
  ListFilterInputTypeOfGpsPointFilterInput: ListFilterInputTypeOfGpsPointFilterInput;
  ListFilterInputTypeOfInputFilterInput: ListFilterInputTypeOfInputFilterInput;
  ListFilterInputTypeOfInterfaceFilterInput: ListFilterInputTypeOfInterfaceFilterInput;
  ListFilterInputTypeOfKeyValuePairOfStringAndIEnumerableOfStringFilterInput: ListFilterInputTypeOfKeyValuePairOfStringAndIEnumerableOfStringFilterInput;
  ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput: ListFilterInputTypeOfKeyValuePairOfStringAndObjectFilterInput;
  ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput: ListFilterInputTypeOfKeyValuePairOfStringAndStringFilterInput;
  ListFilterInputTypeOfLastContactByTypeFilterInput: ListFilterInputTypeOfLastContactByTypeFilterInput;
  ListFilterInputTypeOfLineFilterInput: ListFilterInputTypeOfLineFilterInput;
  ListFilterInputTypeOfMenuFilterInput: ListFilterInputTypeOfMenuFilterInput;
  ListFilterInputTypeOfMenuRolesFilterInput: ListFilterInputTypeOfMenuRolesFilterInput;
  ListFilterInputTypeOfOperationalAreaFilterInput: ListFilterInputTypeOfOperationalAreaFilterInput;
  ListFilterInputTypeOfPortFilterInput: ListFilterInputTypeOfPortFilterInput;
  ListFilterInputTypeOfProtocolFilterInput: ListFilterInputTypeOfProtocolFilterInput;
  ListFilterInputTypeOfRegionFilterInput: ListFilterInputTypeOfRegionFilterInput;
  ListFilterInputTypeOfRoleFilterInput: ListFilterInputTypeOfRoleFilterInput;
  ListFilterInputTypeOfRoleGraphQlFilterInput: ListFilterInputTypeOfRoleGraphQlFilterInput;
  ListFilterInputTypeOfScheduleOperationModeFilterInput: ListFilterInputTypeOfScheduleOperationModeFilterInput;
  ListFilterInputTypeOfSimCardFilterInput: ListFilterInputTypeOfSimCardFilterInput;
  ListFilterInputTypeOfSubscriptionFilterInput: ListFilterInputTypeOfSubscriptionFilterInput;
  ListFilterInputTypeOfTemplateFilterInput: ListFilterInputTypeOfTemplateFilterInput;
  ListFilterInputTypeOfUserConsentFilterInput: ListFilterInputTypeOfUserConsentFilterInput;
  ListFilterInputTypeOfUserFilterInput: ListFilterInputTypeOfUserFilterInput;
  ListIntOperationFilterInput: ListIntOperationFilterInput;
  ListStringOperationFilterInput: ListStringOperationFilterInput;
  Long: Scalars['Long']['output'];
  LongOperationFilterInput: LongOperationFilterInput;
  MICRO_CONTROLLER_TYPEOperationFilterInput: Micro_Controller_TypeOperationFilterInput;
  Menu: Menu;
  MenuConnection: MenuConnection;
  MenuEdge: MenuEdge;
  MenuFilterInput: MenuFilterInput;
  MenuRoles: MenuRoles;
  MenuRolesActions: MenuRolesActions;
  MenuRolesActionsConnection: MenuRolesActionsConnection;
  MenuRolesActionsEdge: MenuRolesActionsEdge;
  MenuRolesActionsFilterInput: MenuRolesActionsFilterInput;
  MenuRolesActionsSortInput: MenuRolesActionsSortInput;
  MenuRolesConnection: MenuRolesConnection;
  MenuRolesEdge: MenuRolesEdge;
  MenuRolesFilterInput: MenuRolesFilterInput;
  MenuRolesSortInput: MenuRolesSortInput;
  MenuSortInput: MenuSortInput;
  MenuTypeOperationFilterInput: MenuTypeOperationFilterInput;
  ModemSettings: ModemSettings;
  ModemSettingsFilterInput: ModemSettingsFilterInput;
  ModemSettingsSortInput: ModemSettingsSortInput;
  NOTIFICATION_TYPEOperationFilterInput: Notification_TypeOperationFilterInput;
  NetworkPowerQuality: NetworkPowerQuality;
  NetworkPowerQualityConnection: NetworkPowerQualityConnection;
  NetworkPowerQualityEdge: NetworkPowerQualityEdge;
  NetworkPowerQualityFilterInput: NetworkPowerQualityFilterInput;
  NetworkPowerQualitySortInput: NetworkPowerQualitySortInput;
  NullableOfANCHOR_TYPEOperationFilterInput: NullableOfAnchor_TypeOperationFilterInput;
  NullableOfCONNECTION_TYPEOperationFilterInput: NullableOfConnection_TypeOperationFilterInput;
  NullableOfENCRYPTION_TYPEOperationFilterInput: NullableOfEncryption_TypeOperationFilterInput;
  NullableOfEventDataStatusOperationFilterInput: NullableOfEventDataStatusOperationFilterInput;
  NullableOfINPUT_TYPEOperationFilterInput: NullableOfInput_TypeOperationFilterInput;
  NullableOfINSTALLATION_TYPEOperationFilterInput: NullableOfInstallation_TypeOperationFilterInput;
  NullableOfMATERIAL_TYPEOperationFilterInput: NullableOfMaterial_TypeOperationFilterInput;
  NullableOfOF_MONTHOperationFilterInput: NullableOfOf_MonthOperationFilterInput;
  NullableOfON_THEOperationFilterInput: NullableOfOn_TheOperationFilterInput;
  NullableOfON_THE_ITEMOperationFilterInput: NullableOfOn_The_ItemOperationFilterInput;
  NullableOfSERVER_TYPEOperationFilterInput: NullableOfServer_TypeOperationFilterInput;
  NullableOfSUBSTATION_TYPEOperationFilterInput: NullableOfSubstation_TypeOperationFilterInput;
  OperationalArea: OperationalArea;
  OperationalAreaFilterInput: OperationalAreaFilterInput;
  OperationalAreaSortInput: OperationalAreaSortInput;
  OperationalAreasConnection: OperationalAreasConnection;
  OperationalAreasEdge: OperationalAreasEdge;
  PHASE_ROTATIONOperationFilterInput: Phase_RotationOperationFilterInput;
  PHASE_TYPEOperationFilterInput: Phase_TypeOperationFilterInput;
  PORT_TYPEOperationFilterInput: Port_TypeOperationFilterInput;
  PROTOCOL_TYPEOperationFilterInput: Protocol_TypeOperationFilterInput;
  PacketConfiguration: PacketConfiguration;
  PacketConfigurationFilterInput: PacketConfigurationFilterInput;
  PacketConfigurationSortInput: PacketConfigurationSortInput;
  PageInfo: PageInfo;
  PlatformSettings: PlatformSettings;
  PlatformSettingsConnection: PlatformSettingsConnection;
  PlatformSettingsEdge: PlatformSettingsEdge;
  PlatformSettingsFilterInput: PlatformSettingsFilterInput;
  PlatformSettingsSortInput: PlatformSettingsSortInput;
  Port: Port;
  PortFilterInput: PortFilterInput;
  PortSortInput: PortSortInput;
  PortsConnection: PortsConnection;
  PortsEdge: PortsEdge;
  PowerBusLinesConnection: PowerBusLinesConnection;
  PowerBusLinesEdge: PowerBusLinesEdge;
  Protocol: Protocol;
  ProtocolBluetooth: ProtocolBluetooth;
  ProtocolBluetoothFilterInput: ProtocolBluetoothFilterInput;
  ProtocolBluetoothSortInput: ProtocolBluetoothSortInput;
  ProtocolDNP3: ProtocolDnp3;
  ProtocolDNP3FilterInput: ProtocolDnp3FilterInput;
  ProtocolDNP3SortInput: ProtocolDnp3SortInput;
  ProtocolEneidaLoRa: ProtocolEneidaLoRa;
  ProtocolEneidaLoRaFilterInput: ProtocolEneidaLoRaFilterInput;
  ProtocolEneidaLoRaSortInput: ProtocolEneidaLoRaSortInput;
  ProtocolFilterInput: ProtocolFilterInput;
  ProtocolHTTP: ProtocolHttp;
  ProtocolHTTPFilterInput: ProtocolHttpFilterInput;
  ProtocolHTTPSortInput: ProtocolHttpSortInput;
  ProtocolMqtt: ProtocolMqtt;
  ProtocolMqttFilterInput: ProtocolMqttFilterInput;
  ProtocolMqttSortInput: ProtocolMqttSortInput;
  ProtocolsBluetoothConnection: ProtocolsBluetoothConnection;
  ProtocolsBluetoothEdge: ProtocolsBluetoothEdge;
  ProtocolsDNP3Connection: ProtocolsDnp3Connection;
  ProtocolsDNP3Edge: ProtocolsDnp3Edge;
  ProtocolsEneidaLoRaConnection: ProtocolsEneidaLoRaConnection;
  ProtocolsEneidaLoRaEdge: ProtocolsEneidaLoRaEdge;
  ProtocolsHTTPConnection: ProtocolsHttpConnection;
  ProtocolsHTTPEdge: ProtocolsHttpEdge;
  ProtocolsMqttConnection: ProtocolsMqttConnection;
  ProtocolsMqttEdge: ProtocolsMqttEdge;
  Query: {};
  REGIONOperationFilterInput: RegionOperationFilterInput;
  RFSettings: RfSettings;
  RFSettingsFilterInput: RfSettingsFilterInput;
  RFSettingsSortInput: RfSettingsSortInput;
  Region: Region;
  RegionFilterInput: RegionFilterInput;
  RegionSortInput: RegionSortInput;
  RegionsConnection: RegionsConnection;
  RegionsEdge: RegionsEdge;
  ReportDTO: ReportDto;
  ReportDTOFilterInput: ReportDtoFilterInput;
  ReportDTOSortInput: ReportDtoSortInput;
  ReportsConnection: ReportsConnection;
  ReportsEdge: ReportsEdge;
  Role: Role;
  RoleComposite: RoleComposite;
  RoleCompositeFilterInput: RoleCompositeFilterInput;
  RoleConnection: RoleConnection;
  RoleEdge: RoleEdge;
  RoleFilterInput: RoleFilterInput;
  RoleGraphQl: RoleGraphQl;
  RoleGraphQlFilterInput: RoleGraphQlFilterInput;
  RoleGraphQlSortInput: RoleGraphQlSortInput;
  RoleSortInput: RoleSortInput;
  SIM_STATUS_TYPEOperationFilterInput: Sim_Status_TypeOperationFilterInput;
  SLOT_TYPEOperationFilterInput: Slot_TypeOperationFilterInput;
  SOURCEOperationFilterInput: SourceOperationFilterInput;
  STATUSOperationFilterInput: StatusOperationFilterInput;
  ScheduleOperationMode: ScheduleOperationMode;
  ScheduleOperationModeConnection: ScheduleOperationModeConnection;
  ScheduleOperationModeEdge: ScheduleOperationModeEdge;
  ScheduleOperationModeFilterInput: ScheduleOperationModeFilterInput;
  ScheduleOperationModeSortInput: ScheduleOperationModeSortInput;
  Section: Section;
  SectionFilterInput: SectionFilterInput;
  SectionSortInput: SectionSortInput;
  SimCard: SimCard;
  SimCardFilterInput: SimCardFilterInput;
  SimCardSortInput: SimCardSortInput;
  SimCardsConnection: SimCardsConnection;
  SimCardsEdge: SimCardsEdge;
  StringOperationFilterInput: StringOperationFilterInput;
  Subscription: {};
  SubscriptionFilterInput: SubscriptionFilterInput;
  SubscriptionSortInput: SubscriptionSortInput;
  SubscriptionsConnection: SubscriptionsConnection;
  SubscriptionsEdge: SubscriptionsEdge;
  TEMPLATE_MESSAGE_TYPEOperationFilterInput: Template_Message_TypeOperationFilterInput;
  TIME_SERVER_TYPEOperationFilterInput: Time_Server_TypeOperationFilterInput;
  TRANSFORMER_TYPEOperationFilterInput: Transformer_TypeOperationFilterInput;
  Template: Template;
  TemplateConfig: TemplateConfig;
  TemplateConfigFilterInput: TemplateConfigFilterInput;
  TemplateConfigSortInput: TemplateConfigSortInput;
  TemplateFilterInput: TemplateFilterInput;
  TemplateSortInput: TemplateSortInput;
  TemplatesConfigConnection: TemplatesConfigConnection;
  TemplatesConfigEdge: TemplatesConfigEdge;
  TemplatesConnection: TemplatesConnection;
  TemplatesEdge: TemplatesEdge;
  TokenTypeOperationFilterInput: TokenTypeOperationFilterInput;
  TransferEncodingOperationFilterInput: TransferEncodingOperationFilterInput;
  UUID: Scalars['UUID']['output'];
  User: User;
  UserAccess: UserAccess;
  UserAccessFilterInput: UserAccessFilterInput;
  UserAccessSortInput: UserAccessSortInput;
  UserConnection: UserConnection;
  UserConsent: UserConsent;
  UserConsentFilterInput: UserConsentFilterInput;
  UserEdge: UserEdge;
  UserFilterInput: UserFilterInput;
  UserGraphQl: UserGraphQl;
  UserGraphQlFilterInput: UserGraphQlFilterInput;
  UserGraphQlSortInput: UserGraphQlSortInput;
  UserLogAction: UserLogAction;
  UserLogActionConnection: UserLogActionConnection;
  UserLogActionEdge: UserLogActionEdge;
  UserLogActionFilterInput: UserLogActionFilterInput;
  UserLogActionSortInput: UserLogActionSortInput;
  UuidOperationFilterInput: UuidOperationFilterInput;
};

export type AccessGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroup'] = ResolversParentTypes['AccessGroup']> = {
  assets?: Resolver<Array<ResolversTypes['LayoutEquipment']>, ParentType, ContextType>;
  companies?: Resolver<Array<ResolversTypes['Company']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enterprises?: Resolver<Array<ResolversTypes['Enterprise']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isProtected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  operationalAreas?: Resolver<Array<ResolversTypes['OperationalArea']>, ParentType, ContextType>;
  regions?: Resolver<Array<ResolversTypes['Region']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  workingOperationalAreas?: Resolver<Array<ResolversTypes['OperationalArea']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGroupToAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroupToAsset'] = ResolversParentTypes['AccessGroupToAsset']> = {
  accessGroup?: Resolver<ResolversTypes['AccessGroup'], ParentType, ContextType>;
  accessGroupId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  asset?: Resolver<ResolversTypes['LayoutEquipment'], ParentType, ContextType>;
  assetId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGroupToCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroupToCompany'] = ResolversParentTypes['AccessGroupToCompany']> = {
  accessGroup?: Resolver<ResolversTypes['AccessGroup'], ParentType, ContextType>;
  accessGroupId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGroupToOperationalAreaResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroupToOperationalArea'] = ResolversParentTypes['AccessGroupToOperationalArea']> = {
  accessGroup?: Resolver<ResolversTypes['AccessGroup'], ParentType, ContextType>;
  accessGroupId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  operationalArea?: Resolver<ResolversTypes['OperationalArea'], ParentType, ContextType>;
  operationalAreaId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGroupToRegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroupToRegion'] = ResolversParentTypes['AccessGroupToRegion']> = {
  accessGroup?: Resolver<ResolversTypes['AccessGroup'], ParentType, ContextType>;
  accessGroupId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['Region'], ParentType, ContextType>;
  regionId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGroupToUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroupToUser'] = ResolversParentTypes['AccessGroupToUser']> = {
  accessGroup?: Resolver<ResolversTypes['AccessGroup'], ParentType, ContextType>;
  accessGroupId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGroupToWorkingOperationalAreaResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroupToWorkingOperationalArea'] = ResolversParentTypes['AccessGroupToWorkingOperationalArea']> = {
  accessGroup?: Resolver<ResolversTypes['AccessGroup'], ParentType, ContextType>;
  accessGroupId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  operationalArea?: Resolver<ResolversTypes['OperationalArea'], ParentType, ContextType>;
  operationalAreaId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGroupsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroupsConnection'] = ResolversParentTypes['AccessGroupsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AccessGroupsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['AccessGroup']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGroupsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGroupsEdge'] = ResolversParentTypes['AccessGroupsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['AccessGroup']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Action'] = ResolversParentTypes['Action']> = {
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  menuRoles?: Resolver<Maybe<Array<ResolversTypes['MenuRoles']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ActionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionConnection'] = ResolversParentTypes['ActionConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ActionEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Action']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActionEdge'] = ResolversParentTypes['ActionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Action'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandard'] = ResolversParentTypes['AlarmStandard']> = {
  alarmStandardDefinitions?: Resolver<Array<ResolversTypes['AlarmStandardDefinition']>, ParentType, ContextType>;
  alarmStandardVariableDefinitions?: Resolver<Array<ResolversTypes['AlarmStandardVariableDefinition']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  editable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardDefinitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardDefinition'] = ResolversParentTypes['AlarmStandardDefinition']> = {
  alarmStandard?: Resolver<ResolversTypes['AlarmStandard'], ParentType, ContextType>;
  alarmStandardId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  alarmType?: Resolver<ResolversTypes['AlarmType'], ParentType, ContextType>;
  alarmTypeId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardDefinitionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardDefinitionsConnection'] = ResolversParentTypes['AlarmStandardDefinitionsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AlarmStandardDefinitionsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['AlarmStandardDefinition']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardDefinitionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardDefinitionsEdge'] = ResolversParentTypes['AlarmStandardDefinitionsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AlarmStandardDefinition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardVariableAggregationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardVariableAggregation'] = ResolversParentTypes['AlarmStandardVariableAggregation']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardVariableAggregationByAlarmResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardVariableAggregationByAlarm'] = ResolversParentTypes['AlarmStandardVariableAggregationByAlarm']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Array<ResolversTypes['AlarmStandardVariableAggregation']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardVariableDefinitionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardVariableDefinition'] = ResolversParentTypes['AlarmStandardVariableDefinition']> = {
  alarmStandard?: Resolver<ResolversTypes['AlarmStandard'], ParentType, ContextType>;
  alarmStandardId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  alarmVariable?: Resolver<ResolversTypes['AlarmVariable'], ParentType, ContextType>;
  alarmVariableId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isValidAlarmStandardVariableAggregationDefinition?: Resolver<Maybe<Array<ResolversTypes['KeyValuePairOfStringAndString']>>, ParentType, ContextType, RequireFields<AlarmStandardVariableDefinitionIsValidAlarmStandardVariableAggregationDefinitionArgs, 'lines'>>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  listAlarmsStandardAggregation?: Resolver<Maybe<Array<ResolversTypes['AlarmStandardVariableAggregationByAlarm']>>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardVariableDefinitionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardVariableDefinitionsConnection'] = ResolversParentTypes['AlarmStandardVariableDefinitionsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AlarmStandardVariableDefinitionsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['AlarmStandardVariableDefinition']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardVariableDefinitionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardVariableDefinitionsEdge'] = ResolversParentTypes['AlarmStandardVariableDefinitionsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AlarmStandardVariableDefinition'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardsConnection'] = ResolversParentTypes['AlarmStandardsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AlarmStandardsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['AlarmStandard']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmStandardsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmStandardsEdge'] = ResolversParentTypes['AlarmStandardsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AlarmStandard'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmType'] = ResolversParentTypes['AlarmType']> = {
  alarmStandardDefinitions?: Resolver<Array<ResolversTypes['AlarmStandardDefinition']>, ParentType, ContextType>;
  alarmVariables?: Resolver<Array<ResolversTypes['AlarmVariable']>, ParentType, ContextType>;
  defaultStatus?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  entityType?: Resolver<ResolversTypes['ENTITY_TYPE'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['SOURCE'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ALARM_TYPE'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmTypesConnection'] = ResolversParentTypes['AlarmTypesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AlarmTypesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['AlarmType']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmTypesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmTypesEdge'] = ResolversParentTypes['AlarmTypesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AlarmType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmVariableResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmVariable'] = ResolversParentTypes['AlarmVariable']> = {
  alarmStandardVariableDefinitions?: Resolver<Array<ResolversTypes['AlarmStandardVariableDefinition']>, ParentType, ContextType>;
  alarmType?: Resolver<ResolversTypes['AlarmType'], ParentType, ContextType>;
  alarmTypeId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  groupName?: Resolver<ResolversTypes['ALARM_GROUP_NAME'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  jsonConstrains?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  listAlarmsVariablesAggregation?: Resolver<Maybe<Array<ResolversTypes['AlarmVariableAggregation']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['REGION'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmVariableAggregationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmVariableAggregation'] = ResolversParentTypes['AlarmVariableAggregation']> = {
  defaultValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jsonConstraints?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmVariablesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmVariablesConnection'] = ResolversParentTypes['AlarmVariablesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AlarmVariablesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['AlarmVariable']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmVariablesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmVariablesEdge'] = ResolversParentTypes['AlarmVariablesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['AlarmVariable'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Application'] = ResolversParentTypes['Application']> = {
  authorizationTokens?: Resolver<Array<ResolversTypes['AuthorizationToken']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['Asset'] = ResolversParentTypes['Asset']> = {
  alarmStandard?: Resolver<Maybe<ResolversTypes['EquipmentsAlarmStandard']>, ParentType, ContextType>;
  alarmStandardId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  alarmStandardName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assetType?: Resolver<ResolversTypes['ASSET_TYPE'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  customProperties?: Resolver<Array<ResolversTypes['CustomProperties']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  devices?: Resolver<Array<ResolversTypes['EquipmentsDevice']>, ParentType, ContextType>;
  equipBulkConfiguration?: Resolver<Maybe<ResolversTypes['EquipmentsBulkConfiguration']>, ParentType, ContextType>;
  equipBulkConfigurationId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  equipBulkConfigurationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  equipments?: Resolver<Array<ResolversTypes['Equipment']>, ParentType, ContextType>;
  feeders?: Resolver<Array<ResolversTypes['Feeder']>, ParentType, ContextType>;
  hasAbscenceOfVoltage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasEarthData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasEvents?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasHvLineDown?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPhaseLoss?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasRawData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hvLineDownProperties?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  idv2?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastCommissioningDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  lines?: Resolver<Array<ResolversTypes['Line']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  operationalArea?: Resolver<Maybe<ResolversTypes['EquipmentsOperationalArea']>, ParentType, ContextType>;
  operationalAreaId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  operationalAreaV2Id?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  parentAssetId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  parentAssetName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentAssetV2Id?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  parentFeederId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  parentFeederName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentFeederV2Id?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['EquipmentsRegion']>, ParentType, ContextType>;
  regionId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  regionV2Id?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  registryNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sdsType?: Resolver<Maybe<ResolversTypes['SUBSTATION_TYPE']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['ASSET_STATE'], ParentType, ContextType>;
  transformerType?: Resolver<ResolversTypes['TRANSFORMER_TYPE'], ParentType, ContextType>;
  xGeometricPosition?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  yGeometricPosition?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssetBulkConfigurationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetBulkConfigurationsConnection'] = ResolversParentTypes['AssetBulkConfigurationsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AssetBulkConfigurationsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['EquipmentsBulkConfiguration']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssetBulkConfigurationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetBulkConfigurationsEdge'] = ResolversParentTypes['AssetBulkConfigurationsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EquipmentsBulkConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetsConnection'] = ResolversParentTypes['AssetsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AssetsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Asset']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssetsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetsEdge'] = ResolversParentTypes['AssetsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Asset'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Authorization'] = ResolversParentTypes['Authorization']> = {
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  method?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['Role']>>, ParentType, ContextType>;
  scope?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizationAccessGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizationAccessGroup'] = ResolversParentTypes['AuthorizationAccessGroup']> = {
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizationConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizationConnection'] = ResolversParentTypes['AuthorizationConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['AuthorizationEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Authorization']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizationDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizationDevice'] = ResolversParentTypes['AuthorizationDevice']> = {
  authorizationTokens?: Resolver<Array<ResolversTypes['AuthorizationToken']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  serialNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizationEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizationEdge'] = ResolversParentTypes['AuthorizationEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Authorization'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorizationTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthorizationToken'] = ResolversParentTypes['AuthorizationToken']> = {
  application?: Resolver<Maybe<ResolversTypes['Application']>, ParentType, ContextType>;
  applicationId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  devices?: Resolver<Array<ResolversTypes['AuthorizationDevice']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  expirationType?: Resolver<ResolversTypes['ExpirationType'], ParentType, ContextType>;
  guid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokenType?: Resolver<ResolversTypes['TokenType'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchDevice'] = ResolversParentTypes['BatchDevice']> = {
  batchIncludes?: Resolver<Array<ResolversTypes['BatchInclude']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  devices?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchDevicesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchDevicesConnection'] = ResolversParentTypes['BatchDevicesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['BatchDevicesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['BatchDevice']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchDevicesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchDevicesEdge'] = ResolversParentTypes['BatchDevicesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BatchDevice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchIncludeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchInclude'] = ResolversParentTypes['BatchInclude']> = {
  batchDevice?: Resolver<ResolversTypes['BatchDevice'], ParentType, ContextType>;
  batchDeviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  batchSim?: Resolver<ResolversTypes['BatchSim'], ParentType, ContextType>;
  batchSimId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  conTest?: Resolver<ResolversTypes['ConTest'], ParentType, ContextType>;
  conTestId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchIncludesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchIncludesConnection'] = ResolversParentTypes['BatchIncludesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['BatchIncludesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['BatchInclude']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchIncludesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchIncludesEdge'] = ResolversParentTypes['BatchIncludesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BatchInclude'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchSimResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchSim'] = ResolversParentTypes['BatchSim']> = {
  batchIncludes?: Resolver<Array<ResolversTypes['BatchInclude']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  simCards?: Resolver<Array<ResolversTypes['SimCard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchSimsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchSimsConnection'] = ResolversParentTypes['BatchSimsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['BatchSimsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['BatchSim']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BatchSimsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BatchSimsEdge'] = ResolversParentTypes['BatchSimsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BatchSim'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ByteScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Byte'], any> {
  name: 'Byte';
}

export type CableTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CableType'] = ResolversParentTypes['CableType']> = {
  color?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coreSection?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  cores?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fuseWay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CableTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CableTypesConnection'] = ResolversParentTypes['CableTypesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CableTypesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['CableType']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CableTypesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CableTypesEdge'] = ResolversParentTypes['CableTypesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CableType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Company'] = ResolversParentTypes['Company']> = {
  accessGroups?: Resolver<Array<ResolversTypes['AccessGroup']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enterprise?: Resolver<ResolversTypes['Enterprise'], ParentType, ContextType>;
  enterpriseId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  gpsPoints?: Resolver<Array<ResolversTypes['GpsPoint']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  regions?: Resolver<Array<ResolversTypes['Region']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanysConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanysConnection'] = ResolversParentTypes['CompanysConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CompanysEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Company']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CompanysEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CompanysEdge'] = ResolversParentTypes['CompanysEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTest'] = ResolversParentTypes['ConTest']> = {
  batchIncludes?: Resolver<Array<ResolversTypes['BatchInclude']>, ParentType, ContextType>;
  checkTimeOut?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conTestDeviceResults?: Resolver<Array<ResolversTypes['ConTestDeviceResult']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceBulkConfiguration?: Resolver<ResolversTypes['DeviceBulkConfiguration'], ParentType, ContextType>;
  deviceBulkConfigurationId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  hasConnectivity?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestDeviceResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTestDeviceResult'] = ResolversParentTypes['ConTestDeviceResult']> = {
  conTest?: Resolver<ResolversTypes['ConTest'], ParentType, ContextType>;
  conTestId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  externalResult?: Resolver<ResolversTypes['CON_TEST_RESULT_TYPE'], ParentType, ContextType>;
  externalResultTime?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  hasRawData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasStateField?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  result?: Resolver<ResolversTypes['CON_TEST_RESULT_TYPE'], ParentType, ContextType>;
  resultLog?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestDeviceResultsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTestDeviceResultsConnection'] = ResolversParentTypes['ConTestDeviceResultsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ConTestDeviceResultsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ConTestDeviceResult']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestDeviceResultsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTestDeviceResultsEdge'] = ResolversParentTypes['ConTestDeviceResultsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ConTestDeviceResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestExtendedResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTestExtended'] = ResolversParentTypes['ConTestExtended']> = {
  batchIncludes?: Resolver<Array<ResolversTypes['BatchInclude']>, ParentType, ContextType>;
  checkTimeOut?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conTestDeviceResults?: Resolver<Array<ResolversTypes['ConTestDeviceResult']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceBulkConfiguration?: Resolver<ResolversTypes['DeviceBulkConfiguration'], ParentType, ContextType>;
  deviceBulkConfigurationId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  hasConnectivity?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  remainingDevices?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  remainingSimCards?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  testedDevices?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTestsConnection'] = ResolversParentTypes['ConTestsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ConTestsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ConTest']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTestsEdge'] = ResolversParentTypes['ConTestsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ConTest'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestsExtendedConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTestsExtendedConnection'] = ResolversParentTypes['ConTestsExtendedConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ConTestsExtendedEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ConTestExtended']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ConTestsExtendedEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ConTestsExtendedEdge'] = ResolversParentTypes['ConTestsExtendedEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ConTestExtended'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contact'] = ResolversParentTypes['Contact']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptions?: Resolver<Maybe<Array<ResolversTypes['Subscription']>>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactsConnection'] = ResolversParentTypes['ContactsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ContactsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Contact']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContactsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContactsEdge'] = ResolversParentTypes['ContactsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Contact'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CredentialsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Credentials'] = ResolversParentTypes['Credentials']> = {
  algorithm?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  config?: Resolver<Maybe<Array<ResolversTypes['KeyValuePairOfStringAndString']>>, ParentType, ContextType>;
  counter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  digits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hashIterations?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hashSaltedValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  period?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  temporary?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentHarmonicsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentHarmonics'] = ResolversParentTypes['CurrentHarmonics']> = {
  aggregatedInterval?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  angles?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endTypeValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scheduleOperationModes?: Resolver<Array<ResolversTypes['ScheduleOperationMode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentHarmonicsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentHarmonicsConnection'] = ResolversParentTypes['CurrentHarmonicsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CurrentHarmonicsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['CurrentHarmonics']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrentHarmonicsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CurrentHarmonicsEdge'] = ResolversParentTypes['CurrentHarmonicsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CurrentHarmonics'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomPropertiesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomProperties'] = ResolversParentTypes['CustomProperties']> = {
  asset?: Resolver<ResolversTypes['Asset'], ParentType, ContextType>;
  assetId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  constraintType?: Resolver<ResolversTypes['CONSTRAINT_TYPE'], ParentType, ContextType>;
  dataType?: Resolver<ResolversTypes['DATA_TYPE'], ParentType, ContextType>;
  defaultValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  jsonConstraints?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomPropertiesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomPropertiesConnection'] = ResolversParentTypes['CustomPropertiesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['CustomPropertiesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['CustomProperties']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomPropertiesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomPropertiesEdge'] = ResolversParentTypes['CustomPropertiesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['CustomProperties'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Device'] = ResolversParentTypes['Device']> = {
  acquisitionRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  alarmLastConfigTs?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  alarmStandard?: Resolver<ResolversTypes['DevicesAlarmStandard'], ParentType, ContextType>;
  alarmStandardId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  alarmsConfig?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  assetName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  batchDevice?: Resolver<Maybe<ResolversTypes['BatchDevice']>, ParentType, ContextType>;
  batchDeviceId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  bulkConfiguration?: Resolver<Maybe<ResolversTypes['DeviceBulkConfiguration']>, ParentType, ContextType>;
  bulkConfigurationConfig?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bulkConfigurationId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comissionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  communicationRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conTestDeviceResults?: Resolver<Maybe<Array<ResolversTypes['ConTestDeviceResult']>>, ParentType, ContextType>;
  configRefreshInterval?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  decomissionDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceSlot?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  deviceSpecificConfig?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceTags?: Resolver<Array<ResolversTypes['DeviceTag']>, ParentType, ContextType>;
  deviceToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceType?: Resolver<ResolversTypes['DEVICE_TYPE'], ParentType, ContextType>;
  externalReference?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firmwareDeployDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firmwareTasks?: Resolver<Maybe<Array<ResolversTypes['FirmwareTask']>>, ParentType, ContextType>;
  firmwareTasksLogs?: Resolver<Array<ResolversTypes['FirmwareTaskLog']>, ParentType, ContextType>;
  firmwareVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  idv2?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  interfaces?: Resolver<Array<ResolversTypes['Interface']>, ParentType, ContextType>;
  isCommissioned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isDeleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastAddress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastCommunication?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastConfigTs?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastContacts?: Resolver<Array<ResolversTypes['LastContactByType']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  micros?: Resolver<Array<ResolversTypes['MICRO_CONTROLLER_TYPE']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ports?: Resolver<Array<ResolversTypes['Port']>, ParentType, ContextType>;
  serialNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  simCard?: Resolver<Maybe<ResolversTypes['SimCard']>, ParentType, ContextType>;
  simCardId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceBulkConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceBulkConfiguration'] = ResolversParentTypes['DeviceBulkConfiguration']> = {
  aquisitionRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  aquisitionRateEarth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bluetoothTimeout?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  communicationRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  communicationRateEarth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  conTests?: Resolver<Array<ResolversTypes['ConTest']>, ParentType, ContextType>;
  customDnsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  device?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType>;
  deviceTypeConfigurations?: Resolver<Array<ResolversTypes['DeviceTypeConfiguration']>, ParentType, ContextType>;
  dnsServerName1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dnsServerName2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailSettings?: Resolver<Maybe<ResolversTypes['EmailSettings']>, ParentType, ContextType>;
  httpCreateAlarm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  httpRawData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxSlots?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  mqttCertificateUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mqttCreateAlarm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mqttGroupId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mqttPassword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mqttRawData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mqttServerUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mqttUsername?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protectionEarthFrequencyF1?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  protectionEarthFrequencyF2?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  protectionEarthFrequencyF3?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  proxyEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  proxyPort?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  proxyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheduleOperationModes?: Resolver<Array<ResolversTypes['ScheduleOperationMode']>, ParentType, ContextType>;
  serverUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceEarthFrequencyF1?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  serviceEarthFrequencyF2?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  serviceEarthFrequencyF3?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  slotType?: Resolver<ResolversTypes['SLOT_TYPE'], ParentType, ContextType>;
  timeServerPort?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeServerProtocol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timeServerType?: Resolver<ResolversTypes['TIME_SERVER_TYPE'], ParentType, ContextType>;
  timeServerUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceBulkConfigurationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceBulkConfigurationsConnection'] = ResolversParentTypes['DeviceBulkConfigurationsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DeviceBulkConfigurationsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['DeviceBulkConfiguration']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceBulkConfigurationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceBulkConfigurationsEdge'] = ResolversParentTypes['DeviceBulkConfigurationsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DeviceBulkConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceInputNumbersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceInputNumbersConnection'] = ResolversParentTypes['DeviceInputNumbersConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DeviceInputNumbersEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['EquipmentsDeviceInputNumber']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceInputNumbersEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceInputNumbersEdge'] = ResolversParentTypes['DeviceInputNumbersEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EquipmentsDeviceInputNumber'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceLog'] = ResolversParentTypes['DeviceLog']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  host?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  method?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  requestDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  requestType?: Resolver<ResolversTypes['LASTCONTACT_TYPE'], ParentType, ContextType>;
  serialNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serverIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serverPort?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceLogConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceLogConnection'] = ResolversParentTypes['DeviceLogConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DeviceLogEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['DeviceLog']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceLogEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceLogEdge'] = ResolversParentTypes['DeviceLogEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DeviceLog'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceLogsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceLogsConnection'] = ResolversParentTypes['DeviceLogsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DeviceLogsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['EquipmentsDeviceLog']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceLogsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceLogsEdge'] = ResolversParentTypes['DeviceLogsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EquipmentsDeviceLog'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceMessage'] = ResolversParentTypes['DeviceMessage']> = {
  actionMethod?: Resolver<ResolversTypes['ACTION_METHOD'], ParentType, ContextType>;
  actionProto?: Resolver<ResolversTypes['ACTION_PROTO'], ParentType, ContextType>;
  actionType?: Resolver<ResolversTypes['ACTION_TYPE'], ParentType, ContextType>;
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  inputData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  resultData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceMessagesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceMessagesConnection'] = ResolversParentTypes['DeviceMessagesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DeviceMessagesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['DeviceMessage']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceMessagesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceMessagesEdge'] = ResolversParentTypes['DeviceMessagesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DeviceMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceTagResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceTag'] = ResolversParentTypes['DeviceTag']> = {
  devices?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType>;
  firmwareTasks?: Resolver<Array<ResolversTypes['FirmwareTask']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceTypeConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceTypeConfiguration'] = ResolversParentTypes['DeviceTypeConfiguration']> = {
  bulkConfigurationId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  deviceBulkConfiguration?: Resolver<ResolversTypes['DeviceBulkConfiguration'], ParentType, ContextType>;
  deviceType?: Resolver<ResolversTypes['DEVICE_TYPE'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceTypeConfigurationsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceTypeConfigurationsConnection'] = ResolversParentTypes['DeviceTypeConfigurationsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DeviceTypeConfigurationsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['DeviceTypeConfiguration']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceTypeConfigurationsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceTypeConfigurationsEdge'] = ResolversParentTypes['DeviceTypeConfigurationsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DeviceTypeConfiguration'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesAccessGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesAccessGroup'] = ResolversParentTypes['DevicesAccessGroup']> = {
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  firmwareTasks?: Resolver<Maybe<Array<ResolversTypes['FirmwareTask']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesAlarmStandardResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesAlarmStandard'] = ResolversParentTypes['DevicesAlarmStandard']> = {
  device?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesCompanyResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesCompany'] = ResolversParentTypes['DevicesCompany']> = {
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  firmwareTasks?: Resolver<Array<ResolversTypes['FirmwareTask']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesConnection'] = ResolversParentTypes['DevicesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DevicesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Device']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesEdge'] = ResolversParentTypes['DevicesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesFirmwareDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesFirmwareDocument'] = ResolversParentTypes['DevicesFirmwareDocument']> = {
  deviceType?: Resolver<ResolversTypes['DEVICE_TYPE'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  firmware?: Resolver<ResolversTypes['Firmware'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  microType?: Resolver<ResolversTypes['MICRO_CONTROLLER_TYPE'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesFirmwareDocumentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesFirmwareDocumentsConnection'] = ResolversParentTypes['DevicesFirmwareDocumentsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['DevicesFirmwareDocumentsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['DevicesFirmwareDocument']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesFirmwareDocumentsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesFirmwareDocumentsEdge'] = ResolversParentTypes['DevicesFirmwareDocumentsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['DevicesFirmwareDocument'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesOperationalAreaResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesOperationalArea'] = ResolversParentTypes['DevicesOperationalArea']> = {
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  firmwareTasks?: Resolver<Array<ResolversTypes['FirmwareTask']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DevicesRegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DevicesRegion'] = ResolversParentTypes['DevicesRegion']> = {
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  firmwareTasks?: Resolver<Array<ResolversTypes['FirmwareTask']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailResolvers<ContextType = any, ParentType extends ResolversParentTypes['Email'] = ResolversParentTypes['Email']> = {
  bcc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bccName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bodyEncoding?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bodyPlainText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bodyTransferEncoding?: Resolver<ResolversTypes['TransferEncoding'], ParentType, ContextType>;
  cc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ccName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deliverDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  emailAttachments?: Resolver<Maybe<Array<ResolversTypes['EmailAttachment']>>, ParentType, ContextType>;
  emailStatus?: Resolver<Maybe<Array<ResolversTypes['EmailStatus']>>, ParentType, ContextType>;
  errorMsg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  from?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fromName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headers?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headersEncoding?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isBodyHtml?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  messageSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  receptionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  replyToList?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  replyToListName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sender?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  senderName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subjectEncoding?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  to?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAttachment'] = ResolversParentTypes['EmailAttachment']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  documentManagerId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['Email']>, ParentType, ContextType>;
  emailId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  fileData?: Resolver<Maybe<Array<ResolversTypes['Byte']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailAttachmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAttachmentsConnection'] = ResolversParentTypes['EmailAttachmentsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EmailAttachmentsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['EmailAttachment']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailAttachmentsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailAttachmentsEdge'] = ResolversParentTypes['EmailAttachmentsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EmailAttachment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailSettings'] = ResolversParentTypes['EmailSettings']> = {
  checkIntervalEmail?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deviceBulkConfiguration?: Resolver<Maybe<ResolversTypes['DeviceBulkConfiguration']>, ParentType, ContextType>;
  deviceBulkConfigurationId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  emailBodyExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emailPassword?: Resolver<Maybe<Array<ResolversTypes['Byte']>>, ParentType, ContextType>;
  emailServerType?: Resolver<Maybe<ResolversTypes['SERVER_TYPE']>, ParentType, ContextType>;
  emailServerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailSubjectExpression?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  encryptionType?: Resolver<Maybe<ResolversTypes['ENCRYPTION_TYPE']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  maxChecksEmail?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  serverEmailPort?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailStatus'] = ResolversParentTypes['EmailStatus']> = {
  appNoteId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deliverDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['Email']>, ParentType, ContextType>;
  emailId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  messageSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  receptionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  smsId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['STATUS'], ParentType, ContextType>;
  statusMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webhookId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailStatusConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailStatusConnection'] = ResolversParentTypes['EmailStatusConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EmailStatusEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['EmailStatus']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailStatusEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailStatusEdge'] = ResolversParentTypes['EmailStatusEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EmailStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailsConnection'] = ResolversParentTypes['EmailsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EmailsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Email']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailsEdge'] = ResolversParentTypes['EmailsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Email'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnergyBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnergyBalance'] = ResolversParentTypes['EnergyBalance']> = {
  aggregatedInterval?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endTypeValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduleOperationModes?: Resolver<Array<ResolversTypes['ScheduleOperationMode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnergyBalanceConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnergyBalanceConnection'] = ResolversParentTypes['EnergyBalanceConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EnergyBalanceEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['EnergyBalance']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnergyBalanceEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnergyBalanceEdge'] = ResolversParentTypes['EnergyBalanceEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EnergyBalance'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnterpriseResolvers<ContextType = any, ParentType extends ResolversParentTypes['Enterprise'] = ResolversParentTypes['Enterprise']> = {
  accessGroups?: Resolver<Array<ResolversTypes['AccessGroup']>, ParentType, ContextType>;
  companies?: Resolver<Array<ResolversTypes['Company']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnterprisesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnterprisesConnection'] = ResolversParentTypes['EnterprisesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EnterprisesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Enterprise']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EnterprisesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnterprisesEdge'] = ResolversParentTypes['EnterprisesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Enterprise']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Equipment'] = ResolversParentTypes['Equipment']> = {
  anchorType?: Resolver<Maybe<ResolversTypes['ANCHOR_TYPE']>, ParentType, ContextType>;
  asset?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  brand?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connectionType?: Resolver<Maybe<ResolversTypes['CONNECTION_TYPE']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  equipmentType?: Resolver<ResolversTypes['EQUIPMENT_TYPE'], ParentType, ContextType>;
  feederName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeders?: Resolver<Maybe<Array<ResolversTypes['Feeder']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  inputType?: Resolver<Maybe<ResolversTypes['INPUT_TYPE']>, ParentType, ContextType>;
  installationType?: Resolver<Maybe<ResolversTypes['INSTALLATION_TYPE']>, ParentType, ContextType>;
  interbarTransformer?: Resolver<Maybe<ResolversTypes['Equipment']>, ParentType, ContextType>;
  interbarTransformerId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  interbarTransformers?: Resolver<Maybe<Array<ResolversTypes['Equipment']>>, ParentType, ContextType>;
  isMainDeviceConnected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMainTransformer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  manufactureDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  masterBusLines?: Resolver<Maybe<Array<ResolversTypes['Line']>>, ParentType, ContextType>;
  materialType?: Resolver<Maybe<ResolversTypes['MATERIAL_TYPE']>, ParentType, ContextType>;
  model?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentAsset?: Resolver<Maybe<ResolversTypes['Asset']>, ParentType, ContextType>;
  parentAssetId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  parentFeeder?: Resolver<Maybe<ResolversTypes['Feeder']>, ParentType, ContextType>;
  parentFeederId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  phaseRotation?: Resolver<ResolversTypes['PHASE_ROTATION'], ParentType, ContextType>;
  phaseType?: Resolver<ResolversTypes['PHASE_TYPE'], ParentType, ContextType>;
  power?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  serviceEntryDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  transformerType?: Resolver<ResolversTypes['TRANSFORMER_TYPE'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsAlarmStandardResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsAlarmStandard'] = ResolversParentTypes['EquipmentsAlarmStandard']> = {
  assets?: Resolver<Array<ResolversTypes['Asset']>, ParentType, ContextType>;
  editable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  feeders?: Resolver<Array<ResolversTypes['Feeder']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsBulkConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsBulkConfiguration'] = ResolversParentTypes['EquipmentsBulkConfiguration']> = {
  assets?: Resolver<Array<ResolversTypes['Asset']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsConnection'] = ResolversParentTypes['EquipmentsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EquipmentsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Equipment']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsDevice'] = ResolversParentTypes['EquipmentsDevice']> = {
  asset?: Resolver<ResolversTypes['Asset'], ParentType, ContextType>;
  assetId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  createdDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deviceInputs?: Resolver<Array<ResolversTypes['EquipmentsDeviceInputNumber']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  serialNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsDeviceInputNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsDeviceInputNumber'] = ResolversParentTypes['EquipmentsDeviceInputNumber']> = {
  deviceExternalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  devicePortId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  deviceSerialNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  equipmentId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  feederId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  inputNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inputType?: Resolver<ResolversTypes['INPUT_TYPE'], ParentType, ContextType>;
  isEnabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  masterBusLineId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  portNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  powerBusLineId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  typeId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsDeviceLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsDeviceLog'] = ResolversParentTypes['EquipmentsDeviceLog']> = {
  assetId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  comissionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deComissionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  serialNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsDevicesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsDevicesConnection'] = ResolversParentTypes['EquipmentsDevicesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EquipmentsDevicesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['EquipmentsDevice']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsDevicesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsDevicesEdge'] = ResolversParentTypes['EquipmentsDevicesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EquipmentsDevice'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsEdge'] = ResolversParentTypes['EquipmentsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Equipment'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsOperationalAreaResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsOperationalArea'] = ResolversParentTypes['EquipmentsOperationalArea']> = {
  assets?: Resolver<Array<ResolversTypes['Asset']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EquipmentsRegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EquipmentsRegion'] = ResolversParentTypes['EquipmentsRegion']> = {
  assets?: Resolver<Array<ResolversTypes['Asset']>, ParentType, ContextType>;
  externalId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventResolvers<ContextType = any, ParentType extends ResolversParentTypes['Event'] = ResolversParentTypes['Event']> = {
  assetId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deviceEventId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  deviceSerial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceStatus?: Resolver<Maybe<ResolversTypes['EventDataStatus']>, ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  entityType?: Resolver<ResolversTypes['EventEntityType'], ParentType, ContextType>;
  equipmentId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  eventData?: Resolver<Array<ResolversTypes['EventData']>, ParentType, ContextType>;
  feederId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  feederName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fuseRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  fuseWay?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hasWFC?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  line?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  portNumber?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  registrationNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  severity?: Resolver<ResolversTypes['EventSeverity'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['SOURCE'], ParentType, ContextType>;
  sourceEntityType?: Resolver<ResolversTypes['ENTITY_TYPE'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EventStatus'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['EventType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventData'] = ResolversParentTypes['EventData']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  delta_T?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceStatus?: Resolver<Maybe<ResolversTypes['EventDataStatus']>, ParentType, ContextType>;
  event?: Resolver<ResolversTypes['Event'], ParentType, ContextType>;
  eventId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  iavg?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  imax?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  imin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  notes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratio?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['EventStatus'], ParentType, ContextType>;
  timeStamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventDataConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventDataConnection'] = ResolversParentTypes['EventDataConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EventDataEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['EventData']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventDataEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventDataEdge'] = ResolversParentTypes['EventDataEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['EventData'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventsConnection'] = ResolversParentTypes['EventsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['EventsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Event']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventsEdge'] = ResolversParentTypes['EventsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Event'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FederatedIdentityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FederatedIdentity'] = ResolversParentTypes['FederatedIdentity']> = {
  identityProvider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeederResolvers<ContextType = any, ParentType extends ResolversParentTypes['Feeder'] = ResolversParentTypes['Feeder']> = {
  alarmStandard?: Resolver<ResolversTypes['EquipmentsAlarmStandard'], ParentType, ContextType>;
  alarmStandardId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  assetId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  cableType?: Resolver<ResolversTypes['CableType'], ParentType, ContextType>;
  cableTypeId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  equipmentId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  feederType?: Resolver<ResolversTypes['FEEDER_TYPE'], ParentType, ContextType>;
  fuseRating?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  hasData?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  idv2?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCommissioned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isReadOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lines?: Resolver<Array<ResolversTypes['Line']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  parentEquipments?: Resolver<Maybe<Array<ResolversTypes['Equipment']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeedersConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeedersConnection'] = ResolversParentTypes['FeedersConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['FeedersEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Feeder']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeedersEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeedersEdge'] = ResolversParentTypes['FeedersEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Feeder'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilterResolvers<ContextType = any, ParentType extends ResolversParentTypes['Filter'] = ResolversParentTypes['Filter']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  joinOperator?: Resolver<ResolversTypes['JOIN_OPERATOR'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  operator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subscription?: Resolver<Maybe<ResolversTypes['Subscription']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwareResolvers<ContextType = any, ParentType extends ResolversParentTypes['Firmware'] = ResolversParentTypes['Firmware']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firmwareDocument?: Resolver<ResolversTypes['DevicesFirmwareDocument'], ParentType, ContextType>;
  firmwareDocumentId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  firmwareTasks?: Resolver<Maybe<Array<ResolversTypes['FirmwareTask']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwareTaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirmwareTask'] = ResolversParentTypes['FirmwareTask']> = {
  accessGroups?: Resolver<Maybe<Array<ResolversTypes['DevicesAccessGroup']>>, ParentType, ContextType>;
  cancelDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  companies?: Resolver<Maybe<Array<ResolversTypes['DevicesCompany']>>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  deviceTags?: Resolver<Maybe<Array<ResolversTypes['DeviceTag']>>, ParentType, ContextType>;
  devices?: Resolver<Maybe<Array<ResolversTypes['Device']>>, ParentType, ContextType>;
  downloadAttempts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  firmware?: Resolver<ResolversTypes['Firmware'], ParentType, ContextType>;
  firmwareId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  firmwareTaskLogs?: Resolver<Maybe<Array<ResolversTypes['FirmwareTaskLog']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  operationalAreas?: Resolver<Maybe<Array<ResolversTypes['DevicesOperationalArea']>>, ParentType, ContextType>;
  processed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  processedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  regions?: Resolver<Maybe<Array<ResolversTypes['DevicesRegion']>>, ParentType, ContextType>;
  scheduleDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  taskName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwareTaskLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirmwareTaskLog'] = ResolversParentTypes['FirmwareTaskLog']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  currentBlock?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  downloadAttempts?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firmwareTask?: Resolver<ResolversTypes['FirmwareTask'], ParentType, ContextType>;
  firmwareTaskId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  numberBlocks?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  progress?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FIRMWARE_TASK_STATUS'], ParentType, ContextType>;
  taskLog?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwareTaskLogConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirmwareTaskLogConnection'] = ResolversParentTypes['FirmwareTaskLogConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['FirmwareTaskLogEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['FirmwareTaskLog']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwareTaskLogEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirmwareTaskLogEdge'] = ResolversParentTypes['FirmwareTaskLogEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FirmwareTaskLog'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwareTasksConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirmwareTasksConnection'] = ResolversParentTypes['FirmwareTasksConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['FirmwareTasksEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['FirmwareTask']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwareTasksEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirmwareTasksEdge'] = ResolversParentTypes['FirmwareTasksEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['FirmwareTask'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwaresConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirmwaresConnection'] = ResolversParentTypes['FirmwaresConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['FirmwaresEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Firmware']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmwaresEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['FirmwaresEdge'] = ResolversParentTypes['FirmwaresEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Firmware'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeneralSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeneralSettings'] = ResolversParentTypes['GeneralSettings']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  groupName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settings?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GpsPointResolvers<ContextType = any, ParentType extends ResolversParentTypes['GpsPoint'] = ResolversParentTypes['GpsPoint']> = {
  asset?: Resolver<Maybe<ResolversTypes['LayoutEquipment']>, ParentType, ContextType>;
  assetId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['Company']>, ParentType, ContextType>;
  companyId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  designOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  latitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  longitude?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  operationalArea?: Resolver<Maybe<ResolversTypes['OperationalArea']>, ParentType, ContextType>;
  operationalAreaId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  region?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  regionId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GpsPointsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GpsPointsConnection'] = ResolversParentTypes['GpsPointsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['GpsPointsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['GpsPoint']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GpsPointsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['GpsPointsEdge'] = ResolversParentTypes['GpsPointsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['GpsPoint']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InputResolvers<ContextType = any, ParentType extends ResolversParentTypes['Input'] = ResolversParentTypes['Input']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  devicePortId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  inputType?: Resolver<ResolversTypes['INPUT_TYPE'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  port?: Resolver<ResolversTypes['Port'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InputsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InputsConnection'] = ResolversParentTypes['InputsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['InputsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Input']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InputsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InputsEdge'] = ResolversParentTypes['InputsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Input'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Interface'] = ResolversParentTypes['Interface']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interfaceType?: Resolver<ResolversTypes['INTERFACE_TYPE'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  protocols?: Resolver<Array<ResolversTypes['Protocol']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfaceBluetoothResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfaceBluetooth'] = ResolversParentTypes['InterfaceBluetooth']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interfaceType?: Resolver<ResolversTypes['INTERFACE_TYPE'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastStateChange?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  protocols?: Resolver<Array<ResolversTypes['Protocol']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfaceEthernetResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfaceEthernet'] = ResolversParentTypes['InterfaceEthernet']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  deviceMac?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceMasc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ethDutyCycle?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interfaceType?: Resolver<ResolversTypes['INTERFACE_TYPE'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  protocols?: Resolver<Array<ResolversTypes['Protocol']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfaceGprsResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfaceGprs'] = ResolversParentTypes['InterfaceGprs']> = {
  apnAuthType?: Resolver<ResolversTypes['APN_AUTH_TYPE'], ParentType, ContextType>;
  apnName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  apnPwd?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  apnUser?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  iccid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interfaceType?: Resolver<ResolversTypes['INTERFACE_TYPE'], ParentType, ContextType>;
  lastCommunication?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  protocols?: Resolver<Array<ResolversTypes['Protocol']>, ParentType, ContextType>;
  simId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  simIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfaceLoRaResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfaceLoRa'] = ResolversParentTypes['InterfaceLoRa']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interfaceType?: Resolver<ResolversTypes['INTERFACE_TYPE'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  modemSettings?: Resolver<ResolversTypes['ModemSettings'], ParentType, ContextType>;
  modemSettingsId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  packetConfiguration?: Resolver<ResolversTypes['PacketConfiguration'], ParentType, ContextType>;
  packetConfigurationId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  protocols?: Resolver<Array<ResolversTypes['Protocol']>, ParentType, ContextType>;
  rfSettings?: Resolver<ResolversTypes['RFSettings'], ParentType, ContextType>;
  rfSettingsId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfacesBluetoothConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfacesBluetoothConnection'] = ResolversParentTypes['InterfacesBluetoothConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['InterfacesBluetoothEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['InterfaceBluetooth']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfacesBluetoothEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfacesBluetoothEdge'] = ResolversParentTypes['InterfacesBluetoothEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['InterfaceBluetooth'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfacesEthernetConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfacesEthernetConnection'] = ResolversParentTypes['InterfacesEthernetConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['InterfacesEthernetEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['InterfaceEthernet']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfacesEthernetEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfacesEthernetEdge'] = ResolversParentTypes['InterfacesEthernetEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['InterfaceEthernet'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfacesGprsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfacesGprsConnection'] = ResolversParentTypes['InterfacesGprsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['InterfacesGprsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['InterfaceGprs']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfacesGprsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfacesGprsEdge'] = ResolversParentTypes['InterfacesGprsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['InterfaceGprs'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfacesLoRaConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfacesLoRaConnection'] = ResolversParentTypes['InterfacesLoRaConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['InterfacesLoRaEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['InterfaceLoRa']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InterfacesLoRaEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['InterfacesLoRaEdge'] = ResolversParentTypes['InterfacesLoRaEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['InterfaceLoRa'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeyValuePairOfStringAndIEnumerableOfStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeyValuePairOfStringAndIEnumerableOfString'] = ResolversParentTypes['KeyValuePairOfStringAndIEnumerableOfString']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeyValuePairOfStringAndObjectResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeyValuePairOfStringAndObject'] = ResolversParentTypes['KeyValuePairOfStringAndObject']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeyValuePairOfStringAndStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeyValuePairOfStringAndString'] = ResolversParentTypes['KeyValuePairOfStringAndString']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeycloakRoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeycloakRole'] = ResolversParentTypes['KeycloakRole']> = {
  attributes?: Resolver<Maybe<Array<ResolversTypes['KeyValuePairOfStringAndObject']>>, ParentType, ContextType>;
  clientRole?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  composite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  composites?: Resolver<Maybe<ResolversTypes['RoleComposite']>, ParentType, ContextType>;
  containerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeycloakRoleConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeycloakRoleConnection'] = ResolversParentTypes['KeycloakRoleConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['KeycloakRoleEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['KeycloakRole']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeycloakRoleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeycloakRoleEdge'] = ResolversParentTypes['KeycloakRoleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['KeycloakRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeycloakUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeycloakUser'] = ResolversParentTypes['KeycloakUser']> = {
  access?: Resolver<Maybe<ResolversTypes['UserAccess']>, ParentType, ContextType>;
  attributes?: Resolver<Maybe<Array<ResolversTypes['KeyValuePairOfStringAndIEnumerableOfString']>>, ParentType, ContextType>;
  clientConsents?: Resolver<Maybe<Array<Maybe<ResolversTypes['UserConsent']>>>, ParentType, ContextType>;
  clientRoles?: Resolver<Maybe<Array<ResolversTypes['KeyValuePairOfStringAndObject']>>, ParentType, ContextType>;
  createdTimestamp?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  credentials?: Resolver<Maybe<Array<Maybe<ResolversTypes['Credentials']>>>, ParentType, ContextType>;
  disableableCredentialTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailVerified?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  federatedIdentities?: Resolver<Maybe<Array<Maybe<ResolversTypes['FederatedIdentity']>>>, ParentType, ContextType>;
  federationLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notBefore?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  realmRoles?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  requiredActions?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  self?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serviceAccountClientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totp?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeycloakUserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeycloakUserConnection'] = ResolversParentTypes['KeycloakUserConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['KeycloakUserEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['KeycloakUser']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KeycloakUserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['KeycloakUserEdge'] = ResolversParentTypes['KeycloakUserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['KeycloakUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LastContactByTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastContactByType'] = ResolversParentTypes['LastContactByType']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastContact?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastContactType?: Resolver<ResolversTypes['LASTCONTACT_TYPE'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  remoteIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LastContactByTypesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastContactByTypesConnection'] = ResolversParentTypes['LastContactByTypesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['LastContactByTypesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['LastContactByType']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LastContactByTypesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastContactByTypesEdge'] = ResolversParentTypes['LastContactByTypesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['LastContactByType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutAsset'] = ResolversParentTypes['LayoutAsset']> = {
  accessGroups?: Resolver<Array<ResolversTypes['AccessGroup']>, ParentType, ContextType>;
  externalAssetId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  gpsPoint?: Resolver<Maybe<ResolversTypes['GpsPoint']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  operationalArea?: Resolver<Maybe<ResolversTypes['OperationalArea']>, ParentType, ContextType>;
  operationalAreaId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  registrationNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateAsset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<LayoutAssetUpdateAssetArgs, 'name' | 'registrationNumber'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutAssetsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutAssetsConnection'] = ResolversParentTypes['LayoutAssetsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['LayoutAssetsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['LayoutEquipment']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutAssetsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutAssetsEdge'] = ResolversParentTypes['LayoutAssetsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['LayoutEquipment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutEquipmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutEquipment'] = ResolversParentTypes['LayoutEquipment']> = {
  accessGroups?: Resolver<Array<ResolversTypes['AccessGroup']>, ParentType, ContextType>;
  externalAssetId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  gpsPoint?: Resolver<Maybe<ResolversTypes['GpsPoint']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  operationalArea?: Resolver<Maybe<ResolversTypes['OperationalArea']>, ParentType, ContextType>;
  operationalAreaId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  registrationNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateAsset?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<LayoutEquipmentUpdateAssetArgs, 'name' | 'registrationNumber'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutMessage'] = ResolversParentTypes['LayoutMessage']> = {
  actionMethod?: Resolver<ResolversTypes['ACTION_METHOD'], ParentType, ContextType>;
  actionProto?: Resolver<ResolversTypes['ACTION_PROTO'], ParentType, ContextType>;
  actionType?: Resolver<ResolversTypes['ACTION_TYPE'], ParentType, ContextType>;
  errorMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  inputData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  resultData?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutMessagesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutMessagesConnection'] = ResolversParentTypes['LayoutMessagesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['LayoutMessagesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['LayoutMessage']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutMessagesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutMessagesEdge'] = ResolversParentTypes['LayoutMessagesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['LayoutMessage'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineResolvers<ContextType = any, ParentType extends ResolversParentTypes['Line'] = ResolversParentTypes['Line']> = {
  assetId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  childLines?: Resolver<Maybe<Array<ResolversTypes['Line']>>, ParentType, ContextType>;
  equipmentId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  feederId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  idv2?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  inputType?: Resolver<ResolversTypes['INPUT_TYPE'], ParentType, ContextType>;
  lineType?: Resolver<ResolversTypes['LINE_TYPE'], ParentType, ContextType>;
  oldId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  parentLine?: Resolver<Maybe<ResolversTypes['Line']>, ParentType, ContextType>;
  parentLineId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  referenceAngle?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LongScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Long'], any> {
  name: 'Long';
}

export type MenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['Menu'] = ResolversParentTypes['Menu']> = {
  breadcrumbs?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  children?: Resolver<Maybe<Array<ResolversTypes['Menu']>>, ParentType, ContextType>;
  element?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  externalUrl?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  i18nKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parent?: Resolver<Maybe<ResolversTypes['Menu']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['Role']>>, ParentType, ContextType>;
  section?: Resolver<Maybe<ResolversTypes['Section']>, ParentType, ContextType>;
  sectionId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MenuType'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuConnection'] = ResolversParentTypes['MenuConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['MenuEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Menu']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuEdge'] = ResolversParentTypes['MenuEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Menu'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuRolesResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuRoles'] = ResolversParentTypes['MenuRoles']> = {
  actions?: Resolver<Maybe<Array<ResolversTypes['Action']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  menu?: Resolver<Maybe<ResolversTypes['Menu']>, ParentType, ContextType>;
  menuId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['Role']>, ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuRolesActionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuRolesActions'] = ResolversParentTypes['MenuRolesActions']> = {
  action?: Resolver<Maybe<ResolversTypes['Action']>, ParentType, ContextType>;
  actionId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  menuId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  menuRoles?: Resolver<Maybe<ResolversTypes['MenuRoles']>, ParentType, ContextType>;
  roleId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuRolesActionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuRolesActionsConnection'] = ResolversParentTypes['MenuRolesActionsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['MenuRolesActionsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['MenuRolesActions']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuRolesActionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuRolesActionsEdge'] = ResolversParentTypes['MenuRolesActionsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MenuRolesActions'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuRolesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuRolesConnection'] = ResolversParentTypes['MenuRolesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['MenuRolesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['MenuRoles']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuRolesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['MenuRolesEdge'] = ResolversParentTypes['MenuRolesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['MenuRoles'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModemSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModemSettings'] = ResolversParentTypes['ModemSettings']> = {
  bandWidth?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  codingRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interfaceLoRa?: Resolver<ResolversTypes['InterfaceLoRa'], ParentType, ContextType>;
  interfaceLoRaId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lowDataRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  spreadingFactor?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NetworkPowerQualityResolvers<ContextType = any, ParentType extends ResolversParentTypes['NetworkPowerQuality'] = ResolversParentTypes['NetworkPowerQuality']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  inputReferenceFrequency?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inputReferenceVoltage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  negativeVoltageRVCHisterese?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  negativeVoltageRVCThreshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  positiveVoltageRVCHisterese?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  positiveVoltageRVCThreshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scheduleOperationModes?: Resolver<Array<ResolversTypes['ScheduleOperationMode']>, ParentType, ContextType>;
  voltageDipHisterese?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voltageDipThreshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voltageInterruptHisterese?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voltageInterruptThreshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voltageSwellHisterese?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  voltageSwellThreshold?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NetworkPowerQualityConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['NetworkPowerQualityConnection'] = ResolversParentTypes['NetworkPowerQualityConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['NetworkPowerQualityEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['NetworkPowerQuality']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NetworkPowerQualityEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['NetworkPowerQualityEdge'] = ResolversParentTypes['NetworkPowerQualityEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['NetworkPowerQuality'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OperationalAreaResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperationalArea'] = ResolversParentTypes['OperationalArea']> = {
  accessGroups?: Resolver<Array<ResolversTypes['AccessGroup']>, ParentType, ContextType>;
  accessGroupsWorkingOP?: Resolver<Array<ResolversTypes['AccessGroup']>, ParentType, ContextType>;
  assets?: Resolver<Array<ResolversTypes['LayoutEquipment']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  gpsPoints?: Resolver<Array<ResolversTypes['GpsPoint']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  idv2?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['Region'], ParentType, ContextType>;
  regionId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OperationalAreasConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperationalAreasConnection'] = ResolversParentTypes['OperationalAreasConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['OperationalAreasEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['OperationalArea']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OperationalAreasEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperationalAreasEdge'] = ResolversParentTypes['OperationalAreasEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['OperationalArea']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PacketConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PacketConfiguration'] = ResolversParentTypes['PacketConfiguration']> = {
  crcEnabled?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  headerMode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interfaceLoRa?: Resolver<ResolversTypes['InterfaceLoRa'], ParentType, ContextType>;
  interfaceLoRaId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  payloadLength?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  programmedPreamble?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPreambleLength?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformSettings'] = ResolversParentTypes['PlatformSettings']> = {
  applicationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  mandatory?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  regex?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sectionName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settingName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settingType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  settingValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformSettingsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformSettingsConnection'] = ResolversParentTypes['PlatformSettingsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PlatformSettingsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['PlatformSettings']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlatformSettingsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformSettingsEdge'] = ResolversParentTypes['PlatformSettingsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PlatformSettings'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortResolvers<ContextType = any, ParentType extends ResolversParentTypes['Port'] = ResolversParentTypes['Port']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<ResolversTypes['Device'], ParentType, ContextType>;
  deviceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  inputs?: Resolver<Array<ResolversTypes['Input']>, ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  portNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  portType?: Resolver<ResolversTypes['PORT_TYPE'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortsConnection'] = ResolversParentTypes['PortsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PortsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Port']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PortsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortsEdge'] = ResolversParentTypes['PortsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Port'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PowerBusLinesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PowerBusLinesConnection'] = ResolversParentTypes['PowerBusLinesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['PowerBusLinesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Line']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PowerBusLinesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PowerBusLinesEdge'] = ResolversParentTypes['PowerBusLinesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Line'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolResolvers<ContextType = any, ParentType extends ResolversParentTypes['Protocol'] = ResolversParentTypes['Protocol']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interface?: Resolver<ResolversTypes['Interface'], ParentType, ContextType>;
  interfaceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  protocolType?: Resolver<ResolversTypes['PROTOCOL_TYPE'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolBluetoothResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolBluetooth'] = ResolversParentTypes['ProtocolBluetooth']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interface?: Resolver<ResolversTypes['Interface'], ParentType, ContextType>;
  interfaceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pin?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  protocolType?: Resolver<ResolversTypes['PROTOCOL_TYPE'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolDnp3Resolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolDNP3'] = ResolversParentTypes['ProtocolDNP3']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interface?: Resolver<ResolversTypes['Interface'], ParentType, ContextType>;
  interfaceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  protocolType?: Resolver<ResolversTypes['PROTOCOL_TYPE'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolEneidaLoRaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolEneidaLoRa'] = ResolversParentTypes['ProtocolEneidaLoRa']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interface?: Resolver<ResolversTypes['Interface'], ParentType, ContextType>;
  interfaceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  protocolType?: Resolver<ResolversTypes['PROTOCOL_TYPE'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolHttpResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolHTTP'] = ResolversParentTypes['ProtocolHTTP']> = {
  createAlarm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interface?: Resolver<ResolversTypes['Interface'], ParentType, ContextType>;
  interfaceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  protocolType?: Resolver<ResolversTypes['PROTOCOL_TYPE'], ParentType, ContextType>;
  sendRawData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolMqttResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolMqtt'] = ResolversParentTypes['ProtocolMqtt']> = {
  certificateUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createAlarm?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interface?: Resolver<ResolversTypes['Interface'], ParentType, ContextType>;
  interfaceId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  password?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  protocolType?: Resolver<ResolversTypes['PROTOCOL_TYPE'], ParentType, ContextType>;
  sendRawData?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsBluetoothConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsBluetoothConnection'] = ResolversParentTypes['ProtocolsBluetoothConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ProtocolsBluetoothEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ProtocolBluetooth']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsBluetoothEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsBluetoothEdge'] = ResolversParentTypes['ProtocolsBluetoothEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProtocolBluetooth'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsDnp3ConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsDNP3Connection'] = ResolversParentTypes['ProtocolsDNP3Connection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ProtocolsDNP3Edge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ProtocolDNP3']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsDnp3EdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsDNP3Edge'] = ResolversParentTypes['ProtocolsDNP3Edge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProtocolDNP3'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsEneidaLoRaConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsEneidaLoRaConnection'] = ResolversParentTypes['ProtocolsEneidaLoRaConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ProtocolsEneidaLoRaEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ProtocolEneidaLoRa']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsEneidaLoRaEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsEneidaLoRaEdge'] = ResolversParentTypes['ProtocolsEneidaLoRaEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProtocolEneidaLoRa'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsHttpConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsHTTPConnection'] = ResolversParentTypes['ProtocolsHTTPConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ProtocolsHTTPEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ProtocolHTTP']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsHttpEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsHTTPEdge'] = ResolversParentTypes['ProtocolsHTTPEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProtocolHTTP'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsMqttConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsMqttConnection'] = ResolversParentTypes['ProtocolsMqttConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ProtocolsMqttEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ProtocolMqtt']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProtocolsMqttEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProtocolsMqttEdge'] = ResolversParentTypes['ProtocolsMqttEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProtocolMqtt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  accessGroups?: Resolver<Maybe<ResolversTypes['AccessGroupsConnection']>, ParentType, ContextType, Partial<QueryAccessGroupsArgs>>;
  action?: Resolver<Maybe<ResolversTypes['ActionConnection']>, ParentType, ContextType, Partial<QueryActionArgs>>;
  alarmStandardDefinitions?: Resolver<Maybe<ResolversTypes['AlarmStandardDefinitionsConnection']>, ParentType, ContextType, Partial<QueryAlarmStandardDefinitionsArgs>>;
  alarmStandardVariableDefinitions?: Resolver<Maybe<ResolversTypes['AlarmStandardVariableDefinitionsConnection']>, ParentType, ContextType, Partial<QueryAlarmStandardVariableDefinitionsArgs>>;
  alarmStandards?: Resolver<Maybe<ResolversTypes['AlarmStandardsConnection']>, ParentType, ContextType, Partial<QueryAlarmStandardsArgs>>;
  alarmTypes?: Resolver<Maybe<ResolversTypes['AlarmTypesConnection']>, ParentType, ContextType, Partial<QueryAlarmTypesArgs>>;
  alarmVariables?: Resolver<Maybe<ResolversTypes['AlarmVariablesConnection']>, ParentType, ContextType, Partial<QueryAlarmVariablesArgs>>;
  assetBulkConfigurations?: Resolver<Maybe<ResolversTypes['AssetBulkConfigurationsConnection']>, ParentType, ContextType, Partial<QueryAssetBulkConfigurationsArgs>>;
  assets?: Resolver<Maybe<ResolversTypes['AssetsConnection']>, ParentType, ContextType, Partial<QueryAssetsArgs>>;
  authorization?: Resolver<Maybe<ResolversTypes['AuthorizationConnection']>, ParentType, ContextType, Partial<QueryAuthorizationArgs>>;
  batchDevices?: Resolver<Maybe<ResolversTypes['BatchDevicesConnection']>, ParentType, ContextType, Partial<QueryBatchDevicesArgs>>;
  batchIncludes?: Resolver<Maybe<ResolversTypes['BatchIncludesConnection']>, ParentType, ContextType, Partial<QueryBatchIncludesArgs>>;
  batchSims?: Resolver<Maybe<ResolversTypes['BatchSimsConnection']>, ParentType, ContextType, Partial<QueryBatchSimsArgs>>;
  cableTypes?: Resolver<Maybe<ResolversTypes['CableTypesConnection']>, ParentType, ContextType, Partial<QueryCableTypesArgs>>;
  companys?: Resolver<Maybe<ResolversTypes['CompanysConnection']>, ParentType, ContextType, Partial<QueryCompanysArgs>>;
  conTestDeviceResults?: Resolver<Maybe<ResolversTypes['ConTestDeviceResultsConnection']>, ParentType, ContextType, Partial<QueryConTestDeviceResultsArgs>>;
  conTests?: Resolver<Maybe<ResolversTypes['ConTestsConnection']>, ParentType, ContextType, Partial<QueryConTestsArgs>>;
  conTestsExtended?: Resolver<Maybe<ResolversTypes['ConTestsExtendedConnection']>, ParentType, ContextType, Partial<QueryConTestsExtendedArgs>>;
  contacts?: Resolver<Maybe<ResolversTypes['ContactsConnection']>, ParentType, ContextType, Partial<QueryContactsArgs>>;
  currentHarmonics?: Resolver<Maybe<ResolversTypes['CurrentHarmonicsConnection']>, ParentType, ContextType, Partial<QueryCurrentHarmonicsArgs>>;
  customProperties?: Resolver<Maybe<ResolversTypes['CustomPropertiesConnection']>, ParentType, ContextType, Partial<QueryCustomPropertiesArgs>>;
  deviceBulkConfigurations?: Resolver<Maybe<ResolversTypes['DeviceBulkConfigurationsConnection']>, ParentType, ContextType, Partial<QueryDeviceBulkConfigurationsArgs>>;
  deviceInputNumbers?: Resolver<Maybe<ResolversTypes['DeviceInputNumbersConnection']>, ParentType, ContextType, Partial<QueryDeviceInputNumbersArgs>>;
  deviceLog?: Resolver<Maybe<ResolversTypes['DeviceLogConnection']>, ParentType, ContextType, Partial<QueryDeviceLogArgs>>;
  deviceLogs?: Resolver<Maybe<ResolversTypes['DeviceLogsConnection']>, ParentType, ContextType, Partial<QueryDeviceLogsArgs>>;
  deviceMessages?: Resolver<Maybe<ResolversTypes['DeviceMessagesConnection']>, ParentType, ContextType, Partial<QueryDeviceMessagesArgs>>;
  deviceTypeConfigurations?: Resolver<Maybe<ResolversTypes['DeviceTypeConfigurationsConnection']>, ParentType, ContextType, Partial<QueryDeviceTypeConfigurationsArgs>>;
  devices?: Resolver<Maybe<ResolversTypes['DevicesConnection']>, ParentType, ContextType, Partial<QueryDevicesArgs>>;
  devicesFirmwareDocuments?: Resolver<Maybe<ResolversTypes['DevicesFirmwareDocumentsConnection']>, ParentType, ContextType, Partial<QueryDevicesFirmwareDocumentsArgs>>;
  emailAttachments?: Resolver<Maybe<ResolversTypes['EmailAttachmentsConnection']>, ParentType, ContextType, Partial<QueryEmailAttachmentsArgs>>;
  emailStatus?: Resolver<Maybe<ResolversTypes['EmailStatusConnection']>, ParentType, ContextType, Partial<QueryEmailStatusArgs>>;
  emails?: Resolver<Maybe<ResolversTypes['EmailsConnection']>, ParentType, ContextType, Partial<QueryEmailsArgs>>;
  energyBalance?: Resolver<Maybe<ResolversTypes['EnergyBalanceConnection']>, ParentType, ContextType, Partial<QueryEnergyBalanceArgs>>;
  enterprises?: Resolver<Maybe<ResolversTypes['EnterprisesConnection']>, ParentType, ContextType, Partial<QueryEnterprisesArgs>>;
  equipments?: Resolver<Maybe<ResolversTypes['EquipmentsConnection']>, ParentType, ContextType, Partial<QueryEquipmentsArgs>>;
  equipmentsDevices?: Resolver<Maybe<ResolversTypes['EquipmentsDevicesConnection']>, ParentType, ContextType, Partial<QueryEquipmentsDevicesArgs>>;
  eventData?: Resolver<Maybe<ResolversTypes['EventDataConnection']>, ParentType, ContextType, Partial<QueryEventDataArgs>>;
  events?: Resolver<Maybe<ResolversTypes['EventsConnection']>, ParentType, ContextType, Partial<QueryEventsArgs>>;
  feeders?: Resolver<Maybe<ResolversTypes['FeedersConnection']>, ParentType, ContextType, Partial<QueryFeedersArgs>>;
  firmwareTaskLog?: Resolver<Maybe<ResolversTypes['FirmwareTaskLogConnection']>, ParentType, ContextType, Partial<QueryFirmwareTaskLogArgs>>;
  firmwareTasks?: Resolver<Maybe<ResolversTypes['FirmwareTasksConnection']>, ParentType, ContextType, Partial<QueryFirmwareTasksArgs>>;
  firmwares?: Resolver<Maybe<ResolversTypes['FirmwaresConnection']>, ParentType, ContextType, Partial<QueryFirmwaresArgs>>;
  gpsPoints?: Resolver<Maybe<ResolversTypes['GpsPointsConnection']>, ParentType, ContextType, Partial<QueryGpsPointsArgs>>;
  inputs?: Resolver<Maybe<ResolversTypes['InputsConnection']>, ParentType, ContextType, Partial<QueryInputsArgs>>;
  interfacesBluetooth?: Resolver<Maybe<ResolversTypes['InterfacesBluetoothConnection']>, ParentType, ContextType, Partial<QueryInterfacesBluetoothArgs>>;
  interfacesEthernet?: Resolver<Maybe<ResolversTypes['InterfacesEthernetConnection']>, ParentType, ContextType, Partial<QueryInterfacesEthernetArgs>>;
  interfacesGprs?: Resolver<Maybe<ResolversTypes['InterfacesGprsConnection']>, ParentType, ContextType, Partial<QueryInterfacesGprsArgs>>;
  interfacesLoRa?: Resolver<Maybe<ResolversTypes['InterfacesLoRaConnection']>, ParentType, ContextType, Partial<QueryInterfacesLoRaArgs>>;
  keycloakRole?: Resolver<Maybe<ResolversTypes['KeycloakRoleConnection']>, ParentType, ContextType, Partial<QueryKeycloakRoleArgs>>;
  keycloakUser?: Resolver<Maybe<ResolversTypes['KeycloakUserConnection']>, ParentType, ContextType, Partial<QueryKeycloakUserArgs>>;
  lastContactByTypes?: Resolver<Maybe<ResolversTypes['LastContactByTypesConnection']>, ParentType, ContextType, Partial<QueryLastContactByTypesArgs>>;
  layoutAssets?: Resolver<Maybe<ResolversTypes['LayoutAssetsConnection']>, ParentType, ContextType, Partial<QueryLayoutAssetsArgs>>;
  layoutMessages?: Resolver<Maybe<ResolversTypes['LayoutMessagesConnection']>, ParentType, ContextType, Partial<QueryLayoutMessagesArgs>>;
  menu?: Resolver<Maybe<ResolversTypes['MenuConnection']>, ParentType, ContextType, Partial<QueryMenuArgs>>;
  menuRoles?: Resolver<Maybe<ResolversTypes['MenuRolesConnection']>, ParentType, ContextType, Partial<QueryMenuRolesArgs>>;
  menuRolesActions?: Resolver<Maybe<ResolversTypes['MenuRolesActionsConnection']>, ParentType, ContextType, Partial<QueryMenuRolesActionsArgs>>;
  networkPowerQuality?: Resolver<Maybe<ResolversTypes['NetworkPowerQualityConnection']>, ParentType, ContextType, Partial<QueryNetworkPowerQualityArgs>>;
  operationalAreas?: Resolver<Maybe<ResolversTypes['OperationalAreasConnection']>, ParentType, ContextType, Partial<QueryOperationalAreasArgs>>;
  platformSettings?: Resolver<Maybe<ResolversTypes['PlatformSettingsConnection']>, ParentType, ContextType, Partial<QueryPlatformSettingsArgs>>;
  ports?: Resolver<Maybe<ResolversTypes['PortsConnection']>, ParentType, ContextType, Partial<QueryPortsArgs>>;
  powerBusLines?: Resolver<Maybe<ResolversTypes['PowerBusLinesConnection']>, ParentType, ContextType, Partial<QueryPowerBusLinesArgs>>;
  protocolsBluetooth?: Resolver<Maybe<ResolversTypes['ProtocolsBluetoothConnection']>, ParentType, ContextType, Partial<QueryProtocolsBluetoothArgs>>;
  protocolsDNP3?: Resolver<Maybe<ResolversTypes['ProtocolsDNP3Connection']>, ParentType, ContextType, Partial<QueryProtocolsDnp3Args>>;
  protocolsEneidaLoRa?: Resolver<Maybe<ResolversTypes['ProtocolsEneidaLoRaConnection']>, ParentType, ContextType, Partial<QueryProtocolsEneidaLoRaArgs>>;
  protocolsHTTP?: Resolver<Maybe<ResolversTypes['ProtocolsHTTPConnection']>, ParentType, ContextType, Partial<QueryProtocolsHttpArgs>>;
  protocolsMqtt?: Resolver<Maybe<ResolversTypes['ProtocolsMqttConnection']>, ParentType, ContextType, Partial<QueryProtocolsMqttArgs>>;
  regions?: Resolver<Maybe<ResolversTypes['RegionsConnection']>, ParentType, ContextType, Partial<QueryRegionsArgs>>;
  reports?: Resolver<Maybe<ResolversTypes['ReportsConnection']>, ParentType, ContextType, Partial<QueryReportsArgs>>;
  role?: Resolver<Maybe<ResolversTypes['RoleConnection']>, ParentType, ContextType, Partial<QueryRoleArgs>>;
  scheduleOperationMode?: Resolver<Maybe<ResolversTypes['ScheduleOperationModeConnection']>, ParentType, ContextType, Partial<QueryScheduleOperationModeArgs>>;
  simCards?: Resolver<Maybe<ResolversTypes['SimCardsConnection']>, ParentType, ContextType, Partial<QuerySimCardsArgs>>;
  subscriptions?: Resolver<Maybe<ResolversTypes['SubscriptionsConnection']>, ParentType, ContextType, Partial<QuerySubscriptionsArgs>>;
  templates?: Resolver<Maybe<ResolversTypes['TemplatesConnection']>, ParentType, ContextType, Partial<QueryTemplatesArgs>>;
  templatesConfig?: Resolver<Maybe<ResolversTypes['TemplatesConfigConnection']>, ParentType, ContextType, Partial<QueryTemplatesConfigArgs>>;
  user?: Resolver<Maybe<ResolversTypes['UserConnection']>, ParentType, ContextType, Partial<QueryUserArgs>>;
  userLogAction?: Resolver<Maybe<ResolversTypes['UserLogActionConnection']>, ParentType, ContextType, Partial<QueryUserLogActionArgs>>;
};

export type RfSettingsResolvers<ContextType = any, ParentType extends ResolversParentTypes['RFSettings'] = ResolversParentTypes['RFSettings']> = {
  centreFrequency?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  frequencyDeviation?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hardwareImplementation?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  interfaceLoRa?: Resolver<ResolversTypes['InterfaceLoRa'], ParentType, ContextType>;
  interfaceLoRaId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  transmitPower?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Region'] = ResolversParentTypes['Region']> = {
  accessGroups?: Resolver<Array<ResolversTypes['AccessGroup']>, ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  gpsPoints?: Resolver<Array<ResolversTypes['GpsPoint']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  operationalAreas?: Resolver<Array<ResolversTypes['OperationalArea']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegionsConnection'] = ResolversParentTypes['RegionsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['RegionsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['Region']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegionsEdge'] = ResolversParentTypes['RegionsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<Maybe<ResolversTypes['Region']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportDtoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportDTO'] = ResolversParentTypes['ReportDTO']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  equipments?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  errors?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  period_end?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  period_start?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  periodic?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ready?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  report_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  requested_by?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportsConnection'] = ResolversParentTypes['ReportsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ReportsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ReportDTO']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportsEdge'] = ResolversParentTypes['ReportsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ReportDTO'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Role'] = ResolversParentTypes['Role']> = {
  authorizations?: Resolver<Maybe<Array<ResolversTypes['Authorization']>>, ParentType, ContextType>;
  hasMobileAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasWebAccess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  keycloakId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  menus?: Resolver<Maybe<Array<ResolversTypes['Menu']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  users?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleCompositeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleComposite'] = ResolversParentTypes['RoleComposite']> = {
  client?: Resolver<Maybe<Array<ResolversTypes['KeyValuePairOfStringAndString']>>, ParentType, ContextType>;
  realm?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleConnection'] = ResolversParentTypes['RoleConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['RoleEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['RoleGraphQl']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleEdge'] = ResolversParentTypes['RoleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['RoleGraphQl'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoleGraphQlResolvers<ContextType = any, ParentType extends ResolversParentTypes['RoleGraphQl'] = ResolversParentTypes['RoleGraphQl']> = {
  id?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  keycloakId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleOperationModeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduleOperationMode'] = ResolversParentTypes['ScheduleOperationMode']> = {
  activationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  currentEndSchedule?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  currentHarmonics?: Resolver<Maybe<ResolversTypes['CurrentHarmonics']>, ParentType, ContextType>;
  currentHarmonicsId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  currentSchedule?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deviceBulkConfigurations?: Resolver<Array<ResolversTypes['DeviceBulkConfiguration']>, ParentType, ContextType>;
  duration?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  durationType?: Resolver<ResolversTypes['DURATION_TYPE'], ParentType, ContextType>;
  enable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  energyBalance?: Resolver<Maybe<ResolversTypes['EnergyBalance']>, ParentType, ContextType>;
  energyBalanceId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  every?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  executions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  forever?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  friday?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  lastEndSchedule?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastSchedule?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  monday?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  networkPowerQuality?: Resolver<Maybe<ResolversTypes['NetworkPowerQuality']>, ParentType, ContextType>;
  networkPowerQualityId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  nextEndSchedule?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  nextSchedule?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  ofEvery?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ofMonth?: Resolver<Maybe<ResolversTypes['OF_MONTH']>, ParentType, ContextType>;
  onDay?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  onThe?: Resolver<Maybe<ResolversTypes['ON_THE']>, ParentType, ContextType>;
  onTheItem?: Resolver<Maybe<ResolversTypes['ON_THE_ITEM']>, ParentType, ContextType>;
  recurrenceType?: Resolver<ResolversTypes['DURATION_TYPE'], ParentType, ContextType>;
  recurrencyQuantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saturday?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  sunday?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  thursday?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  tuesday?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  wednesday?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleOperationModeConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduleOperationModeConnection'] = ResolversParentTypes['ScheduleOperationModeConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['ScheduleOperationModeEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['ScheduleOperationMode']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleOperationModeEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScheduleOperationModeEdge'] = ResolversParentTypes['ScheduleOperationModeEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ScheduleOperationMode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Section'] = ResolversParentTypes['Section']> = {
  i18nKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  menus?: Resolver<Maybe<Array<ResolversTypes['Menu']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimCard'] = ResolversParentTypes['SimCard']> = {
  apnAuthType?: Resolver<ResolversTypes['APN_AUTH_TYPE'], ParentType, ContextType>;
  apnIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apnName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  apnPwd?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apnUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  associationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  associationLog?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  associationSucess?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  batchSim?: Resolver<ResolversTypes['BatchSim'], ParentType, ContextType>;
  batchSimId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  device?: Resolver<Maybe<ResolversTypes['Device']>, ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  iccid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  importDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  imsi?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  simIp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  simStatusType?: Resolver<ResolversTypes['SIM_STATUS_TYPE'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimCardsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimCardsConnection'] = ResolversParentTypes['SimCardsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['SimCardsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['SimCard']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimCardsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimCardsEdge'] = ResolversParentTypes['SimCardsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SimCard'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  contacts?: SubscriptionResolver<Maybe<Array<ResolversTypes['Contact']>>, "contacts", ParentType, ContextType>;
  createdBy?: SubscriptionResolver<Maybe<ResolversTypes['String']>, "createdBy", ParentType, ContextType>;
  createdDate?: SubscriptionResolver<Maybe<ResolversTypes['DateTime']>, "createdDate", ParentType, ContextType>;
  description?: SubscriptionResolver<Maybe<ResolversTypes['String']>, "description", ParentType, ContextType>;
  emailBcc?: SubscriptionResolver<Maybe<Array<ResolversTypes['Contact']>>, "emailBcc", ParentType, ContextType>;
  emailCc?: SubscriptionResolver<Maybe<Array<ResolversTypes['Contact']>>, "emailCc", ParentType, ContextType>;
  emailTo?: SubscriptionResolver<Maybe<Array<ResolversTypes['Contact']>>, "emailTo", ParentType, ContextType>;
  filters?: SubscriptionResolver<Maybe<Array<ResolversTypes['Filter']>>, "filters", ParentType, ContextType>;
  id?: SubscriptionResolver<ResolversTypes['Long'], "id", ParentType, ContextType>;
  isActive?: SubscriptionResolver<ResolversTypes['Boolean'], "isActive", ParentType, ContextType>;
  lastModifiedBy?: SubscriptionResolver<Maybe<ResolversTypes['String']>, "lastModifiedBy", ParentType, ContextType>;
  lastModifiedDate?: SubscriptionResolver<Maybe<ResolversTypes['DateTime']>, "lastModifiedDate", ParentType, ContextType>;
  name?: SubscriptionResolver<ResolversTypes['String'], "name", ParentType, ContextType>;
  templates?: SubscriptionResolver<Maybe<Array<ResolversTypes['Template']>>, "templates", ParentType, ContextType>;
};

export type SubscriptionsConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionsConnection'] = ResolversParentTypes['SubscriptionsConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['SubscriptionsEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Subscription']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionsEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionsEdge'] = ResolversParentTypes['SubscriptionsEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Subscription'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateResolvers<ContextType = any, ParentType extends ResolversParentTypes['Template'] = ResolversParentTypes['Template']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  isDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastModifiedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModifiedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messageType?: Resolver<ResolversTypes['TEMPLATE_MESSAGE_TYPE'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationType?: Resolver<ResolversTypes['NOTIFICATION_TYPE'], ParentType, ContextType>;
  readOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptions?: Resolver<Array<ResolversTypes['Subscription']>, ParentType, ContextType>;
  templateConfig?: Resolver<ResolversTypes['TemplateConfig'], ParentType, ContextType>;
  templateConfigId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplateConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplateConfig'] = ResolversParentTypes['TemplateConfig']> = {
  baseTemplate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  footer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  header?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notificationType?: Resolver<ResolversTypes['NOTIFICATION_TYPE'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplatesConfigConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplatesConfigConnection'] = ResolversParentTypes['TemplatesConfigConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['TemplatesConfigEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['TemplateConfig']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplatesConfigEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplatesConfigEdge'] = ResolversParentTypes['TemplatesConfigEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TemplateConfig'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplatesConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplatesConnection'] = ResolversParentTypes['TemplatesConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['TemplatesEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['Template']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TemplatesEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TemplatesEdge'] = ResolversParentTypes['TemplatesEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Template'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  accessGroups?: Resolver<Array<ResolversTypes['AuthorizationAccessGroup']>, ParentType, ContextType>;
  authorizationTokens?: Resolver<Maybe<Array<ResolversTypes['AuthorizationToken']>>, ParentType, ContextType>;
  company?: Resolver<ResolversTypes['Company'], ParentType, ContextType>;
  companyId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  keycloakId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['Role']>>, ParentType, ContextType>;
  userSettings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAccess'] = ResolversParentTypes['UserAccess']> = {
  impersonate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  manage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  manageGroupMembership?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mapRoles?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  view?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserConnection'] = ResolversParentTypes['UserConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['UserEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['UserGraphQl']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserConsentResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserConsent'] = ResolversParentTypes['UserConsent']> = {
  clientId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  grantedClientScopes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  lastUpdatedDate?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserEdge'] = ResolversParentTypes['UserEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserGraphQl'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserGraphQlResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserGraphQl'] = ResolversParentTypes['UserGraphQl']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  keycloakId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roles?: Resolver<Maybe<Array<ResolversTypes['RoleGraphQl']>>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userSettings?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLogActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLogAction'] = ResolversParentTypes['UserLogAction']> = {
  actionDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  apiTranslation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apiUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['UUID'], ParentType, ContextType>;
  responseBody?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  responseCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  userActionType?: Resolver<ResolversTypes['ActionLoggingType'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLogActionConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLogActionConnection'] = ResolversParentTypes['UserLogActionConnection']> = {
  edges?: Resolver<Maybe<Array<ResolversTypes['UserLogActionEdge']>>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<ResolversTypes['UserLogAction']>>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLogActionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLogActionEdge'] = ResolversParentTypes['UserLogActionEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['UserLogAction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AccessGroup?: AccessGroupResolvers<ContextType>;
  AccessGroupToAsset?: AccessGroupToAssetResolvers<ContextType>;
  AccessGroupToCompany?: AccessGroupToCompanyResolvers<ContextType>;
  AccessGroupToOperationalArea?: AccessGroupToOperationalAreaResolvers<ContextType>;
  AccessGroupToRegion?: AccessGroupToRegionResolvers<ContextType>;
  AccessGroupToUser?: AccessGroupToUserResolvers<ContextType>;
  AccessGroupToWorkingOperationalArea?: AccessGroupToWorkingOperationalAreaResolvers<ContextType>;
  AccessGroupsConnection?: AccessGroupsConnectionResolvers<ContextType>;
  AccessGroupsEdge?: AccessGroupsEdgeResolvers<ContextType>;
  Action?: ActionResolvers<ContextType>;
  ActionConnection?: ActionConnectionResolvers<ContextType>;
  ActionEdge?: ActionEdgeResolvers<ContextType>;
  AlarmStandard?: AlarmStandardResolvers<ContextType>;
  AlarmStandardDefinition?: AlarmStandardDefinitionResolvers<ContextType>;
  AlarmStandardDefinitionsConnection?: AlarmStandardDefinitionsConnectionResolvers<ContextType>;
  AlarmStandardDefinitionsEdge?: AlarmStandardDefinitionsEdgeResolvers<ContextType>;
  AlarmStandardVariableAggregation?: AlarmStandardVariableAggregationResolvers<ContextType>;
  AlarmStandardVariableAggregationByAlarm?: AlarmStandardVariableAggregationByAlarmResolvers<ContextType>;
  AlarmStandardVariableDefinition?: AlarmStandardVariableDefinitionResolvers<ContextType>;
  AlarmStandardVariableDefinitionsConnection?: AlarmStandardVariableDefinitionsConnectionResolvers<ContextType>;
  AlarmStandardVariableDefinitionsEdge?: AlarmStandardVariableDefinitionsEdgeResolvers<ContextType>;
  AlarmStandardsConnection?: AlarmStandardsConnectionResolvers<ContextType>;
  AlarmStandardsEdge?: AlarmStandardsEdgeResolvers<ContextType>;
  AlarmType?: AlarmTypeResolvers<ContextType>;
  AlarmTypesConnection?: AlarmTypesConnectionResolvers<ContextType>;
  AlarmTypesEdge?: AlarmTypesEdgeResolvers<ContextType>;
  AlarmVariable?: AlarmVariableResolvers<ContextType>;
  AlarmVariableAggregation?: AlarmVariableAggregationResolvers<ContextType>;
  AlarmVariablesConnection?: AlarmVariablesConnectionResolvers<ContextType>;
  AlarmVariablesEdge?: AlarmVariablesEdgeResolvers<ContextType>;
  Application?: ApplicationResolvers<ContextType>;
  Asset?: AssetResolvers<ContextType>;
  AssetBulkConfigurationsConnection?: AssetBulkConfigurationsConnectionResolvers<ContextType>;
  AssetBulkConfigurationsEdge?: AssetBulkConfigurationsEdgeResolvers<ContextType>;
  AssetsConnection?: AssetsConnectionResolvers<ContextType>;
  AssetsEdge?: AssetsEdgeResolvers<ContextType>;
  Authorization?: AuthorizationResolvers<ContextType>;
  AuthorizationAccessGroup?: AuthorizationAccessGroupResolvers<ContextType>;
  AuthorizationConnection?: AuthorizationConnectionResolvers<ContextType>;
  AuthorizationDevice?: AuthorizationDeviceResolvers<ContextType>;
  AuthorizationEdge?: AuthorizationEdgeResolvers<ContextType>;
  AuthorizationToken?: AuthorizationTokenResolvers<ContextType>;
  BatchDevice?: BatchDeviceResolvers<ContextType>;
  BatchDevicesConnection?: BatchDevicesConnectionResolvers<ContextType>;
  BatchDevicesEdge?: BatchDevicesEdgeResolvers<ContextType>;
  BatchInclude?: BatchIncludeResolvers<ContextType>;
  BatchIncludesConnection?: BatchIncludesConnectionResolvers<ContextType>;
  BatchIncludesEdge?: BatchIncludesEdgeResolvers<ContextType>;
  BatchSim?: BatchSimResolvers<ContextType>;
  BatchSimsConnection?: BatchSimsConnectionResolvers<ContextType>;
  BatchSimsEdge?: BatchSimsEdgeResolvers<ContextType>;
  Byte?: GraphQLScalarType;
  CableType?: CableTypeResolvers<ContextType>;
  CableTypesConnection?: CableTypesConnectionResolvers<ContextType>;
  CableTypesEdge?: CableTypesEdgeResolvers<ContextType>;
  Company?: CompanyResolvers<ContextType>;
  CompanysConnection?: CompanysConnectionResolvers<ContextType>;
  CompanysEdge?: CompanysEdgeResolvers<ContextType>;
  ConTest?: ConTestResolvers<ContextType>;
  ConTestDeviceResult?: ConTestDeviceResultResolvers<ContextType>;
  ConTestDeviceResultsConnection?: ConTestDeviceResultsConnectionResolvers<ContextType>;
  ConTestDeviceResultsEdge?: ConTestDeviceResultsEdgeResolvers<ContextType>;
  ConTestExtended?: ConTestExtendedResolvers<ContextType>;
  ConTestsConnection?: ConTestsConnectionResolvers<ContextType>;
  ConTestsEdge?: ConTestsEdgeResolvers<ContextType>;
  ConTestsExtendedConnection?: ConTestsExtendedConnectionResolvers<ContextType>;
  ConTestsExtendedEdge?: ConTestsExtendedEdgeResolvers<ContextType>;
  Contact?: ContactResolvers<ContextType>;
  ContactsConnection?: ContactsConnectionResolvers<ContextType>;
  ContactsEdge?: ContactsEdgeResolvers<ContextType>;
  Credentials?: CredentialsResolvers<ContextType>;
  CurrentHarmonics?: CurrentHarmonicsResolvers<ContextType>;
  CurrentHarmonicsConnection?: CurrentHarmonicsConnectionResolvers<ContextType>;
  CurrentHarmonicsEdge?: CurrentHarmonicsEdgeResolvers<ContextType>;
  CustomProperties?: CustomPropertiesResolvers<ContextType>;
  CustomPropertiesConnection?: CustomPropertiesConnectionResolvers<ContextType>;
  CustomPropertiesEdge?: CustomPropertiesEdgeResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  Device?: DeviceResolvers<ContextType>;
  DeviceBulkConfiguration?: DeviceBulkConfigurationResolvers<ContextType>;
  DeviceBulkConfigurationsConnection?: DeviceBulkConfigurationsConnectionResolvers<ContextType>;
  DeviceBulkConfigurationsEdge?: DeviceBulkConfigurationsEdgeResolvers<ContextType>;
  DeviceInputNumbersConnection?: DeviceInputNumbersConnectionResolvers<ContextType>;
  DeviceInputNumbersEdge?: DeviceInputNumbersEdgeResolvers<ContextType>;
  DeviceLog?: DeviceLogResolvers<ContextType>;
  DeviceLogConnection?: DeviceLogConnectionResolvers<ContextType>;
  DeviceLogEdge?: DeviceLogEdgeResolvers<ContextType>;
  DeviceLogsConnection?: DeviceLogsConnectionResolvers<ContextType>;
  DeviceLogsEdge?: DeviceLogsEdgeResolvers<ContextType>;
  DeviceMessage?: DeviceMessageResolvers<ContextType>;
  DeviceMessagesConnection?: DeviceMessagesConnectionResolvers<ContextType>;
  DeviceMessagesEdge?: DeviceMessagesEdgeResolvers<ContextType>;
  DeviceTag?: DeviceTagResolvers<ContextType>;
  DeviceTypeConfiguration?: DeviceTypeConfigurationResolvers<ContextType>;
  DeviceTypeConfigurationsConnection?: DeviceTypeConfigurationsConnectionResolvers<ContextType>;
  DeviceTypeConfigurationsEdge?: DeviceTypeConfigurationsEdgeResolvers<ContextType>;
  DevicesAccessGroup?: DevicesAccessGroupResolvers<ContextType>;
  DevicesAlarmStandard?: DevicesAlarmStandardResolvers<ContextType>;
  DevicesCompany?: DevicesCompanyResolvers<ContextType>;
  DevicesConnection?: DevicesConnectionResolvers<ContextType>;
  DevicesEdge?: DevicesEdgeResolvers<ContextType>;
  DevicesFirmwareDocument?: DevicesFirmwareDocumentResolvers<ContextType>;
  DevicesFirmwareDocumentsConnection?: DevicesFirmwareDocumentsConnectionResolvers<ContextType>;
  DevicesFirmwareDocumentsEdge?: DevicesFirmwareDocumentsEdgeResolvers<ContextType>;
  DevicesOperationalArea?: DevicesOperationalAreaResolvers<ContextType>;
  DevicesRegion?: DevicesRegionResolvers<ContextType>;
  Email?: EmailResolvers<ContextType>;
  EmailAttachment?: EmailAttachmentResolvers<ContextType>;
  EmailAttachmentsConnection?: EmailAttachmentsConnectionResolvers<ContextType>;
  EmailAttachmentsEdge?: EmailAttachmentsEdgeResolvers<ContextType>;
  EmailSettings?: EmailSettingsResolvers<ContextType>;
  EmailStatus?: EmailStatusResolvers<ContextType>;
  EmailStatusConnection?: EmailStatusConnectionResolvers<ContextType>;
  EmailStatusEdge?: EmailStatusEdgeResolvers<ContextType>;
  EmailsConnection?: EmailsConnectionResolvers<ContextType>;
  EmailsEdge?: EmailsEdgeResolvers<ContextType>;
  EnergyBalance?: EnergyBalanceResolvers<ContextType>;
  EnergyBalanceConnection?: EnergyBalanceConnectionResolvers<ContextType>;
  EnergyBalanceEdge?: EnergyBalanceEdgeResolvers<ContextType>;
  Enterprise?: EnterpriseResolvers<ContextType>;
  EnterprisesConnection?: EnterprisesConnectionResolvers<ContextType>;
  EnterprisesEdge?: EnterprisesEdgeResolvers<ContextType>;
  Equipment?: EquipmentResolvers<ContextType>;
  EquipmentsAlarmStandard?: EquipmentsAlarmStandardResolvers<ContextType>;
  EquipmentsBulkConfiguration?: EquipmentsBulkConfigurationResolvers<ContextType>;
  EquipmentsConnection?: EquipmentsConnectionResolvers<ContextType>;
  EquipmentsDevice?: EquipmentsDeviceResolvers<ContextType>;
  EquipmentsDeviceInputNumber?: EquipmentsDeviceInputNumberResolvers<ContextType>;
  EquipmentsDeviceLog?: EquipmentsDeviceLogResolvers<ContextType>;
  EquipmentsDevicesConnection?: EquipmentsDevicesConnectionResolvers<ContextType>;
  EquipmentsDevicesEdge?: EquipmentsDevicesEdgeResolvers<ContextType>;
  EquipmentsEdge?: EquipmentsEdgeResolvers<ContextType>;
  EquipmentsOperationalArea?: EquipmentsOperationalAreaResolvers<ContextType>;
  EquipmentsRegion?: EquipmentsRegionResolvers<ContextType>;
  Event?: EventResolvers<ContextType>;
  EventData?: EventDataResolvers<ContextType>;
  EventDataConnection?: EventDataConnectionResolvers<ContextType>;
  EventDataEdge?: EventDataEdgeResolvers<ContextType>;
  EventsConnection?: EventsConnectionResolvers<ContextType>;
  EventsEdge?: EventsEdgeResolvers<ContextType>;
  FederatedIdentity?: FederatedIdentityResolvers<ContextType>;
  Feeder?: FeederResolvers<ContextType>;
  FeedersConnection?: FeedersConnectionResolvers<ContextType>;
  FeedersEdge?: FeedersEdgeResolvers<ContextType>;
  Filter?: FilterResolvers<ContextType>;
  Firmware?: FirmwareResolvers<ContextType>;
  FirmwareTask?: FirmwareTaskResolvers<ContextType>;
  FirmwareTaskLog?: FirmwareTaskLogResolvers<ContextType>;
  FirmwareTaskLogConnection?: FirmwareTaskLogConnectionResolvers<ContextType>;
  FirmwareTaskLogEdge?: FirmwareTaskLogEdgeResolvers<ContextType>;
  FirmwareTasksConnection?: FirmwareTasksConnectionResolvers<ContextType>;
  FirmwareTasksEdge?: FirmwareTasksEdgeResolvers<ContextType>;
  FirmwaresConnection?: FirmwaresConnectionResolvers<ContextType>;
  FirmwaresEdge?: FirmwaresEdgeResolvers<ContextType>;
  GeneralSettings?: GeneralSettingsResolvers<ContextType>;
  GpsPoint?: GpsPointResolvers<ContextType>;
  GpsPointsConnection?: GpsPointsConnectionResolvers<ContextType>;
  GpsPointsEdge?: GpsPointsEdgeResolvers<ContextType>;
  Input?: InputResolvers<ContextType>;
  InputsConnection?: InputsConnectionResolvers<ContextType>;
  InputsEdge?: InputsEdgeResolvers<ContextType>;
  Interface?: InterfaceResolvers<ContextType>;
  InterfaceBluetooth?: InterfaceBluetoothResolvers<ContextType>;
  InterfaceEthernet?: InterfaceEthernetResolvers<ContextType>;
  InterfaceGprs?: InterfaceGprsResolvers<ContextType>;
  InterfaceLoRa?: InterfaceLoRaResolvers<ContextType>;
  InterfacesBluetoothConnection?: InterfacesBluetoothConnectionResolvers<ContextType>;
  InterfacesBluetoothEdge?: InterfacesBluetoothEdgeResolvers<ContextType>;
  InterfacesEthernetConnection?: InterfacesEthernetConnectionResolvers<ContextType>;
  InterfacesEthernetEdge?: InterfacesEthernetEdgeResolvers<ContextType>;
  InterfacesGprsConnection?: InterfacesGprsConnectionResolvers<ContextType>;
  InterfacesGprsEdge?: InterfacesGprsEdgeResolvers<ContextType>;
  InterfacesLoRaConnection?: InterfacesLoRaConnectionResolvers<ContextType>;
  InterfacesLoRaEdge?: InterfacesLoRaEdgeResolvers<ContextType>;
  KeyValuePairOfStringAndIEnumerableOfString?: KeyValuePairOfStringAndIEnumerableOfStringResolvers<ContextType>;
  KeyValuePairOfStringAndObject?: KeyValuePairOfStringAndObjectResolvers<ContextType>;
  KeyValuePairOfStringAndString?: KeyValuePairOfStringAndStringResolvers<ContextType>;
  KeycloakRole?: KeycloakRoleResolvers<ContextType>;
  KeycloakRoleConnection?: KeycloakRoleConnectionResolvers<ContextType>;
  KeycloakRoleEdge?: KeycloakRoleEdgeResolvers<ContextType>;
  KeycloakUser?: KeycloakUserResolvers<ContextType>;
  KeycloakUserConnection?: KeycloakUserConnectionResolvers<ContextType>;
  KeycloakUserEdge?: KeycloakUserEdgeResolvers<ContextType>;
  LastContactByType?: LastContactByTypeResolvers<ContextType>;
  LastContactByTypesConnection?: LastContactByTypesConnectionResolvers<ContextType>;
  LastContactByTypesEdge?: LastContactByTypesEdgeResolvers<ContextType>;
  LayoutAsset?: LayoutAssetResolvers<ContextType>;
  LayoutAssetsConnection?: LayoutAssetsConnectionResolvers<ContextType>;
  LayoutAssetsEdge?: LayoutAssetsEdgeResolvers<ContextType>;
  LayoutEquipment?: LayoutEquipmentResolvers<ContextType>;
  LayoutMessage?: LayoutMessageResolvers<ContextType>;
  LayoutMessagesConnection?: LayoutMessagesConnectionResolvers<ContextType>;
  LayoutMessagesEdge?: LayoutMessagesEdgeResolvers<ContextType>;
  Line?: LineResolvers<ContextType>;
  Long?: GraphQLScalarType;
  Menu?: MenuResolvers<ContextType>;
  MenuConnection?: MenuConnectionResolvers<ContextType>;
  MenuEdge?: MenuEdgeResolvers<ContextType>;
  MenuRoles?: MenuRolesResolvers<ContextType>;
  MenuRolesActions?: MenuRolesActionsResolvers<ContextType>;
  MenuRolesActionsConnection?: MenuRolesActionsConnectionResolvers<ContextType>;
  MenuRolesActionsEdge?: MenuRolesActionsEdgeResolvers<ContextType>;
  MenuRolesConnection?: MenuRolesConnectionResolvers<ContextType>;
  MenuRolesEdge?: MenuRolesEdgeResolvers<ContextType>;
  ModemSettings?: ModemSettingsResolvers<ContextType>;
  NetworkPowerQuality?: NetworkPowerQualityResolvers<ContextType>;
  NetworkPowerQualityConnection?: NetworkPowerQualityConnectionResolvers<ContextType>;
  NetworkPowerQualityEdge?: NetworkPowerQualityEdgeResolvers<ContextType>;
  OperationalArea?: OperationalAreaResolvers<ContextType>;
  OperationalAreasConnection?: OperationalAreasConnectionResolvers<ContextType>;
  OperationalAreasEdge?: OperationalAreasEdgeResolvers<ContextType>;
  PacketConfiguration?: PacketConfigurationResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PlatformSettings?: PlatformSettingsResolvers<ContextType>;
  PlatformSettingsConnection?: PlatformSettingsConnectionResolvers<ContextType>;
  PlatformSettingsEdge?: PlatformSettingsEdgeResolvers<ContextType>;
  Port?: PortResolvers<ContextType>;
  PortsConnection?: PortsConnectionResolvers<ContextType>;
  PortsEdge?: PortsEdgeResolvers<ContextType>;
  PowerBusLinesConnection?: PowerBusLinesConnectionResolvers<ContextType>;
  PowerBusLinesEdge?: PowerBusLinesEdgeResolvers<ContextType>;
  Protocol?: ProtocolResolvers<ContextType>;
  ProtocolBluetooth?: ProtocolBluetoothResolvers<ContextType>;
  ProtocolDNP3?: ProtocolDnp3Resolvers<ContextType>;
  ProtocolEneidaLoRa?: ProtocolEneidaLoRaResolvers<ContextType>;
  ProtocolHTTP?: ProtocolHttpResolvers<ContextType>;
  ProtocolMqtt?: ProtocolMqttResolvers<ContextType>;
  ProtocolsBluetoothConnection?: ProtocolsBluetoothConnectionResolvers<ContextType>;
  ProtocolsBluetoothEdge?: ProtocolsBluetoothEdgeResolvers<ContextType>;
  ProtocolsDNP3Connection?: ProtocolsDnp3ConnectionResolvers<ContextType>;
  ProtocolsDNP3Edge?: ProtocolsDnp3EdgeResolvers<ContextType>;
  ProtocolsEneidaLoRaConnection?: ProtocolsEneidaLoRaConnectionResolvers<ContextType>;
  ProtocolsEneidaLoRaEdge?: ProtocolsEneidaLoRaEdgeResolvers<ContextType>;
  ProtocolsHTTPConnection?: ProtocolsHttpConnectionResolvers<ContextType>;
  ProtocolsHTTPEdge?: ProtocolsHttpEdgeResolvers<ContextType>;
  ProtocolsMqttConnection?: ProtocolsMqttConnectionResolvers<ContextType>;
  ProtocolsMqttEdge?: ProtocolsMqttEdgeResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RFSettings?: RfSettingsResolvers<ContextType>;
  Region?: RegionResolvers<ContextType>;
  RegionsConnection?: RegionsConnectionResolvers<ContextType>;
  RegionsEdge?: RegionsEdgeResolvers<ContextType>;
  ReportDTO?: ReportDtoResolvers<ContextType>;
  ReportsConnection?: ReportsConnectionResolvers<ContextType>;
  ReportsEdge?: ReportsEdgeResolvers<ContextType>;
  Role?: RoleResolvers<ContextType>;
  RoleComposite?: RoleCompositeResolvers<ContextType>;
  RoleConnection?: RoleConnectionResolvers<ContextType>;
  RoleEdge?: RoleEdgeResolvers<ContextType>;
  RoleGraphQl?: RoleGraphQlResolvers<ContextType>;
  ScheduleOperationMode?: ScheduleOperationModeResolvers<ContextType>;
  ScheduleOperationModeConnection?: ScheduleOperationModeConnectionResolvers<ContextType>;
  ScheduleOperationModeEdge?: ScheduleOperationModeEdgeResolvers<ContextType>;
  Section?: SectionResolvers<ContextType>;
  SimCard?: SimCardResolvers<ContextType>;
  SimCardsConnection?: SimCardsConnectionResolvers<ContextType>;
  SimCardsEdge?: SimCardsEdgeResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionsConnection?: SubscriptionsConnectionResolvers<ContextType>;
  SubscriptionsEdge?: SubscriptionsEdgeResolvers<ContextType>;
  Template?: TemplateResolvers<ContextType>;
  TemplateConfig?: TemplateConfigResolvers<ContextType>;
  TemplatesConfigConnection?: TemplatesConfigConnectionResolvers<ContextType>;
  TemplatesConfigEdge?: TemplatesConfigEdgeResolvers<ContextType>;
  TemplatesConnection?: TemplatesConnectionResolvers<ContextType>;
  TemplatesEdge?: TemplatesEdgeResolvers<ContextType>;
  UUID?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserAccess?: UserAccessResolvers<ContextType>;
  UserConnection?: UserConnectionResolvers<ContextType>;
  UserConsent?: UserConsentResolvers<ContextType>;
  UserEdge?: UserEdgeResolvers<ContextType>;
  UserGraphQl?: UserGraphQlResolvers<ContextType>;
  UserLogAction?: UserLogActionResolvers<ContextType>;
  UserLogActionConnection?: UserLogActionConnectionResolvers<ContextType>;
  UserLogActionEdge?: UserLogActionEdgeResolvers<ContextType>;
};

